var map = {
	"./Addition/AdditionLevel.png": 946773,
	"./Addition/AdditionMenu.png": 956770,
	"./Addition/AdditionRating.png": 651096,
	"./Addition/AdditionsLevel.png": 457140,
	"./Addition/Animation/combo0.gif": 940019,
	"./Addition/Animation/combo1.gif": 742954,
	"./Addition/Animation/combo2.gif": 177989,
	"./Addition/Animation/combo3.gif": 745772,
	"./Addition/Animation/combo4.gif": 16127,
	"./Addition/ExtraQuestions/additions_extraquestions.csv": 987924,
	"./Addition/addition_rating.gif": 418972,
	"./Addition/additions_extra_bg.png": 26061,
	"./Addition/menu_addition.gif": 976844,
	"./Algebra/AlgebraLevel.png": 766683,
	"./Algebra/AlgebraMenu.png": 540892,
	"./Algebra/AlgebraRating.png": 500242,
	"./Algebra/Animation/combo0.gif": 256577,
	"./Algebra/Animation/combo1.gif": 779144,
	"./Algebra/Animation/combo2.gif": 168591,
	"./Algebra/Animation/combo3.gif": 482742,
	"./Algebra/Animation/combo4.gif": 52693,
	"./Algebra/algebra.gif": 39570,
	"./Algebra/menu_algebra.gif": 242830,
	"./AlgebraScreenshot.jpg": 893816,
	"./Audio/5OK.wav": 681156,
	"./Audio/6WRONG.wav": 544256,
	"./Audio/Greece.mp3": 590604,
	"./Audio/I’m.mp3": 399856,
	"./Audio/I’ve.mp3": 622868,
	"./Audio/Mavis.mp3": 517611,
	"./Audio/Paul.mp3": 891527,
	"./Audio/Steve.mp3": 639106,
	"./Audio/Sue.mp3": 513066,
	"./Audio/Sydney.mp3": 227233,
	"./Audio/a-2.mp3": 165759,
	"./Audio/a-3.mp3": 973146,
	"./Audio/a.mp3": 227170,
	"./Audio/a3.mp3": 280785,
	"./Audio/ab.mp3": 549180,
	"./Audio/abbreviate.mp3": 389014,
	"./Audio/abbreviation.mp3": 151817,
	"./Audio/ablaze.mp3": 752742,
	"./Audio/able.mp3": 35873,
	"./Audio/about.mp3": 874536,
	"./Audio/above.mp3": 548944,
	"./Audio/absolute.mp3": 508890,
	"./Audio/acceleration.mp3": 167505,
	"./Audio/accent.mp3": 918999,
	"./Audio/accept.mp3": 990777,
	"./Audio/acceptance.mp3": 874424,
	"./Audio/access.mp3": 493751,
	"./Audio/accessed.mp3": 994400,
	"./Audio/accident.mp3": 188002,
	"./Audio/accidental.mp3": 158773,
	"./Audio/accidentally.mp3": 303004,
	"./Audio/accidents.mp3": 976145,
	"./Audio/accommodate.mp3": 434544,
	"./Audio/accomodated.mp3": 896213,
	"./Audio/accomodating.mp3": 440386,
	"./Audio/accompanied.mp3": 241929,
	"./Audio/accompany.mp3": 576282,
	"./Audio/according.mp3": 345999,
	"./Audio/accordingly.mp3": 177366,
	"./Audio/accords.mp3": 969972,
	"./Audio/account.mp3": 555538,
	"./Audio/accumulate.mp3": 426191,
	"./Audio/accurate.mp3": 82359,
	"./Audio/accuse.mp3": 474945,
	"./Audio/ach.mp3": 346827,
	"./Audio/ache.mp3": 30848,
	"./Audio/achieve.mp3": 46482,
	"./Audio/acorn.mp3": 644760,
	"./Audio/acoustic.mp3": 892392,
	"./Audio/acrobat.mp3": 63245,
	"./Audio/acronym.mp3": 521268,
	"./Audio/acropolis.mp3": 689441,
	"./Audio/across.mp3": 887778,
	"./Audio/acted.mp3": 788192,
	"./Audio/acting.mp3": 348665,
	"./Audio/action.mp3": 313807,
	"./Audio/activate.mp3": 470818,
	"./Audio/active.mp3": 66307,
	"./Audio/actively.mp3": 799026,
	"./Audio/actors.mp3": 378023,
	"./Audio/actual.mp3": 963903,
	"./Audio/actually.mp3": 985894,
	"./Audio/acuity.mp3": 484226,
	"./Audio/acupuncture.mp3": 281836,
	"./Audio/acute.mp3": 187719,
	"./Audio/add.mp3": 558306,
	"./Audio/addition.mp3": 314041,
	"./Audio/address.mp3": 527255,
	"./Audio/addressed.mp3": 617792,
	"./Audio/addresses.mp3": 80387,
	"./Audio/addressing.mp3": 477145,
	"./Audio/adhere.mp3": 752728,
	"./Audio/adjective.mp3": 251926,
	"./Audio/adjust.mp3": 998788,
	"./Audio/admiration.mp3": 676073,
	"./Audio/admission.mp3": 987416,
	"./Audio/adorable.mp3": 540441,
	"./Audio/adorably.mp3": 184517,
	"./Audio/adoration.mp3": 321336,
	"./Audio/advance.mp3": 393901,
	"./Audio/advantageous.mp3": 681999,
	"./Audio/adventure.mp3": 308399,
	"./Audio/adventurous.mp3": 272381,
	"./Audio/adverb.mp3": 6681,
	"./Audio/adversary.mp3": 226654,
	"./Audio/advert.mp3": 912831,
	"./Audio/advertise.mp3": 892948,
	"./Audio/advertisement.mp3": 742480,
	"./Audio/advertises.mp3": 851083,
	"./Audio/advice.mp3": 847281,
	"./Audio/advisable.mp3": 302352,
	"./Audio/advise.mp3": 647233,
	"./Audio/advocate.mp3": 703482,
	"./Audio/aerobics.mp3": 779711,
	"./Audio/aerofoil.mp3": 421492,
	"./Audio/aeronaut.mp3": 86034,
	"./Audio/aerospace.mp3": 984964,
	"./Audio/affect.mp3": 106238,
	"./Audio/affection.mp3": 477316,
	"./Audio/afford.mp3": 159511,
	"./Audio/afloat.mp3": 778140,
	"./Audio/afraid.mp3": 120920,
	"./Audio/after.mp3": 764421,
	"./Audio/afterwards.mp3": 978778,
	"./Audio/again.mp3": 820439,
	"./Audio/age.mp3": 808166,
	"./Audio/aggressive.mp3": 706633,
	"./Audio/ago.mp3": 504428,
	"./Audio/aground.mp3": 596159,
	"./Audio/ahead.mp3": 816608,
	"./Audio/ahoy.mp3": 453670,
	"./Audio/aib.mp3": 151971,
	"./Audio/aik.mp3": 250918,
	"./Audio/ail.mp3": 880125,
	"./Audio/aim.mp3": 157400,
	"./Audio/air -2.mp3": 589228,
	"./Audio/air -3.mp3": 951537,
	"./Audio/air.mp3": 272659,
	"./Audio/airch.mp3": 274610,
	"./Audio/airport.mp3": 169434,
	"./Audio/aisle.mp3": 643627,
	"./Audio/aithor.mp3": 398808,
	"./Audio/ak.mp3": 541353,
	"./Audio/alhabet.mp3": 481712,
	"./Audio/alhalet.mp3": 284810,
	"./Audio/align.mp3": 637104,
	"./Audio/all.mp3": 141650,
	"./Audio/alley.mp3": 447048,
	"./Audio/allowed.mp3": 907931,
	"./Audio/almost.mp3": 660851,
	"./Audio/aloe.mp3": 736998,
	"./Audio/alone.mp3": 866898,
	"./Audio/along.mp3": 607168,
	"./Audio/aloud.mp3": 252006,
	"./Audio/alpabet.mp3": 14600,
	"./Audio/alpalet.mp3": 62546,
	"./Audio/alphabet.mp3": 821124,
	"./Audio/alphalet.mp3": 727334,
	"./Audio/alphanumeric.mp3": 258728,
	"./Audio/alrabet.mp3": 812202,
	"./Audio/alralet.mp3": 128656,
	"./Audio/already.mp3": 488635,
	"./Audio/alright.mp3": 219332,
	"./Audio/altar.mp3": 211011,
	"./Audio/alter.mp3": 421359,
	"./Audio/although.mp3": 991439,
	"./Audio/always.mp3": 470734,
	"./Audio/am.mp3": 383263,
	"./Audio/amateur.mp3": 227048,
	"./Audio/amaze.mp3": 487167,
	"./Audio/ambitious.mp3": 482076,
	"./Audio/amuse.mp3": 984368,
	"./Audio/amusement.mp3": 683804,
	"./Audio/an.mp3": 999592,
	"./Audio/analogue.mp3": 213883,
	"./Audio/analogy.mp3": 443074,
	"./Audio/anchor.mp3": 631110,
	"./Audio/ancient.mp3": 595683,
	"./Audio/and.mp3": 790492,
	"./Audio/angel.mp3": 161716,
	"./Audio/angrily.mp3": 513877,
	"./Audio/angry.mp3": 59460,
	"./Audio/animal.mp3": 707665,
	"./Audio/animals.mp3": 539436,
	"./Audio/animation.mp3": 260997,
	"./Audio/anm.mp3": 759689,
	"./Audio/anniversary.mp3": 499669,
	"./Audio/annoy.mp3": 354182,
	"./Audio/annoying.mp3": 425666,
	"./Audio/annual.mp3": 293336,
	"./Audio/annually.mp3": 3281,
	"./Audio/another.mp3": 647118,
	"./Audio/anp.mp3": 187056,
	"./Audio/ans.mp3": 305223,
	"./Audio/ansade.mp3": 664973,
	"./Audio/anslame.mp3": 500728,
	"./Audio/anss.mp3": 566802,
	"./Audio/answer.mp3": 667835,
	"./Audio/anticipate.mp3": 793841,
	"./Audio/anticlimax.mp3": 376365,
	"./Audio/anticlockwise.mp3": 100693,
	"./Audio/antidote.mp3": 990595,
	"./Audio/antique.mp3": 325936,
	"./Audio/antiseptic.mp3": 69037,
	"./Audio/antisocial.mp3": 977144,
	"./Audio/anxious.mp3": 954816,
	"./Audio/any.mp3": 427709,
	"./Audio/anyone.mp3": 76055,
	"./Audio/anywhere.mp3": 814982,
	"./Audio/aon.mp3": 123705,
	"./Audio/aot.mp3": 723379,
	"./Audio/ap.mp3": 619326,
	"./Audio/apparent.mp3": 967678,
	"./Audio/appear.mp3": 315258,
	"./Audio/apple.mp3": 15823,
	"./Audio/applicable.mp3": 256402,
	"./Audio/applicably.mp3": 456774,
	"./Audio/application.mp3": 547701,
	"./Audio/applicator.mp3": 208858,
	"./Audio/appreciate.mp3": 323399,
	"./Audio/appreciated.mp3": 659665,
	"./Audio/appreciation.mp3": 996416,
	"./Audio/appreciative.mp3": 257196,
	"./Audio/apprehensive.mp3": 311125,
	"./Audio/approximately.mp3": 318924,
	"./Audio/april.mp3": 886883,
	"./Audio/aquarium.mp3": 360124,
	"./Audio/aquatics.mp3": 831806,
	"./Audio/aqueduct.mp3": 277277,
	"./Audio/ar -2.mp3": 956725,
	"./Audio/ar -3.mp3": 270096,
	"./Audio/ar .mp3": 506092,
	"./Audio/ar.mp3": 733900,
	"./Audio/arc.mp3": 738211,
	"./Audio/are.mp3": 506453,
	"./Audio/aren't.mp3": 709572,
	"./Audio/arfar.mp3": 484283,
	"./Audio/arfay.mp3": 193756,
	"./Audio/arfear.mp3": 326570,
	"./Audio/arfow.mp3": 168668,
	"./Audio/arfue.mp3": 160268,
	"./Audio/argar.mp3": 786010,
	"./Audio/argay.mp3": 259077,
	"./Audio/argear.mp3": 590417,
	"./Audio/argew.mp3": 320887,
	"./Audio/argow.mp3": 808249,
	"./Audio/argue.mp3": 697637,
	"./Audio/arguing.mp3": 204308,
	"./Audio/argument.mp3": 710232,
	"./Audio/ark.mp3": 593483,
	"./Audio/arl.mp3": 743640,
	"./Audio/arm.mp3": 466365,
	"./Audio/around.mp3": 462146,
	"./Audio/arrange.mp3": 919991,
	"./Audio/arrival.mp3": 542424,
	"./Audio/arrivals.mp3": 495671,
	"./Audio/arrive.mp3": 425680,
	"./Audio/arrives.mp3": 90175,
	"./Audio/arriving.mp3": 966101,
	"./Audio/arrow.mp3": 436376,
	"./Audio/artificial.mp3": 72517,
	"./Audio/artist.mp3": 687468,
	"./Audio/artwork.mp3": 893651,
	"./Audio/as.mp3": 791761,
	"./Audio/ascent.mp3": 485319,
	"./Audio/ascertain.mp3": 604317,
	"./Audio/ask.mp3": 610980,
	"./Audio/asked.mp3": 38067,
	"./Audio/asleep.mp3": 145015,
	"./Audio/assess.mp3": 126647,
	"./Audio/assign.mp3": 329478,
	"./Audio/assigning.mp3": 681666,
	"./Audio/assistance.mp3": 230757,
	"./Audio/assistant.mp3": 937575,
	"./Audio/assoa.mp3": 375688,
	"./Audio/assor.mp3": 742223,
	"./Audio/assow.mp3": 888870,
	"./Audio/assuhe.mp3": 141260,
	"./Audio/assure.mp3": 913758,
	"./Audio/asterisk.mp3": 804769,
	"./Audio/astrologer.mp3": 977265,
	"./Audio/astronaut.mp3": 757026,
	"./Audio/astronomer.mp3": 95917,
	"./Audio/astrophysics.mp3": 862893,
	"./Audio/at.mp3": 481954,
	"./Audio/ate.mp3": 902487,
	"./Audio/athlete.mp3": 712366,
	"./Audio/athor.mp3": 850225,
	"./Audio/atmosphere.mp3": 179361,
	"./Audio/atrocious.mp3": 961458,
	"./Audio/attached.mp3": 740017,
	"./Audio/attack.mp3": 482597,
	"./Audio/attempts.mp3": 117063,
	"./Audio/attention.mp3": 538745,
	"./Audio/audacious.mp3": 346325,
	"./Audio/audible.mp3": 148013,
	"./Audio/audience.mp3": 712207,
	"./Audio/audio.mp3": 76945,
	"./Audio/aught.mp3": 390714,
	"./Audio/august.mp3": 672214,
	"./Audio/author.mp3": 23668,
	"./Audio/authored.mp3": 780611,
	"./Audio/autobiography.mp3": 276347,
	"./Audio/autograph.mp3": 747796,
	"./Audio/automate.mp3": 628123,
	"./Audio/automatic.mp3": 241938,
	"./Audio/automatically.mp3": 415788,
	"./Audio/automobile.mp3": 240742,
	"./Audio/autonomy.mp3": 173939,
	"./Audio/autopilot.mp3": 151410,
	"./Audio/autumn.mp3": 785235,
	"./Audio/availability.mp3": 248292,
	"./Audio/available.mp3": 231918,
	"./Audio/avenar.mp3": 267028,
	"./Audio/avenay.mp3": 665475,
	"./Audio/avene.mp3": 287158,
	"./Audio/avenear.mp3": 727631,
	"./Audio/avenow.mp3": 525095,
	"./Audio/avenue.mp3": 916763,
	"./Audio/average.mp3": 726090,
	"./Audio/avine.mp3": 887426,
	"./Audio/avone.mp3": 2652,
	"./Audio/avune.mp3": 43494,
	"./Audio/award.mp3": 691048,
	"./Audio/away.mp3": 758243,
	"./Audio/awful.mp3": 399682,
	"./Audio/awkward.mp3": 545278,
	"./Audio/awkwardly.mp3": 858791,
	"./Audio/ay -2.mp3": 471844,
	"./Audio/ay -3.mp3": 690441,
	"./Audio/ay .mp3": 302369,
	"./Audio/ay.mp3": 5611,
	"./Audio/aych.mp3": 251386,
	"./Audio/ayntray.mp3": 841159,
	"./Audio/b -2.mp3": 759694,
	"./Audio/b -3.mp3": 257939,
	"./Audio/b.mp3": 663797,
	"./Audio/ba.mp3": 445146,
	"./Audio/babies'.mp3": 352528,
	"./Audio/babies.mp3": 967137,
	"./Audio/baby's.mp3": 260127,
	"./Audio/baby.mp3": 290689,
	"./Audio/bach.mp3": 422835,
	"./Audio/back.mp3": 341500,
	"./Audio/background.mp3": 238489,
	"./Audio/backward.mp3": 866298,
	"./Audio/backwards.mp3": 509561,
	"./Audio/bad.mp3": 219418,
	"./Audio/badge.mp3": 675230,
	"./Audio/badger.mp3": 256224,
	"./Audio/badly.mp3": 58299,
	"./Audio/baf.mp3": 35656,
	"./Audio/bag.mp3": 680941,
	"./Audio/baggage.mp3": 89353,
	"./Audio/baguette.mp3": 576056,
	"./Audio/bah.mp3": 860430,
	"./Audio/bai.mp3": 358675,
	"./Audio/baik.mp3": 337374,
	"./Audio/bail.mp3": 97557,
	"./Audio/baip.mp3": 389449,
	"./Audio/bait.mp3": 772269,
	"./Audio/bak.mp3": 464225,
	"./Audio/bake.mp3": 736354,
	"./Audio/balance.mp3": 425543,
	"./Audio/balar.mp3": 652491,
	"./Audio/balay.mp3": 592428,
	"./Audio/balb.mp3": 413548,
	"./Audio/bald.mp3": 642050,
	"./Audio/balear.mp3": 740250,
	"./Audio/ball.mp3": 304042,
	"./Audio/balm.mp3": 782543,
	"./Audio/balow.mp3": 871788,
	"./Audio/balt.mp3": 305266,
	"./Audio/balue.mp3": 311580,
	"./Audio/bame.mp3": 952412,
	"./Audio/bane.mp3": 937033,
	"./Audio/bang.mp3": 258363,
	"./Audio/bank.mp3": 457847,
	"./Audio/bankrupt.mp3": 205344,
	"./Audio/bannair.mp3": 744514,
	"./Audio/bannar.mp3": 313959,
	"./Audio/bannare.mp3": 545004,
	"./Audio/banner.mp3": 795419,
	"./Audio/bannerer.mp3": 232442,
	"./Audio/bannor.mp3": 443033,
	"./Audio/banquet.mp3": 458493,
	"./Audio/baon.mp3": 882769,
	"./Audio/baop.mp3": 627295,
	"./Audio/bap.mp3": 336934,
	"./Audio/bar.mp3": 88564,
	"./Audio/bard.mp3": 353064,
	"./Audio/bare.mp3": 500493,
	"./Audio/bargain.mp3": 760265,
	"./Audio/bargained.mp3": 649722,
	"./Audio/bargaining.mp3": 420591,
	"./Audio/barge.mp3": 641844,
	"./Audio/bark.mp3": 983987,
	"./Audio/barth.mp3": 123384,
	"./Audio/bas.mp3": 48409,
	"./Audio/bash.mp3": 338275,
	"./Audio/basically.mp3": 531027,
	"./Audio/bast.mp3": 901823,
	"./Audio/bat.mp3": 228138,
	"./Audio/bath.mp3": 719998,
	"./Audio/batoa.mp3": 178970,
	"./Audio/bator.mp3": 925693,
	"./Audio/batow.mp3": 48116,
	"./Audio/batuhe.mp3": 34102,
	"./Audio/bature.mp3": 789524,
	"./Audio/baw.mp3": 966141,
	"./Audio/bawl.mp3": 268027,
	"./Audio/bax.mp3": 246046,
	"./Audio/bay.mp3": 237987,
	"./Audio/baz.mp3": 33196,
	"./Audio/be.mp3": 761110,
	"./Audio/beach.mp3": 206254,
	"./Audio/bead.mp3": 698537,
	"./Audio/beak.mp3": 353938,
	"./Audio/beam.mp3": 706364,
	"./Audio/bear.mp3": 65839,
	"./Audio/beard.mp3": 967945,
	"./Audio/beards.mp3": 219924,
	"./Audio/beast.mp3": 858010,
	"./Audio/beat.mp3": 214201,
	"./Audio/beath.mp3": 531203,
	"./Audio/beautician.mp3": 526576,
	"./Audio/beautiful.mp3": 985738,
	"./Audio/beauty.mp3": 586605,
	"./Audio/because.mp3": 206071,
	"./Audio/becc.mp3": 9568,
	"./Audio/bech.mp3": 763711,
	"./Audio/beckon.mp3": 585359,
	"./Audio/bed.mp3": 331174,
	"./Audio/bedroom.mp3": 431575,
	"./Audio/bee.mp3": 875595,
	"./Audio/beek.mp3": 720822,
	"./Audio/been.mp3": 992159,
	"./Audio/beep.mp3": 247633,
	"./Audio/bees.mp3": 75198,
	"./Audio/beet.mp3": 916981,
	"./Audio/before.mp3": 111916,
	"./Audio/beg.mp3": 347097,
	"./Audio/began.mp3": 380380,
	"./Audio/begg.mp3": 215960,
	"./Audio/begin.mp3": 59572,
	"./Audio/beginner.mp3": 253239,
	"./Audio/beginning.mp3": 518662,
	"./Audio/behind.mp3": 645833,
	"./Audio/beige.mp3": 537091,
	"./Audio/bek.mp3": 304917,
	"./Audio/beke.mp3": 278070,
	"./Audio/believable.mp3": 48422,
	"./Audio/believe.mp3": 42367,
	"./Audio/believer.mp3": 866207,
	"./Audio/believing.mp3": 625854,
	"./Audio/bell.mp3": 802790,
	"./Audio/below.mp3": 189512,
	"./Audio/belt.mp3": 842638,
	"./Audio/beme.mp3": 49096,
	"./Audio/ben.mp3": 331884,
	"./Audio/benc.mp3": 332995,
	"./Audio/bench.mp3": 619073,
	"./Audio/bend.mp3": 860880,
	"./Audio/beneficial.mp3": 347253,
	"./Audio/benefit.mp3": 761438,
	"./Audio/benh.mp3": 630100,
	"./Audio/benk.mp3": 634539,
	"./Audio/bent.mp3": 565952,
	"./Audio/berr.mp3": 72226,
	"./Audio/berry.mp3": 775083,
	"./Audio/best.mp3": 238291,
	"./Audio/bet.mp3": 376598,
	"./Audio/bettair.mp3": 437834,
	"./Audio/bettar.mp3": 60719,
	"./Audio/bettare.mp3": 164580,
	"./Audio/better.mp3": 850371,
	"./Audio/betterer.mp3": 224322,
	"./Audio/bettor.mp3": 479505,
	"./Audio/bew.mp3": 292361,
	"./Audio/beware.mp3": 751073,
	"./Audio/biannual.mp3": 935403,
	"./Audio/bias.mp3": 533222,
	"./Audio/bicc.mp3": 908540,
	"./Audio/bicentennial.mp3": 590285,
	"./Audio/bich.mp3": 221787,
	"./Audio/bicycle.mp3": 224672,
	"./Audio/bid.mp3": 723778,
	"./Audio/biennial.mp3": 603259,
	"./Audio/bif.mp3": 187568,
	"./Audio/bifocals.mp3": 458876,
	"./Audio/big.mp3": 468309,
	"./Audio/bigg.mp3": 892484,
	"./Audio/bigh.mp3": 66391,
	"./Audio/bike.mp3": 867178,
	"./Audio/bilingual.mp3": 559376,
	"./Audio/bill.mp3": 731874,
	"./Audio/bim.mp3": 864271,
	"./Audio/bime.mp3": 198020,
	"./Audio/bin.mp3": 221848,
	"./Audio/binary.mp3": 39498,
	"./Audio/bind.mp3": 130412,
	"./Audio/binoculars.mp3": 814875,
	"./Audio/biodiversity.mp3": 580082,
	"./Audio/biography.mp3": 133352,
	"./Audio/biologist.mp3": 903551,
	"./Audio/biology.mp3": 89898,
	"./Audio/biosphere.mp3": 654498,
	"./Audio/bip.mp3": 322510,
	"./Audio/biped.mp3": 643037,
	"./Audio/bird.mp3": 650592,
	"./Audio/birds.mp3": 273423,
	"./Audio/birr.mp3": 332894,
	"./Audio/birth.mp3": 438608,
	"./Audio/birthday.mp3": 948062,
	"./Audio/bis.mp3": 926305,
	"./Audio/bisect.mp3": 232055,
	"./Audio/bish.mp3": 256235,
	"./Audio/bit.mp3": 386994,
	"./Audio/bith.mp3": 409062,
	"./Audio/biweekly.mp3": 211567,
	"./Audio/bizarre.mp3": 105386,
	"./Audio/black.mp3": 702566,
	"./Audio/blackberry.mp3": 463318,
	"./Audio/blae.mp3": 718285,
	"./Audio/blaird.mp3": 762983,
	"./Audio/blame.mp3": 259814,
	"./Audio/bland.mp3": 9954,
	"./Audio/blank.mp3": 68665,
	"./Audio/blape.mp3": 654381,
	"./Audio/blar.mp3": 425862,
	"./Audio/blard.mp3": 238070,
	"./Audio/blast.mp3": 268693,
	"./Audio/blaw.mp3": 937391,
	"./Audio/blay.mp3": 336849,
	"./Audio/blaze.mp3": 834819,
	"./Audio/bleak.mp3": 865024,
	"./Audio/blear.mp3": 55773,
	"./Audio/bled.mp3": 640300,
	"./Audio/bleme.mp3": 115562,
	"./Audio/blend.mp3": 486742,
	"./Audio/blepe.mp3": 191689,
	"./Audio/blew.mp3": 508307,
	"./Audio/blied.mp3": 435387,
	"./Audio/blime .mp3": 229362,
	"./Audio/blind.mp3": 640554,
	"./Audio/blink.mp3": 807921,
	"./Audio/blipe.mp3": 399397,
	"./Audio/bload.mp3": 556029,
	"./Audio/blob.mp3": 705180,
	"./Audio/block.mp3": 542228,
	"./Audio/blome.mp3": 522900,
	"./Audio/blond.mp3": 781884,
	"./Audio/blonde.mp3": 146277,
	"./Audio/bloo.mp3": 998317,
	"./Audio/blope.mp3": 346275,
	"./Audio/blow.mp3": 170581,
	"./Audio/blue.mp3": 498113,
	"./Audio/bluebell.mp3": 68866,
	"./Audio/bluff.mp3": 342300,
	"./Audio/blush.mp3": 457021,
	"./Audio/bluw.mp3": 156227,
	"./Audio/bo.mp3": 707676,
	"./Audio/boa.mp3": 483553,
	"./Audio/boach.mp3": 637108,
	"./Audio/boad.mp3": 65063,
	"./Audio/boak.mp3": 462996,
	"./Audio/boal.mp3": 886831,
	"./Audio/boan.mp3": 105949,
	"./Audio/boap.mp3": 92339,
	"./Audio/boast.mp3": 913872,
	"./Audio/boat.mp3": 679447,
	"./Audio/bockair.mp3": 223698,
	"./Audio/bockar.mp3": 707927,
	"./Audio/bockay.mp3": 6248,
	"./Audio/bockey.mp3": 434028,
	"./Audio/bockoy.mp3": 704014,
	"./Audio/boe.mp3": 711813,
	"./Audio/boi.mp3": 317449,
	"./Audio/boil.mp3": 217367,
	"./Audio/bok.mp3": 638779,
	"./Audio/boke.mp3": 642512,
	"./Audio/bold.mp3": 49852,
	"./Audio/bomb.mp3": 323074,
	"./Audio/bome.mp3": 493534,
	"./Audio/bomp.mp3": 66423,
	"./Audio/bone.mp3": 596607,
	"./Audio/bonfire.mp3": 160422,
	"./Audio/boo.mp3": 947711,
	"./Audio/book.mp3": 440802,
	"./Audio/boon.mp3": 662915,
	"./Audio/boop.mp3": 132045,
	"./Audio/boot.mp3": 500201,
	"./Audio/bop.mp3": 52524,
	"./Audio/bor.mp3": 265374,
	"./Audio/bord.mp3": 79774,
	"./Audio/born.mp3": 922292,
	"./Audio/borough.mp3": 965263,
	"./Audio/borp.mp3": 605618,
	"./Audio/borth.mp3": 230778,
	"./Audio/bos.mp3": 257315,
	"./Audio/boss.mp3": 260774,
	"./Audio/bot.mp3": 744816,
	"./Audio/both.mp3": 777040,
	"./Audio/bottle.mp3": 699705,
	"./Audio/bou.mp3": 25557,
	"./Audio/bough.mp3": 296876,
	"./Audio/bought.mp3": 191040,
	"./Audio/boulder.mp3": 51056,
	"./Audio/bounce.mp3": 550837,
	"./Audio/bow.mp3": 862983,
	"./Audio/bowl.mp3": 44153,
	"./Audio/bowled.mp3": 909226,
	"./Audio/box.mp3": 107892,
	"./Audio/boxair.mp3": 818448,
	"./Audio/boxar.mp3": 23065,
	"./Audio/boxare.mp3": 655466,
	"./Audio/boxer.mp3": 567781,
	"./Audio/boxerer.mp3": 490200,
	"./Audio/boxor.mp3": 708263,
	"./Audio/boy's.mp3": 940279,
	"./Audio/boy.mp3": 67737,
	"./Audio/boys'.mp3": 791599,
	"./Audio/boys.mp3": 929764,
	"./Audio/brack.mp3": 957828,
	"./Audio/brake.mp3": 607658,
	"./Audio/brand.mp3": 870892,
	"./Audio/brash.mp3": 996715,
	"./Audio/brat.mp3": 403634,
	"./Audio/brave.mp3": 157385,
	"./Audio/bravely.mp3": 885944,
	"./Audio/bread.mp3": 786689,
	"./Audio/break.mp3": 180410,
	"./Audio/breakable.mp3": 365958,
	"./Audio/breakfast.mp3": 635884,
	"./Audio/bream.mp3": 268100,
	"./Audio/breath.mp3": 263099,
	"./Audio/breathe.mp3": 923344,
	"./Audio/breathes.mp3": 63935,
	"./Audio/breathing.mp3": 611029,
	"./Audio/breathless.mp3": 822584,
	"./Audio/breathlessly.mp3": 12145,
	"./Audio/breaths.mp3": 642030,
	"./Audio/breathtaking.mp3": 310759,
	"./Audio/breete.mp3": 154110,
	"./Audio/breeze.mp3": 932152,
	"./Audio/brew.mp3": 827409,
	"./Audio/brick.mp3": 565628,
	"./Audio/bridal.mp3": 746077,
	"./Audio/bridge.mp3": 184926,
	"./Audio/bridle.mp3": 792199,
	"./Audio/brief.mp3": 981163,
	"./Audio/bright.mp3": 407801,
	"./Audio/bring.mp3": 998843,
	"./Audio/brish.mp3": 78755,
	"./Audio/bristle.mp3": 750706,
	"./Audio/brite.mp3": 902831,
	"./Audio/broadcast.mp3": 299102,
	"./Audio/brochure.mp3": 742877,
	"./Audio/brock.mp3": 921174,
	"./Audio/broke.mp3": 589352,
	"./Audio/broom.mp3": 409716,
	"./Audio/brote.mp3": 756385,
	"./Audio/broth.mp3": 174792,
	"./Audio/brother.mp3": 265633,
	"./Audio/brought.mp3": 8568,
	"./Audio/brow.mp3": 14687,
	"./Audio/brown.mp3": 530851,
	"./Audio/bruch.mp3": 741847,
	"./Audio/bruf.mp3": 88492,
	"./Audio/brug.mp3": 450801,
	"./Audio/bruise.mp3": 680783,
	"./Audio/brung.mp3": 382239,
	"./Audio/brus.mp3": 747781,
	"./Audio/brush.mp3": 2599,
	"./Audio/bruss.mp3": 974184,
	"./Audio/brute.mp3": 104179,
	"./Audio/bucket.mp3": 601767,
	"./Audio/bud.mp3": 628310,
	"./Audio/bug.mp3": 874697,
	"./Audio/buil.mp3": 372937,
	"./Audio/build.mp3": 281439,
	"./Audio/builder.mp3": 235782,
	"./Audio/building.mp3": 613329,
	"./Audio/bulb.mp3": 190336,
	"./Audio/bulge.mp3": 978626,
	"./Audio/bull.mp3": 848886,
	"./Audio/bullies.mp3": 396851,
	"./Audio/bult.mp3": 872638,
	"./Audio/bume.mp3": 302424,
	"./Audio/bump.mp3": 840777,
	"./Audio/bun.mp3": 905500,
	"./Audio/burger.mp3": 54050,
	"./Audio/burn.mp3": 889254,
	"./Audio/burp.mp3": 116064,
	"./Audio/bursar.mp3": 737322,
	"./Audio/burst.mp3": 669361,
	"./Audio/bury.mp3": 233261,
	"./Audio/bus.mp3": 542717,
	"./Audio/bush.mp3": 28287,
	"./Audio/busier.mp3": 201503,
	"./Audio/busiest.mp3": 135050,
	"./Audio/busily.mp3": 294651,
	"./Audio/business.mp3": 437195,
	"./Audio/buss.mp3": 825392,
	"./Audio/busses.mp3": 53764,
	"./Audio/bustle.mp3": 579846,
	"./Audio/busy.mp3": 328042,
	"./Audio/but.mp3": 913510,
	"./Audio/buww.mp3": 917896,
	"./Audio/buxx.mp3": 446502,
	"./Audio/buy.mp3": 420231,
	"./Audio/buyy.mp3": 256808,
	"./Audio/buzz.mp3": 469394,
	"./Audio/buzzed.mp3": 839537,
	"./Audio/buzzer.mp3": 720439,
	"./Audio/buzzing.mp3": 783238,
	"./Audio/buzzword.mp3": 443726,
	"./Audio/by.mp3": 944898,
	"./Audio/c.mp3": 977168,
	"./Audio/ca.mp3": 797309,
	"./Audio/cable.mp3": 318312,
	"./Audio/cach.mp3": 988384,
	"./Audio/cack.mp3": 243575,
	"./Audio/cad.mp3": 384787,
	"./Audio/caddot.mp3": 762792,
	"./Audio/caf.mp3": 617185,
	"./Audio/caffeine.mp3": 958368,
	"./Audio/cag.mp3": 24412,
	"./Audio/cage.mp3": 127493,
	"./Audio/cai.mp3": 761882,
	"./Audio/caid.mp3": 635098,
	"./Audio/caik.mp3": 879905,
	"./Audio/cail.mp3": 340594,
	"./Audio/cain.mp3": 979424,
	"./Audio/cair.mp3": 504244,
	"./Audio/cais.mp3": 464089,
	"./Audio/cait.mp3": 643818,
	"./Audio/cake.mp3": 108353,
	"./Audio/cakkok.mp3": 104317,
	"./Audio/calendar.mp3": 989847,
	"./Audio/calf.mp3": 118055,
	"./Audio/call.mp3": 158941,
	"./Audio/called.mp3": 19662,
	"./Audio/calm.mp3": 546424,
	"./Audio/cam.mp3": 77846,
	"./Audio/came.mp3": 291275,
	"./Audio/camel.mp3": 719373,
	"./Audio/camp.mp3": 476314,
	"./Audio/can't.mp3": 611564,
	"./Audio/can.mp3": 993609,
	"./Audio/cancel.mp3": 129019,
	"./Audio/cant.mp3": 486703,
	"./Audio/caods.mp3": 245783,
	"./Audio/caol.mp3": 262416,
	"./Audio/cap.mp3": 539143,
	"./Audio/capable.mp3": 706455,
	"./Audio/capacity.mp3": 611889,
	"./Audio/capital.mp3": 349135,
	"./Audio/capitalise.mp3": 525604,
	"./Audio/captive.mp3": 274061,
	"./Audio/captop.mp3": 154272,
	"./Audio/capture.mp3": 948549,
	"./Audio/car rote.mp3": 916371,
	"./Audio/car's.mp3": 947835,
	"./Audio/car.mp3": 6165,
	"./Audio/car_s.mp3": 266035,
	"./Audio/card.mp3": 559579,
	"./Audio/care.mp3": 266550,
	"./Audio/careful.mp3": 231419,
	"./Audio/carefully.mp3": 381578,
	"./Audio/careless.mp3": 289437,
	"./Audio/carelessness.mp3": 929636,
	"./Audio/cargais.mp3": 610501,
	"./Audio/cargays.mp3": 843125,
	"./Audio/cargees.mp3": 656373,
	"./Audio/cargoes.mp3": 274323,
	"./Audio/cargows.mp3": 577685,
	"./Audio/cargoys.mp3": 390023,
	"./Audio/carnivorous.mp3": 194046,
	"./Audio/carriage.mp3": 678519,
	"./Audio/carriages.mp3": 304450,
	"./Audio/carries.mp3": 654682,
	"./Audio/carrot.mp3": 465416,
	"./Audio/carry.mp3": 702602,
	"./Audio/cars'.mp3": 534019,
	"./Audio/cars_.mp3": 680187,
	"./Audio/cart.mp3": 33387,
	"./Audio/cas.mp3": 209072,
	"./Audio/case.mp3": 664057,
	"./Audio/casework.mp3": 603326,
	"./Audio/cash.mp3": 838992,
	"./Audio/cast.mp3": 7556,
	"./Audio/castle.mp3": 35513,
	"./Audio/castles.mp3": 331140,
	"./Audio/casual.mp3": 350558,
	"./Audio/casually.mp3": 470279,
	"./Audio/casualty.mp3": 130735,
	"./Audio/cat's.mp3": 672409,
	"./Audio/cat.mp3": 390947,
	"./Audio/cat_s.mp3": 751313,
	"./Audio/catalogue.mp3": 947140,
	"./Audio/catch.mp3": 77506,
	"./Audio/catches.mp3": 982274,
	"./Audio/category.mp3": 383177,
	"./Audio/cats.mp3": 338854,
	"./Audio/cattot.mp3": 74216,
	"./Audio/caught.mp3": 500037,
	"./Audio/cause.mp3": 535814,
	"./Audio/cautious.mp3": 215190,
	"./Audio/cave.mp3": 361746,
	"./Audio/cays.mp3": 623081,
	"./Audio/ceb.mp3": 211737,
	"./Audio/ceck.mp3": 452339,
	"./Audio/ceebe.mp3": 59181,
	"./Audio/ceed.mp3": 921418,
	"./Audio/ceeds.mp3": 145289,
	"./Audio/ceek.mp3": 877137,
	"./Audio/ceel.mp3": 720354,
	"./Audio/cees.mp3": 805929,
	"./Audio/ceese.mp3": 579034,
	"./Audio/ceet.mp3": 8698,
	"./Audio/ceff.mp3": 581153,
	"./Audio/ceg.mp3": 923096,
	"./Audio/ceiling.mp3": 593378,
	"./Audio/celebrate.mp3": 440344,
	"./Audio/celebration.mp3": 138003,
	"./Audio/celery.mp3": 626351,
	"./Audio/cell.mp3": 305081,
	"./Audio/cellar.mp3": 128696,
	"./Audio/ceme.mp3": 945527,
	"./Audio/cement.mp3": 646053,
	"./Audio/cemetery.mp3": 54713,
	"./Audio/cemetry.mp3": 911718,
	"./Audio/cent.mp3": 842859,
	"./Audio/centigrade.mp3": 31237,
	"./Audio/centimetre.mp3": 221633,
	"./Audio/centipede.mp3": 712088,
	"./Audio/central.mp3": 494096,
	"./Audio/centrally.mp3": 597993,
	"./Audio/centre.mp3": 612872,
	"./Audio/centred.mp3": 343484,
	"./Audio/centuries.mp3": 330775,
	"./Audio/century.mp3": 122627,
	"./Audio/cep.mp3": 782779,
	"./Audio/cereal.mp3": 110077,
	"./Audio/cert.mp3": 169327,
	"./Audio/certain.mp3": 983481,
	"./Audio/certainly.mp3": 882312,
	"./Audio/certificate.mp3": 458686,
	"./Audio/certificates.mp3": 375717,
	"./Audio/certified.mp3": 198896,
	"./Audio/certify.mp3": 319031,
	"./Audio/certifying.mp3": 650105,
	"./Audio/certitude.mp3": 83896,
	"./Audio/ces.mp3": 726500,
	"./Audio/cest.mp3": 229032,
	"./Audio/cet.mp3": 91711,
	"./Audio/cewk.mp3": 602335,
	"./Audio/ch -2.mp3": 997865,
	"./Audio/ch -3.mp3": 830852,
	"./Audio/ch .mp3": 198904,
	"./Audio/ch.mp3": 344752,
	"./Audio/chack.mp3": 911831,
	"./Audio/chad.mp3": 788723,
	"./Audio/chai.mp3": 902330,
	"./Audio/chaik.mp3": 858049,
	"./Audio/chaim.mp3": 29719,
	"./Audio/chain.mp3": 265472,
	"./Audio/chair.mp3": 813268,
	"./Audio/chak.mp3": 674152,
	"./Audio/chalet.mp3": 491780,
	"./Audio/chalk.mp3": 948966,
	"./Audio/chall.mp3": 578173,
	"./Audio/challenge.mp3": 40196,
	"./Audio/cham.mp3": 243958,
	"./Audio/chame.mp3": 658923,
	"./Audio/champ.mp3": 550458,
	"./Audio/champagne.mp3": 171969,
	"./Audio/championship.mp3": 873606,
	"./Audio/chan.mp3": 215913,
	"./Audio/chance.mp3": 572765,
	"./Audio/change.mp3": 837377,
	"./Audio/changeable.mp3": 261909,
	"./Audio/chaos.mp3": 246907,
	"./Audio/chapel.mp3": 68216,
	"./Audio/character.mp3": 767670,
	"./Audio/charge.mp3": 507741,
	"./Audio/chark.mp3": 799008,
	"./Audio/charl.mp3": 110291,
	"./Audio/chart.mp3": 328523,
	"./Audio/chase.mp3": 252441,
	"./Audio/chass.mp3": 132415,
	"./Audio/chat.mp3": 378627,
	"./Audio/chauffeur.mp3": 295086,
	"./Audio/chaw.mp3": 255436,
	"./Audio/chawn.mp3": 426410,
	"./Audio/chay.mp3": 815050,
	"./Audio/che.mp3": 382713,
	"./Audio/chead.mp3": 140918,
	"./Audio/cheal.mp3": 979630,
	"./Audio/cheat.mp3": 968646,
	"./Audio/check.mp3": 234963,
	"./Audio/ched.mp3": 51055,
	"./Audio/chee.mp3": 825418,
	"./Audio/cheek.mp3": 714545,
	"./Audio/cheem.mp3": 162695,
	"./Audio/cheen.mp3": 44528,
	"./Audio/cheer.mp3": 882212,
	"./Audio/cheerful.mp3": 766033,
	"./Audio/cheese.mp3": 879290,
	"./Audio/chef.mp3": 270173,
	"./Audio/cheff.mp3": 75649,
	"./Audio/cheg.mp3": 657656,
	"./Audio/chelf.mp3": 566691,
	"./Audio/chell.mp3": 893465,
	"./Audio/chem.mp3": 624354,
	"./Audio/cheme.mp3": 740631,
	"./Audio/chemist.mp3": 543550,
	"./Audio/chen.mp3": 60981,
	"./Audio/cheque.mp3": 855856,
	"./Audio/cherry.mp3": 105806,
	"./Audio/chese.mp3": 260093,
	"./Audio/chess.mp3": 217851,
	"./Audio/chest.mp3": 634056,
	"./Audio/chew.mp3": 141992,
	"./Audio/chick.mp3": 890463,
	"./Audio/chicken.mp3": 158994,
	"./Audio/chid.mp3": 156027,
	"./Audio/chief's.mp3": 446362,
	"./Audio/chief.mp3": 443060,
	"./Audio/chiff.mp3": 754701,
	"./Audio/chift.mp3": 973807,
	"./Audio/chigh.mp3": 251468,
	"./Audio/chil.mp3": 895251,
	"./Audio/child's.mp3": 817187,
	"./Audio/child.mp3": 330301,
	"./Audio/childhood.mp3": 824623,
	"./Audio/childishness.mp3": 165222,
	"./Audio/children's.mp3": 199954,
	"./Audio/children.mp3": 320588,
	"./Audio/chill.mp3": 370389,
	"./Audio/chilly.mp3": 46306,
	"./Audio/chim.mp3": 397006,
	"./Audio/chime.mp3": 705331,
	"./Audio/chimnair.mp3": 311584,
	"./Audio/chimnar.mp3": 58825,
	"./Audio/chimnay.mp3": 137486,
	"./Audio/chimney.mp3": 521002,
	"./Audio/chimnoy.mp3": 923368,
	"./Audio/chimp.mp3": 556770,
	"./Audio/chin.mp3": 801,
	"./Audio/chink.mp3": 528404,
	"./Audio/chip.mp3": 938767,
	"./Audio/chips.mp3": 757130,
	"./Audio/chirl.mp3": 540859,
	"./Audio/chirp.mp3": 765063,
	"./Audio/chirt.mp3": 159395,
	"./Audio/chis.mp3": 296344,
	"./Audio/chise.mp3": 769329,
	"./Audio/chit.mp3": 629835,
	"./Audio/choad.mp3": 111896,
	"./Audio/choak.mp3": 716963,
	"./Audio/choal.mp3": 51440,
	"./Audio/choan.mp3": 587650,
	"./Audio/chob.mp3": 773979,
	"./Audio/chock.mp3": 108917,
	"./Audio/chocolate.mp3": 279205,
	"./Audio/chod.mp3": 872845,
	"./Audio/choe.mp3": 699240,
	"./Audio/choice.mp3": 313272,
	"./Audio/choin.mp3": 485946,
	"./Audio/chol.mp3": 686949,
	"./Audio/chom.mp3": 636672,
	"./Audio/chome.mp3": 288937,
	"./Audio/chomp.mp3": 262840,
	"./Audio/choo.mp3": 896402,
	"./Audio/choon.mp3": 546808,
	"./Audio/choose.mp3": 306306,
	"./Audio/chop.mp3": 756665,
	"./Audio/chore.mp3": 609632,
	"./Audio/chorl.mp3": 726829,
	"./Audio/chorn.mp3": 363775,
	"./Audio/chort.mp3": 899093,
	"./Audio/chorus.mp3": 547807,
	"./Audio/chose.mp3": 677851,
	"./Audio/chow.mp3": 382666,
	"./Audio/chowl.mp3": 308290,
	"./Audio/chown.mp3": 772080,
	"./Audio/choy.mp3": 433548,
	"./Audio/chrill.mp3": 567699,
	"./Audio/christmas.mp3": 46075,
	"./Audio/chronic.mp3": 942173,
	"./Audio/chronicle.mp3": 772208,
	"./Audio/chronography.mp3": 533313,
	"./Audio/chronological.mp3": 775869,
	"./Audio/chud.mp3": 888383,
	"./Audio/chug.mp3": 995656,
	"./Audio/chume.mp3": 741063,
	"./Audio/chump.mp3": 604814,
	"./Audio/chunk.mp3": 297488,
	"./Audio/chup.mp3": 53259,
	"./Audio/church.mp3": 741884,
	"./Audio/chuse.mp3": 321997,
	"./Audio/chute.mp3": 23300,
	"./Audio/chuzz.mp3": 699129,
	"./Audio/cib.mp3": 562829,
	"./Audio/cibe.mp3": 50814,
	"./Audio/cick.mp3": 69247,
	"./Audio/cicken.mp3": 608114,
	"./Audio/ciff.mp3": 506605,
	"./Audio/cig.mp3": 273796,
	"./Audio/cim.mp3": 823918,
	"./Audio/cime.mp3": 194003,
	"./Audio/cimney.mp3": 355466,
	"./Audio/cin.mp3": 792385,
	"./Audio/cip.mp3": 781935,
	"./Audio/circa.mp3": 627917,
	"./Audio/circadian.mp3": 486013,
	"./Audio/circle.mp3": 655141,
	"./Audio/circuit.mp3": 21358,
	"./Audio/circular.mp3": 17338,
	"./Audio/circulation.mp3": 374294,
	"./Audio/circumference.mp3": 337924,
	"./Audio/circumnavigate.mp3": 258995,
	"./Audio/circumstance.mp3": 310454,
	"./Audio/circus.mp3": 688516,
	"./Audio/cirp.mp3": 84583,
	"./Audio/ciss.mp3": 24535,
	"./Audio/cit.mp3": 752043,
	"./Audio/cities.mp3": 336464,
	"./Audio/city.mp3": 933556,
	"./Audio/civil.mp3": 31686,
	"./Audio/cix.mp3": 960167,
	"./Audio/ciz.mp3": 665013,
	"./Audio/claird.mp3": 601660,
	"./Audio/clais.mp3": 620589,
	"./Audio/clamp.mp3": 325094,
	"./Audio/clang.mp3": 261868,
	"./Audio/clank.mp3": 530968,
	"./Audio/clap.mp3": 908899,
	"./Audio/clapping.mp3": 996831,
	"./Audio/clar.mp3": 66417,
	"./Audio/clard.mp3": 769367,
	"./Audio/clas.mp3": 220460,
	"./Audio/clash.mp3": 462804,
	"./Audio/clasp.mp3": 222716,
	"./Audio/class.mp3": 304051,
	"./Audio/classes.mp3": 778455,
	"./Audio/classroom.mp3": 73166,
	"./Audio/claw.mp3": 396400,
	"./Audio/claws.mp3": 62559,
	"./Audio/clay.mp3": 524198,
	"./Audio/clean.mp3": 369056,
	"./Audio/clear.mp3": 893876,
	"./Audio/cled.mp3": 126971,
	"./Audio/clee.mp3": 101782,
	"./Audio/clep.mp3": 909711,
	"./Audio/clew.mp3": 265460,
	"./Audio/cley.mp3": 769218,
	"./Audio/click.mp3": 10643,
	"./Audio/clied.mp3": 992234,
	"./Audio/cliff.mp3": 851329,
	"./Audio/climb.mp3": 33596,
	"./Audio/climbing.mp3": 267860,
	"./Audio/cling.mp3": 899940,
	"./Audio/clip.mp3": 187675,
	"./Audio/cload.mp3": 460284,
	"./Audio/clock.mp3": 186081,
	"./Audio/clod.mp3": 949705,
	"./Audio/cloid.mp3": 852644,
	"./Audio/clois.mp3": 175311,
	"./Audio/closure.mp3": 643860,
	"./Audio/cloth.mp3": 988835,
	"./Audio/clothe.mp3": 566344,
	"./Audio/clothes.mp3": 716839,
	"./Audio/cloud.mp3": 3624,
	"./Audio/clow.mp3": 504870,
	"./Audio/clows.mp3": 290749,
	"./Audio/cloy.mp3": 377072,
	"./Audio/clu.mp3": 323365,
	"./Audio/cluck.mp3": 909839,
	"./Audio/clud.mp3": 187595,
	"./Audio/clue.mp3": 947622,
	"./Audio/clueless.mp3": 793805,
	"./Audio/cluid.mp3": 506162,
	"./Audio/clump.mp3": 288498,
	"./Audio/clumsy.mp3": 626450,
	"./Audio/clung.mp3": 11264,
	"./Audio/clutch.mp3": 17610,
	"./Audio/co-author.mp3": 912605,
	"./Audio/co-exist.mp3": 218525,
	"./Audio/co-operate.mp3": 560548,
	"./Audio/co-operation.mp3": 528583,
	"./Audio/co-ordinate.mp3": 536288,
	"./Audio/co-ordinated.mp3": 320164,
	"./Audio/co-ordinating.mp3": 36773,
	"./Audio/co-own.mp3": 275552,
	"./Audio/co-won.mp3": 212224,
	"./Audio/co.mp3": 526627,
	"./Audio/coa.mp3": 283748,
	"./Audio/coach.mp3": 652809,
	"./Audio/coad.mp3": 472248,
	"./Audio/coak.mp3": 144707,
	"./Audio/coal.mp3": 672592,
	"./Audio/coan.mp3": 922594,
	"./Audio/coarse.mp3": 598782,
	"./Audio/coat.mp3": 956584,
	"./Audio/cob.mp3": 340027,
	"./Audio/cobe.mp3": 630992,
	"./Audio/coconut.mp3": 762718,
	"./Audio/cod.mp3": 401517,
	"./Audio/coes.mp3": 517159,
	"./Audio/coffee.mp3": 207113,
	"./Audio/cognition.mp3": 452315,
	"./Audio/cohesive.mp3": 291165,
	"./Audio/coil.mp3": 169160,
	"./Audio/coin.mp3": 895450,
	"./Audio/coincide.mp3": 47603,
	"./Audio/coincided.mp3": 602653,
	"./Audio/coincidence.mp3": 169399,
	"./Audio/coincidental.mp3": 981254,
	"./Audio/coinciding.mp3": 858970,
	"./Audio/coint.mp3": 938346,
	"./Audio/cok.mp3": 581006,
	"./Audio/col.mp3": 413061,
	"./Audio/cold.mp3": 835051,
	"./Audio/collaborate.mp3": 231667,
	"./Audio/colleague.mp3": 72270,
	"./Audio/collection.mp3": 442093,
	"./Audio/collision.mp3": 86371,
	"./Audio/colocate.mp3": 717409,
	"./Audio/colourful.mp3": 208474,
	"./Audio/column.mp3": 170391,
	"./Audio/com.mp3": 284320,
	"./Audio/comb.mp3": 570586,
	"./Audio/combine.mp3": 694860,
	"./Audio/come.mp3": 132937,
	"./Audio/comfort.mp3": 906055,
	"./Audio/comfortable.mp3": 849623,
	"./Audio/comforted.mp3": 585008,
	"./Audio/comforting.mp3": 147945,
	"./Audio/comically.mp3": 445026,
	"./Audio/coming.mp3": 266656,
	"./Audio/commence.mp3": 942556,
	"./Audio/commentary.mp3": 341318,
	"./Audio/committed.mp3": 68181,
	"./Audio/committee.mp3": 787440,
	"./Audio/common.mp3": 378822,
	"./Audio/communicate.mp3": 110648,
	"./Audio/communicated.mp3": 919628,
	"./Audio/communicating.mp3": 263133,
	"./Audio/communicative.mp3": 470599,
	"./Audio/communities.mp3": 755656,
	"./Audio/community.mp3": 31564,
	"./Audio/comp.mp3": 594584,
	"./Audio/companion.mp3": 819933,
	"./Audio/company.mp3": 386774,
	"./Audio/compere.mp3": 639538,
	"./Audio/compete.mp3": 190572,
	"./Audio/competency.mp3": 294286,
	"./Audio/competent.mp3": 523226,
	"./Audio/competing.mp3": 108169,
	"./Audio/competition.mp3": 562798,
	"./Audio/complate.mp3": 813508,
	"./Audio/complement.mp3": 951865,
	"./Audio/complete.mp3": 842936,
	"./Audio/completed.mp3": 117836,
	"./Audio/completely.mp3": 173681,
	"./Audio/completing.mp3": 399389,
	"./Audio/completion.mp3": 145267,
	"./Audio/compliment.mp3": 83949,
	"./Audio/complite.mp3": 76700,
	"./Audio/complote.mp3": 393650,
	"./Audio/composing.mp3": 26474,
	"./Audio/composition.mp3": 160213,
	"./Audio/composure.mp3": 216240,
	"./Audio/compound.mp3": 582494,
	"./Audio/comprehension.mp3": 634203,
	"./Audio/computer.mp3": 153598,
	"./Audio/conceive.mp3": 716179,
	"./Audio/concentrate.mp3": 464743,
	"./Audio/concentrated.mp3": 518577,
	"./Audio/concentrating.mp3": 367430,
	"./Audio/concentration.mp3": 386400,
	"./Audio/concerned.mp3": 412180,
	"./Audio/conclusion.mp3": 202312,
	"./Audio/confession.mp3": 631792,
	"./Audio/confide.mp3": 90713,
	"./Audio/confidence.mp3": 435617,
	"./Audio/confident.mp3": 30315,
	"./Audio/confidential.mp3": 300007,
	"./Audio/confused.mp3": 445520,
	"./Audio/confusion.mp3": 200607,
	"./Audio/congested.mp3": 19269,
	"./Audio/congratulation.mp3": 946407,
	"./Audio/connected.mp3": 469482,
	"./Audio/connecting.mp3": 89343,
	"./Audio/conquer.mp3": 74868,
	"./Audio/conquest.mp3": 458495,
	"./Audio/conquests.mp3": 291002,
	"./Audio/conscience.mp3": 293535,
	"./Audio/conscientious.mp3": 118201,
	"./Audio/conscious.mp3": 709345,
	"./Audio/consequential.mp3": 228710,
	"./Audio/consider.mp3": 106312,
	"./Audio/considerable.mp3": 593104,
	"./Audio/considerably.mp3": 761668,
	"./Audio/considerate.mp3": 361232,
	"./Audio/consideration.mp3": 113787,
	"./Audio/consonant.mp3": 638320,
	"./Audio/conspire.mp3": 67876,
	"./Audio/construction.mp3": 228014,
	"./Audio/constructive.mp3": 237678,
	"./Audio/constructure.mp3": 172654,
	"./Audio/consumer.mp3": 439429,
	"./Audio/cont.mp3": 214897,
	"./Audio/content.mp3": 581372,
	"./Audio/contentious.mp3": 983012,
	"./Audio/contest.mp3": 146231,
	"./Audio/contestant.mp3": 622398,
	"./Audio/continar.mp3": 913169,
	"./Audio/continay.mp3": 697734,
	"./Audio/continear.mp3": 376468,
	"./Audio/continow.mp3": 678406,
	"./Audio/continue.mp3": 121158,
	"./Audio/continuous.mp3": 309928,
	"./Audio/contract.mp3": 823611,
	"./Audio/contradict.mp3": 285274,
	"./Audio/contradicted.mp3": 785977,
	"./Audio/contradicting.mp3": 503102,
	"./Audio/contrarian.mp3": 348416,
	"./Audio/contrary.mp3": 762245,
	"./Audio/contrast.mp3": 710603,
	"./Audio/contribute.mp3": 10108,
	"./Audio/control.mp3": 187332,
	"./Audio/controversial.mp3": 311652,
	"./Audio/controversy.mp3": 814527,
	"./Audio/convenience.mp3": 277482,
	"./Audio/convenient.mp3": 477274,
	"./Audio/conveniently.mp3": 167739,
	"./Audio/conversation.mp3": 73028,
	"./Audio/convey.mp3": 2845,
	"./Audio/cood.mp3": 837954,
	"./Audio/coods.mp3": 948977,
	"./Audio/cook.mp3": 624665,
	"./Audio/cool.mp3": 499946,
	"./Audio/coose.mp3": 89058,
	"./Audio/cop.mp3": 768985,
	"./Audio/copied.mp3": 130669,
	"./Audio/copier.mp3": 389963,
	"./Audio/copies.mp3": 329190,
	"./Audio/copilot.mp3": 83479,
	"./Audio/copying.mp3": 60442,
	"./Audio/cor.mp3": 813835,
	"./Audio/cord.mp3": 994853,
	"./Audio/cordial.mp3": 139029,
	"./Audio/cords.mp3": 944648,
	"./Audio/core.mp3": 944576,
	"./Audio/cork.mp3": 119478,
	"./Audio/corl.mp3": 697101,
	"./Audio/coronation.mp3": 397491,
	"./Audio/corporal.mp3": 433909,
	"./Audio/corporation.mp3": 936257,
	"./Audio/corpse.mp3": 615989,
	"./Audio/correspond.mp3": 862250,
	"./Audio/correspondence.mp3": 378939,
	"./Audio/corrupt.mp3": 852692,
	"./Audio/cot.mp3": 686717,
	"./Audio/cough.mp3": 884641,
	"./Audio/could.mp3": 115944,
	"./Audio/couldn't.mp3": 176447,
	"./Audio/couldnt.mp3": 461334,
	"./Audio/count.mp3": 290214,
	"./Audio/country.mp3": 267821,
	"./Audio/couple.mp3": 371717,
	"./Audio/coupon.mp3": 676615,
	"./Audio/courage.mp3": 154559,
	"./Audio/courageous.mp3": 654902,
	"./Audio/course.mp3": 547682,
	"./Audio/courteous.mp3": 889886,
	"./Audio/cousin.mp3": 581942,
	"./Audio/cover.mp3": 762454,
	"./Audio/cow.mp3": 948714,
	"./Audio/cowl.mp3": 931554,
	"./Audio/cown.mp3": 681552,
	"./Audio/coworker.mp3": 79329,
	"./Audio/coys.mp3": 641971,
	"./Audio/crab.mp3": 816067,
	"./Audio/crack.mp3": 310173,
	"./Audio/craft.mp3": 409249,
	"./Audio/craftsmanship.mp3": 918086,
	"./Audio/crail.mp3": 56352,
	"./Audio/crairon.mp3": 185501,
	"./Audio/crairs.mp3": 747197,
	"./Audio/cral.mp3": 60573,
	"./Audio/cramp.mp3": 882432,
	"./Audio/craon.mp3": 507824,
	"./Audio/crars.mp3": 200694,
	"./Audio/crash.mp3": 997037,
	"./Audio/crashes.mp3": 912122,
	"./Audio/craw.mp3": 613202,
	"./Audio/crawl.mp3": 772490,
	"./Audio/crayon.mp3": 464299,
	"./Audio/crazy.mp3": 474148,
	"./Audio/crazy2.mp3": 972150,
	"./Audio/cream.mp3": 358201,
	"./Audio/creation.mp3": 553166,
	"./Audio/creative.mp3": 562830,
	"./Audio/creature.mp3": 14158,
	"./Audio/creatures.mp3": 359733,
	"./Audio/cree.mp3": 118932,
	"./Audio/creede.mp3": 684801,
	"./Audio/creeon.mp3": 78715,
	"./Audio/creep.mp3": 783924,
	"./Audio/crepe.mp3": 190206,
	"./Audio/crept.mp3": 896947,
	"./Audio/cres.mp3": 73786,
	"./Audio/crescent.mp3": 870580,
	"./Audio/cresh.mp3": 222126,
	"./Audio/cress.mp3": 328505,
	"./Audio/crest.mp3": 954506,
	"./Audio/crew.mp3": 229686,
	"./Audio/crib.mp3": 583627,
	"./Audio/cride.mp3": 597134,
	"./Audio/cried.mp3": 222316,
	"./Audio/cries.mp3": 491703,
	"./Audio/crisp.mp3": 389210,
	"./Audio/criss.mp3": 850733,
	"./Audio/critically.mp3": 234615,
	"./Audio/criticise.mp3": 299494,
	"./Audio/critique.mp3": 161545,
	"./Audio/croas.mp3": 503561,
	"./Audio/crob.mp3": 101469,
	"./Audio/crock.mp3": 734639,
	"./Audio/crode.mp3": 784608,
	"./Audio/croil.mp3": 669882,
	"./Audio/croo.mp3": 250124,
	"./Audio/cross.mp3": 29767,
	"./Audio/crow.mp3": 43588,
	"./Audio/crowl.mp3": 379440,
	"./Audio/crucial.mp3": 698272,
	"./Audio/crude.mp3": 664858,
	"./Audio/cruel.mp3": 106992,
	"./Audio/cruelly.mp3": 692297,
	"./Audio/cruise.mp3": 343844,
	"./Audio/crumb.mp3": 205486,
	"./Audio/crush.mp3": 152862,
	"./Audio/crust.mp3": 999386,
	"./Audio/cry.mp3": 372323,
	"./Audio/crying.mp3": 109165,
	"./Audio/cryptically.mp3": 666053,
	"./Audio/crystal.mp3": 696657,
	"./Audio/cub.mp3": 380585,
	"./Audio/cube.mp3": 110106,
	"./Audio/cuck.mp3": 64739,
	"./Audio/cud.mp3": 679967,
	"./Audio/cuff.mp3": 288273,
	"./Audio/cug.mp3": 838824,
	"./Audio/cuhe.mp3": 893880,
	"./Audio/cuhh.mp3": 627857,
	"./Audio/cuil.mp3": 435734,
	"./Audio/cuin.mp3": 947172,
	"./Audio/cuint.mp3": 147880,
	"./Audio/cum.mp3": 824082,
	"./Audio/cume.mp3": 76711,
	"./Audio/cump.mp3": 93486,
	"./Audio/cun.mp3": 130981,
	"./Audio/cup.mp3": 175467,
	"./Audio/cupboard.mp3": 95029,
	"./Audio/cupid.mp3": 525432,
	"./Audio/cupp.mp3": 789169,
	"./Audio/curable.mp3": 467357,
	"./Audio/curds.mp3": 314922,
	"./Audio/cure.mp3": 239754,
	"./Audio/curiosity.mp3": 925000,
	"./Audio/curious.mp3": 315193,
	"./Audio/curl.mp3": 643623,
	"./Audio/currency.mp3": 288576,
	"./Audio/curve.mp3": 591294,
	"./Audio/cuss.mp3": 333195,
	"./Audio/cute.mp3": 488996,
	"./Audio/cutting.mp3": 755295,
	"./Audio/cuzz.mp3": 298009,
	"./Audio/cycle.mp3": 500653,
	"./Audio/cycled.mp3": 682339,
	"./Audio/cycling.mp3": 40956,
	"./Audio/cyclist.mp3": 165776,
	"./Audio/cyclists.mp3": 640127,
	"./Audio/cyclone.mp3": 285776,
	"./Audio/cyclones.mp3": 356031,
	"./Audio/cygnet.mp3": 60929,
	"./Audio/d -2.mp3": 80092,
	"./Audio/d -3.mp3": 215393,
	"./Audio/d.mp3": 932931,
	"./Audio/da.mp3": 399812,
	"./Audio/dab.mp3": 471782,
	"./Audio/dack.mp3": 26422,
	"./Audio/dact.mp3": 349429,
	"./Audio/dad.mp3": 894616,
	"./Audio/daft.mp3": 643194,
	"./Audio/dag.mp3": 537039,
	"./Audio/daib.mp3": 842561,
	"./Audio/dail.mp3": 823071,
	"./Audio/dain.mp3": 613005,
	"./Audio/daip.mp3": 170051,
	"./Audio/dair.mp3": 78545,
	"./Audio/daish.mp3": 972404,
	"./Audio/dait.mp3": 526695,
	"./Audio/dal .mp3": 470968,
	"./Audio/dalha.mp3": 719229,
	"./Audio/dall.mp3": 174412,
	"./Audio/dalpa.mp3": 874757,
	"./Audio/dalpha.mp3": 269541,
	"./Audio/dalra.mp3": 739931,
	"./Audio/dam.mp3": 141077,
	"./Audio/damage.mp3": 656766,
	"./Audio/damp.mp3": 380399,
	"./Audio/dan.mp3": 396546,
	"./Audio/dance.mp3": 164194,
	"./Audio/dangerous.mp3": 148511,
	"./Audio/danoa.mp3": 60226,
	"./Audio/danor.mp3": 491013,
	"./Audio/danow.mp3": 823004,
	"./Audio/danuhe.mp3": 916014,
	"./Audio/danure.mp3": 505596,
	"./Audio/dap.mp3": 698020,
	"./Audio/dar.mp3": 186582,
	"./Audio/dare.mp3": 277771,
	"./Audio/darel.mp3": 961357,
	"./Audio/dark.mp3": 707093,
	"./Audio/darn.mp3": 734060,
	"./Audio/das.mp3": 754299,
	"./Audio/dash.mp3": 363001,
	"./Audio/dask.mp3": 729286,
	"./Audio/daslake.mp3": 721674,
	"./Audio/dass.mp3": 740270,
	"./Audio/dat.mp3": 170504,
	"./Audio/date.mp3": 772673,
	"./Audio/daub.mp3": 479765,
	"./Audio/daughter.mp3": 223633,
	"./Audio/daul.mp3": 566795,
	"./Audio/daunt.mp3": 499199,
	"./Audio/daw.mp3": 63231,
	"./Audio/dawn.mp3": 41987,
	"./Audio/day.mp3": 599073,
	"./Audio/de.mp3": 541416,
	"./Audio/dead.mp3": 228523,
	"./Audio/deadly.mp3": 998618,
	"./Audio/dear.mp3": 396109,
	"./Audio/debris.mp3": 735124,
	"./Audio/decade.mp3": 787229,
	"./Audio/decagon.mp3": 16176,
	"./Audio/decathlon.mp3": 43439,
	"./Audio/deceased.mp3": 648843,
	"./Audio/deceit.mp3": 912943,
	"./Audio/deceitful.mp3": 19644,
	"./Audio/deceive.mp3": 78510,
	"./Audio/december.mp3": 916200,
	"./Audio/decency.mp3": 392190,
	"./Audio/decent.mp3": 70058,
	"./Audio/decide.mp3": 960613,
	"./Audio/decided.mp3": 804171,
	"./Audio/decision.mp3": 186463,
	"./Audio/decisive.mp3": 450227,
	"./Audio/deckon.mp3": 82641,
	"./Audio/decode.mp3": 285115,
	"./Audio/decompose.mp3": 425716,
	"./Audio/decoration.mp3": 464891,
	"./Audio/decrease.mp3": 462933,
	"./Audio/ded.mp3": 995932,
	"./Audio/dee.mp3": 588705,
	"./Audio/deen.mp3": 649373,
	"./Audio/deep.mp3": 847667,
	"./Audio/deer.mp3": 593729,
	"./Audio/deesh.mp3": 62980,
	"./Audio/deet.mp3": 249047,
	"./Audio/defeated.mp3": 905175,
	"./Audio/defend.mp3": 21297,
	"./Audio/deff.mp3": 313916,
	"./Audio/definite.mp3": 862073,
	"./Audio/deflate.mp3": 479018,
	"./Audio/deflay.mp3": 331760,
	"./Audio/deflo.mp3": 472401,
	"./Audio/defloi.mp3": 219862,
	"./Audio/deflou.mp3": 887298,
	"./Audio/defloy.mp3": 658086,
	"./Audio/deform.mp3": 711554,
	"./Audio/defraud.mp3": 526366,
	"./Audio/defrost.mp3": 238630,
	"./Audio/deft.mp3": 688510,
	"./Audio/defuse.mp3": 842587,
	"./Audio/deg.mp3": 356307,
	"./Audio/degenerate.mp3": 790705,
	"./Audio/dek.mp3": 926015,
	"./Audio/delate.mp3": 478388,
	"./Audio/delete.mp3": 45992,
	"./Audio/delicate.mp3": 117500,
	"./Audio/delicious.mp3": 291076,
	"./Audio/delight.mp3": 383412,
	"./Audio/delite.mp3": 274060,
	"./Audio/delote.mp3": 726946,
	"./Audio/delusion.mp3": 676874,
	"./Audio/dem.mp3": 965129,
	"./Audio/demagogue.mp3": 503001,
	"./Audio/democracy.mp3": 895496,
	"./Audio/demography.mp3": 840729,
	"./Audio/demonstrate.mp3": 176225,
	"./Audio/den.mp3": 49366,
	"./Audio/dense.mp3": 517022,
	"./Audio/dentist.mp3": 168210,
	"./Audio/dentures.mp3": 654295,
	"./Audio/dep.mp3": 696944,
	"./Audio/depart.mp3": 873739,
	"./Audio/department.mp3": 701059,
	"./Audio/dependable.mp3": 137019,
	"./Audio/dephaw.mp3": 117804,
	"./Audio/dephew.mp3": 418952,
	"./Audio/dephoo.mp3": 865458,
	"./Audio/dephow.mp3": 864234,
	"./Audio/deport.mp3": 927957,
	"./Audio/deporting.mp3": 531715,
	"./Audio/depreciate.mp3": 998785,
	"./Audio/depreciating.mp3": 153976,
	"./Audio/depreciation.mp3": 569010,
	"./Audio/depress.mp3": 76377,
	"./Audio/depressed.mp3": 261194,
	"./Audio/depressing.mp3": 248223,
	"./Audio/depth.mp3": 437932,
	"./Audio/der.mp3": 233154,
	"./Audio/derail.mp3": 887928,
	"./Audio/des.mp3": 510663,
	"./Audio/descent.mp3": 217541,
	"./Audio/descray.mp3": 499782,
	"./Audio/describe.mp3": 748010,
	"./Audio/described.mp3": 9866,
	"./Audio/description.mp3": 846745,
	"./Audio/descro.mp3": 304527,
	"./Audio/descroi.mp3": 324800,
	"./Audio/descrou.mp3": 872596,
	"./Audio/descroy.mp3": 772752,
	"./Audio/desert.mp3": 526782,
	"./Audio/desh.mp3": 370013,
	"./Audio/design.mp3": 449495,
	"./Audio/designed.mp3": 872320,
	"./Audio/designer.mp3": 70974,
	"./Audio/desirable.mp3": 833294,
	"./Audio/desk.mp3": 925258,
	"./Audio/desleke.mp3": 686546,
	"./Audio/desperate.mp3": 527776,
	"./Audio/desperately.mp3": 394841,
	"./Audio/desperation.mp3": 74315,
	"./Audio/dessert.mp3": 58801,
	"./Audio/destination.mp3": 882095,
	"./Audio/destroy.mp3": 735373,
	"./Audio/destruct.mp3": 553287,
	"./Audio/destruction.mp3": 334207,
	"./Audio/destructive.mp3": 754835,
	"./Audio/det.mp3": 4652,
	"./Audio/determination.mp3": 166682,
	"./Audio/determine.mp3": 15776,
	"./Audio/determined.mp3": 551972,
	"./Audio/develop.mp3": 877340,
	"./Audio/developed.mp3": 17067,
	"./Audio/developing.mp3": 15348,
	"./Audio/development.mp3": 131448,
	"./Audio/developmental.mp3": 565523,
	"./Audio/device.mp3": 706527,
	"./Audio/devil.mp3": 42945,
	"./Audio/devise.mp3": 880399,
	"./Audio/dew.mp3": 362467,
	"./Audio/dex.mp3": 757400,
	"./Audio/diagonal.mp3": 263932,
	"./Audio/diagram.mp3": 278424,
	"./Audio/dialogue.mp3": 826151,
	"./Audio/diameter.mp3": 745220,
	"./Audio/dice.mp3": 789176,
	"./Audio/dich.mp3": 65681,
	"./Audio/dictation.mp3": 732240,
	"./Audio/dictionary.mp3": 379157,
	"./Audio/did.mp3": 792192,
	"./Audio/didn't.mp3": 486359,
	"./Audio/didnt.mp3": 369502,
	"./Audio/die.mp3": 842469,
	"./Audio/dieb.mp3": 76989,
	"./Audio/died.mp3": 687755,
	"./Audio/diel.mp3": 348835,
	"./Audio/dif.mp3": 51922,
	"./Audio/difference.mp3": 494836,
	"./Audio/different.mp3": 562324,
	"./Audio/difficult.mp3": 997449,
	"./Audio/diffuse.mp3": 806765,
	"./Audio/dig.mp3": 556439,
	"./Audio/digestible.mp3": 174713,
	"./Audio/digestion.mp3": 11550,
	"./Audio/digestive.mp3": 874513,
	"./Audio/digging.mp3": 302714,
	"./Audio/dight.mp3": 844147,
	"./Audio/dim.mp3": 28365,
	"./Audio/din.mp3": 294842,
	"./Audio/dine.mp3": 637151,
	"./Audio/dink.mp3": 172993,
	"./Audio/dinosaur.mp3": 277704,
	"./Audio/dip.mp3": 589068,
	"./Audio/direction.mp3": 84380,
	"./Audio/dirt.mp3": 726830,
	"./Audio/dis.mp3": 559235,
	"./Audio/disable.mp3": 829939,
	"./Audio/disadvantage.mp3": 964622,
	"./Audio/disagree.mp3": 130525,
	"./Audio/disappear.mp3": 607196,
	"./Audio/disappeared.mp3": 25899,
	"./Audio/disappoint.mp3": 598918,
	"./Audio/disapprove.mp3": 863318,
	"./Audio/disaster.mp3": 567384,
	"./Audio/disastrous.mp3": 56144,
	"./Audio/disbelieve.mp3": 691553,
	"./Audio/disbelieving.mp3": 762008,
	"./Audio/disc.mp3": 435702,
	"./Audio/discipline.mp3": 209183,
	"./Audio/disclosure.mp3": 166790,
	"./Audio/discomfort.mp3": 938157,
	"./Audio/disconnect.mp3": 114783,
	"./Audio/discontinue.mp3": 556884,
	"./Audio/discord.mp3": 831383,
	"./Audio/discount.mp3": 546060,
	"./Audio/discounted.mp3": 193179,
	"./Audio/discover.mp3": 344424,
	"./Audio/discretionary.mp3": 205739,
	"./Audio/discuss.mp3": 682037,
	"./Audio/discussion.mp3": 415113,
	"./Audio/disease.mp3": 97953,
	"./Audio/disguise.mp3": 874244,
	"./Audio/dish.mp3": 759233,
	"./Audio/dishonest.mp3": 681438,
	"./Audio/dislike.mp3": 777018,
	"./Audio/dislocate.mp3": 102849,
	"./Audio/disobey.mp3": 523938,
	"./Audio/disorder.mp3": 924953,
	"./Audio/displeasure.mp3": 663262,
	"./Audio/disposed.mp3": 703368,
	"./Audio/dispossess.mp3": 96601,
	"./Audio/dispossessed.mp3": 240970,
	"./Audio/dispossessing.mp3": 705503,
	"./Audio/disqualify.mp3": 195040,
	"./Audio/disrepair.mp3": 639036,
	"./Audio/disrespect.mp3": 66715,
	"./Audio/disrespectful.mp3": 20392,
	"./Audio/disrespecting.mp3": 578421,
	"./Audio/disrupt.mp3": 822956,
	"./Audio/diss.mp3": 263430,
	"./Audio/dissect.mp3": 302158,
	"./Audio/dissolve.mp3": 335072,
	"./Audio/distance.mp3": 980076,
	"./Audio/distract.mp3": 333167,
	"./Audio/distraught.mp3": 478562,
	"./Audio/distrust.mp3": 453731,
	"./Audio/disturbed.mp3": 814489,
	"./Audio/dit.mp3": 87120,
	"./Audio/dive.mp3": 542103,
	"./Audio/diverse.mp3": 524807,
	"./Audio/divide.mp3": 228726,
	"./Audio/divided.mp3": 766982,
	"./Audio/dividend.mp3": 76400,
	"./Audio/dividing.mp3": 538499,
	"./Audio/division.mp3": 785268,
	"./Audio/dizzy.mp3": 918725,
	"./Audio/do.mp3": 526674,
	"./Audio/doa.mp3": 1987,
	"./Audio/doael.mp3": 573860,
	"./Audio/doan.mp3": 686999,
	"./Audio/docc.mp3": 288796,
	"./Audio/dock.mp3": 523044,
	"./Audio/docket.mp3": 314435,
	"./Audio/document.mp3": 31410,
	"./Audio/dod.mp3": 779874,
	"./Audio/dodge.mp3": 151846,
	"./Audio/dodgem.mp3": 58451,
	"./Audio/dodgey.mp3": 212807,
	"./Audio/doe.mp3": 384807,
	"./Audio/doel.mp3": 451033,
	"./Audio/does.mp3": 327538,
	"./Audio/dog.mp3": 216501,
	"./Audio/dogg.mp3": 55204,
	"./Audio/dogs'.mp3": 410659,
	"./Audio/dogs.mp3": 582424,
	"./Audio/dolhin.mp3": 899891,
	"./Audio/doll.mp3": 654658,
	"./Audio/dollar.mp3": 822971,
	"./Audio/dolphin.mp3": 425135,
	"./Audio/dolpin.mp3": 319339,
	"./Audio/dolrin.mp3": 682477,
	"./Audio/dominais.mp3": 954375,
	"./Audio/dominays.mp3": 841367,
	"./Audio/dominees.mp3": 650839,
	"./Audio/dominoes.mp3": 492121,
	"./Audio/dominoys.mp3": 174853,
	"./Audio/don't.mp3": 762973,
	"./Audio/don.mp3": 813176,
	"./Audio/donation.mp3": 318571,
	"./Audio/donkair.mp3": 182309,
	"./Audio/donkar.mp3": 589602,
	"./Audio/donkay.mp3": 82397,
	"./Audio/donkey.mp3": 647617,
	"./Audio/donkoy.mp3": 67567,
	"./Audio/doo.mp3": 425693,
	"./Audio/door.mp3": 22197,
	"./Audio/dop.mp3": 401582,
	"./Audio/dor.mp3": 847100,
	"./Audio/dorel.mp3": 126371,
	"./Audio/dormant.mp3": 296940,
	"./Audio/dorn.mp3": 315962,
	"./Audio/dorr.mp3": 11966,
	"./Audio/dose.mp3": 943682,
	"./Audio/dosloke.mp3": 58078,
	"./Audio/dot.mp3": 494674,
	"./Audio/double.mp3": 491162,
	"./Audio/doubt.mp3": 529617,
	"./Audio/dough.mp3": 803866,
	"./Audio/dow.mp3": 285221,
	"./Audio/dowel.mp3": 842830,
	"./Audio/down.mp3": 778801,
	"./Audio/downstairs.mp3": 387451,
	"./Audio/draft.mp3": 983346,
	"./Audio/dragging.mp3": 8858,
	"./Audio/dragon.mp3": 726700,
	"./Audio/drain.mp3": 592997,
	"./Audio/draird.mp3": 816303,
	"./Audio/drake.mp3": 443792,
	"./Audio/dram.mp3": 980205,
	"./Audio/dramatically.mp3": 735080,
	"./Audio/dran.mp3": 391834,
	"./Audio/drank.mp3": 60577,
	"./Audio/drard.mp3": 881054,
	"./Audio/draught.mp3": 613120,
	"./Audio/draw.mp3": 169095,
	"./Audio/drawn.mp3": 794027,
	"./Audio/dray.mp3": 678297,
	"./Audio/dread.mp3": 930851,
	"./Audio/dream.mp3": 572326,
	"./Audio/dreary.mp3": 955154,
	"./Audio/dred.mp3": 894372,
	"./Audio/dree.mp3": 629321,
	"./Audio/drem.mp3": 795425,
	"./Audio/dress.mp3": 653450,
	"./Audio/dresses.mp3": 544138,
	"./Audio/drew.mp3": 424459,
	"./Audio/drey.mp3": 853781,
	"./Audio/dri.mp3": 264932,
	"./Audio/dried.mp3": 556531,
	"./Audio/dries.mp3": 157968,
	"./Audio/drift.mp3": 951130,
	"./Audio/drill.mp3": 104492,
	"./Audio/drink.mp3": 477033,
	"./Audio/drip.mp3": 464388,
	"./Audio/driss.mp3": 25230,
	"./Audio/drive.mp3": 731999,
	"./Audio/droad.mp3": 922997,
	"./Audio/droin.mp3": 720135,
	"./Audio/dropped.mp3": 338825,
	"./Audio/dropping.mp3": 187246,
	"./Audio/dross.mp3": 464740,
	"./Audio/drought.mp3": 818978,
	"./Audio/drove.mp3": 281649,
	"./Audio/drown.mp3": 731849,
	"./Audio/droy.mp3": 517923,
	"./Audio/drum.mp3": 821713,
	"./Audio/drunk.mp3": 813469,
	"./Audio/dry.mp3": 790324,
	"./Audio/dual.mp3": 391635,
	"./Audio/dub.mp3": 788834,
	"./Audio/ducc.mp3": 36098,
	"./Audio/duch.mp3": 436093,
	"./Audio/duck.mp3": 698090,
	"./Audio/ducket.mp3": 961049,
	"./Audio/duct.mp3": 391649,
	"./Audio/dud.mp3": 430284,
	"./Audio/dude.mp3": 790293,
	"./Audio/due.mp3": 945617,
	"./Audio/duel.mp3": 286207,
	"./Audio/duet.mp3": 870855,
	"./Audio/duf.mp3": 773182,
	"./Audio/duft.mp3": 752110,
	"./Audio/dug.mp3": 553475,
	"./Audio/dugg.mp3": 635706,
	"./Audio/duhe.mp3": 719569,
	"./Audio/dul.mp3": 638676,
	"./Audio/dull.mp3": 38752,
	"./Audio/duly.mp3": 413041,
	"./Audio/dum.mp3": 363897,
	"./Audio/dumb.mp3": 695801,
	"./Audio/dummy.mp3": 447467,
	"./Audio/dump.mp3": 713115,
	"./Audio/dun-2.mp3": 432795,
	"./Audio/dun.mp3": 246534,
	"./Audio/duo.mp3": 185643,
	"./Audio/dup.mp3": 90880,
	"./Audio/duplex.mp3": 17783,
	"./Audio/duplicate.mp3": 634164,
	"./Audio/durable.mp3": 286990,
	"./Audio/duration.mp3": 719409,
	"./Audio/dure.mp3": 158759,
	"./Audio/during.mp3": 340870,
	"./Audio/durr.mp3": 621052,
	"./Audio/dus.mp3": 881303,
	"./Audio/dush.mp3": 792653,
	"./Audio/dustbin.mp3": 692284,
	"./Audio/dut.mp3": 398588,
	"./Audio/e -2.mp3": 765823,
	"./Audio/e -3.mp3": 56858,
	"./Audio/e.mp3": 364542,
	"./Audio/eac.mp3": 396482,
	"./Audio/each.mp3": 988054,
	"./Audio/eager.mp3": 380619,
	"./Audio/eah.mp3": 796477,
	"./Audio/eak.mp3": 58474,
	"./Audio/ear.mp3": 106743,
	"./Audio/earl.mp3": 826313,
	"./Audio/earlier.mp3": 48891,
	"./Audio/early.mp3": 641534,
	"./Audio/earn.mp3": 147643,
	"./Audio/earnings.mp3": 356152,
	"./Audio/earth.mp3": 455451,
	"./Audio/earthquake.mp3": 79042,
	"./Audio/ease.mp3": 824263,
	"./Audio/easily.mp3": 625402,
	"./Audio/eat.mp3": 752033,
	"./Audio/eb.mp3": 683664,
	"./Audio/echo.mp3": 824726,
	"./Audio/ecosystem.mp3": 498731,
	"./Audio/edge.mp3": 218802,
	"./Audio/edited.mp3": 283338,
	"./Audio/education.mp3": 478885,
	"./Audio/ee -2.mp3": 671516,
	"./Audio/ee -3.mp3": 264289,
	"./Audio/ee .mp3": 282345,
	"./Audio/ee.mp3": 698307,
	"./Audio/eech.mp3": 218338,
	"./Audio/eek.mp3": 660078,
	"./Audio/een.mp3": 257687,
	"./Audio/eerie.mp3": 384221,
	"./Audio/eese.mp3": 707547,
	"./Audio/eet.mp3": 684189,
	"./Audio/effect.mp3": 846066,
	"./Audio/effortless.mp3": 947928,
	"./Audio/egg.mp3": 408800,
	"./Audio/eggs.mp3": 504207,
	"./Audio/egypt.mp3": 876346,
	"./Audio/eight.mp3": 101058,
	"./Audio/eighteen.mp3": 866970,
	"./Audio/eighth.mp3": 462358,
	"./Audio/eighty.mp3": 477707,
	"./Audio/either.mp3": 70114,
	"./Audio/ekit.mp3": 41162,
	"./Audio/election.mp3": 683060,
	"./Audio/electrician.mp3": 635208,
	"./Audio/elehant.mp3": 392880,
	"./Audio/elepant.mp3": 867672,
	"./Audio/elephant.mp3": 818858,
	"./Audio/elerant.mp3": 409170,
	"./Audio/eleven.mp3": 209242,
	"./Audio/em.mp3": 330475,
	"./Audio/embarassed.mp3": 586890,
	"./Audio/embarassing.mp3": 240223,
	"./Audio/embarassingly.mp3": 687046,
	"./Audio/embarassment.mp3": 388709,
	"./Audio/embarrass.mp3": 382391,
	"./Audio/embarrassment.mp3": 926607,
	"./Audio/empay.mp3": 960527,
	"./Audio/employ.mp3": 739583,
	"./Audio/empo.mp3": 454056,
	"./Audio/empoi.mp3": 188013,
	"./Audio/empou.mp3": 928753,
	"./Audio/empoy.mp3": 15741,
	"./Audio/emray.mp3": 400129,
	"./Audio/emro.mp3": 520754,
	"./Audio/emroi.mp3": 421579,
	"./Audio/emrou.mp3": 147255,
	"./Audio/emroy.mp3": 947771,
	"./Audio/enclosure.mp3": 226191,
	"./Audio/encounter.mp3": 874736,
	"./Audio/encourage.mp3": 176584,
	"./Audio/encouraged.mp3": 125116,
	"./Audio/end.mp3": 718024,
	"./Audio/endurance.mp3": 260704,
	"./Audio/enduring.mp3": 150087,
	"./Audio/energetically.mp3": 393417,
	"./Audio/energy.mp3": 209201,
	"./Audio/engage.mp3": 887720,
	"./Audio/engineer.mp3": 805538,
	"./Audio/engines.mp3": 777510,
	"./Audio/enjay.mp3": 484472,
	"./Audio/enjo.mp3": 640105,
	"./Audio/enjoi.mp3": 666574,
	"./Audio/enjou.mp3": 34282,
	"./Audio/enjoy.mp3": 52190,
	"./Audio/enjoyable.mp3": 145258,
	"./Audio/enjoyment.mp3": 196382,
	"./Audio/enlighten.mp3": 989301,
	"./Audio/enlightening.mp3": 830947,
	"./Audio/enormous.mp3": 946035,
	"./Audio/enough.mp3": 367293,
	"./Audio/enpay.mp3": 420062,
	"./Audio/enpo.mp3": 825111,
	"./Audio/enpoi.mp3": 879208,
	"./Audio/enpou .mp3": 761836,
	"./Audio/enpoy.mp3": 725496,
	"./Audio/enray.mp3": 592384,
	"./Audio/enro.mp3": 424993,
	"./Audio/enroi.mp3": 555462,
	"./Audio/enrou.mp3": 355090,
	"./Audio/enroy.mp3": 270262,
	"./Audio/ensede.mp3": 951613,
	"./Audio/ensleme.mp3": 180960,
	"./Audio/ensure.mp3": 16255,
	"./Audio/entertainment.mp3": 279533,
	"./Audio/entrance.mp3": 353351,
	"./Audio/enumerate.mp3": 19649,
	"./Audio/envelepe.mp3": 153027,
	"./Audio/envelipe.mp3": 300943,
	"./Audio/envelope.mp3": 249193,
	"./Audio/envelupe.mp3": 503635,
	"./Audio/envious.mp3": 225442,
	"./Audio/environment.mp3": 434092,
	"./Audio/ep.mp3": 979090,
	"./Audio/epidemic.mp3": 19235,
	"./Audio/equal.mp3": 532319,
	"./Audio/equalise.mp3": 293300,
	"./Audio/equidistant.mp3": 367024,
	"./Audio/equilateral.mp3": 158962,
	"./Audio/equip.mp3": 378811,
	"./Audio/equiped.mp3": 798644,
	"./Audio/equiping.mp3": 572437,
	"./Audio/equipment.mp3": 94355,
	"./Audio/equipped.mp3": 340146,
	"./Audio/erit.mp3": 260987,
	"./Audio/esit.mp3": 931714,
	"./Audio/especially.mp3": 390430,
	"./Audio/essential.mp3": 913263,
	"./Audio/evacuate.mp3": 469791,
	"./Audio/eve.mp3": 976805,
	"./Audio/even.mp3": 389041,
	"./Audio/evening.mp3": 778759,
	"./Audio/eventually.mp3": 147894,
	"./Audio/ever.mp3": 674477,
	"./Audio/every.mp3": 307482,
	"./Audio/everybody.mp3": 408902,
	"./Audio/everyone.mp3": 173554,
	"./Audio/everywhere.mp3": 555835,
	"./Audio/evidence.mp3": 775186,
	"./Audio/evil.mp3": 802103,
	"./Audio/exaggerate.mp3": 325120,
	"./Audio/exaggerated.mp3": 216708,
	"./Audio/exaggeration.mp3": 166891,
	"./Audio/exceed.mp3": 133881,
	"./Audio/excel.mp3": 182962,
	"./Audio/exceling.mp3": 929830,
	"./Audio/excellence.mp3": 6651,
	"./Audio/excellent.mp3": 114413,
	"./Audio/except.mp3": 369126,
	"./Audio/excess.mp3": 47780,
	"./Audio/excessive.mp3": 999670,
	"./Audio/excitable.mp3": 866378,
	"./Audio/excite.mp3": 575107,
	"./Audio/excited.mp3": 390861,
	"./Audio/excitement.mp3": 310299,
	"./Audio/exciting.mp3": 593514,
	"./Audio/exclaim.mp3": 244734,
	"./Audio/exclude.mp3": 445209,
	"./Audio/exercise.mp3": 619131,
	"./Audio/exglede.mp3": 590301,
	"./Audio/exglide.mp3": 218833,
	"./Audio/exglode.mp3": 849599,
	"./Audio/exglude.mp3": 437165,
	"./Audio/exhale.mp3": 851386,
	"./Audio/exhilarate.mp3": 838216,
	"./Audio/exist.mp3": 340150,
	"./Audio/existed.mp3": 851909,
	"./Audio/existence.mp3": 274511,
	"./Audio/existing.mp3": 721426,
	"./Audio/exit.mp3": 122381,
	"./Audio/expansion.mp3": 865132,
	"./Audio/expectant.mp3": 494213,
	"./Audio/expectation.mp3": 684813,
	"./Audio/expense.mp3": 658639,
	"./Audio/expensive.mp3": 743172,
	"./Audio/experience.mp3": 655061,
	"./Audio/experienced.mp3": 412443,
	"./Audio/experiences.mp3": 395896,
	"./Audio/experiment.mp3": 5288,
	"./Audio/experimenting.mp3": 633944,
	"./Audio/expert.mp3": 633709,
	"./Audio/expertise.mp3": 668762,
	"./Audio/expertly.mp3": 478804,
	"./Audio/explained.mp3": 257669,
	"./Audio/explaining.mp3": 857170,
	"./Audio/explanation.mp3": 657066,
	"./Audio/explosion.mp3": 815558,
	"./Audio/export.mp3": 227287,
	"./Audio/exporting.mp3": 480089,
	"./Audio/express.mp3": 553971,
	"./Audio/expression.mp3": 764787,
	"./Audio/expressive.mp3": 710023,
	"./Audio/extension.mp3": 47772,
	"./Audio/exterminate.mp3": 430303,
	"./Audio/extermination.mp3": 700456,
	"./Audio/extortionate.mp3": 797857,
	"./Audio/extra-ordinary.mp3": 527172,
	"./Audio/extra.mp3": 474361,
	"./Audio/extraneous.mp3": 21329,
	"./Audio/extraordinary.mp3": 741603,
	"./Audio/extraterrestrial.mp3": 729616,
	"./Audio/extreme.mp3": 429483,
	"./Audio/extremely.mp3": 600218,
	"./Audio/extremities.mp3": 50958,
	"./Audio/extremity.mp3": 347382,
	"./Audio/eye.mp3": 348084,
	"./Audio/eyes.mp3": 846059,
	"./Audio/f-2.mp3": 189492,
	"./Audio/f.mp3": 536977,
	"./Audio/fable.mp3": 115749,
	"./Audio/face.mp3": 930086,
	"./Audio/facial.mp3": 136789,
	"./Audio/fack.mp3": 802288,
	"./Audio/facket.mp3": 358623,
	"./Audio/fact.mp3": 696251,
	"./Audio/fad.mp3": 474670,
	"./Audio/faf.mp3": 403836,
	"./Audio/fag.mp3": 900609,
	"./Audio/fai.mp3": 237919,
	"./Audio/faid.mp3": 404569,
	"./Audio/fail.mp3": 447217,
	"./Audio/faim.mp3": 389356,
	"./Audio/faip.mp3": 706477,
	"./Audio/fair.mp3": 827071,
	"./Audio/fait.mp3": 349833,
	"./Audio/fal.mp3": 966582,
	"./Audio/fall.mp3": 365886,
	"./Audio/falsehood.mp3": 406528,
	"./Audio/falt.mp3": 342134,
	"./Audio/fam.mp3": 928987,
	"./Audio/familiar.mp3": 260100,
	"./Audio/familiarise.mp3": 334741,
	"./Audio/familiarise_2.mp3": 764590,
	"./Audio/families.mp3": 93053,
	"./Audio/family.mp3": 590069,
	"./Audio/famous.mp3": 348205,
	"./Audio/fan.mp3": 382020,
	"./Audio/fancy.mp3": 568148,
	"./Audio/fang.mp3": 768015,
	"./Audio/fantastic.mp3": 798004,
	"./Audio/fao.mp3": 396009,
	"./Audio/faop.mp3": 6667,
	"./Audio/fap.mp3": 336610,
	"./Audio/far.mp3": 86608,
	"./Audio/fare.mp3": 990809,
	"./Audio/farmer.mp3": 556732,
	"./Audio/farmland.mp3": 575574,
	"./Audio/farmland_2.mp3": 951393,
	"./Audio/farmyard.mp3": 827449,
	"./Audio/farst.mp3": 194985,
	"./Audio/fart.mp3": 717476,
	"./Audio/farther.mp3": 127965,
	"./Audio/fascinate.mp3": 323931,
	"./Audio/fashionable.mp3": 602735,
	"./Audio/fass.mp3": 275928,
	"./Audio/fast.mp3": 583243,
	"./Audio/fasten.mp3": 711982,
	"./Audio/fat.mp3": 990334,
	"./Audio/father.mp3": 195183,
	"./Audio/fatherhood.mp3": 973033,
	"./Audio/fatigue.mp3": 288592,
	"./Audio/fatigue_2.mp3": 111131,
	"./Audio/fatter.mp3": 840123,
	"./Audio/fattest.mp3": 162326,
	"./Audio/fault.mp3": 972219,
	"./Audio/fave.mp3": 628373,
	"./Audio/favourable.mp3": 440546,
	"./Audio/favourable_2.mp3": 726933,
	"./Audio/favoured.mp3": 352501,
	"./Audio/favoured_2.mp3": 573966,
	"./Audio/favouring.mp3": 129058,
	"./Audio/favouring_2.mp3": 979285,
	"./Audio/favourite.mp3": 977682,
	"./Audio/favouritism.mp3": 344838,
	"./Audio/favouritism_2.mp3": 941585,
	"./Audio/faw.mp3": 162769,
	"./Audio/fax.mp3": 537674,
	"./Audio/fay.mp3": 763311,
	"./Audio/fe.mp3": 771506,
	"./Audio/fear.mp3": 691851,
	"./Audio/fearless.mp3": 245320,
	"./Audio/feast.mp3": 541606,
	"./Audio/feat.mp3": 81085,
	"./Audio/feather.mp3": 764198,
	"./Audio/feature.mp3": 169929,
	"./Audio/feb.mp3": 466220,
	"./Audio/february.mp3": 9879,
	"./Audio/feck.mp3": 289028,
	"./Audio/fed.mp3": 694722,
	"./Audio/fee.mp3": 972231,
	"./Audio/feebe.mp3": 619692,
	"./Audio/feed.mp3": 512529,
	"./Audio/feek.mp3": 887434,
	"./Audio/feel.mp3": 261433,
	"./Audio/feem.mp3": 205588,
	"./Audio/feep.mp3": 708069,
	"./Audio/feet.mp3": 250369,
	"./Audio/fef.mp3": 158512,
	"./Audio/feg.mp3": 439253,
	"./Audio/fel.mp3": 873066,
	"./Audio/felf.mp3": 226360,
	"./Audio/felfet.mp3": 853959,
	"./Audio/fell.mp3": 193058,
	"./Audio/felt.mp3": 150778,
	"./Audio/fem.mp3": 835215,
	"./Audio/fen.mp3": 735320,
	"./Audio/fence.mp3": 294348,
	"./Audio/fep.mp3": 835982,
	"./Audio/ferocious.mp3": 443778,
	"./Audio/fertilise.mp3": 827448,
	"./Audio/fess.mp3": 244860,
	"./Audio/fet.mp3": 357938,
	"./Audio/fetch.mp3": 439195,
	"./Audio/fete.mp3": 834439,
	"./Audio/feve.mp3": 378313,
	"./Audio/few.mp3": 125509,
	"./Audio/ff.mp3": 539077,
	"./Audio/fib.mp3": 894104,
	"./Audio/fibe.mp3": 81649,
	"./Audio/fic.mp3": 616829,
	"./Audio/ficc.mp3": 797472,
	"./Audio/fich.mp3": 162111,
	"./Audio/fict.mp3": 471715,
	"./Audio/fiction.mp3": 933379,
	"./Audio/fictitious.mp3": 805880,
	"./Audio/fid.mp3": 987622,
	"./Audio/field.mp3": 167043,
	"./Audio/fiend.mp3": 652761,
	"./Audio/fierce.mp3": 741739,
	"./Audio/fiery.mp3": 177676,
	"./Audio/fif.mp3": 222900,
	"./Audio/fiff.mp3": 682746,
	"./Audio/fift.mp3": 300856,
	"./Audio/fifteen.mp3": 372824,
	"./Audio/fig.mp3": 699097,
	"./Audio/figg.mp3": 318360,
	"./Audio/fight.mp3": 540477,
	"./Audio/fights.mp3": 625136,
	"./Audio/fik.mp3": 656917,
	"./Audio/fill.mp3": 90918,
	"./Audio/filthy.mp3": 64579,
	"./Audio/fim.mp3": 594704,
	"./Audio/fin.mp3": 683884,
	"./Audio/final.mp3": 878591,
	"./Audio/finalise.mp3": 929876,
	"./Audio/finally.mp3": 98470,
	"./Audio/find.mp3": 90128,
	"./Audio/fine.mp3": 166261,
	"./Audio/finich.mp3": 238492,
	"./Audio/finif.mp3": 358941,
	"./Audio/finig.mp3": 746424,
	"./Audio/finis.mp3": 242180,
	"./Audio/finish.mp3": 664876,
	"./Audio/finish_2.mp3": 135455,
	"./Audio/finishes.mp3": 569624,
	"./Audio/finishes_2.mp3": 667347,
	"./Audio/finishing.mp3": 828964,
	"./Audio/finishing_2.mp3": 950791,
	"./Audio/finite.mp3": 863604,
	"./Audio/finite_2.mp3": 991748,
	"./Audio/finiz.mp3": 760769,
	"./Audio/fip.mp3": 870106,
	"./Audio/fir.mp3": 686344,
	"./Audio/fire.mp3": 738625,
	"./Audio/firm.mp3": 903401,
	"./Audio/firr.mp3": 301474,
	"./Audio/first.mp3": 536481,
	"./Audio/firt.mp3": 942924,
	"./Audio/fis.mp3": 815277,
	"./Audio/fish.mp3": 358031,
	"./Audio/fisit.mp3": 675194,
	"./Audio/fiss.mp3": 188960,
	"./Audio/fist.mp3": 857043,
	"./Audio/fit.mp3": 702422,
	"./Audio/fite.mp3": 760075,
	"./Audio/five.mp3": 474013,
	"./Audio/fix.mp3": 575602,
	"./Audio/fiz.mp3": 698080,
	"./Audio/fizz.mp3": 2114,
	"./Audio/flag.mp3": 364163,
	"./Audio/flame.mp3": 505290,
	"./Audio/flapping.mp3": 656392,
	"./Audio/flare.mp3": 342247,
	"./Audio/flash.mp3": 492493,
	"./Audio/flask.mp3": 89594,
	"./Audio/flaw.mp3": 290611,
	"./Audio/flea.mp3": 352393,
	"./Audio/fleme.mp3": 797382,
	"./Audio/flew.mp3": 456463,
	"./Audio/flexible.mp3": 87340,
	"./Audio/flies.mp3": 633060,
	"./Audio/flies_2.mp3": 771719,
	"./Audio/flime.mp3": 986962,
	"./Audio/fling.mp3": 475057,
	"./Audio/flo.mp3": 423422,
	"./Audio/flock.mp3": 863648,
	"./Audio/flog.mp3": 824145,
	"./Audio/flome.mp3": 306400,
	"./Audio/floo.mp3": 242425,
	"./Audio/floor.mp3": 447081,
	"./Audio/floppy.mp3": 624143,
	"./Audio/floss.mp3": 57672,
	"./Audio/flout.mp3": 27661,
	"./Audio/flow.mp3": 104513,
	"./Audio/flu.mp3": 815108,
	"./Audio/flug.mp3": 178575,
	"./Audio/flume.mp3": 440438,
	"./Audio/flung.mp3": 157317,
	"./Audio/flush.mp3": 262073,
	"./Audio/flute.mp3": 798593,
	"./Audio/fly.mp3": 741120,
	"./Audio/fo.mp3": 882248,
	"./Audio/foa.mp3": 121317,
	"./Audio/foad.mp3": 90507,
	"./Audio/foak.mp3": 722736,
	"./Audio/foal.mp3": 904611,
	"./Audio/foam.mp3": 912670,
	"./Audio/foap.mp3": 468159,
	"./Audio/foat.mp3": 616699,
	"./Audio/fobe.mp3": 917287,
	"./Audio/foch.mp3": 551181,
	"./Audio/fock.mp3": 817658,
	"./Audio/foct.mp3": 169745,
	"./Audio/fod.mp3": 378748,
	"./Audio/foe.mp3": 206145,
	"./Audio/fog.mp3": 460083,
	"./Audio/foi.mp3": 976589,
	"./Audio/foil.mp3": 826347,
	"./Audio/foind.mp3": 988399,
	"./Audio/foit.mp3": 934899,
	"./Audio/fol.mp3": 687556,
	"./Audio/follow.mp3": 375946,
	"./Audio/fom .mp3": 807035,
	"./Audio/fon.mp3": 398966,
	"./Audio/fond.mp3": 759686,
	"./Audio/fong.mp3": 877049,
	"./Audio/foo.mp3": 208347,
	"./Audio/food.mp3": 962581,
	"./Audio/fook.mp3": 988838,
	"./Audio/foolishness.mp3": 944166,
	"./Audio/foom.mp3": 742296,
	"./Audio/foop.mp3": 573601,
	"./Audio/foot.mp3": 648837,
	"./Audio/football.mp3": 504450,
	"./Audio/fop.mp3": 35344,
	"./Audio/for.mp3": 285346,
	"./Audio/forcible.mp3": 19261,
	"./Audio/foreign.mp3": 121479,
	"./Audio/foreseeable.mp3": 453684,
	"./Audio/forgetful.mp3": 241963,
	"./Audio/forgetting.mp3": 729890,
	"./Audio/forgive.mp3": 936377,
	"./Audio/forgotten.mp3": 508889,
	"./Audio/forgotten_2.mp3": 658954,
	"./Audio/fork.mp3": 480489,
	"./Audio/form.mp3": 779871,
	"./Audio/forp.mp3": 862910,
	"./Audio/forst.mp3": 984711,
	"./Audio/fort.mp3": 878562,
	"./Audio/forty.mp3": 630699,
	"./Audio/forward.mp3": 147240,
	"./Audio/forwards.mp3": 50119,
	"./Audio/forwards_2.mp3": 862536,
	"./Audio/fossil.mp3": 923981,
	"./Audio/fot.mp3": 410444,
	"./Audio/fote.mp3": 548821,
	"./Audio/fou.mp3": 442129,
	"./Audio/fought.mp3": 744564,
	"./Audio/fought_2.mp3": 19095,
	"./Audio/found.mp3": 923747,
	"./Audio/foundation.mp3": 356882,
	"./Audio/foundations.mp3": 884993,
	"./Audio/four.mp3": 181233,
	"./Audio/fourteen.mp3": 443681,
	"./Audio/fout.mp3": 629383,
	"./Audio/fove.mp3": 594691,
	"./Audio/fow.mp3": 533635,
	"./Audio/fowl.mp3": 941861,
	"./Audio/fox.mp3": 191800,
	"./Audio/foy.mp3": 261789,
	"./Audio/fra.mp3": 601537,
	"./Audio/fraction.mp3": 863771,
	"./Audio/fracture.mp3": 820143,
	"./Audio/fraird.mp3": 272089,
	"./Audio/frantically.mp3": 487658,
	"./Audio/frard.mp3": 368404,
	"./Audio/fraught.mp3": 65982,
	"./Audio/frech.mp3": 778491,
	"./Audio/fred.mp3": 109218,
	"./Audio/free.mp3": 714151,
	"./Audio/freeze.mp3": 421268,
	"./Audio/fref.mp3": 859216,
	"./Audio/freg.mp3": 62197,
	"./Audio/freight.mp3": 438118,
	"./Audio/frequency.mp3": 872117,
	"./Audio/frequent.mp3": 966275,
	"./Audio/frequently.mp3": 767090,
	"./Audio/frequently_2.mp3": 863013,
	"./Audio/fres.mp3": 673217,
	"./Audio/fresh.mp3": 974411,
	"./Audio/fresher.mp3": 425994,
	"./Audio/freshest.mp3": 591065,
	"./Audio/fri.mp3": 985206,
	"./Audio/frick.mp3": 162280,
	"./Audio/friday.mp3": 742112,
	"./Audio/fridge.mp3": 828186,
	"./Audio/fried.mp3": 159941,
	"./Audio/friend.mp3": 891961,
	"./Audio/friends.mp3": 548804,
	"./Audio/fries.mp3": 713502,
	"./Audio/fright.mp3": 67997,
	"./Audio/frightened.mp3": 17715,
	"./Audio/fringe.mp3": 331276,
	"./Audio/frisky.mp3": 774925,
	"./Audio/frith.mp3": 535202,
	"./Audio/froad.mp3": 944043,
	"./Audio/frock.mp3": 994778,
	"./Audio/frog.mp3": 202003,
	"./Audio/from.mp3": 294473,
	"./Audio/frond.mp3": 96870,
	"./Audio/frost.mp3": 487361,
	"./Audio/froth.mp3": 452244,
	"./Audio/frug.mp3": 27749,
	"./Audio/fruit.mp3": 817029,
	"./Audio/fruitful.mp3": 709650,
	"./Audio/fruitful_2.mp3": 633733,
	"./Audio/fruition.mp3": 528313,
	"./Audio/fruition_2.mp3": 252650,
	"./Audio/fruitless.mp3": 131218,
	"./Audio/fruitless_2.mp3": 288773,
	"./Audio/fruitlessly.mp3": 278163,
	"./Audio/fruitlessly_2.mp3": 873276,
	"./Audio/fruity.mp3": 358738,
	"./Audio/fruity_2.mp3": 990213,
	"./Audio/fry.mp3": 812934,
	"./Audio/fube.mp3": 666565,
	"./Audio/fuch.mp3": 296491,
	"./Audio/fudge.mp3": 146678,
	"./Audio/fuel.mp3": 958089,
	"./Audio/fuf .mp3": 200072,
	"./Audio/fug.mp3": 919749,
	"./Audio/fuil.mp3": 698013,
	"./Audio/fuind.mp3": 482313,
	"./Audio/fuit.mp3": 557541,
	"./Audio/fulfil.mp3": 680043,
	"./Audio/full.mp3": 879666,
	"./Audio/fume.mp3": 272724,
	"./Audio/fun.mp3": 746568,
	"./Audio/function.mp3": 524109,
	"./Audio/fund.mp3": 362556,
	"./Audio/funnily.mp3": 777742,
	"./Audio/funny.mp3": 677911,
	"./Audio/fup.mp3": 473310,
	"./Audio/fur.mp3": 260460,
	"./Audio/furious.mp3": 239700,
	"./Audio/furniture.mp3": 46345,
	"./Audio/furp.mp3": 401212,
	"./Audio/further.mp3": 735385,
	"./Audio/fury.mp3": 393385,
	"./Audio/fus.mp3": 106417,
	"./Audio/fush.mp3": 778395,
	"./Audio/fuss.mp3": 980492,
	"./Audio/fust.mp3": 943975,
	"./Audio/fut.mp3": 488962,
	"./Audio/future.mp3": 819004,
	"./Audio/fuzz.mp3": 313726,
	"./Audio/g -2.mp3": 618741,
	"./Audio/g -3.mp3": 932112,
	"./Audio/g.mp3": 479116,
	"./Audio/gack.mp3": 657883,
	"./Audio/gacket.mp3": 487492,
	"./Audio/gad.mp3": 98391,
	"./Audio/gaft.mp3": 328955,
	"./Audio/gag.mp3": 791616,
	"./Audio/gaid.mp3": 955590,
	"./Audio/gail.mp3": 482238,
	"./Audio/gais.mp3": 705485,
	"./Audio/gait.mp3": 127862,
	"./Audio/gal.mp3": 907231,
	"./Audio/gam.mp3": 294266,
	"./Audio/game.mp3": 947487,
	"./Audio/gan.mp3": 697165,
	"./Audio/gap.mp3": 254211,
	"./Audio/gaptop.mp3": 887204,
	"./Audio/garden.mp3": 653978,
	"./Audio/gardener.mp3": 534495,
	"./Audio/gardening.mp3": 384382,
	"./Audio/gare.mp3": 210994,
	"./Audio/garl.mp3": 756991,
	"./Audio/gas.mp3": 131020,
	"./Audio/gasp.mp3": 762972,
	"./Audio/gat.mp3": 94503,
	"./Audio/gaunt.mp3": 902124,
	"./Audio/gave.mp3": 39126,
	"./Audio/geal.mp3": 735698,
	"./Audio/gear.mp3": 540116,
	"./Audio/gecko.mp3": 143742,
	"./Audio/ged.mp3": 630235,
	"./Audio/geed.mp3": 615814,
	"./Audio/gees.mp3": 391885,
	"./Audio/geese.mp3": 115198,
	"./Audio/geet.mp3": 814262,
	"./Audio/geg.mp3": 83268,
	"./Audio/gel.mp3": 186419,
	"./Audio/gelf.mp3": 137007,
	"./Audio/gell.mp3": 146933,
	"./Audio/gelp.mp3": 769705,
	"./Audio/gem.mp3": 175918,
	"./Audio/geme.mp3": 296403,
	"./Audio/gen.mp3": 601857,
	"./Audio/generally.mp3": 86758,
	"./Audio/generate.mp3": 139852,
	"./Audio/generation.mp3": 227199,
	"./Audio/genetic.mp3": 520894,
	"./Audio/gentle.mp3": 57338,
	"./Audio/gently.mp3": 753342,
	"./Audio/gently_2.mp3": 47673,
	"./Audio/genuinely.mp3": 62709,
	"./Audio/geography.mp3": 683037,
	"./Audio/geology.mp3": 579947,
	"./Audio/geometry.mp3": 318309,
	"./Audio/gestate.mp3": 838108,
	"./Audio/gestate_2.mp3": 765967,
	"./Audio/gesture.mp3": 849806,
	"./Audio/gesture_2.mp3": 95177,
	"./Audio/get.mp3": 561515,
	"./Audio/getting.mp3": 565315,
	"./Audio/ghost.mp3": 424802,
	"./Audio/giant.mp3": 961008,
	"./Audio/gid.mp3": 536463,
	"./Audio/gift.mp3": 257443,
	"./Audio/gig.mp3": 436568,
	"./Audio/giggle.mp3": 195334,
	"./Audio/gil-2.mp3": 234406,
	"./Audio/gil.mp3": 673479,
	"./Audio/gild.mp3": 501009,
	"./Audio/gill.mp3": 249913,
	"./Audio/gilt.mp3": 238849,
	"./Audio/gime.mp3": 848055,
	"./Audio/gin.mp3": 140501,
	"./Audio/ginger.mp3": 122773,
	"./Audio/gingerly.mp3": 146492,
	"./Audio/gip.mp3": 753723,
	"./Audio/giraffe.mp3": 410495,
	"./Audio/girl's.mp3": 541013,
	"./Audio/girl.mp3": 737623,
	"./Audio/girls'.mp3": 406885,
	"./Audio/girls.mp3": 983266,
	"./Audio/give.mp3": 699294,
	"./Audio/glamorous.mp3": 577364,
	"./Audio/glar.mp3": 204637,
	"./Audio/glare.mp3": 421102,
	"./Audio/glass.mp3": 471127,
	"./Audio/glasses.mp3": 518083,
	"./Audio/glay.mp3": 558818,
	"./Audio/gleaming.mp3": 99221,
	"./Audio/glear.mp3": 677808,
	"./Audio/glee.mp3": 55954,
	"./Audio/gley.mp3": 951878,
	"./Audio/glide.mp3": 956568,
	"./Audio/glimpse.mp3": 970666,
	"./Audio/globe.mp3": 547896,
	"./Audio/glorious.mp3": 943259,
	"./Audio/gloss.mp3": 885541,
	"./Audio/glow.mp3": 1570,
	"./Audio/glue.mp3": 444322,
	"./Audio/gluw.mp3": 899392,
	"./Audio/gnat.mp3": 846933,
	"./Audio/gnaw.mp3": 618754,
	"./Audio/gnome.mp3": 783219,
	"./Audio/gnomes.mp3": 339382,
	"./Audio/go.mp3": 701199,
	"./Audio/goa.mp3": 46760,
	"./Audio/goad.mp3": 516892,
	"./Audio/goal.mp3": 234788,
	"./Audio/goat.mp3": 9260,
	"./Audio/gock.mp3": 886401,
	"./Audio/god.mp3": 72169,
	"./Audio/goes.mp3": 758907,
	"./Audio/gog.mp3": 100214,
	"./Audio/going.mp3": 465889,
	"./Audio/gol.mp3": 907393,
	"./Audio/gold.mp3": 992775,
	"./Audio/golt.mp3": 968055,
	"./Audio/gome.mp3": 847077,
	"./Audio/gone.mp3": 206584,
	"./Audio/good.mp3": 73486,
	"./Audio/gor.mp3": 896943,
	"./Audio/gorgeous.mp3": 912362,
	"./Audio/gorl.mp3": 160225,
	"./Audio/got.mp3": 561657,
	"./Audio/goulash.mp3": 499168,
	"./Audio/government.mp3": 304252,
	"./Audio/gown.mp3": 966204,
	"./Audio/gows.mp3": 544797,
	"./Audio/goys.mp3": 644415,
	"./Audio/grabbing.mp3": 136409,
	"./Audio/grace.mp3": 501927,
	"./Audio/gracious.mp3": 768010,
	"./Audio/gradually.mp3": 241804,
	"./Audio/grahics.mp3": 895588,
	"./Audio/grammar.mp3": 330836,
	"./Audio/grammatical.mp3": 851649,
	"./Audio/grammatical_2.mp3": 662210,
	"./Audio/gran.mp3": 33499,
	"./Audio/grandad.mp3": 608506,
	"./Audio/grander.mp3": 162664,
	"./Audio/grandest.mp3": 908147,
	"./Audio/graph.mp3": 678711,
	"./Audio/graphical.mp3": 526204,
	"./Audio/graphics.mp3": 789282,
	"./Audio/grapics.mp3": 699788,
	"./Audio/grarics.mp3": 509394,
	"./Audio/grasp.mp3": 447550,
	"./Audio/grass.mp3": 619985,
	"./Audio/grassland.mp3": 346742,
	"./Audio/grassland_2.mp3": 994113,
	"./Audio/grate.mp3": 599730,
	"./Audio/graw.mp3": 94846,
	"./Audio/great.mp3": 260568,
	"./Audio/greedily.mp3": 515752,
	"./Audio/green.mp3": 503750,
	"./Audio/greenhouse.mp3": 471078,
	"./Audio/grew.mp3": 78586,
	"./Audio/grey.mp3": 188092,
	"./Audio/grey_2.mp3": 770735,
	"./Audio/grief.mp3": 568890,
	"./Audio/grill.mp3": 522143,
	"./Audio/grit.mp3": 748873,
	"./Audio/griy.mp3": 471968,
	"./Audio/groan.mp3": 932652,
	"./Audio/groind.mp3": 907864,
	"./Audio/grond.mp3": 295467,
	"./Audio/groo.mp3": 29216,
	"./Audio/gross.mp3": 346027,
	"./Audio/ground.mp3": 453556,
	"./Audio/group.mp3": 895094,
	"./Audio/grow.mp3": 98392,
	"./Audio/grown.mp3": 467622,
	"./Audio/growth.mp3": 591972,
	"./Audio/growth_2.mp3": 927239,
	"./Audio/grue.mp3": 747240,
	"./Audio/gruff.mp3": 270539,
	"./Audio/gruind.mp3": 779834,
	"./Audio/grumpily.mp3": 939684,
	"./Audio/grumpy.mp3": 529805,
	"./Audio/grund.mp3": 943553,
	"./Audio/gruw.mp3": 888138,
	"./Audio/guarantee.mp3": 617,
	"./Audio/guard.mp3": 275960,
	"./Audio/guard_2.mp3": 844019,
	"./Audio/guardian.mp3": 796152,
	"./Audio/guardian_2.mp3": 631475,
	"./Audio/guess.mp3": 773136,
	"./Audio/guess_2.mp3": 249371,
	"./Audio/guessed.mp3": 219727,
	"./Audio/guest.mp3": 245251,
	"./Audio/guest_2.mp3": 858668,
	"./Audio/guidance.mp3": 795431,
	"./Audio/guidance_2.mp3": 642408,
	"./Audio/guide.mp3": 385127,
	"./Audio/guilt.mp3": 519178,
	"./Audio/guilt_2.mp3": 219053,
	"./Audio/guilty.mp3": 648531,
	"./Audio/guitar.mp3": 96795,
	"./Audio/guitar_2.mp3": 855636,
	"./Audio/gulp.mp3": 756153,
	"./Audio/gume.mp3": 855619,
	"./Audio/gurd.mp3": 269379,
	"./Audio/gym.mp3": 176082,
	"./Audio/gym_2.mp3": 721989,
	"./Audio/h -2.mp3": 279256,
	"./Audio/h -3.mp3": 638653,
	"./Audio/h.mp3": 653871,
	"./Audio/hach.mp3": 203405,
	"./Audio/hack.mp3": 953530,
	"./Audio/had.mp3": 654972,
	"./Audio/haft.mp3": 606494,
	"./Audio/hag.mp3": 736307,
	"./Audio/hai.mp3": 252813,
	"./Audio/haid.mp3": 660675,
	"./Audio/haif.mp3": 264721,
	"./Audio/haik.mp3": 471864,
	"./Audio/hail.mp3": 962219,
	"./Audio/hain.mp3": 13625,
	"./Audio/haint.mp3": 992351,
	"./Audio/hainted.mp3": 405672,
	"./Audio/hair.mp3": 943909,
	"./Audio/half.mp3": 31338,
	"./Audio/halp.mp3": 366372,
	"./Audio/halt.mp3": 838856,
	"./Audio/ham.mp3": 647145,
	"./Audio/hammair.mp3": 177182,
	"./Audio/hammare.mp3": 72832,
	"./Audio/hammer.mp3": 551319,
	"./Audio/hammerer.mp3": 770366,
	"./Audio/han.mp3": 675190,
	"./Audio/hand.mp3": 895558,
	"./Audio/hang.mp3": 12921,
	"./Audio/hant.mp3": 67830,
	"./Audio/hanted.mp3": 972741,
	"./Audio/haot.mp3": 784709,
	"./Audio/hapless.mp3": 212023,
	"./Audio/hapless_2.mp3": 777656,
	"./Audio/happened.mp3": 736238,
	"./Audio/happening.mp3": 955003,
	"./Audio/happier.mp3": 631104,
	"./Audio/happier_2.mp3": 554187,
	"./Audio/happiest.mp3": 962747,
	"./Audio/happily.mp3": 279284,
	"./Audio/happiness.mp3": 691668,
	"./Audio/happy.mp3": 678941,
	"./Audio/har.mp3": 561570,
	"./Audio/harass.mp3": 798285,
	"./Audio/harass_2.mp3": 163382,
	"./Audio/harassed.mp3": 308094,
	"./Audio/harassed_2.mp3": 633977,
	"./Audio/harassment.mp3": 460153,
	"./Audio/harassment_2.mp3": 411434,
	"./Audio/hard.mp3": 576210,
	"./Audio/harder.mp3": 130679,
	"./Audio/hardest.mp3": 248114,
	"./Audio/hardness.mp3": 587635,
	"./Audio/hare.mp3": 623255,
	"./Audio/has.mp3": 166503,
	"./Audio/hase.mp3": 701996,
	"./Audio/hasn't.mp3": 847890,
	"./Audio/hat.mp3": 686668,
	"./Audio/hatch.mp3": 947489,
	"./Audio/haunt.mp3": 90131,
	"./Audio/haunted.mp3": 675756,
	"./Audio/have.mp3": 246915,
	"./Audio/hax.mp3": 468024,
	"./Audio/hay.mp3": 538013,
	"./Audio/hazardous.mp3": 364784,
	"./Audio/he'll.mp3": 839663,
	"./Audio/he.mp3": 390436,
	"./Audio/he_s.mp3": 695682,
	"./Audio/head.mp3": 82159,
	"./Audio/headphones.mp3": 528672,
	"./Audio/heal.mp3": 260391,
	"./Audio/healed.mp3": 488592,
	"./Audio/healed_2.mp3": 123739,
	"./Audio/healing.mp3": 687241,
	"./Audio/healing_2.mp3": 63674,
	"./Audio/heals.mp3": 65778,
	"./Audio/heals_2.mp3": 610277,
	"./Audio/health.mp3": 74475,
	"./Audio/health_2.mp3": 56292,
	"./Audio/healthiest.mp3": 838500,
	"./Audio/healthiest_2.mp3": 264071,
	"./Audio/healthy.mp3": 257332,
	"./Audio/healthy_2.mp3": 276695,
	"./Audio/hear.mp3": 257385,
	"./Audio/hear_2.mp3": 511706,
	"./Audio/heard.mp3": 751231,
	"./Audio/heard_2.mp3": 666960,
	"./Audio/hears.mp3": 911412,
	"./Audio/hears_2.mp3": 143703,
	"./Audio/heart.mp3": 225039,
	"./Audio/heat.mp3": 556767,
	"./Audio/heb.mp3": 970758,
	"./Audio/hedge.mp3": 883048,
	"./Audio/hedges.mp3": 966343,
	"./Audio/hee.mp3": 217757,
	"./Audio/heed.mp3": 835955,
	"./Audio/heef.mp3": 251393,
	"./Audio/heege.mp3": 473957,
	"./Audio/heek.mp3": 721384,
	"./Audio/heel.mp3": 796123,
	"./Audio/heese.mp3": 391321,
	"./Audio/heet.mp3": 909507,
	"./Audio/heft.mp3": 230554,
	"./Audio/height.mp3": 8628,
	"./Audio/heir.mp3": 973553,
	"./Audio/hel.mp3": 805584,
	"./Audio/held.mp3": 108660,
	"./Audio/helhet.mp3": 494111,
	"./Audio/hell.mp3": 900268,
	"./Audio/help.mp3": 386376,
	"./Audio/helpful.mp3": 69765,
	"./Audio/heme.mp3": 492566,
	"./Audio/hemisphere.mp3": 474501,
	"./Audio/hemp.mp3": 300495,
	"./Audio/hen.mp3": 55586,
	"./Audio/her.mp3": 685558,
	"./Audio/herd.mp3": 552006,
	"./Audio/herd_2.mp3": 28433,
	"./Audio/here's.mp3": 971745,
	"./Audio/here.mp3": 160491,
	"./Audio/here_2.mp3": 176612,
	"./Audio/here_s_2.mp3": 432570,
	"./Audio/heroically.mp3": 811499,
	"./Audio/hesitancy.mp3": 637193,
	"./Audio/hesitant.mp3": 320279,
	"./Audio/hesitation.mp3": 317931,
	"./Audio/hest.mp3": 136709,
	"./Audio/het.mp3": 89576,
	"./Audio/hexagon.mp3": 440919,
	"./Audio/hexagram.mp3": 264408,
	"./Audio/hey.mp3": 619585,
	"./Audio/hic.mp3": 412543,
	"./Audio/hich.mp3": 118581,
	"./Audio/hicked.mp3": 883265,
	"./Audio/hicken.mp3": 885467,
	"./Audio/hide.mp3": 337437,
	"./Audio/hideous.mp3": 133216,
	"./Audio/hient.mp3": 299387,
	"./Audio/hiented.mp3": 718708,
	"./Audio/hig.mp3": 103611,
	"./Audio/hige.mp3": 883664,
	"./Audio/high.mp3": 708729,
	"./Audio/highland.mp3": 668734,
	"./Audio/highland_2.mp3": 755385,
	"./Audio/highly.mp3": 246728,
	"./Audio/hike.mp3": 917340,
	"./Audio/hiked.mp3": 926112,
	"./Audio/hiker.mp3": 608414,
	"./Audio/hiking.mp3": 226553,
	"./Audio/hild.mp3": 619296,
	"./Audio/hill.mp3": 421832,
	"./Audio/hilt.mp3": 111664,
	"./Audio/him.mp3": 432033,
	"./Audio/hime.mp3": 184930,
	"./Audio/himney.mp3": 62159,
	"./Audio/hin.mp3": 344590,
	"./Audio/hinder.mp3": 143675,
	"./Audio/hinder_2.mp3": 872180,
	"./Audio/hinderance.mp3": 156682,
	"./Audio/hinderance_2.mp3": 858093,
	"./Audio/hindered.mp3": 956980,
	"./Audio/hindered_2.mp3": 395159,
	"./Audio/hindering.mp3": 11989,
	"./Audio/hindering_2.mp3": 742638,
	"./Audio/hindmost.mp3": 720111,
	"./Audio/hindmost_2.mp3": 250432,
	"./Audio/hindrance.mp3": 110301,
	"./Audio/hindsight.mp3": 464881,
	"./Audio/hindsight_2.mp3": 287026,
	"./Audio/hinge.mp3": 102210,
	"./Audio/hip.mp3": 727576,
	"./Audio/hire.mp3": 127279,
	"./Audio/hirp.mp3": 814198,
	"./Audio/his.mp3": 369999,
	"./Audio/hisit.mp3": 247188,
	"./Audio/hiskers.mp3": 163010,
	"./Audio/hisper.mp3": 342256,
	"./Audio/historian.mp3": 28754,
	"./Audio/historian_2.mp3": 353861,
	"./Audio/historians.mp3": 675201,
	"./Audio/historians_2.mp3": 949186,
	"./Audio/historic.mp3": 487398,
	"./Audio/historic_2.mp3": 526833,
	"./Audio/historical.mp3": 575185,
	"./Audio/historical_2.mp3": 384786,
	"./Audio/historically.mp3": 664640,
	"./Audio/historically_2.mp3": 431563,
	"./Audio/history.mp3": 969315,
	"./Audio/hit.mp3": 572724,
	"./Audio/hive.mp3": 562875,
	"./Audio/ho.mp3": 687694,
	"./Audio/hoad.mp3": 800833,
	"./Audio/hoaf.mp3": 538419,
	"./Audio/hoak.mp3": 652026,
	"./Audio/hoat.mp3": 520465,
	"./Audio/hockey.mp3": 291246,
	"./Audio/hod.mp3": 750894,
	"./Audio/hoe.mp3": 761395,
	"./Audio/hof.mp3": 680060,
	"./Audio/hog.mp3": 176833,
	"./Audio/hoge.mp3": 289410,
	"./Audio/hok.mp3": 820429,
	"./Audio/hol.mp3": 242806,
	"./Audio/hold.mp3": 763206,
	"./Audio/hole.mp3": 888043,
	"./Audio/hologram.mp3": 980808,
	"./Audio/hologram_2.mp3": 630147,
	"./Audio/home.mp3": 897264,
	"./Audio/honey.mp3": 373290,
	"./Audio/honk.mp3": 409059,
	"./Audio/hood.mp3": 520191,
	"./Audio/hoof.mp3": 399597,
	"./Audio/hook.mp3": 590108,
	"./Audio/hoose.mp3": 878861,
	"./Audio/hoot.mp3": 451471,
	"./Audio/hop.mp3": 612834,
	"./Audio/hope.mp3": 160279,
	"./Audio/hopeful.mp3": 831780,
	"./Audio/hopeless.mp3": 497444,
	"./Audio/hopping.mp3": 341034,
	"./Audio/hor.mp3": 362832,
	"./Audio/horrible.mp3": 695614,
	"./Audio/horribly.mp3": 515962,
	"./Audio/horse.mp3": 972244,
	"./Audio/horses.mp3": 870795,
	"./Audio/horses_2.mp3": 356036,
	"./Audio/hort.mp3": 853348,
	"./Audio/hospital.mp3": 983255,
	"./Audio/hot.mp3": 266558,
	"./Audio/hotel.mp3": 961061,
	"./Audio/hound.mp3": 792449,
	"./Audio/hour.mp3": 337067,
	"./Audio/house.mp3": 387739,
	"./Audio/house_2.mp3": 46164,
	"./Audio/how.mp3": 438993,
	"./Audio/howl.mp3": 233983,
	"./Audio/hoy.mp3": 39535,
	"./Audio/huch.mp3": 591961,
	"./Audio/hue.mp3": 829389,
	"./Audio/huf.mp3": 426490,
	"./Audio/huff.mp3": 955112,
	"./Audio/huft.mp3": 638538,
	"./Audio/hug.mp3": 39455,
	"./Audio/huge.mp3": 333428,
	"./Audio/hugging.mp3": 907298,
	"./Audio/huhh.mp3": 502212,
	"./Audio/hum.mp3": 974117,
	"./Audio/human.mp3": 139216,
	"./Audio/humanity.mp3": 575092,
	"./Audio/humanly.mp3": 202025,
	"./Audio/humbly.mp3": 887236,
	"./Audio/hume.mp3": 133286,
	"./Audio/hummed.mp3": 513773,
	"./Audio/humming.mp3": 822218,
	"./Audio/humorous.mp3": 924425,
	"./Audio/humorous_2.mp3": 333306,
	"./Audio/hump.mp3": 55359,
	"./Audio/hun.mp3": 183570,
	"./Audio/hund.mp3": 899554,
	"./Audio/hungry.mp3": 37290,
	"./Audio/hunt.mp3": 614354,
	"./Audio/hunted.mp3": 22513,
	"./Audio/hunter.mp3": 903415,
	"./Audio/hunting.mp3": 228230,
	"./Audio/hupp.mp3": 909300,
	"./Audio/hurl.mp3": 635758,
	"./Audio/hurt.mp3": 929222,
	"./Audio/hus.mp3": 534955,
	"./Audio/hush.mp3": 119561,
	"./Audio/huss.mp3": 67486,
	"./Audio/hustle.mp3": 105336,
	"./Audio/hut.mp3": 44600,
	"./Audio/hutch.mp3": 248893,
	"./Audio/hymn.mp3": 710317,
	"./Audio/i -2.mp3": 66171,
	"./Audio/i -3.mp3": 498454,
	"./Audio/i -4.mp3": 127661,
	"./Audio/i -5.mp3": 482376,
	"./Audio/i -6.mp3": 375103,
	"./Audio/i .mp3": 801190,
	"./Audio/i'll.mp3": 46109,
	"./Audio/i'm.mp3": 812950,
	"./Audio/i've.mp3": 248914,
	"./Audio/i.mp3": 428234,
	"./Audio/i1.mp3": 871803,
	"./Audio/i2.mp3": 27428,
	"./Audio/ice.mp3": 850538,
	"./Audio/icicle.mp3": 473976,
	"./Audio/icing.mp3": 534047,
	"./Audio/icy.mp3": 813454,
	"./Audio/identical.mp3": 451182,
	"./Audio/identifiable.mp3": 775665,
	"./Audio/identified.mp3": 33870,
	"./Audio/identify.mp3": 403981,
	"./Audio/identity.mp3": 947459,
	"./Audio/iethor.mp3": 438780,
	"./Audio/if.mp3": 39448,
	"./Audio/igh.mp3": 556543,
	"./Audio/ignorance.mp3": 224687,
	"./Audio/ih.mp3": 525726,
	"./Audio/ill.mp3": 857242,
	"./Audio/illegal.mp3": 773617,
	"./Audio/illegible.mp3": 773274,
	"./Audio/illegibly.mp3": 926750,
	"./Audio/illiterate.mp3": 887704,
	"./Audio/illogical.mp3": 840799,
	"./Audio/illusion.mp3": 703960,
	"./Audio/im.mp3": 123335,
	"./Audio/image.mp3": 195136,
	"./Audio/imagery.mp3": 234387,
	"./Audio/imagination.mp3": 919457,
	"./Audio/imaginative.mp3": 784929,
	"./Audio/imagine.mp3": 648823,
	"./Audio/imagining.mp3": 440790,
	"./Audio/immaterial.mp3": 648204,
	"./Audio/immature.mp3": 536539,
	"./Audio/immeasurable.mp3": 190596,
	"./Audio/immediate.mp3": 228220,
	"./Audio/immediately.mp3": 618813,
	"./Audio/immense.mp3": 349533,
	"./Audio/immigrate.mp3": 681126,
	"./Audio/immortal.mp3": 976742,
	"./Audio/impartial.mp3": 375034,
	"./Audio/impatient.mp3": 723142,
	"./Audio/imperfect.mp3": 819862,
	"./Audio/implant.mp3": 859362,
	"./Audio/impolite.mp3": 208360,
	"./Audio/import.mp3": 237278,
	"./Audio/important.mp3": 420309,
	"./Audio/importantly.mp3": 798268,
	"./Audio/impossible.mp3": 614922,
	"./Audio/impossibly.mp3": 551918,
	"./Audio/impress.mp3": 4008,
	"./Audio/impresses.mp3": 409468,
	"./Audio/impression.mp3": 671314,
	"./Audio/impressive.mp3": 841314,
	"./Audio/improve.mp3": 228431,
	"./Audio/in.mp3": 5168,
	"./Audio/inactive.mp3": 197990,
	"./Audio/incident.mp3": 931087,
	"./Audio/incidental.mp3": 145956,
	"./Audio/incidentally.mp3": 261829,
	"./Audio/incidents.mp3": 612682,
	"./Audio/include.mp3": 910103,
	"./Audio/income.mp3": 488816,
	"./Audio/incomplete.mp3": 640289,
	"./Audio/inconvenience.mp3": 381541,
	"./Audio/inconvenient.mp3": 990759,
	"./Audio/incorrect.mp3": 339546,
	"./Audio/increase.mp3": 820509,
	"./Audio/incredible.mp3": 700328,
	"./Audio/incredibly.mp3": 434636,
	"./Audio/indefinite.mp3": 910676,
	"./Audio/independence.mp3": 445291,
	"./Audio/independent.mp3": 892381,
	"./Audio/indicate.mp3": 852012,
	"./Audio/individual.mp3": 619100,
	"./Audio/individualise.mp3": 756781,
	"./Audio/individually.mp3": 155037,
	"./Audio/individuals.mp3": 439971,
	"./Audio/inexpensive.mp3": 849819,
	"./Audio/inexperience.mp3": 8060,
	"./Audio/infant.mp3": 83005,
	"./Audio/infectious.mp3": 420182,
	"./Audio/infinite.mp3": 852881,
	"./Audio/infinitely.mp3": 765120,
	"./Audio/influence.mp3": 270382,
	"./Audio/influential.mp3": 852492,
	"./Audio/information.mp3": 836681,
	"./Audio/infrequent.mp3": 231289,
	"./Audio/initial.mp3": 301959,
	"./Audio/initiate.mp3": 266772,
	"./Audio/inject.mp3": 671506,
	"./Audio/injection.mp3": 553056,
	"./Audio/injured.mp3": 254560,
	"./Audio/ink.mp3": 371431,
	"./Audio/innate.mp3": 732834,
	"./Audio/innocence.mp3": 659789,
	"./Audio/innocent.mp3": 205887,
	"./Audio/innovate.mp3": 23639,
	"./Audio/insane.mp3": 8379,
	"./Audio/inscribe.mp3": 772610,
	"./Audio/insecure.mp3": 990959,
	"./Audio/inside.mp3": 438253,
	"./Audio/insincere.mp3": 190529,
	"./Audio/insincerely.mp3": 304336,
	"./Audio/insoluble.mp3": 748502,
	"./Audio/inspect.mp3": 832811,
	"./Audio/inspected.mp3": 729636,
	"./Audio/inspecting.mp3": 702949,
	"./Audio/inspection.mp3": 98251,
	"./Audio/inspiration.mp3": 764535,
	"./Audio/inspire.mp3": 592317,
	"./Audio/instant.mp3": 561504,
	"./Audio/instead.mp3": 620501,
	"./Audio/instruct.mp3": 404559,
	"./Audio/instruction.mp3": 301415,
	"./Audio/intelligence.mp3": 961168,
	"./Audio/intend.mp3": 655711,
	"./Audio/interact.mp3": 495439,
	"./Audio/interacted.mp3": 387224,
	"./Audio/interacting.mp3": 803489,
	"./Audio/interaction.mp3": 589927,
	"./Audio/interactivity.mp3": 31526,
	"./Audio/intercept.mp3": 774733,
	"./Audio/intercepted.mp3": 854718,
	"./Audio/intercepting.mp3": 776811,
	"./Audio/interception.mp3": 364737,
	"./Audio/intercity.mp3": 53468,
	"./Audio/interest.mp3": 354867,
	"./Audio/interesting.mp3": 199517,
	"./Audio/interestingly.mp3": 66340,
	"./Audio/interests.mp3": 778934,
	"./Audio/interface.mp3": 710350,
	"./Audio/interfere.mp3": 545165,
	"./Audio/interfered.mp3": 445315,
	"./Audio/interference.mp3": 214573,
	"./Audio/intergalactic.mp3": 906101,
	"./Audio/intermediary.mp3": 995708,
	"./Audio/intermediate.mp3": 136742,
	"./Audio/international.mp3": 564023,
	"./Audio/interrelated.mp3": 936042,
	"./Audio/interrupt.mp3": 931090,
	"./Audio/interruption.mp3": 336160,
	"./Audio/interrupts.mp3": 739905,
	"./Audio/intersect.mp3": 954864,
	"./Audio/intersected.mp3": 959855,
	"./Audio/intersection.mp3": 666650,
	"./Audio/interval.mp3": 512558,
	"./Audio/interview.mp3": 155722,
	"./Audio/interviewer.mp3": 145711,
	"./Audio/interviewing.mp3": 118670,
	"./Audio/interviews.mp3": 194441,
	"./Audio/into.mp3": 163719,
	"./Audio/intrigue.mp3": 851320,
	"./Audio/invalid.mp3": 237686,
	"./Audio/invasion.mp3": 909240,
	"./Audio/invention.mp3": 162693,
	"./Audio/invest.mp3": 902542,
	"./Audio/invincible.mp3": 91234,
	"./Audio/invisible.mp3": 214742,
	"./Audio/invite.mp3": 792482,
	"./Audio/involve.mp3": 714736,
	"./Audio/involved.mp3": 38484,
	"./Audio/ip.mp3": 331414,
	"./Audio/ir -2.mp3": 734221,
	"./Audio/ir -3.mp3": 560616,
	"./Audio/ir .mp3": 198164,
	"./Audio/ir.mp3": 842852,
	"./Audio/ire.mp3": 352093,
	"./Audio/ireland.mp3": 200938,
	"./Audio/irrational.mp3": 211922,
	"./Audio/irreconciled.mp3": 985300,
	"./Audio/irregular.mp3": 486056,
	"./Audio/irregularity.mp3": 507420,
	"./Audio/irrelevant.mp3": 300675,
	"./Audio/irreplaceable.mp3": 989252,
	"./Audio/irresistible.mp3": 982462,
	"./Audio/irrespective.mp3": 795292,
	"./Audio/irresponsible.mp3": 796692,
	"./Audio/is.mp3": 577801,
	"./Audio/ise.mp3": 211578,
	"./Audio/island.mp3": 576846,
	"./Audio/isle.mp3": 994236,
	"./Audio/it's.mp3": 264992,
	"./Audio/it.mp3": 499098,
	"./Audio/itch.mp3": 886451,
	"./Audio/itinerary.mp3": 840392,
	"./Audio/its.mp3": 946265,
	"./Audio/j -2.mp3": 480022,
	"./Audio/j -3.mp3": 505211,
	"./Audio/j.mp3": 872989,
	"./Audio/jack.mp3": 103972,
	"./Audio/jacket.mp3": 33219,
	"./Audio/jai.mp3": 93227,
	"./Audio/jail.mp3": 670253,
	"./Audio/jain.mp3": 917695,
	"./Audio/jainty.mp3": 880222,
	"./Audio/jaip.mp3": 384817,
	"./Audio/jam.mp3": 123119,
	"./Audio/jamp.mp3": 487613,
	"./Audio/janty.mp3": 32505,
	"./Audio/january.mp3": 778709,
	"./Audio/jap.mp3": 165102,
	"./Audio/jar.mp3": 306172,
	"./Audio/jass.mp3": 760988,
	"./Audio/jaunt.mp3": 730565,
	"./Audio/jaunty.mp3": 406930,
	"./Audio/jaw.mp3": 48741,
	"./Audio/jaww.mp3": 527396,
	"./Audio/jaxx.mp3": 102482,
	"./Audio/jay.mp3": 619419,
	"./Audio/jayy.mp3": 970148,
	"./Audio/jazz.mp3": 282830,
	"./Audio/jealous.mp3": 209732,
	"./Audio/jeene.mp3": 110796,
	"./Audio/jeep.mp3": 800777,
	"./Audio/jellies.mp3": 163003,
	"./Audio/jen.mp3": 714340,
	"./Audio/jep.mp3": 717314,
	"./Audio/jet.mp3": 854686,
	"./Audio/jewel.mp3": 38813,
	"./Audio/jienty.mp3": 204714,
	"./Audio/jill.mp3": 272266,
	"./Audio/jilt.mp3": 786002,
	"./Audio/jine.mp3": 703657,
	"./Audio/jo.mp3": 1348,
	"./Audio/joa.mp3": 946777,
	"./Audio/joan.mp3": 322773,
	"./Audio/jog.mp3": 784207,
	"./Audio/joi.mp3": 989425,
	"./Audio/join.mp3": 210061,
	"./Audio/joke.mp3": 909448,
	"./Audio/jolt.mp3": 879428,
	"./Audio/jone.mp3": 618423,
	"./Audio/jou.mp3": 732333,
	"./Audio/journalist.mp3": 889906,
	"./Audio/journey.mp3": 938747,
	"./Audio/jow.mp3": 852927,
	"./Audio/jown.mp3": 622915,
	"./Audio/joy.mp3": 515617,
	"./Audio/joyful.mp3": 809486,
	"./Audio/joyless.mp3": 772942,
	"./Audio/judge.mp3": 579634,
	"./Audio/judged.mp3": 3650,
	"./Audio/judgement.mp3": 208706,
	"./Audio/judicial.mp3": 960000,
	"./Audio/juice.mp3": 811519,
	"./Audio/juin.mp3": 662099,
	"./Audio/july.mp3": 721831,
	"./Audio/jump.mp3": 319793,
	"./Audio/jumped.mp3": 33762,
	"./Audio/jumper.mp3": 100988,
	"./Audio/jumping.mp3": 844039,
	"./Audio/jumps.mp3": 879820,
	"./Audio/june.mp3": 120877,
	"./Audio/junty.mp3": 897005,
	"./Audio/just.mp3": 823099,
	"./Audio/k -2.mp3": 760337,
	"./Audio/k -3.mp3": 245004,
	"./Audio/k.mp3": 260472,
	"./Audio/kack.mp3": 33567,
	"./Audio/kag.mp3": 415588,
	"./Audio/kain.mp3": 709080,
	"./Audio/kaip.mp3": 809742,
	"./Audio/kair.mp3": 278236,
	"./Audio/kak.mp3": 873632,
	"./Audio/kalt.mp3": 629549,
	"./Audio/kam.mp3": 43470,
	"./Audio/kap.mp3": 42703,
	"./Audio/kase.mp3": 896305,
	"./Audio/keck.mp3": 96955,
	"./Audio/keek.mp3": 968665,
	"./Audio/keep.mp3": 323214,
	"./Audio/keese.mp3": 676386,
	"./Audio/kehin.mp3": 181042,
	"./Audio/kem.mp3": 539674,
	"./Audio/ken.mp3": 1197,
	"./Audio/kenin.mp3": 122448,
	"./Audio/kent.mp3": 811795,
	"./Audio/kep.mp3": 558243,
	"./Audio/kept.mp3": 222461,
	"./Audio/kerin.mp3": 781580,
	"./Audio/kest.mp3": 596928,
	"./Audio/kettle.mp3": 92420,
	"./Audio/kevin.mp3": 217400,
	"./Audio/kew.mp3": 45744,
	"./Audio/key.mp3": 657190,
	"./Audio/kich.mp3": 744256,
	"./Audio/kick.mp3": 508503,
	"./Audio/kicken.mp3": 103866,
	"./Audio/kid.mp3": 578163,
	"./Audio/kidney.mp3": 341417,
	"./Audio/kig.mp3": 13180,
	"./Audio/kilt.mp3": 231813,
	"./Audio/kim.mp3": 59574,
	"./Audio/kimney.mp3": 265186,
	"./Audio/kin.mp3": 489001,
	"./Audio/kind.mp3": 887743,
	"./Audio/kindly.mp3": 862566,
	"./Audio/king.mp3": 452488,
	"./Audio/kip.mp3": 550887,
	"./Audio/kirp.mp3": 395599,
	"./Audio/kit.mp3": 651715,
	"./Audio/kitchen.mp3": 946459,
	"./Audio/kite.mp3": 367976,
	"./Audio/kitten.mp3": 982756,
	"./Audio/kiz.mp3": 591773,
	"./Audio/knaw.mp3": 802262,
	"./Audio/knee.mp3": 774704,
	"./Audio/kneel.mp3": 108492,
	"./Audio/knew.mp3": 974130,
	"./Audio/knife.mp3": 536504,
	"./Audio/knight.mp3": 333226,
	"./Audio/knighthood.mp3": 62452,
	"./Audio/knit.mp3": 778961,
	"./Audio/knitting.mp3": 198761,
	"./Audio/knock.mp3": 242091,
	"./Audio/knoo.mp3": 529624,
	"./Audio/knot.mp3": 588791,
	"./Audio/know.mp3": 333600,
	"./Audio/knowing.mp3": 236064,
	"./Audio/knowingly.mp3": 734553,
	"./Audio/knowledge.mp3": 175495,
	"./Audio/knowledgeable.mp3": 115863,
	"./Audio/known.mp3": 589646,
	"./Audio/knows.mp3": 615055,
	"./Audio/knuckle.mp3": 419232,
	"./Audio/koose.mp3": 879210,
	"./Audio/kop.mp3": 690673,
	"./Audio/kount.mp3": 864942,
	"./Audio/kug.mp3": 251504,
	"./Audio/l  .mp3": 9283,
	"./Audio/l -2.mp3": 133860,
	"./Audio/l.mp3": 750827,
	"./Audio/la.mp3": 150428,
	"./Audio/laboratory.mp3": 140822,
	"./Audio/laborious.mp3": 332825,
	"./Audio/labour.mp3": 700996,
	"./Audio/lace.mp3": 25496,
	"./Audio/lacey.mp3": 240685,
	"./Audio/lacy.mp3": 111004,
	"./Audio/lad.mp3": 855520,
	"./Audio/laddair.mp3": 881088,
	"./Audio/laddare.mp3": 971418,
	"./Audio/ladder.mp3": 994741,
	"./Audio/ladderer.mp3": 124808,
	"./Audio/ladies.mp3": 941149,
	"./Audio/ladle.mp3": 954501,
	"./Audio/lady.mp3": 335893,
	"./Audio/laf.mp3": 216690,
	"./Audio/laflet.mp3": 381849,
	"./Audio/lai.mp3": 589897,
	"./Audio/laid.mp3": 866335,
	"./Audio/laif.mp3": 656269,
	"./Audio/laik.mp3": 515900,
	"./Audio/lain.mp3": 470373,
	"./Audio/lainch.mp3": 988952,
	"./Audio/lair.mp3": 23737,
	"./Audio/lake.mp3": 609488,
	"./Audio/lamb.mp3": 67669,
	"./Audio/lamp.mp3": 33399,
	"./Audio/lan.mp3": 511194,
	"./Audio/lanch.mp3": 363251,
	"./Audio/lane.mp3": 563583,
	"./Audio/language.mp3": 383571,
	"./Audio/lap.mp3": 324972,
	"./Audio/laptop.mp3": 827945,
	"./Audio/lar.mp3": 537822,
	"./Audio/large.mp3": 421458,
	"./Audio/large2.mp3": 775036,
	"./Audio/lass.mp3": 227750,
	"./Audio/last.mp3": 856957,
	"./Audio/lat.mp3": 17264,
	"./Audio/latch.mp3": 62021,
	"./Audio/late.mp3": 52729,
	"./Audio/lately.mp3": 615240,
	"./Audio/later.mp3": 68201,
	"./Audio/lattair.mp3": 5536,
	"./Audio/laugh.mp3": 172,
	"./Audio/laughed.mp3": 793659,
	"./Audio/laughing.mp3": 516708,
	"./Audio/launch.mp3": 655444,
	"./Audio/law.mp3": 135431,
	"./Audio/lawn.mp3": 832875,
	"./Audio/lawyer.mp3": 347137,
	"./Audio/layal.mp3": 50510,
	"./Audio/lazily.mp3": 144254,
	"./Audio/le.mp3": 842720,
	"./Audio/lead.mp3": 812131,
	"./Audio/leaf.mp3": 969649,
	"./Audio/leaflet.mp3": 804600,
	"./Audio/league.mp3": 907878,
	"./Audio/lear.mp3": 266629,
	"./Audio/learn.mp3": 28817,
	"./Audio/least.mp3": 873524,
	"./Audio/leather.mp3": 127228,
	"./Audio/lecture.mp3": 481981,
	"./Audio/led.mp3": 387108,
	"./Audio/ledge.mp3": 236004,
	"./Audio/leed.mp3": 667359,
	"./Audio/leef.mp3": 973645,
	"./Audio/leek.mp3": 375804,
	"./Audio/leet.mp3": 192751,
	"./Audio/leflet.mp3": 960061,
	"./Audio/left.mp3": 14678,
	"./Audio/leg.mp3": 231483,
	"./Audio/legible.mp3": 464931,
	"./Audio/leisure.mp3": 743346,
	"./Audio/leke.mp3": 460316,
	"./Audio/lene.mp3": 466803,
	"./Audio/length.mp3": 622317,
	"./Audio/lentil.mp3": 235425,
	"./Audio/let's.mp3": 697498,
	"./Audio/let.mp3": 369972,
	"./Audio/lete.mp3": 34573,
	"./Audio/lettare.mp3": 290254,
	"./Audio/letter.mp3": 80433,
	"./Audio/letterer .mp3": 968124,
	"./Audio/letting.mp3": 503304,
	"./Audio/liaise.mp3": 730918,
	"./Audio/liberal.mp3": 174464,
	"./Audio/liberate.mp3": 648529,
	"./Audio/liberty.mp3": 228506,
	"./Audio/librarian.mp3": 467887,
	"./Audio/library.mp3": 339178,
	"./Audio/licence.mp3": 777382,
	"./Audio/license.mp3": 931542,
	"./Audio/licid.mp3": 430968,
	"./Audio/lie.mp3": 861981,
	"./Audio/lied.mp3": 421683,
	"./Audio/liench.mp3": 94156,
	"./Audio/lifid.mp3": 503469,
	"./Audio/lift.mp3": 146906,
	"./Audio/light.mp3": 349019,
	"./Audio/lightened.mp3": 338893,
	"./Audio/lightning.mp3": 158945,
	"./Audio/like.mp3": 815848,
	"./Audio/likeable.mp3": 628656,
	"./Audio/liked.mp3": 481884,
	"./Audio/likid.mp3": 592640,
	"./Audio/lilt.mp3": 668772,
	"./Audio/limb.mp3": 334125,
	"./Audio/limitation.mp3": 529809,
	"./Audio/limited.mp3": 840401,
	"./Audio/limiting.mp3": 247718,
	"./Audio/limp.mp3": 55375,
	"./Audio/line.mp3": 349079,
	"./Audio/lineage.mp3": 265456,
	"./Audio/lip.mp3": 287748,
	"./Audio/liquid.mp3": 618061,
	"./Audio/listen.mp3": 485564,
	"./Audio/listen2.mp3": 764862,
	"./Audio/lit.mp3": 429352,
	"./Audio/lite.mp3": 982881,
	"./Audio/literate.mp3": 897011,
	"./Audio/little.mp3": 341713,
	"./Audio/live.mp3": 613279,
	"./Audio/liveable.mp3": 750783,
	"./Audio/lived.mp3": 177177,
	"./Audio/liwid.mp3": 525780,
	"./Audio/ll.mp3": 959917,
	"./Audio/loa.mp3": 891899,
	"./Audio/load.mp3": 961845,
	"./Audio/loaf.mp3": 740647,
	"./Audio/loaflet.mp3": 504698,
	"./Audio/loak.mp3": 593414,
	"./Audio/loal.mp3": 628509,
	"./Audio/local.mp3": 651582,
	"./Audio/locality.mp3": 74446,
	"./Audio/location.mp3": 130268,
	"./Audio/loch.mp3": 873459,
	"./Audio/locomotive.mp3": 746926,
	"./Audio/lod.mp3": 491866,
	"./Audio/lof.mp3": 308104,
	"./Audio/loft.mp3": 808396,
	"./Audio/log.mp3": 953389,
	"./Audio/logged.mp3": 629883,
	"./Audio/loi.mp3": 631123,
	"./Audio/loial.mp3": 189568,
	"./Audio/loin.mp3": 901959,
	"./Audio/lok.mp3": 736673,
	"./Audio/loke.mp3": 703330,
	"./Audio/lollipop.mp3": 820232,
	"./Audio/lon.mp3": 836192,
	"./Audio/lone.mp3": 904009,
	"./Audio/lonely.mp3": 808312,
	"./Audio/long.mp3": 225339,
	"./Audio/lonk.mp3": 908471,
	"./Audio/look.mp3": 442960,
	"./Audio/looked.mp3": 322255,
	"./Audio/looking.mp3": 483120,
	"./Audio/looks.mp3": 181759,
	"./Audio/lor.mp3": 361012,
	"./Audio/lore.mp3": 467469,
	"./Audio/lorries.mp3": 812035,
	"./Audio/lot.mp3": 500586,
	"./Audio/lote.mp3": 129327,
	"./Audio/lots.mp3": 304553,
	"./Audio/loual.mp3": 499684,
	"./Audio/loud.mp3": 852137,
	"./Audio/loudly.mp3": 650392,
	"./Audio/love.mp3": 463473,
	"./Audio/loveable.mp3": 443589,
	"./Audio/lovely.mp3": 385312,
	"./Audio/low.mp3": 238589,
	"./Audio/lown.mp3": 913673,
	"./Audio/loyal.mp3": 323664,
	"./Audio/luch.mp3": 76357,
	"./Audio/luckily.mp3": 104186,
	"./Audio/lug.mp3": 342571,
	"./Audio/luggage.mp3": 411455,
	"./Audio/luhe.mp3": 605337,
	"./Audio/luke.mp3": 879148,
	"./Audio/lum.mp3": 102545,
	"./Audio/lump.mp3": 794211,
	"./Audio/lun.mp3": 930110,
	"./Audio/lunc.mp3": 638581,
	"./Audio/lunch.mp3": 579255,
	"./Audio/lung.mp3": 511761,
	"./Audio/lungs.mp3": 803884,
	"./Audio/lunh.mp3": 403018,
	"./Audio/lunk.mp3": 847773,
	"./Audio/lunt.mp3": 823662,
	"./Audio/lure.mp3": 64607,
	"./Audio/luscious.mp3": 824738,
	"./Audio/lute.mp3": 946493,
	"./Audio/lyric.mp3": 177426,
	"./Audio/m -2.mp3": 927527,
	"./Audio/m .mp3": 787258,
	"./Audio/m.mp3": 625990,
	"./Audio/ma.mp3": 372895,
	"./Audio/machine.mp3": 664536,
	"./Audio/mack.mp3": 217681,
	"./Audio/mad.mp3": 311705,
	"./Audio/made.mp3": 196202,
	"./Audio/madness.mp3": 269824,
	"./Audio/mag.mp3": 600230,
	"./Audio/magic.mp3": 384178,
	"./Audio/magician.mp3": 610298,
	"./Audio/magnum.mp3": 894574,
	"./Audio/maiket.mp3": 32704,
	"./Audio/mail.mp3": 880460,
	"./Audio/main.mp3": 765886,
	"./Audio/mair.mp3": 586234,
	"./Audio/mait.mp3": 157572,
	"./Audio/make.mp3": 286071,
	"./Audio/maket.mp3": 521265,
	"./Audio/mal.mp3": 658801,
	"./Audio/maladroit.mp3": 459568,
	"./Audio/malady.mp3": 671343,
	"./Audio/malcontent.mp3": 720072,
	"./Audio/male.mp3": 673234,
	"./Audio/malfunction.mp3": 634865,
	"./Audio/malicious.mp3": 647789,
	"./Audio/maliciously.mp3": 320532,
	"./Audio/malk.mp3": 546372,
	"./Audio/malnourished.mp3": 589956,
	"./Audio/malt.mp3": 232743,
	"./Audio/mam.mp3": 296492,
	"./Audio/man's.mp3": 871961,
	"./Audio/man.mp3": 501283,
	"./Audio/mane.mp3": 349064,
	"./Audio/manoa.mp3": 11555,
	"./Audio/manow.mp3": 466053,
	"./Audio/manuhe.mp3": 690353,
	"./Audio/manure.mp3": 587015,
	"./Audio/manuscript.mp3": 361237,
	"./Audio/many.mp3": 862956,
	"./Audio/map.mp3": 944237,
	"./Audio/march.mp3": 725214,
	"./Audio/market.mp3": 584017,
	"./Audio/marriage.mp3": 725221,
	"./Audio/marries.mp3": 451588,
	"./Audio/marvellous.mp3": 100287,
	"./Audio/marvellously.mp3": 37990,
	"./Audio/mas.mp3": 999066,
	"./Audio/mask.mp3": 860769,
	"./Audio/massive.mp3": 689029,
	"./Audio/mat.mp3": 561417,
	"./Audio/match.mp3": 519276,
	"./Audio/matches.mp3": 320408,
	"./Audio/mate.mp3": 557242,
	"./Audio/material.mp3": 184646,
	"./Audio/materialist.mp3": 907106,
	"./Audio/materials.mp3": 309085,
	"./Audio/maternal.mp3": 817157,
	"./Audio/mathematician.mp3": 725658,
	"./Audio/matoa.mp3": 80909,
	"./Audio/mator.mp3": 590730,
	"./Audio/matow.mp3": 913323,
	"./Audio/matuhe.mp3": 681891,
	"./Audio/mature.mp3": 706461,
	"./Audio/maximal.mp3": 469236,
	"./Audio/maximise.mp3": 537204,
	"./Audio/maximum.mp3": 959349,
	"./Audio/may.mp3": 827040,
	"./Audio/me.mp3": 394587,
	"./Audio/meach.mp3": 156929,
	"./Audio/meadow.mp3": 145962,
	"./Audio/meal.mp3": 469432,
	"./Audio/meant.mp3": 737626,
	"./Audio/measure.mp3": 280951,
	"./Audio/meat.mp3": 891200,
	"./Audio/mechanic.mp3": 27407,
	"./Audio/med.mp3": 568213,
	"./Audio/medal.mp3": 73682,
	"./Audio/meddle.mp3": 298958,
	"./Audio/mede.mp3": 603318,
	"./Audio/media.mp3": 43075,
	"./Audio/mediate.mp3": 129646,
	"./Audio/mediation.mp3": 10417,
	"./Audio/medical.mp3": 291126,
	"./Audio/medically.mp3": 844255,
	"./Audio/medicate.mp3": 363587,
	"./Audio/medicated.mp3": 989005,
	"./Audio/medicates.mp3": 696582,
	"./Audio/medicating.mp3": 635242,
	"./Audio/medication.mp3": 975748,
	"./Audio/medicinal.mp3": 766335,
	"./Audio/medicine.mp3": 24757,
	"./Audio/medieval.mp3": 351104,
	"./Audio/medium.mp3": 782404,
	"./Audio/mee.mp3": 287472,
	"./Audio/meen.mp3": 410110,
	"./Audio/meet.mp3": 344324,
	"./Audio/meg.mp3": 823682,
	"./Audio/megan's.mp3": 222437,
	"./Audio/meke.mp3": 948475,
	"./Audio/mel.mp3": 223677,
	"./Audio/meld.mp3": 519251,
	"./Audio/melt.mp3": 9059,
	"./Audio/mem.mp3": 347928,
	"./Audio/membership.mp3": 708917,
	"./Audio/men's.mp3": 753293,
	"./Audio/men.mp3": 964175,
	"./Audio/mention.mp3": 107061,
	"./Audio/mercy.mp3": 6215,
	"./Audio/mere.mp3": 846744,
	"./Audio/merge.mp3": 677039,
	"./Audio/merriment.mp3": 114384,
	"./Audio/merry.mp3": 728836,
	"./Audio/mess.mp3": 232565,
	"./Audio/messy.mp3": 972354,
	"./Audio/met.mp3": 254469,
	"./Audio/metal.mp3": 194242,
	"./Audio/mew.mp3": 486898,
	"./Audio/mice's.mp3": 923909,
	"./Audio/mice.mp3": 508903,
	"./Audio/micro-organism.mp3": 934736,
	"./Audio/micrometre.mp3": 557672,
	"./Audio/microphone.mp3": 597661,
	"./Audio/microscope.mp3": 514449,
	"./Audio/mid.mp3": 29569,
	"./Audio/midday.mp3": 868421,
	"./Audio/middle.mp3": 165386,
	"./Audio/mide.mp3": 377282,
	"./Audio/midrange.mp3": 563604,
	"./Audio/midriff.mp3": 101482,
	"./Audio/mig.mp3": 87278,
	"./Audio/might.mp3": 606186,
	"./Audio/mik.mp3": 423290,
	"./Audio/mike.mp3": 343199,
	"./Audio/mild.mp3": 608063,
	"./Audio/mildew.mp3": 161359,
	"./Audio/mileage.mp3": 751319,
	"./Audio/milk.mp3": 677980,
	"./Audio/millimetre.mp3": 736893,
	"./Audio/million.mp3": 920207,
	"./Audio/millionaire.mp3": 497670,
	"./Audio/millipede.mp3": 122180,
	"./Audio/mim.mp3": 510980,
	"./Audio/min.mp3": 57947,
	"./Audio/mind.mp3": 265877,
	"./Audio/mine.mp3": 985136,
	"./Audio/mined.mp3": 663764,
	"./Audio/mini.mp3": 348212,
	"./Audio/miniature.mp3": 295419,
	"./Audio/minimal.mp3": 248482,
	"./Audio/minimise.mp3": 235090,
	"./Audio/minimum.mp3": 273827,
	"./Audio/miniscule.mp3": 602406,
	"./Audio/miniskirt.mp3": 358865,
	"./Audio/minor.mp3": 495492,
	"./Audio/minority.mp3": 47176,
	"./Audio/minute 2.mp3": 377399,
	"./Audio/minute.mp3": 425997,
	"./Audio/minute2.mp3": 556325,
	"./Audio/minutes.mp3": 17024,
	"./Audio/mip.mp3": 902197,
	"./Audio/mir.mp3": 70503,
	"./Audio/mis.mp3": 465570,
	"./Audio/misbehave.mp3": 547467,
	"./Audio/mischief.mp3": 641057,
	"./Audio/mischievous.mp3": 557388,
	"./Audio/mischievously.mp3": 940013,
	"./Audio/miscommunicate.mp3": 117881,
	"./Audio/misconduct.mp3": 606830,
	"./Audio/misfortune.mp3": 982293,
	"./Audio/misguide.mp3": 498034,
	"./Audio/mishap.mp3": 606525,
	"./Audio/mishaps.mp3": 149424,
	"./Audio/misinform.mp3": 482005,
	"./Audio/misjudge.mp3": 808831,
	"./Audio/mislead.mp3": 869292,
	"./Audio/mispell.mp3": 127971,
	"./Audio/misplace.mp3": 797039,
	"./Audio/misprint.mp3": 131431,
	"./Audio/mispronounce.mp3": 826735,
	"./Audio/mispronounced.mp3": 760585,
	"./Audio/miss.mp3": 338641,
	"./Audio/missed.mp3": 274306,
	"./Audio/mission.mp3": 402317,
	"./Audio/misspell.mp3": 772464,
	"./Audio/mist.mp3": 28834,
	"./Audio/mistake.mp3": 137347,
	"./Audio/mistletoe.mp3": 774953,
	"./Audio/mistreat.mp3": 24010,
	"./Audio/misuse.mp3": 46644,
	"./Audio/mix.mp3": 111389,
	"./Audio/mixture.mp3": 972263,
	"./Audio/moaket.mp3": 138622,
	"./Audio/moal.mp3": 38438,
	"./Audio/moan.mp3": 247540,
	"./Audio/moch.mp3": 653844,
	"./Audio/mod.mp3": 126279,
	"./Audio/mode.mp3": 919436,
	"./Audio/model.mp3": 244120,
	"./Audio/modern.mp3": 121860,
	"./Audio/mointain.mp3": 59072,
	"./Audio/moisten.mp3": 58806,
	"./Audio/moith-2.mp3": 706991,
	"./Audio/moith.mp3": 815218,
	"./Audio/moke-2.mp3": 258936,
	"./Audio/moke.mp3": 33165,
	"./Audio/mole.mp3": 250820,
	"./Audio/molt.mp3": 907321,
	"./Audio/mom-2.mp3": 424375,
	"./Audio/mom.mp3": 510762,
	"./Audio/mon-2.mp3": 756040,
	"./Audio/mon.mp3": 248765,
	"./Audio/monarch.mp3": 593329,
	"./Audio/monday.mp3": 633553,
	"./Audio/monday2.mp3": 948017,
	"./Audio/money.mp3": 215151,
	"./Audio/monkey.mp3": 465558,
	"./Audio/monogram.mp3": 263113,
	"./Audio/monologue.mp3": 368836,
	"./Audio/monorail.mp3": 476380,
	"./Audio/monosyllable.mp3": 806692,
	"./Audio/monotonous.mp3": 922310,
	"./Audio/montain-2.mp3": 832216,
	"./Audio/montain.mp3": 732397,
	"./Audio/month.mp3": 848654,
	"./Audio/mood.mp3": 183212,
	"./Audio/moon.mp3": 486950,
	"./Audio/mop.mp3": 641299,
	"./Audio/more.mp3": 785378,
	"./Audio/morning.mp3": 757531,
	"./Audio/mortal.mp3": 141308,
	"./Audio/mortality.mp3": 57744,
	"./Audio/mortgage.mp3": 877875,
	"./Audio/mortician.mp3": 354737,
	"./Audio/mosh.mp3": 245348,
	"./Audio/mosque.mp3": 128087,
	"./Audio/most.mp3": 195760,
	"./Audio/mot.mp3": 101559,
	"./Audio/moth.mp3": 810925,
	"./Audio/mother.mp3": 511840,
	"./Audio/motherhood.mp3": 801842,
	"./Audio/motion.mp3": 312847,
	"./Audio/motive.mp3": 896195,
	"./Audio/motorcycle.mp3": 358506,
	"./Audio/motorcyclist.mp3": 200283,
	"./Audio/motorist.mp3": 121876,
	"./Audio/mound.mp3": 693484,
	"./Audio/mount.mp3": 201116,
	"./Audio/mountain.mp3": 384828,
	"./Audio/mountainous.mp3": 26139,
	"./Audio/mourning.mp3": 883134,
	"./Audio/mouse's.mp3": 667912,
	"./Audio/mouse.mp3": 965026,
	"./Audio/mouse_s.mp3": 617776,
	"./Audio/moustache.mp3": 148982,
	"./Audio/mouth.mp3": 657638,
	"./Audio/move.mp3": 716358,
	"./Audio/movement.mp3": 84038,
	"./Audio/moving.mp3": 561619,
	"./Audio/moxer.mp3": 927578,
	"./Audio/moxor.mp3": 246244,
	"./Audio/moz.mp3": 580745,
	"./Audio/mr.mp3": 894392,
	"./Audio/mrs.mp3": 19415,
	"./Audio/much.mp3": 18234,
	"./Audio/mud.mp3": 532357,
	"./Audio/mude.mp3": 443910,
	"./Audio/mug.mp3": 764786,
	"./Audio/muil.mp3": 736912,
	"./Audio/muintain.mp3": 444842,
	"./Audio/muith.mp3": 254536,
	"./Audio/muke.mp3": 435147,
	"./Audio/mule.mp3": 546334,
	"./Audio/mult.mp3": 532115,
	"./Audio/multiple.mp3": 134497,
	"./Audio/multiply.mp3": 178941,
	"./Audio/mum.mp3": 875528,
	"./Audio/mumble.mp3": 363599,
	"./Audio/mun.mp3": 768255,
	"./Audio/muntain.mp3": 935147,
	"./Audio/mup.mp3": 235377,
	"./Audio/murl.mp3": 457221,
	"./Audio/muscle.mp3": 726520,
	"./Audio/museum.mp3": 242969,
	"./Audio/music.mp3": 512634,
	"./Audio/musician.mp3": 434162,
	"./Audio/muss.mp3": 909637,
	"./Audio/must.mp3": 620110,
	"./Audio/mustn't.mp3": 382521,
	"./Audio/mut.mp3": 846101,
	"./Audio/muth.mp3": 330391,
	"./Audio/muww.mp3": 441045,
	"./Audio/muxx.mp3": 108691,
	"./Audio/muyy.mp3": 226257,
	"./Audio/muzz.mp3": 77483,
	"./Audio/my.mp3": 76519,
	"./Audio/mysterious.mp3": 897263,
	"./Audio/mystery.mp3": 98616,
	"./Audio/myth.mp3": 706987,
	"./Audio/n -2.mp3": 624866,
	"./Audio/n -3.mp3": 229799,
	"./Audio/n.mp3": 802233,
	"./Audio/na.mp3": 381702,
	"./Audio/nacc.mp3": 116432,
	"./Audio/nach.mp3": 793135,
	"./Audio/nack.mp3": 789240,
	"./Audio/nad.mp3": 796790,
	"./Audio/nade.mp3": 448043,
	"./Audio/nag.mp3": 226217,
	"./Audio/nagg.mp3": 161288,
	"./Audio/nait.mp3": 80465,
	"./Audio/nall.mp3": 729558,
	"./Audio/nam.mp3": 315379,
	"./Audio/name.mp3": 483704,
	"./Audio/named.mp3": 901452,
	"./Audio/nan.mp3": 234044,
	"./Audio/nap.mp3": 367882,
	"./Audio/nar.mp3": 200120,
	"./Audio/narl.mp3": 462932,
	"./Audio/narr.mp3": 658514,
	"./Audio/narrator.mp3": 843350,
	"./Audio/nas.mp3": 812637,
	"./Audio/nash.mp3": 392607,
	"./Audio/nast.mp3": 713411,
	"./Audio/nastiness.mp3": 432473,
	"./Audio/nat.mp3": 81990,
	"./Audio/nath.mp3": 52370,
	"./Audio/nation.mp3": 893132,
	"./Audio/national.mp3": 942111,
	"./Audio/nationality.mp3": 934113,
	"./Audio/nationally.mp3": 670214,
	"./Audio/native.mp3": 277224,
	"./Audio/natives.mp3": 798535,
	"./Audio/nativity.mp3": 564357,
	"./Audio/natural.mp3": 375760,
	"./Audio/nature.mp3": 989320,
	"./Audio/naught.mp3": 679462,
	"./Audio/naughtier.mp3": 495134,
	"./Audio/naughty.mp3": 186759,
	"./Audio/naw.mp3": 741881,
	"./Audio/nawt.mp3": 844319,
	"./Audio/naz.mp3": 916816,
	"./Audio/ne.mp3": 125066,
	"./Audio/near.mp3": 652867,
	"./Audio/nearby.mp3": 165028,
	"./Audio/necc.mp3": 342132,
	"./Audio/necessary.mp3": 850126,
	"./Audio/necessity.mp3": 726360,
	"./Audio/neck.mp3": 803116,
	"./Audio/neckon.mp3": 362067,
	"./Audio/ned.mp3": 186922,
	"./Audio/nede.mp3": 315631,
	"./Audio/need.mp3": 495913,
	"./Audio/neen.mp3": 585075,
	"./Audio/neet.mp3": 11577,
	"./Audio/neg.mp3": 924925,
	"./Audio/negate.mp3": 374599,
	"./Audio/negative.mp3": 622380,
	"./Audio/negg.mp3": 631004,
	"./Audio/neglect.mp3": 268857,
	"./Audio/negligence.mp3": 348882,
	"./Audio/negotiations.mp3": 43871,
	"./Audio/neighbour.mp3": 453762,
	"./Audio/neighbourhood.mp3": 405852,
	"./Audio/neighbouring.mp3": 733590,
	"./Audio/neighbourly.mp3": 525731,
	"./Audio/neither.mp3": 607526,
	"./Audio/nell.mp3": 861786,
	"./Audio/nelnet.mp3": 925623,
	"./Audio/nem.mp3": 802439,
	"./Audio/neme.mp3": 666892,
	"./Audio/nen.mp3": 988720,
	"./Audio/nep.mp3": 857494,
	"./Audio/nephew.mp3": 644318,
	"./Audio/nerr.mp3": 951286,
	"./Audio/nervous.mp3": 670893,
	"./Audio/nescar.mp3": 154825,
	"./Audio/nescay.mp3": 564110,
	"./Audio/nescear.mp3": 568348,
	"./Audio/nescow.mp3": 427886,
	"./Audio/nescue.mp3": 499998,
	"./Audio/nest.mp3": 811951,
	"./Audio/net.mp3": 25178,
	"./Audio/never.mp3": 122465,
	"./Audio/new.mp3": 97197,
	"./Audio/newspaper.mp3": 331318,
	"./Audio/newt.mp3": 552019,
	"./Audio/next.mp3": 640529,
	"./Audio/ng -2.mp3": 858257,
	"./Audio/ng -3.mp3": 800396,
	"./Audio/ng .mp3": 169232,
	"./Audio/ng.mp3": 346808,
	"./Audio/ni.mp3": 908350,
	"./Audio/nib.mp3": 378896,
	"./Audio/nic.mp3": 65525,
	"./Audio/nice.mp3": 292694,
	"./Audio/nicer.mp3": 762120,
	"./Audio/nicest.mp3": 601171,
	"./Audio/nick.mp3": 415200,
	"./Audio/nid.mp3": 766270,
	"./Audio/nide.mp3": 713539,
	"./Audio/niece.mp3": 110443,
	"./Audio/niff.mp3": 92290,
	"./Audio/nig.mp3": 938705,
	"./Audio/night.mp3": 517861,
	"./Audio/nim.mp3": 152555,
	"./Audio/nime.mp3": 857952,
	"./Audio/nin.mp3": 148116,
	"./Audio/nine.mp3": 533101,
	"./Audio/nineteen.mp3": 245581,
	"./Audio/nip.mp3": 343698,
	"./Audio/nis.mp3": 134245,
	"./Audio/nisit.mp3": 465410,
	"./Audio/nit.mp3": 250606,
	"./Audio/nk.mp3": 565452,
	"./Audio/no.mp3": 674000,
	"./Audio/noa.mp3": 950013,
	"./Audio/noal.mp3": 789179,
	"./Audio/noan.mp3": 467849,
	"./Audio/nobly.mp3": 474603,
	"./Audio/nock.mp3": 849810,
	"./Audio/nod.mp3": 72436,
	"./Audio/node.mp3": 21645,
	"./Audio/noise.mp3": 622545,
	"./Audio/noisily.mp3": 780068,
	"./Audio/noisy.mp3": 3981,
	"./Audio/nol.mp3": 17068,
	"./Audio/nom.mp3": 379377,
	"./Audio/nome.mp3": 869138,
	"./Audio/non-essential.mp3": 404525,
	"./Audio/non-profit.mp3": 314761,
	"./Audio/nondescript.mp3": 725870,
	"./Audio/nonfiction.mp3": 482466,
	"./Audio/nonsense.mp3": 527336,
	"./Audio/noo.mp3": 221859,
	"./Audio/noon.mp3": 997623,
	"./Audio/noot.mp3": 687357,
	"./Audio/nop.mp3": 19528,
	"./Audio/nor.mp3": 719642,
	"./Audio/norl.mp3": 364338,
	"./Audio/normal.mp3": 747420,
	"./Audio/norn.mp3": 156192,
	"./Audio/nose.mp3": 757396,
	"./Audio/nost.mp3": 297577,
	"./Audio/nostril.mp3": 291430,
	"./Audio/not.mp3": 547044,
	"./Audio/notation.mp3": 226391,
	"./Audio/notch.mp3": 190665,
	"./Audio/note.mp3": 893661,
	"./Audio/noted.mp3": 175539,
	"./Audio/nothing.mp3": 730948,
	"./Audio/notice.mp3": 552773,
	"./Audio/noticeable.mp3": 101609,
	"./Audio/notified.mp3": 154497,
	"./Audio/notifies.mp3": 590498,
	"./Audio/notify.mp3": 210450,
	"./Audio/notifying.mp3": 433478,
	"./Audio/notion.mp3": 268982,
	"./Audio/nought.mp3": 84556,
	"./Audio/nourish.mp3": 39111,
	"./Audio/novel.mp3": 561805,
	"./Audio/novelty.mp3": 289276,
	"./Audio/november.mp3": 406999,
	"./Audio/novice.mp3": 474391,
	"./Audio/now.mp3": 603323,
	"./Audio/nowhere.mp3": 600477,
	"./Audio/nowl.mp3": 182685,
	"./Audio/nowt.mp3": 42213,
	"./Audio/nuch.mp3": 575507,
	"./Audio/nucket.mp3": 897179,
	"./Audio/nuclear.mp3": 649153,
	"./Audio/nud.mp3": 547962,
	"./Audio/nude.mp3": 880351,
	"./Audio/nudged.mp3": 261758,
	"./Audio/nuf.mp3": 107880,
	"./Audio/nug.mp3": 797837,
	"./Audio/nuhe.mp3": 585171,
	"./Audio/nuisance.mp3": 67003,
	"./Audio/num.mp3": 809559,
	"./Audio/numb.mp3": 81175,
	"./Audio/nume.mp3": 82108,
	"./Audio/numerical.mp3": 858781,
	"./Audio/numerically.mp3": 787236,
	"./Audio/numerous.mp3": 186105,
	"./Audio/nun.mp3": 45312,
	"./Audio/nup.mp3": 505414,
	"./Audio/nure.mp3": 85549,
	"./Audio/nurkair.mp3": 657761,
	"./Audio/nurkar.mp3": 187142,
	"./Audio/nurkay.mp3": 886225,
	"./Audio/nurkey.mp3": 218477,
	"./Audio/nurkoy.mp3": 188043,
	"./Audio/nurse.mp3": 671680,
	"./Audio/nus.mp3": 165305,
	"./Audio/nush.mp3": 256323,
	"./Audio/nuss.mp3": 926596,
	"./Audio/nut.mp3": 791306,
	"./Audio/nutritious.mp3": 512927,
	"./Audio/nutritiously.mp3": 596934,
	"./Audio/o -2.mp3": 27325,
	"./Audio/o -3.mp3": 304600,
	"./Audio/o -4.mp3": 154443,
	"./Audio/o -5.mp3": 398118,
	"./Audio/o -6.mp3": 109593,
	"./Audio/o.mp3": 230036,
	"./Audio/o2.mp3": 358438,
	"./Audio/oa.mp3": 135049,
	"./Audio/oak.mp3": 532284,
	"./Audio/oal.mp3": 684375,
	"./Audio/ob.mp3": 888662,
	"./Audio/obedience.mp3": 143171,
	"./Audio/obedient.mp3": 976101,
	"./Audio/obey.mp3": 965908,
	"./Audio/object.mp3": 296536,
	"./Audio/obligatory.mp3": 293187,
	"./Audio/observance.mp3": 790443,
	"./Audio/observant.mp3": 394205,
	"./Audio/observation.mp3": 915141,
	"./Audio/obsession.mp3": 23698,
	"./Audio/obstruct.mp3": 579017,
	"./Audio/obstruction.mp3": 658917,
	"./Audio/obtuse.mp3": 558227,
	"./Audio/obvious.mp3": 863596,
	"./Audio/occasion.mp3": 244480,
	"./Audio/occasional.mp3": 612523,
	"./Audio/occasionally.mp3": 635354,
	"./Audio/occupancy.mp3": 657100,
	"./Audio/occupant.mp3": 783552,
	"./Audio/occupier.mp3": 74523,
	"./Audio/occupy.mp3": 493086,
	"./Audio/occur.mp3": 847515,
	"./Audio/octagon.mp3": 132738,
	"./Audio/octet.mp3": 117414,
	"./Audio/october.mp3": 882475,
	"./Audio/octopus.mp3": 749784,
	"./Audio/odorous.mp3": 17938,
	"./Audio/of.mp3": 56346,
	"./Audio/off.mp3": 144712,
	"./Audio/official.mp3": 258194,
	"./Audio/often.mp3": 812947,
	"./Audio/oh.mp3": 165852,
	"./Audio/ohh.mp3": 903460,
	"./Audio/oil.mp3": 353839,
	"./Audio/oit.mp3": 662807,
	"./Audio/ok.mp3": 195603,
	"./Audio/ol.mp3": 400672,
	"./Audio/old.mp3": 909220,
	"./Audio/om.mp3": 529413,
	"./Audio/ome.mp3": 374470,
	"./Audio/omnidirectional.mp3": 5302,
	"./Audio/omnipotent.mp3": 96622,
	"./Audio/omnipresent.mp3": 38619,
	"./Audio/omniscient.mp3": 9280,
	"./Audio/omnivore.mp3": 598556,
	"./Audio/omnivorous.mp3": 646190,
	"./Audio/on.mp3": 761842,
	"./Audio/once.mp3": 42706,
	"./Audio/one.mp3": 626695,
	"./Audio/only.mp3": 393203,
	"./Audio/onslome.mp3": 200048,
	"./Audio/onsode.mp3": 609685,
	"./Audio/oo -2.mp3": 318848,
	"./Audio/oo -3.mp3": 369125,
	"./Audio/oo -4.mp3": 485486,
	"./Audio/oo -5.mp3": 12339,
	"./Audio/oo -6.mp3": 931004,
	"./Audio/oo .mp3": 838533,
	"./Audio/oo.mp3": 139511,
	"./Audio/oon.mp3": 738171,
	"./Audio/oot.mp3": 209777,
	"./Audio/op.mp3": 925492,
	"./Audio/opacity.mp3": 975400,
	"./Audio/opaque.mp3": 647168,
	"./Audio/operable.mp3": 861641,
	"./Audio/operation.mp3": 483048,
	"./Audio/opp.mp3": 849876,
	"./Audio/opportune.mp3": 450673,
	"./Audio/opportunist.mp3": 545540,
	"./Audio/opportunistic.mp3": 353532,
	"./Audio/opportunity.mp3": 573100,
	"./Audio/opposing.mp3": 540758,
	"./Audio/opposite.mp3": 938086,
	"./Audio/opposition.mp3": 937433,
	"./Audio/optician.mp3": 723856,
	"./Audio/option.mp3": 513346,
	"./Audio/or -2.mp3": 963847,
	"./Audio/or -3.mp3": 381890,
	"./Audio/or .mp3": 932378,
	"./Audio/or.mp3": 173862,
	"./Audio/orchestra.mp3": 648898,
	"./Audio/orchid.mp3": 432260,
	"./Audio/order.mp3": 645443,
	"./Audio/ordered.mp3": 712924,
	"./Audio/ordinary.mp3": 303231,
	"./Audio/ore.mp3": 305083,
	"./Audio/orhan.mp3": 262647,
	"./Audio/original.mp3": 747344,
	"./Audio/orl.mp3": 88590,
	"./Audio/orn.mp3": 226460,
	"./Audio/orpan.mp3": 604671,
	"./Audio/orphan.mp3": 710475,
	"./Audio/orran.mp3": 598977,
	"./Audio/ort.mp3": 234470,
	"./Audio/ortor.mp3": 541633,
	"./Audio/os.mp3": 930187,
	"./Audio/ose.mp3": 455808,
	"./Audio/oss.mp3": 138110,
	"./Audio/ostentatious.mp3": 214027,
	"./Audio/ot.mp3": 596696,
	"./Audio/other.mp3": 525201,
	"./Audio/ou.mp3": 803069,
	"./Audio/ouch.mp3": 945184,
	"./Audio/ought.mp3": 771048,
	"./Audio/our.mp3": 361941,
	"./Audio/out.mp3": 77347,
	"./Audio/outgoings.mp3": 12246,
	"./Audio/outrage.mp3": 527996,
	"./Audio/outrageous.mp3": 565083,
	"./Audio/outside.mp3": 274466,
	"./Audio/oval.mp3": 206893,
	"./Audio/over.mp3": 248399,
	"./Audio/overambitious.mp3": 994822,
	"./Audio/overbalance.mp3": 48081,
	"./Audio/overcoat.mp3": 739002,
	"./Audio/overcook.mp3": 807915,
	"./Audio/overfamiliar.mp3": 694622,
	"./Audio/overfamiliarity.mp3": 542209,
	"./Audio/overlook.mp3": 396278,
	"./Audio/overpaid.mp3": 699525,
	"./Audio/overpopulated.mp3": 983407,
	"./Audio/overreact.mp3": 816856,
	"./Audio/overslept.mp3": 847787,
	"./Audio/overthrow.mp3": 126141,
	"./Audio/overtired.mp3": 825215,
	"./Audio/overturn.mp3": 863602,
	"./Audio/ow -2.mp3": 363448,
	"./Audio/ow .mp3": 39565,
	"./Audio/ow.mp3": 239119,
	"./Audio/ow2.mp3": 258671,
	"./Audio/owl.mp3": 911169,
	"./Audio/own.mp3": 165107,
	"./Audio/ownership.mp3": 643236,
	"./Audio/oxygen.mp3": 31101,
	"./Audio/oy -2.mp3": 392986,
	"./Audio/oy -3.mp3": 101951,
	"./Audio/oy .mp3": 999859,
	"./Audio/oy.mp3": 232433,
	"./Audio/oyster.mp3": 692601,
	"./Audio/p -2.mp3": 555872,
	"./Audio/p -3.mp3": 531589,
	"./Audio/p.mp3": 446487,
	"./Audio/pa.mp3": 206720,
	"./Audio/pab.mp3": 680122,
	"./Audio/pace.mp3": 94324,
	"./Audio/pach.mp3": 234370,
	"./Audio/pacific.mp3": 789010,
	"./Audio/pack.mp3": 267458,
	"./Audio/pact.mp3": 303881,
	"./Audio/pad.mp3": 793988,
	"./Audio/paddle.mp3": 626765,
	"./Audio/pag.mp3": 314779,
	"./Audio/page.mp3": 29936,
	"./Audio/pai.mp3": 227749,
	"./Audio/paid.mp3": 954955,
	"./Audio/paik.mp3": 587184,
	"./Audio/paim.mp3": 777118,
	"./Audio/pain.mp3": 952753,
	"./Audio/painful.mp3": 14750,
	"./Audio/paint.mp3": 888935,
	"./Audio/pair.mp3": 695661,
	"./Audio/paison.mp3": 858447,
	"./Audio/pait.mp3": 481147,
	"./Audio/pak.mp3": 484247,
	"./Audio/pake.mp3": 275260,
	"./Audio/palace.mp3": 984245,
	"./Audio/pale.mp3": 723045,
	"./Audio/palm.mp3": 425293,
	"./Audio/palp.mp3": 469644,
	"./Audio/palt.mp3": 967696,
	"./Audio/pam.mp3": 312577,
	"./Audio/pamphlet.mp3": 855224,
	"./Audio/pan.mp3": 344110,
	"./Audio/pank.mp3": 253613,
	"./Audio/pantob.mp3": 907801,
	"./Audio/pap.mp3": 298232,
	"./Audio/paper.mp3": 79729,
	"./Audio/par.mp3": 76490,
	"./Audio/parachute.mp3": 276298,
	"./Audio/parade.mp3": 711718,
	"./Audio/paradoxically.mp3": 550422,
	"./Audio/paragraph.mp3": 202673,
	"./Audio/parallel.mp3": 325724,
	"./Audio/paranormal.mp3": 111174,
	"./Audio/parasite.mp3": 701930,
	"./Audio/pard.mp3": 795050,
	"./Audio/parents'.mp3": 588507,
	"./Audio/parents.mp3": 943616,
	"./Audio/park.mp3": 962417,
	"./Audio/parliament.mp3": 861768,
	"./Audio/parsley.mp3": 165369,
	"./Audio/partial.mp3": 306944,
	"./Audio/participate.mp3": 419855,
	"./Audio/particular.mp3": 162572,
	"./Audio/particularly.mp3": 169965,
	"./Audio/parties.mp3": 631927,
	"./Audio/partnership.mp3": 427035,
	"./Audio/partridge.mp3": 266115,
	"./Audio/party.mp3": 152611,
	"./Audio/pas.mp3": 302127,
	"./Audio/pash.mp3": 111429,
	"./Audio/pass.mp3": 342634,
	"./Audio/passed.mp3": 625673,
	"./Audio/passenger.mp3": 287183,
	"./Audio/passes.mp3": 555690,
	"./Audio/passive.mp3": 198052,
	"./Audio/passport.mp3": 843111,
	"./Audio/past.mp3": 467353,
	"./Audio/pat-2.mp3": 43853,
	"./Audio/pat.mp3": 725268,
	"./Audio/patch.mp3": 314681,
	"./Audio/patches.mp3": 392310,
	"./Audio/path.mp3": 453084,
	"./Audio/patient.mp3": 814636,
	"./Audio/patiently.mp3": 923021,
	"./Audio/patted.mp3": 316055,
	"./Audio/patting.mp3": 978024,
	"./Audio/pause.mp3": 64125,
	"./Audio/paw.mp3": 788587,
	"./Audio/payment.mp3": 173921,
	"./Audio/payrsay.mp3": 492234,
	"./Audio/payrtay.mp3": 667905,
	"./Audio/paz.mp3": 875426,
	"./Audio/pe.mp3": 514428,
	"./Audio/peace.mp3": 274549,
	"./Audio/pear.mp3": 129633,
	"./Audio/pearl.mp3": 687343,
	"./Audio/peb.mp3": 507502,
	"./Audio/peckon.mp3": 746741,
	"./Audio/peculiar.mp3": 434576,
	"./Audio/peculiarities.mp3": 603152,
	"./Audio/peculiarity.mp3": 298676,
	"./Audio/peculiarly.mp3": 123369,
	"./Audio/ped.mp3": 340864,
	"./Audio/pedal.mp3": 831019,
	"./Audio/peege.mp3": 711181,
	"./Audio/peem.mp3": 459742,
	"./Audio/peen.mp3": 609201,
	"./Audio/peer.mp3": 894637,
	"./Audio/peers.mp3": 814496,
	"./Audio/peet.mp3": 833147,
	"./Audio/peg.mp3": 105111,
	"./Audio/peke.mp3": 381936,
	"./Audio/pelt.mp3": 237228,
	"./Audio/pen.mp3": 843514,
	"./Audio/penalises.mp3": 745769,
	"./Audio/pence.mp3": 714330,
	"./Audio/pencil.mp3": 810678,
	"./Audio/penniless.mp3": 473586,
	"./Audio/pension.mp3": 128757,
	"./Audio/pentagon.mp3": 495849,
	"./Audio/pentagram.mp3": 365482,
	"./Audio/people's.mp3": 548622,
	"./Audio/people.mp3": 210304,
	"./Audio/pep.mp3": 137740,
	"./Audio/perceive.mp3": 186232,
	"./Audio/percent.mp3": 358848,
	"./Audio/percentage.mp3": 658069,
	"./Audio/perennial.mp3": 311863,
	"./Audio/perfect.mp3": 179308,
	"./Audio/perfectly.mp3": 575693,
	"./Audio/perfeeme.mp3": 95912,
	"./Audio/perfime.mp3": 493303,
	"./Audio/perfome.mp3": 780645,
	"./Audio/perfume.mp3": 484739,
	"./Audio/perhaps.mp3": 690220,
	"./Audio/peril.mp3": 899297,
	"./Audio/period.mp3": 902446,
	"./Audio/perishable.mp3": 923594,
	"./Audio/permanent.mp3": 207901,
	"./Audio/permission.mp3": 475060,
	"./Audio/permitted.mp3": 945979,
	"./Audio/perpetual.mp3": 623269,
	"./Audio/persist.mp3": 365351,
	"./Audio/persistent.mp3": 49818,
	"./Audio/person.mp3": 936970,
	"./Audio/perspective.mp3": 580281,
	"./Audio/persuade.mp3": 113882,
	"./Audio/perusal.mp3": 856417,
	"./Audio/pet.mp3": 635792,
	"./Audio/pete.mp3": 127705,
	"./Audio/petition.mp3": 324619,
	"./Audio/pew.mp3": 490727,
	"./Audio/phantob.mp3": 365823,
	"./Audio/pharmacy.mp3": 600198,
	"./Audio/phene.mp3": 660589,
	"./Audio/phine.mp3": 485817,
	"./Audio/phone.mp3": 254599,
	"./Audio/phonics.mp3": 322965,
	"./Audio/phopics.mp3": 84851,
	"./Audio/phot.mp3": 950936,
	"./Audio/photo.mp3": 529291,
	"./Audio/photograph.mp3": 196209,
	"./Audio/phream.mp3": 282444,
	"./Audio/phune.mp3": 144349,
	"./Audio/physical.mp3": 783858,
	"./Audio/physicality.mp3": 459714,
	"./Audio/physically.mp3": 537331,
	"./Audio/physician.mp3": 248823,
	"./Audio/physicist.mp3": 42519,
	"./Audio/physics.mp3": 585112,
	"./Audio/pic.mp3": 492087,
	"./Audio/pick.mp3": 382106,
	"./Audio/pict.mp3": 558193,
	"./Audio/picture.mp3": 451477,
	"./Audio/pid.mp3": 544604,
	"./Audio/pie.mp3": 137377,
	"./Audio/piece.mp3": 929429,
	"./Audio/pieces.mp3": 461816,
	"./Audio/pig.mp3": 421331,
	"./Audio/pige.mp3": 247320,
	"./Audio/pight.mp3": 232935,
	"./Audio/pike.mp3": 89940,
	"./Audio/pim.mp3": 513801,
	"./Audio/pin.mp3": 114390,
	"./Audio/pineapple.mp3": 822017,
	"./Audio/pinf.mp3": 693300,
	"./Audio/pink.mp3": 457941,
	"./Audio/pip.mp3": 245616,
	"./Audio/pipe.mp3": 401401,
	"./Audio/pit.mp3": 553324,
	"./Audio/pity.mp3": 896105,
	"./Audio/pla.mp3": 282838,
	"./Audio/placate.mp3": 780871,
	"./Audio/place.mp3": 319118,
	"./Audio/plag.mp3": 717785,
	"./Audio/plai.mp3": 513031,
	"./Audio/plain.mp3": 468587,
	"./Audio/plainness.mp3": 475134,
	"./Audio/plair.mp3": 164247,
	"./Audio/plairon.mp3": 397452,
	"./Audio/plam.mp3": 907363,
	"./Audio/plane.mp3": 391221,
	"./Audio/plank.mp3": 478251,
	"./Audio/plant.mp3": 867136,
	"./Audio/plants.mp3": 52271,
	"./Audio/plaon.mp3": 320269,
	"./Audio/plaque.mp3": 789565,
	"./Audio/play.mp3": 971959,
	"./Audio/playful.mp3": 892932,
	"./Audio/playground.mp3": 379094,
	"./Audio/playon.mp3": 45036,
	"./Audio/plays.mp3": 999746,
	"./Audio/pleasant.mp3": 570789,
	"./Audio/please.mp3": 964691,
	"./Audio/pleasure.mp3": 249728,
	"./Audio/plee.mp3": 460543,
	"./Audio/pleeon.mp3": 276116,
	"./Audio/plentiful.mp3": 481774,
	"./Audio/plinth.mp3": 666152,
	"./Audio/ploe.mp3": 8393,
	"./Audio/plonk.mp3": 29197,
	"./Audio/plot.mp3": 315188,
	"./Audio/plough.mp3": 90264,
	"./Audio/ploy.mp3": 232853,
	"./Audio/pluck.mp3": 79948,
	"./Audio/plug.mp3": 299805,
	"./Audio/plum.mp3": 928295,
	"./Audio/plumb.mp3": 20871,
	"./Audio/plumber's.mp3": 757212,
	"./Audio/plumber.mp3": 976078,
	"./Audio/plume.mp3": 998508,
	"./Audio/plump.mp3": 657797,
	"./Audio/plush.mp3": 522323,
	"./Audio/poa.mp3": 744879,
	"./Audio/poad.mp3": 685065,
	"./Audio/poak.mp3": 616306,
	"./Audio/poam.mp3": 715868,
	"./Audio/poan.mp3": 592595,
	"./Audio/poason.mp3": 504033,
	"./Audio/poat.mp3": 739801,
	"./Audio/pocket.mp3": 234775,
	"./Audio/pod.mp3": 775878,
	"./Audio/podet.mp3": 81285,
	"./Audio/poff.mp3": 463002,
	"./Audio/pog.mp3": 893241,
	"./Audio/poge.mp3": 700874,
	"./Audio/pohh.mp3": 129078,
	"./Audio/poi.mp3": 923111,
	"./Audio/point.mp3": 233269,
	"./Audio/poison.mp3": 243401,
	"./Audio/poisonous.mp3": 334724,
	"./Audio/poke.mp3": 463766,
	"./Audio/polar.mp3": 264183,
	"./Audio/pole.mp3": 731587,
	"./Audio/politician.mp3": 288279,
	"./Audio/pollution.mp3": 771113,
	"./Audio/pom.mp3": 82819,
	"./Audio/pomp.mp3": 632121,
	"./Audio/pon.mp3": 959628,
	"./Audio/pond.mp3": 888624,
	"./Audio/ponies.mp3": 655785,
	"./Audio/ponk.mp3": 256395,
	"./Audio/pool.mp3": 181631,
	"./Audio/poom.mp3": 472666,
	"./Audio/poor.mp3": 801777,
	"./Audio/poot.mp3": 249927,
	"./Audio/pop.mp3": 122874,
	"./Audio/popcorn.mp3": 734224,
	"./Audio/popet.mp3": 767753,
	"./Audio/popics.mp3": 218013,
	"./Audio/popp.mp3": 385990,
	"./Audio/popular.mp3": 374976,
	"./Audio/popularity.mp3": 642052,
	"./Audio/populate.mp3": 167571,
	"./Audio/populating.mp3": 90426,
	"./Audio/population.mp3": 104340,
	"./Audio/por.mp3": 378344,
	"./Audio/pore.mp3": 741729,
	"./Audio/porridge.mp3": 737885,
	"./Audio/portable.mp3": 515748,
	"./Audio/porter.mp3": 807165,
	"./Audio/portion.mp3": 759518,
	"./Audio/posing.mp3": 847403,
	"./Audio/position.mp3": 850632,
	"./Audio/positive.mp3": 876628,
	"./Audio/poss.mp3": 378304,
	"./Audio/possess.mp3": 209131,
	"./Audio/possessed.mp3": 746660,
	"./Audio/possesses.mp3": 373775,
	"./Audio/possessing.mp3": 992037,
	"./Audio/possession.mp3": 870987,
	"./Audio/possessions.mp3": 199294,
	"./Audio/possessive.mp3": 512735,
	"./Audio/possible.mp3": 118032,
	"./Audio/possibly.mp3": 286596,
	"./Audio/postal.mp3": 53344,
	"./Audio/postdate.mp3": 758311,
	"./Audio/postmortem.mp3": 95715,
	"./Audio/postpone.mp3": 204979,
	"./Audio/postscript.mp3": 810814,
	"./Audio/pot.mp3": 948150,
	"./Audio/potatoes.mp3": 962628,
	"./Audio/potential.mp3": 441001,
	"./Audio/potet.mp3": 382165,
	"./Audio/potter.mp3": 510563,
	"./Audio/poultry.mp3": 435348,
	"./Audio/pound.mp3": 563497,
	"./Audio/pour.mp3": 478099,
	"./Audio/pow.mp3": 920105,
	"./Audio/powson.mp3": 25243,
	"./Audio/practice.mp3": 89462,
	"./Audio/practise.mp3": 808454,
	"./Audio/praise.mp3": 665969,
	"./Audio/pram.mp3": 568785,
	"./Audio/prance.mp3": 75350,
	"./Audio/pray.mp3": 764325,
	"./Audio/pre-empt.mp3": 806519,
	"./Audio/pre-existing.mp3": 462850,
	"./Audio/pream.mp3": 411482,
	"./Audio/prearrange.mp3": 900228,
	"./Audio/precautionary.mp3": 610727,
	"./Audio/precede.mp3": 727877,
	"./Audio/precept.mp3": 91588,
	"./Audio/precious.mp3": 774875,
	"./Audio/prediction.mp3": 483038,
	"./Audio/preene.mp3": 808354,
	"./Audio/prefab.mp3": 341867,
	"./Audio/prefer.mp3": 412775,
	"./Audio/preference.mp3": 976106,
	"./Audio/preferential.mp3": 553664,
	"./Audio/preferred.mp3": 820640,
	"./Audio/preferring.mp3": 270457,
	"./Audio/prehistoric.mp3": 787019,
	"./Audio/prehistorically.mp3": 782977,
	"./Audio/prehistory.mp3": 211796,
	"./Audio/prejudice.mp3": 620098,
	"./Audio/prem.mp3": 68189,
	"./Audio/preoccupied.mp3": 359216,
	"./Audio/preoccupy.mp3": 769783,
	"./Audio/preparation.mp3": 34132,
	"./Audio/prepare.mp3": 201890,
	"./Audio/prepared.mp3": 212050,
	"./Audio/preparing.mp3": 600919,
	"./Audio/prescribe.mp3": 53094,
	"./Audio/prescribed.mp3": 59734,
	"./Audio/prescribes.mp3": 974141,
	"./Audio/prescription.mp3": 73789,
	"./Audio/present.mp3": 907654,
	"./Audio/preserve.mp3": 204009,
	"./Audio/press.mp3": 374134,
	"./Audio/pressed.mp3": 589381,
	"./Audio/presses.mp3": 295966,
	"./Audio/pressure.mp3": 969432,
	"./Audio/pressuring.mp3": 279421,
	"./Audio/pretend.mp3": 349035,
	"./Audio/pretentious.mp3": 416384,
	"./Audio/pretty.mp3": 411825,
	"./Audio/prevent.mp3": 77045,
	"./Audio/previous.mp3": 755978,
	"./Audio/previously.mp3": 805131,
	"./Audio/prey.mp3": 481769,
	"./Audio/price.mp3": 480780,
	"./Audio/prick.mp3": 429898,
	"./Audio/primary.mp3": 197613,
	"./Audio/prince.mp3": 937694,
	"./Audio/principal.mp3": 399393,
	"./Audio/principle.mp3": 806211,
	"./Audio/prine.mp3": 750843,
	"./Audio/print.mp3": 468326,
	"./Audio/privilege.mp3": 21910,
	"./Audio/prize.mp3": 483199,
	"./Audio/probable.mp3": 821008,
	"./Audio/probably.mp3": 600068,
	"./Audio/problem.mp3": 666262,
	"./Audio/proceed.mp3": 531821,
	"./Audio/processes.mp3": 801724,
	"./Audio/procession.mp3": 462802,
	"./Audio/procrastinate.mp3": 859954,
	"./Audio/produce.mp3": 592131,
	"./Audio/produces.mp3": 906054,
	"./Audio/production.mp3": 618260,
	"./Audio/profession.mp3": 796919,
	"./Audio/professional.mp3": 690716,
	"./Audio/profile.mp3": 587988,
	"./Audio/profit.mp3": 204359,
	"./Audio/prognosis.mp3": 662611,
	"./Audio/program.mp3": 215411,
	"./Audio/programme.mp3": 917209,
	"./Audio/programmed.mp3": 59407,
	"./Audio/programmer.mp3": 955337,
	"./Audio/programs.mp3": 332214,
	"./Audio/progress.mp3": 3284,
	"./Audio/progressed.mp3": 552739,
	"./Audio/progression.mp3": 965830,
	"./Audio/progressive.mp3": 249254,
	"./Audio/prohet.mp3": 685249,
	"./Audio/project.mp3": 919368,
	"./Audio/prologue.mp3": 630130,
	"./Audio/promise.mp3": 444472,
	"./Audio/promised.mp3": 51212,
	"./Audio/promises.mp3": 18583,
	"./Audio/promising.mp3": 503453,
	"./Audio/promote.mp3": 292471,
	"./Audio/prone.mp3": 485253,
	"./Audio/pronounce.mp3": 899362,
	"./Audio/pronouncing.mp3": 926551,
	"./Audio/pronunciation.mp3": 508172,
	"./Audio/prooduce.mp3": 259672,
	"./Audio/propel.mp3": 330401,
	"./Audio/propet.mp3": 761561,
	"./Audio/prophecy.mp3": 706967,
	"./Audio/prophesy.mp3": 827943,
	"./Audio/prophet.mp3": 233181,
	"./Audio/proposal.mp3": 801971,
	"./Audio/propose.mp3": 127217,
	"./Audio/proposed.mp3": 197591,
	"./Audio/proposition.mp3": 133571,
	"./Audio/proret.mp3": 651303,
	"./Audio/proscribe.mp3": 808112,
	"./Audio/prospered.mp3": 386589,
	"./Audio/prospering.mp3": 520346,
	"./Audio/prosperity.mp3": 665534,
	"./Audio/prosperous.mp3": 319017,
	"./Audio/prospers.mp3": 551349,
	"./Audio/protein.mp3": 634162,
	"./Audio/proud.mp3": 654117,
	"./Audio/prove.mp3": 839309,
	"./Audio/proverb.mp3": 731453,
	"./Audio/provide.mp3": 595404,
	"./Audio/prune.mp3": 447,
	"./Audio/pry.mp3": 584776,
	"./Audio/publicity.mp3": 587970,
	"./Audio/publicly.mp3": 147955,
	"./Audio/pucket.mp3": 773517,
	"./Audio/pud.mp3": 284272,
	"./Audio/pudding.mp3": 459196,
	"./Audio/puff.mp3": 192608,
	"./Audio/pug.mp3": 97991,
	"./Audio/puge.mp3": 526540,
	"./Audio/puhe.mp3": 513421,
	"./Audio/puhh.mp3": 373052,
	"./Audio/puison.mp3": 272907,
	"./Audio/puke.mp3": 49920,
	"./Audio/pull.mp3": 160180,
	"./Audio/pulled.mp3": 751235,
	"./Audio/pulp.mp3": 635360,
	"./Audio/pump.mp3": 5383,
	"./Audio/pun.mp3": 482474,
	"./Audio/punctuation.mp3": 822871,
	"./Audio/puncture.mp3": 949419,
	"./Audio/punk.mp3": 574737,
	"./Audio/puny.mp3": 897139,
	"./Audio/pup.mp3": 583260,
	"./Audio/pupil.mp3": 53271,
	"./Audio/pupp.mp3": 653100,
	"./Audio/puppies.mp3": 343497,
	"./Audio/pure.mp3": 429299,
	"./Audio/purpose.mp3": 526697,
	"./Audio/pursar.mp3": 958708,
	"./Audio/purse.mp3": 301398,
	"./Audio/pursear.mp3": 165679,
	"./Audio/pursow.mp3": 275655,
	"./Audio/pursue.mp3": 913147,
	"./Audio/purtar.mp3": 535543,
	"./Audio/purtear.mp3": 892182,
	"./Audio/purtow.mp3": 411432,
	"./Audio/purtue.mp3": 891960,
	"./Audio/pus.mp3": 459987,
	"./Audio/push.mp3": 999985,
	"./Audio/pushes.mp3": 863233,
	"./Audio/puss.mp3": 986838,
	"./Audio/put.mp3": 53171,
	"./Audio/pyramid.mp3": 206731,
	"./Audio/q.mp3": 941970,
	"./Audio/qu.mp3": 449559,
	"./Audio/quach.mp3": 890773,
	"./Audio/quack.mp3": 146242,
	"./Audio/quadbike.mp3": 742527,
	"./Audio/quadrilateral.mp3": 785344,
	"./Audio/quag.mp3": 19483,
	"./Audio/quaip.mp3": 533567,
	"./Audio/quair.mp3": 286125,
	"./Audio/quait.mp3": 224635,
	"./Audio/qualities.mp3": 377588,
	"./Audio/quality.mp3": 354768,
	"./Audio/qualm.mp3": 457101,
	"./Audio/quam.mp3": 991105,
	"./Audio/quan.mp3": 565166,
	"./Audio/quang.mp3": 68705,
	"./Audio/quantity.mp3": 637998,
	"./Audio/quap.mp3": 976760,
	"./Audio/quarter.mp3": 357535,
	"./Audio/quat.mp3": 946324,
	"./Audio/quate.mp3": 853037,
	"./Audio/quear.mp3": 877025,
	"./Audio/queck.mp3": 31806,
	"./Audio/queen.mp3": 340465,
	"./Audio/queep.mp3": 720319,
	"./Audio/quench.mp3": 279507,
	"./Audio/quep.mp3": 520268,
	"./Audio/query.mp3": 526047,
	"./Audio/quest.mp3": 334493,
	"./Audio/question.mp3": 823537,
	"./Audio/questionable.mp3": 708613,
	"./Audio/questioned.mp3": 664738,
	"./Audio/questioning.mp3": 136327,
	"./Audio/questionnaire.mp3": 211800,
	"./Audio/quests.mp3": 807184,
	"./Audio/quet.mp3": 145168,
	"./Audio/quete.mp3": 544473,
	"./Audio/queue.mp3": 579030,
	"./Audio/queuing.mp3": 771427,
	"./Audio/quib.mp3": 666098,
	"./Audio/quick.mp3": 803418,
	"./Audio/quicker.mp3": 610271,
	"./Audio/quickest.mp3": 736842,
	"./Audio/quickly.mp3": 991739,
	"./Audio/quiet.mp3": 69207,
	"./Audio/quietly.mp3": 937758,
	"./Audio/quig.mp3": 583507,
	"./Audio/quiss.mp3": 904274,
	"./Audio/quit.mp3": 774380,
	"./Audio/quite.mp3": 694645,
	"./Audio/quiver.mp3": 950027,
	"./Audio/quix.mp3": 984600,
	"./Audio/quiz.mp3": 452970,
	"./Audio/quor.mp3": 903848,
	"./Audio/quot.mp3": 499830,
	"./Audio/quote.mp3": 36651,
	"./Audio/quow.mp3": 929257,
	"./Audio/r -2.mp3": 296958,
	"./Audio/r -3.mp3": 77251,
	"./Audio/r.mp3": 732517,
	"./Audio/ra.mp3": 498154,
	"./Audio/rabbit.mp3": 99713,
	"./Audio/race.mp3": 906954,
	"./Audio/rach.mp3": 411651,
	"./Audio/racial.mp3": 137945,
	"./Audio/rack.mp3": 957836,
	"./Audio/racket.mp3": 32619,
	"./Audio/rad.mp3": 54410,
	"./Audio/raddit.mp3": 593373,
	"./Audio/raff.mp3": 132286,
	"./Audio/raft.mp3": 757692,
	"./Audio/rag.mp3": 346141,
	"./Audio/rahh.mp3": 916618,
	"./Audio/rai.mp3": 101635,
	"./Audio/raid.mp3": 954381,
	"./Audio/raif.mp3": 164447,
	"./Audio/rain.mp3": 482455,
	"./Audio/rainbow.mp3": 306409,
	"./Audio/raise.mp3": 791579,
	"./Audio/rait.mp3": 908957,
	"./Audio/rak.mp3": 10129,
	"./Audio/rake.mp3": 841714,
	"./Audio/ram.mp3": 458279,
	"./Audio/ramp.mp3": 52037,
	"./Audio/ran.mp3": 603344,
	"./Audio/rang.mp3": 163787,
	"./Audio/range.mp3": 785920,
	"./Audio/rannit.mp3": 685177,
	"./Audio/ranoa.mp3": 800484,
	"./Audio/ranor.mp3": 118667,
	"./Audio/ranow.mp3": 465450,
	"./Audio/rantob.mp3": 646727,
	"./Audio/ranuhe.mp3": 844088,
	"./Audio/ranure.mp3": 20810,
	"./Audio/rap.mp3": 483318,
	"./Audio/rapid.mp3": 624753,
	"./Audio/rapp.mp3": 416954,
	"./Audio/rappit.mp3": 260685,
	"./Audio/raptop.mp3": 536227,
	"./Audio/rar.mp3": 771908,
	"./Audio/rare.mp3": 460093,
	"./Audio/ras.mp3": 938921,
	"./Audio/rass.mp3": 130100,
	"./Audio/rat.mp3": 141690,
	"./Audio/rather.mp3": 513275,
	"./Audio/rattit.mp3": 320701,
	"./Audio/ravi's.mp3": 393779,
	"./Audio/raw.mp3": 544589,
	"./Audio/rax.mp3": 322030,
	"./Audio/rayal.mp3": 659936,
	"./Audio/re-educate.mp3": 839456,
	"./Audio/re-elect.mp3": 471012,
	"./Audio/re-enter.mp3": 620083,
	"./Audio/re-entering.mp3": 387741,
	"./Audio/re-evaluate.mp3": 247734,
	"./Audio/re-examine.mp3": 917176,
	"./Audio/re-examining.mp3": 689821,
	"./Audio/re.mp3": 606950,
	"./Audio/reac.mp3": 374794,
	"./Audio/reach.mp3": 987614,
	"./Audio/react.mp3": 834138,
	"./Audio/reaction.mp3": 206152,
	"./Audio/reactive.mp3": 232148,
	"./Audio/read.mp3": 748793,
	"./Audio/reah.mp3": 483509,
	"./Audio/reak.mp3": 173730,
	"./Audio/realise.mp3": 198686,
	"./Audio/really.mp3": 38528,
	"./Audio/reappear.mp3": 101537,
	"./Audio/rear.mp3": 75039,
	"./Audio/rearrange.mp3": 267866,
	"./Audio/reason.mp3": 68593,
	"./Audio/reasonable.mp3": 569349,
	"./Audio/reat.mp3": 259305,
	"./Audio/reb.mp3": 131848,
	"./Audio/rebound.mp3": 791662,
	"./Audio/rebra.mp3": 124339,
	"./Audio/rebuild.mp3": 444638,
	"./Audio/receipt.mp3": 728579,
	"./Audio/receive.mp3": 876896,
	"./Audio/received.mp3": 886436,
	"./Audio/recent.mp3": 520952,
	"./Audio/recently.mp3": 637489,
	"./Audio/recite.mp3": 761375,
	"./Audio/reck.mp3": 782488,
	"./Audio/recognisable.mp3": 19475,
	"./Audio/recognise.mp3": 541960,
	"./Audio/recognised.mp3": 936316,
	"./Audio/recognises.mp3": 474023,
	"./Audio/recognising.mp3": 631021,
	"./Audio/recommend.mp3": 525281,
	"./Audio/recommended.mp3": 534738,
	"./Audio/record.mp3": 794166,
	"./Audio/recorded.mp3": 441733,
	"./Audio/recorder.mp3": 140259,
	"./Audio/recycle.mp3": 426300,
	"./Audio/recycling.mp3": 652569,
	"./Audio/red.mp3": 690454,
	"./Audio/redecorate.mp3": 744603,
	"./Audio/redevelop.mp3": 560689,
	"./Audio/redeveloped.mp3": 562850,
	"./Audio/redo.mp3": 476401,
	"./Audio/reduce.mp3": 44803,
	"./Audio/reebe.mp3": 685928,
	"./Audio/reed.mp3": 620725,
	"./Audio/reede.mp3": 905622,
	"./Audio/reef.mp3": 272679,
	"./Audio/reele.mp3": 238510,
	"./Audio/reet.mp3": 689445,
	"./Audio/referee.mp3": 780811,
	"./Audio/reference.mp3": 651240,
	"./Audio/referral.mp3": 109610,
	"./Audio/referred.mp3": 711214,
	"./Audio/referring.mp3": 206139,
	"./Audio/reff.mp3": 384458,
	"./Audio/reflect.mp3": 474808,
	"./Audio/reform.mp3": 926756,
	"./Audio/refresh.mp3": 293866,
	"./Audio/refusal.mp3": 462891,
	"./Audio/refuse.mp3": 491497,
	"./Audio/reg.mp3": 606217,
	"./Audio/regal.mp3": 562814,
	"./Audio/regardless.mp3": 467363,
	"./Audio/region.mp3": 445413,
	"./Audio/regionality.mp3": 54034,
	"./Audio/regionally.mp3": 499203,
	"./Audio/regions.mp3": 324104,
	"./Audio/registration.mp3": 682706,
	"./Audio/regret.mp3": 37210,
	"./Audio/regular.mp3": 194619,
	"./Audio/regularity.mp3": 565933,
	"./Audio/regularly.mp3": 330122,
	"./Audio/regulate.mp3": 726302,
	"./Audio/regulation.mp3": 104033,
	"./Audio/rehearse.mp3": 23274,
	"./Audio/reign.mp3": 190980,
	"./Audio/rein.mp3": 715771,
	"./Audio/reins.mp3": 15406,
	"./Audio/reject.mp3": 730824,
	"./Audio/relation.mp3": 142925,
	"./Audio/release.mp3": 400576,
	"./Audio/relevant.mp3": 185638,
	"./Audio/reliable.mp3": 79167,
	"./Audio/relief.mp3": 606010,
	"./Audio/relieved.mp3": 731817,
	"./Audio/relocate.mp3": 557300,
	"./Audio/relret.mp3": 723455,
	"./Audio/rem.mp3": 997395,
	"./Audio/remainder.mp3": 257074,
	"./Audio/remember.mp3": 801540,
	"./Audio/remove.mp3": 277049,
	"./Audio/ren.mp3": 637020,
	"./Audio/renat.mp3": 195543,
	"./Audio/rene.mp3": 798469,
	"./Audio/reneat.mp3": 898202,
	"./Audio/renege.mp3": 43821,
	"./Audio/renet.mp3": 888859,
	"./Audio/renoat.mp3": 476732,
	"./Audio/renovate.mp3": 275497,
	"./Audio/reorganise.mp3": 495574,
	"./Audio/rep.mp3": 536234,
	"./Audio/repair.mp3": 218934,
	"./Audio/replace.mp3": 500763,
	"./Audio/replay.mp3": 886908,
	"./Audio/replied.mp3": 190676,
	"./Audio/replies.mp3": 572767,
	"./Audio/reply.mp3": 739563,
	"./Audio/replying.mp3": 640229,
	"./Audio/report.mp3": 476387,
	"./Audio/reporter.mp3": 463330,
	"./Audio/reposition.mp3": 446851,
	"./Audio/request.mp3": 109620,
	"./Audio/requested.mp3": 178307,
	"./Audio/requesting.mp3": 888796,
	"./Audio/requests.mp3": 29419,
	"./Audio/rescar.mp3": 999173,
	"./Audio/rescay.mp3": 526106,
	"./Audio/rescear.mp3": 550760,
	"./Audio/rescow.mp3": 924570,
	"./Audio/rescue.mp3": 111402,
	"./Audio/rese.mp3": 838862,
	"./Audio/resign.mp3": 602265,
	"./Audio/resistant.mp3": 905542,
	"./Audio/resolute.mp3": 364324,
	"./Audio/resolutions.mp3": 730386,
	"./Audio/resolve.mp3": 124299,
	"./Audio/respect.mp3": 165821,
	"./Audio/respected.mp3": 252654,
	"./Audio/respectful.mp3": 190666,
	"./Audio/respecting.mp3": 179003,
	"./Audio/respective.mp3": 417137,
	"./Audio/ress.mp3": 161392,
	"./Audio/restaurant.mp3": 44004,
	"./Audio/restoration.mp3": 997359,
	"./Audio/restore.mp3": 133829,
	"./Audio/restored.mp3": 375019,
	"./Audio/restoring.mp3": 714164,
	"./Audio/ret.mp3": 645030,
	"./Audio/return.mp3": 59223,
	"./Audio/reveal.mp3": 224698,
	"./Audio/reverberate.mp3": 829000,
	"./Audio/revere.mp3": 603878,
	"./Audio/reverse.mp3": 945409,
	"./Audio/revert.mp3": 674491,
	"./Audio/review.mp3": 679189,
	"./Audio/revision.mp3": 899182,
	"./Audio/revisit.mp3": 113199,
	"./Audio/reward.mp3": 518188,
	"./Audio/rewind.mp3": 902440,
	"./Audio/rewrite.mp3": 746595,
	"./Audio/rhubarb.mp3": 50407,
	"./Audio/rhyme.mp3": 897978,
	"./Audio/rhythm.mp3": 501893,
	"./Audio/rib.mp3": 104860,
	"./Audio/ribe.mp3": 769413,
	"./Audio/ric.mp3": 723809,
	"./Audio/rice.mp3": 875682,
	"./Audio/rich.mp3": 399339,
	"./Audio/ricked.mp3": 198563,
	"./Audio/ricochet.mp3": 483198,
	"./Audio/rid.mp3": 700850,
	"./Audio/riddle.mp3": 467007,
	"./Audio/ride.mp3": 58887,
	"./Audio/riff.mp3": 829974,
	"./Audio/rift.mp3": 866804,
	"./Audio/rig.mp3": 468421,
	"./Audio/right.mp3": 528161,
	"./Audio/rigorous.mp3": 638121,
	"./Audio/rih.mp3": 827670,
	"./Audio/rik.mp3": 557705,
	"./Audio/rile.mp3": 528511,
	"./Audio/rill.mp3": 982514,
	"./Audio/rim.mp3": 704319,
	"./Audio/rin.mp3": 811592,
	"./Audio/rine.mp3": 292801,
	"./Audio/ring.mp3": 546739,
	"./Audio/rip.mp3": 21982,
	"./Audio/rir.mp3": 809132,
	"./Audio/ris.mp3": 171441,
	"./Audio/rise.mp3": 3666,
	"./Audio/rish.mp3": 881243,
	"./Audio/risit.mp3": 244918,
	"./Audio/risky.mp3": 444513,
	"./Audio/rit.mp3": 37634,
	"./Audio/rith.mp3": 849302,
	"./Audio/river.mp3": 572585,
	"./Audio/rix.mp3": 112870,
	"./Audio/riz.mp3": 864500,
	"./Audio/ro.mp3": 303212,
	"./Audio/roa.mp3": 29457,
	"./Audio/road.mp3": 612535,
	"./Audio/roaf.mp3": 333061,
	"./Audio/roal.mp3": 595135,
	"./Audio/roat.mp3": 179783,
	"./Audio/rob.mp3": 857022,
	"./Audio/robe.mp3": 145091,
	"./Audio/robin.mp3": 581395,
	"./Audio/rockair.mp3": 524066,
	"./Audio/rockar.mp3": 722311,
	"./Audio/rockare.mp3": 678156,
	"./Audio/rocker.mp3": 796795,
	"./Audio/rockerer.mp3": 855578,
	"./Audio/rocket.mp3": 527661,
	"./Audio/rockor.mp3": 604729,
	"./Audio/rocks.mp3": 867285,
	"./Audio/rod.mp3": 622672,
	"./Audio/rode.mp3": 842713,
	"./Audio/rof.mp3": 872674,
	"./Audio/rogue.mp3": 178501,
	"./Audio/roi.mp3": 447737,
	"./Audio/roial.mp3": 957486,
	"./Audio/roind.mp3": 319867,
	"./Audio/role.mp3": 28497,
	"./Audio/rom.mp3": 365469,
	"./Audio/romantically.mp3": 813134,
	"./Audio/romp.mp3": 24231,
	"./Audio/ron.mp3": 73738,
	"./Audio/rond.mp3": 997354,
	"./Audio/rone.mp3": 959503,
	"./Audio/ronkair.mp3": 87967,
	"./Audio/ronkar.mp3": 4848,
	"./Audio/ronkay.mp3": 681551,
	"./Audio/ronkey.mp3": 959515,
	"./Audio/ronkoy.mp3": 905917,
	"./Audio/roo.mp3": 299375,
	"./Audio/roof.mp3": 724347,
	"./Audio/room.mp3": 645724,
	"./Audio/root.mp3": 669657,
	"./Audio/rop.mp3": 966076,
	"./Audio/rope.mp3": 925349,
	"./Audio/ropics.mp3": 78107,
	"./Audio/ror.mp3": 341358,
	"./Audio/rose.mp3": 768504,
	"./Audio/ross.mp3": 492022,
	"./Audio/rot.mp3": 658368,
	"./Audio/rotation.mp3": 907443,
	"./Audio/roual.mp3": 407266,
	"./Audio/rough.mp3": 31740,
	"./Audio/round.mp3": 193495,
	"./Audio/row.mp3": 965143,
	"./Audio/royal.mp3": 643422,
	"./Audio/rream.mp3": 544340,
	"./Audio/rthym.mp3": 940091,
	"./Audio/rubble.mp3": 351423,
	"./Audio/rube.mp3": 184497,
	"./Audio/ruby.mp3": 469933,
	"./Audio/ruc.mp3": 165501,
	"./Audio/ruch.mp3": 264959,
	"./Audio/rude.mp3": 802299,
	"./Audio/rue.mp3": 292619,
	"./Audio/ruf.mp3": 287924,
	"./Audio/ruff.mp3": 785594,
	"./Audio/rug.mp3": 247769,
	"./Audio/ruh.mp3": 461058,
	"./Audio/ruind.mp3": 131333,
	"./Audio/ruk.mp3": 205589,
	"./Audio/rule.mp3": 552291,
	"./Audio/rum.mp3": 437347,
	"./Audio/rump.mp3": 240921,
	"./Audio/run.mp3": 232556,
	"./Audio/rund.mp3": 709328,
	"./Audio/rune.mp3": 269109,
	"./Audio/rung.mp3": 564263,
	"./Audio/runner.mp3": 202479,
	"./Audio/running.mp3": 609998,
	"./Audio/runny.mp3": 974611,
	"./Audio/rup.mp3": 418778,
	"./Audio/rus.mp3": 880301,
	"./Audio/ruse.mp3": 974110,
	"./Audio/rush.mp3": 460879,
	"./Audio/russ.mp3": 291808,
	"./Audio/rut.mp3": 251094,
	"./Audio/ruww.mp3": 511928,
	"./Audio/ruxx.mp3": 662614,
	"./Audio/ruyy.mp3": 918232,
	"./Audio/ruzz.mp3": 104962,
	"./Audio/s -2.mp3": 106809,
	"./Audio/s -3.mp3": 381588,
	"./Audio/s.mp3": 682240,
	"./Audio/sa.mp3": 153869,
	"./Audio/sach.mp3": 430512,
	"./Audio/sack.mp3": 548679,
	"./Audio/sacrifice.mp3": 906676,
	"./Audio/sact.mp3": 268196,
	"./Audio/sad.mp3": 589507,
	"./Audio/sadder.mp3": 480640,
	"./Audio/saddest.mp3": 911355,
	"./Audio/sadly.mp3": 562354,
	"./Audio/sadness.mp3": 270086,
	"./Audio/safe.mp3": 476210,
	"./Audio/sag.mp3": 466316,
	"./Audio/sai.mp3": 25930,
	"./Audio/said.mp3": 908074,
	"./Audio/saif.mp3": 770328,
	"./Audio/sail.mp3": 246082,
	"./Audio/saim.mp3": 523591,
	"./Audio/saip.mp3": 62294,
	"./Audio/sair.mp3": 243108,
	"./Audio/sait.mp3": 746330,
	"./Audio/sak.mp3": 247672,
	"./Audio/sal.mp3": 221675,
	"./Audio/salary.mp3": 53247,
	"./Audio/salt.mp3": 701589,
	"./Audio/salute.mp3": 97597,
	"./Audio/sam-2.mp3": 630811,
	"./Audio/sam.mp3": 282566,
	"./Audio/same.mp3": 480347,
	"./Audio/san.mp3": 399929,
	"./Audio/sand.mp3": 767087,
	"./Audio/sang.mp3": 373688,
	"./Audio/sanset.mp3": 238243,
	"./Audio/saof.mp3": 303578,
	"./Audio/sap.mp3": 917335,
	"./Audio/sar.mp3": 177189,
	"./Audio/sard.mp3": 551627,
	"./Audio/sas.mp3": 610560,
	"./Audio/sash.mp3": 622400,
	"./Audio/sat.mp3": 999603,
	"./Audio/satchel.mp3": 620505,
	"./Audio/sath.mp3": 929553,
	"./Audio/saturday.mp3": 479020,
	"./Audio/sauce.mp3": 951238,
	"./Audio/save.mp3": 399810,
	"./Audio/saw.mp3": 434620,
	"./Audio/say.mp3": 113210,
	"./Audio/says.mp3": 886457,
	"./Audio/saz.mp3": 32461,
	"./Audio/scab.mp3": 573314,
	"./Audio/scaib.mp3": 646213,
	"./Audio/scalp.mp3": 828948,
	"./Audio/scare.mp3": 393863,
	"./Audio/scared.mp3": 527697,
	"./Audio/scaring.mp3": 992166,
	"./Audio/scary.mp3": 169659,
	"./Audio/scaub.mp3": 351313,
	"./Audio/scene.mp3": 844583,
	"./Audio/scenery.mp3": 811288,
	"./Audio/scent.mp3": 801426,
	"./Audio/scheme.mp3": 735208,
	"./Audio/school.mp3": 744625,
	"./Audio/schools.mp3": 763532,
	"./Audio/scieb.mp3": 737529,
	"./Audio/science.mp3": 264385,
	"./Audio/scientific.mp3": 170358,
	"./Audio/scientist.mp3": 307045,
	"./Audio/scientists.mp3": 580040,
	"./Audio/scissors.mp3": 970816,
	"./Audio/sclue.mp3": 445719,
	"./Audio/score.mp3": 321737,
	"./Audio/scrap.mp3": 593344,
	"./Audio/scratch.mp3": 823249,
	"./Audio/scraw.mp3": 982387,
	"./Audio/scream.mp3": 524434,
	"./Audio/screw.mp3": 452687,
	"./Audio/scribble.mp3": 27721,
	"./Audio/scribbled.mp3": 617247,
	"./Audio/scribbles.mp3": 565780,
	"./Audio/scribbling.mp3": 269664,
	"./Audio/script.mp3": 245132,
	"./Audio/scronkair.mp3": 325793,
	"./Audio/scronkar.mp3": 23238,
	"./Audio/scronkay.mp3": 238673,
	"./Audio/scronkey.mp3": 570925,
	"./Audio/scronkoy.mp3": 540491,
	"./Audio/scroo.mp3": 433977,
	"./Audio/scrow.mp3": 422913,
	"./Audio/scruff.mp3": 594488,
	"./Audio/scrumptious.mp3": 784921,
	"./Audio/scub.mp3": 548038,
	"./Audio/scuff.mp3": 657432,
	"./Audio/se.mp3": 522025,
	"./Audio/sea.mp3": 661974,
	"./Audio/sead.mp3": 52326,
	"./Audio/seal.mp3": 418910,
	"./Audio/sear.mp3": 539144,
	"./Audio/search.mp3": 668301,
	"./Audio/seat.mp3": 97750,
	"./Audio/sebra.mp3": 524998,
	"./Audio/secc.mp3": 214699,
	"./Audio/secoa.mp3": 123312,
	"./Audio/second.mp3": 713765,
	"./Audio/secondary.mp3": 96865,
	"./Audio/secor.mp3": 886135,
	"./Audio/secow.mp3": 317134,
	"./Audio/secret.mp3": 820117,
	"./Audio/secretarial.mp3": 971334,
	"./Audio/secretaries.mp3": 202577,
	"./Audio/secretary.mp3": 595953,
	"./Audio/secretive.mp3": 881769,
	"./Audio/secretively.mp3": 402840,
	"./Audio/secretly.mp3": 978428,
	"./Audio/sect.mp3": 878056,
	"./Audio/section.mp3": 321234,
	"./Audio/secuhe.mp3": 703780,
	"./Audio/secure.mp3": 920294,
	"./Audio/sed.mp3": 538623,
	"./Audio/see.mp3": 346010,
	"./Audio/seef.mp3": 756808,
	"./Audio/seem.mp3": 23735,
	"./Audio/seen.mp3": 284896,
	"./Audio/seep.mp3": 58086,
	"./Audio/seer.mp3": 809716,
	"./Audio/seet.mp3": 949290,
	"./Audio/seff.mp3": 569073,
	"./Audio/seg.mp3": 103368,
	"./Audio/segg.mp3": 998387,
	"./Audio/seize.mp3": 586897,
	"./Audio/sel.mp3": 556023,
	"./Audio/self.mp3": 89491,
	"./Audio/sell.mp3": 28937,
	"./Audio/sem.mp3": 508978,
	"./Audio/seme.mp3": 26887,
	"./Audio/sen.mp3": 276549,
	"./Audio/send.mp3": 899499,
	"./Audio/sensation.mp3": 454747,
	"./Audio/senset.mp3": 826711,
	"./Audio/sensible.mp3": 155128,
	"./Audio/sensibly.mp3": 342076,
	"./Audio/sensitive.mp3": 689319,
	"./Audio/sentence.mp3": 784918,
	"./Audio/sentenced.mp3": 606182,
	"./Audio/sentences.mp3": 950189,
	"./Audio/sentencing.mp3": 505443,
	"./Audio/sep.mp3": 160971,
	"./Audio/separate.mp3": 275618,
	"./Audio/separated.mp3": 57042,
	"./Audio/separately.mp3": 238595,
	"./Audio/separating.mp3": 288727,
	"./Audio/september.mp3": 778266,
	"./Audio/sequence.mp3": 954694,
	"./Audio/serial.mp3": 239801,
	"./Audio/serious.mp3": 881625,
	"./Audio/serr.mp3": 48265,
	"./Audio/serve.mp3": 841950,
	"./Audio/sess.mp3": 466411,
	"./Audio/session.mp3": 853643,
	"./Audio/set.mp3": 469903,
	"./Audio/seven.mp3": 75716,
	"./Audio/seventeen.mp3": 777672,
	"./Audio/severe.mp3": 957977,
	"./Audio/sh -2.mp3": 974137,
	"./Audio/sh -3.mp3": 248916,
	"./Audio/sh .mp3": 642280,
	"./Audio/sh.mp3": 917696,
	"./Audio/sha.mp3": 631309,
	"./Audio/shack.mp3": 416007,
	"./Audio/shade.mp3": 282600,
	"./Audio/shadow.mp3": 630757,
	"./Audio/shaft.mp3": 957831,
	"./Audio/shai.mp3": 198410,
	"./Audio/shail.mp3": 113410,
	"./Audio/shal.mp3": 394155,
	"./Audio/shall.mp3": 243629,
	"./Audio/shaon.mp3": 333874,
	"./Audio/shape.mp3": 255612,
	"./Audio/shar.mp3": 833317,
	"./Audio/share.mp3": 874534,
	"./Audio/sharp.mp3": 312959,
	"./Audio/shart.mp3": 461499,
	"./Audio/shass.mp3": 614383,
	"./Audio/shat.mp3": 172083,
	"./Audio/shave.mp3": 783490,
	"./Audio/shawl.mp3": 715688,
	"./Audio/she'll.mp3": 681968,
	"./Audio/she.mp3": 483113,
	"./Audio/sheat.mp3": 965078,
	"./Audio/shed.mp3": 711103,
	"./Audio/sheel.mp3": 513394,
	"./Audio/sheen.mp3": 152224,
	"./Audio/sheer.mp3": 677044,
	"./Audio/sheff.mp3": 436401,
	"./Audio/sheg.mp3": 275848,
	"./Audio/shel.mp3": 212151,
	"./Audio/shelf.mp3": 956819,
	"./Audio/shell.mp3": 896265,
	"./Audio/shem.mp3": 165106,
	"./Audio/shen.mp3": 932677,
	"./Audio/shess.mp3": 333739,
	"./Audio/shich.mp3": 501912,
	"./Audio/shick.mp3": 660687,
	"./Audio/shid.mp3": 496843,
	"./Audio/shield.mp3": 630574,
	"./Audio/shiff.mp3": 766461,
	"./Audio/shift.mp3": 59327,
	"./Audio/shig.mp3": 492148,
	"./Audio/shill.mp3": 838149,
	"./Audio/shim.mp3": 165982,
	"./Audio/shin.mp3": 799089,
	"./Audio/shine.mp3": 505490,
	"./Audio/shing.mp3": 245760,
	"./Audio/shining.mp3": 902983,
	"./Audio/shink.mp3": 378628,
	"./Audio/shiny.mp3": 401414,
	"./Audio/ship.mp3": 848319,
	"./Audio/shirk.mp3": 314136,
	"./Audio/shirt.mp3": 913043,
	"./Audio/shis.mp3": 955592,
	"./Audio/shoa.mp3": 567828,
	"./Audio/shoal.mp3": 52256,
	"./Audio/shock.mp3": 959141,
	"./Audio/shoil.mp3": 194008,
	"./Audio/shol.mp3": 1589,
	"./Audio/shook.mp3": 676585,
	"./Audio/shool.mp3": 91258,
	"./Audio/shoon.mp3": 651176,
	"./Audio/shop.mp3": 108009,
	"./Audio/shore.mp3": 89840,
	"./Audio/shorn.mp3": 766543,
	"./Audio/short.mp3": 56837,
	"./Audio/should've.mp3": 159844,
	"./Audio/should.mp3": 786187,
	"./Audio/shoulder.mp3": 855025,
	"./Audio/shouldered.mp3": 148386,
	"./Audio/shouldering.mp3": 602247,
	"./Audio/shouldn't.mp3": 791311,
	"./Audio/shout.mp3": 945132,
	"./Audio/shouted.mp3": 948731,
	"./Audio/show.mp3": 6330,
	"./Audio/showl.mp3": 592018,
	"./Audio/shrew.mp3": 243974,
	"./Audio/shriek.mp3": 348191,
	"./Audio/shrill.mp3": 678659,
	"./Audio/shud.mp3": 623,
	"./Audio/shug.mp3": 480376,
	"./Audio/shump.mp3": 642686,
	"./Audio/shup.mp3": 496923,
	"./Audio/shurn.mp3": 687173,
	"./Audio/shy.mp3": 376693,
	"./Audio/shyly.mp3": 372636,
	"./Audio/sich.mp3": 634584,
	"./Audio/sick.mp3": 277007,
	"./Audio/sid.mp3": 840715,
	"./Audio/side.mp3": 522496,
	"./Audio/siege.mp3": 886650,
	"./Audio/siff.mp3": 382781,
	"./Audio/sift.mp3": 191999,
	"./Audio/sig.mp3": 836020,
	"./Audio/sigh.mp3": 676476,
	"./Audio/sight.mp3": 41104,
	"./Audio/sign.mp3": 628498,
	"./Audio/signal.mp3": 16869,
	"./Audio/signalling.mp3": 705133,
	"./Audio/signature.mp3": 776681,
	"./Audio/significance.mp3": 626054,
	"./Audio/signify.mp3": 629656,
	"./Audio/signing.mp3": 404998,
	"./Audio/sik.mp3": 472944,
	"./Audio/sil.mp3": 985443,
	"./Audio/silence.mp3": 494446,
	"./Audio/silently.mp3": 846559,
	"./Audio/silk.mp3": 681294,
	"./Audio/silliness.mp3": 16451,
	"./Audio/silly.mp3": 185362,
	"./Audio/silt.mp3": 940029,
	"./Audio/sim.mp3": 993502,
	"./Audio/sime.mp3": 121763,
	"./Audio/similar.mp3": 943392,
	"./Audio/simplicity.mp3": 971766,
	"./Audio/simply.mp3": 807731,
	"./Audio/sin.mp3": 142961,
	"./Audio/since.mp3": 658341,
	"./Audio/sincere.mp3": 518110,
	"./Audio/sincerely.mp3": 167175,
	"./Audio/sing.mp3": 378432,
	"./Audio/singe.mp3": 744553,
	"./Audio/sinset.mp3": 617515,
	"./Audio/sip.mp3": 675839,
	"./Audio/sir.mp3": 428397,
	"./Audio/sird.mp3": 51875,
	"./Audio/sis.mp3": 783112,
	"./Audio/sister.mp3": 384285,
	"./Audio/sit.mp3": 366907,
	"./Audio/site.mp3": 208912,
	"./Audio/six.mp3": 50039,
	"./Audio/sixteen.mp3": 472779,
	"./Audio/sizeable.mp3": 283138,
	"./Audio/skart.mp3": 500634,
	"./Audio/skate.mp3": 646253,
	"./Audio/skeat.mp3": 351671,
	"./Audio/skep.mp3": 310220,
	"./Audio/sketch.mp3": 14885,
	"./Audio/ski.mp3": 442280,
	"./Audio/skilful.mp3": 223889,
	"./Audio/skill.mp3": 867088,
	"./Audio/skin.mp3": 770518,
	"./Audio/skip.mp3": 901744,
	"./Audio/skirt.mp3": 157314,
	"./Audio/skit.mp3": 725804,
	"./Audio/skort .mp3": 678924,
	"./Audio/skort.mp3": 25004,
	"./Audio/skunk.mp3": 442065,
	"./Audio/sky.mp3": 288568,
	"./Audio/slack.mp3": 35115,
	"./Audio/slade.mp3": 753740,
	"./Audio/slane.mp3": 392334,
	"./Audio/slang.mp3": 860828,
	"./Audio/slant.mp3": 769891,
	"./Audio/slave.mp3": 550662,
	"./Audio/slede.mp3": 280000,
	"./Audio/sledge.mp3": 988583,
	"./Audio/sleep.mp3": 119018,
	"./Audio/sleepily.mp3": 391410,
	"./Audio/sleigh.mp3": 725287,
	"./Audio/slene.mp3": 260370,
	"./Audio/slept.mp3": 3305,
	"./Audio/slice.mp3": 259613,
	"./Audio/slide.mp3": 606996,
	"./Audio/slime.mp3": 806663,
	"./Audio/sline.mp3": 554438,
	"./Audio/sling.mp3": 240551,
	"./Audio/slippery.mp3": 986905,
	"./Audio/slit.mp3": 667663,
	"./Audio/slode.mp3": 30506,
	"./Audio/slone.mp3": 183368,
	"./Audio/sloth.mp3": 66035,
	"./Audio/slow.mp3": 759958,
	"./Audio/slowly.mp3": 735999,
	"./Audio/slu.mp3": 701557,
	"./Audio/slung.mp3": 308432,
	"./Audio/slurp.mp3": 314311,
	"./Audio/slush.mp3": 682840,
	"./Audio/sly.mp3": 966841,
	"./Audio/small.mp3": 630286,
	"./Audio/smart.mp3": 459956,
	"./Audio/smarter.mp3": 76389,
	"./Audio/smash.mp3": 579751,
	"./Audio/smell.mp3": 604722,
	"./Audio/smelly.mp3": 616507,
	"./Audio/smile.mp3": 168755,
	"./Audio/smith's.mp3": 36984,
	"./Audio/smoothly.mp3": 35838,
	"./Audio/smoulder.mp3": 812948,
	"./Audio/smudged.mp3": 316150,
	"./Audio/snack.mp3": 692889,
	"./Audio/snail.mp3": 899012,
	"./Audio/snare.mp3": 650892,
	"./Audio/sneeze.mp3": 66879,
	"./Audio/snick.mp3": 565745,
	"./Audio/sniff.mp3": 488247,
	"./Audio/snort.mp3": 459551,
	"./Audio/snow.mp3": 133816,
	"./Audio/snuff.mp3": 956139,
	"./Audio/so.mp3": 94835,
	"./Audio/soa.mp3": 395348,
	"./Audio/soaf.mp3": 840602,
	"./Audio/soal.mp3": 668576,
	"./Audio/soap.mp3": 193396,
	"./Audio/soat.mp3": 864600,
	"./Audio/soch.mp3": 301266,
	"./Audio/social.mp3": 694780,
	"./Audio/socialise.mp3": 936781,
	"./Audio/sock.mp3": 91813,
	"./Audio/sod.mp3": 38301,
	"./Audio/sof.mp3": 819183,
	"./Audio/soft.mp3": 659929,
	"./Audio/sog.mp3": 593546,
	"./Audio/soi.mp3": 644428,
	"./Audio/soil.mp3": 326680,
	"./Audio/soind.mp3": 562570,
	"./Audio/sol.mp3": 829109,
	"./Audio/solar.mp3": 11060,
	"./Audio/solder.mp3": 144026,
	"./Audio/soldier.mp3": 777029,
	"./Audio/solemn.mp3": 450423,
	"./Audio/solution.mp3": 829996,
	"./Audio/solve.mp3": 179626,
	"./Audio/solvent.mp3": 998756,
	"./Audio/solver.mp3": 857924,
	"./Audio/som.mp3": 142480,
	"./Audio/some.mp3": 451929,
	"./Audio/something.mp3": 104867,
	"./Audio/sometimes.mp3": 253889,
	"./Audio/somewhere.mp3": 518338,
	"./Audio/somp.mp3": 439176,
	"./Audio/son.mp3": 997415,
	"./Audio/sond.mp3": 175134,
	"./Audio/song.mp3": 319646,
	"./Audio/sonset.mp3": 835393,
	"./Audio/soof.mp3": 721280,
	"./Audio/soon.mp3": 783848,
	"./Audio/soot.mp3": 749858,
	"./Audio/sop.mp3": 451881,
	"./Audio/sor.mp3": 984859,
	"./Audio/sord.mp3": 503253,
	"./Audio/sore.mp3": 222512,
	"./Audio/sorf.mp3": 824327,
	"./Audio/sort.mp3": 189509,
	"./Audio/sot.mp3": 83725,
	"./Audio/sought.mp3": 159719,
	"./Audio/sound.mp3": 596902,
	"./Audio/soup.mp3": 770096,
	"./Audio/south.mp3": 783124,
	"./Audio/sow.mp3": 350202,
	"./Audio/sowl.mp3": 724690,
	"./Audio/spa.mp3": 838773,
	"./Audio/space.mp3": 563585,
	"./Audio/spacious.mp3": 135984,
	"./Audio/spaciously.mp3": 259401,
	"./Audio/spack.mp3": 900895,
	"./Audio/spam.mp3": 215950,
	"./Audio/spare.mp3": 623118,
	"./Audio/spark.mp3": 255816,
	"./Audio/speak.mp3": 898765,
	"./Audio/special.mp3": 341950,
	"./Audio/specialise.mp3": 717423,
	"./Audio/specialises.mp3": 711978,
	"./Audio/specified.mp3": 934697,
	"./Audio/specify.mp3": 316026,
	"./Audio/specifying.mp3": 822046,
	"./Audio/speck.mp3": 964283,
	"./Audio/spectate.mp3": 556392,
	"./Audio/speke.mp3": 296093,
	"./Audio/spell.mp3": 950417,
	"./Audio/spend.mp3": 685283,
	"./Audio/spends.mp3": 185190,
	"./Audio/spew.mp3": 701872,
	"./Audio/sphere.mp3": 999442,
	"./Audio/spicy.mp3": 593141,
	"./Audio/spied.mp3": 213134,
	"./Audio/spies.mp3": 816405,
	"./Audio/spike.mp3": 418465,
	"./Audio/spiky.mp3": 920381,
	"./Audio/spill.mp3": 372797,
	"./Audio/spim.mp3": 232054,
	"./Audio/spin.mp3": 661481,
	"./Audio/spine.mp3": 562458,
	"./Audio/splach.mp3": 216620,
	"./Audio/splaf.mp3": 27213,
	"./Audio/splag.mp3": 853608,
	"./Audio/splas.mp3": 338836,
	"./Audio/splash.mp3": 790236,
	"./Audio/spoke.mp3": 18955,
	"./Audio/spontaneous.mp3": 837176,
	"./Audio/spoon.mp3": 190752,
	"./Audio/sport.mp3": 179389,
	"./Audio/spotless.mp3": 866146,
	"./Audio/spra.mp3": 251523,
	"./Audio/sprai.mp3": 8828,
	"./Audio/sprair.mp3": 426046,
	"./Audio/spraw.mp3": 142666,
	"./Audio/spray.mp3": 709900,
	"./Audio/spread.mp3": 256084,
	"./Audio/spree.mp3": 71212,
	"./Audio/sprene.mp3": 698624,
	"./Audio/sprew.mp3": 440974,
	"./Audio/sprine.mp3": 25620,
	"./Audio/spring.mp3": 421574,
	"./Audio/sproi.mp3": 178682,
	"./Audio/sproiy.mp3": 276611,
	"./Audio/sprone.mp3": 154906,
	"./Audio/sproo.mp3": 808900,
	"./Audio/sprouy.mp3": 994463,
	"./Audio/sprow.mp3": 15436,
	"./Audio/sproy.mp3": 91402,
	"./Audio/spruiy.mp3": 302525,
	"./Audio/sprune.mp3": 514288,
	"./Audio/spruy.mp3": 914680,
	"./Audio/spuke.mp3": 328653,
	"./Audio/spy.mp3": 93389,
	"./Audio/squad.mp3": 697713,
	"./Audio/squander.mp3": 993240,
	"./Audio/square.mp3": 288220,
	"./Audio/squash.mp3": 748646,
	"./Audio/squawk.mp3": 294861,
	"./Audio/squirrel.mp3": 530384,
	"./Audio/ss.mp3": 889327,
	"./Audio/sta.mp3": 612489,
	"./Audio/stable.mp3": 919964,
	"./Audio/stack.mp3": 846563,
	"./Audio/staff.mp3": 400721,
	"./Audio/stage.mp3": 621089,
	"./Audio/stair.mp3": 221936,
	"./Audio/staird.mp3": 966420,
	"./Audio/stake.mp3": 163173,
	"./Audio/stale.mp3": 410940,
	"./Audio/stalk.mp3": 89530,
	"./Audio/stam.mp3": 352338,
	"./Audio/stame.mp3": 858535,
	"./Audio/stamp.mp3": 722286,
	"./Audio/stan.mp3": 142885,
	"./Audio/stand.mp3": 259787,
	"./Audio/stang.mp3": 255092,
	"./Audio/stank.mp3": 892016,
	"./Audio/stapar.mp3": 570526,
	"./Audio/stapay.mp3": 372889,
	"./Audio/stapear.mp3": 673413,
	"./Audio/stapow.mp3": 271293,
	"./Audio/stapue.mp3": 553529,
	"./Audio/star.mp3": 212601,
	"./Audio/stard.mp3": 247215,
	"./Audio/stare.mp3": 21578,
	"./Audio/starfish.mp3": 970499,
	"./Audio/start.mp3": 721823,
	"./Audio/started.mp3": 967784,
	"./Audio/stash.mp3": 62364,
	"./Audio/statar.mp3": 77922,
	"./Audio/statay.mp3": 570717,
	"./Audio/state.mp3": 286948,
	"./Audio/statear.mp3": 147817,
	"./Audio/station.mp3": 790343,
	"./Audio/stationary.mp3": 88547,
	"./Audio/stationery.mp3": 287151,
	"./Audio/statow.mp3": 471697,
	"./Audio/statue.mp3": 862093,
	"./Audio/stature.mp3": 496859,
	"./Audio/staw.mp3": 670840,
	"./Audio/stay.mp3": 291262,
	"./Audio/steak.mp3": 971017,
	"./Audio/steal.mp3": 739290,
	"./Audio/steam.mp3": 448255,
	"./Audio/sted.mp3": 124963,
	"./Audio/stee.mp3": 649374,
	"./Audio/steel.mp3": 477670,
	"./Audio/steer.mp3": 704480,
	"./Audio/steering.mp3": 934560,
	"./Audio/stem.mp3": 766438,
	"./Audio/steme.mp3": 298107,
	"./Audio/stene.mp3": 359210,
	"./Audio/stew.mp3": 274780,
	"./Audio/stick.mp3": 285003,
	"./Audio/stied.mp3": 89490,
	"./Audio/stiff.mp3": 569609,
	"./Audio/still.mp3": 184225,
	"./Audio/stilt.mp3": 768409,
	"./Audio/stime.mp3": 574607,
	"./Audio/stine.mp3": 986734,
	"./Audio/sting.mp3": 432252,
	"./Audio/stink.mp3": 882664,
	"./Audio/stir.mp3": 663617,
	"./Audio/stitch.mp3": 591174,
	"./Audio/stoad.mp3": 944292,
	"./Audio/stoam.mp3": 302817,
	"./Audio/stock.mp3": 340121,
	"./Audio/stole.mp3": 278650,
	"./Audio/stolhin.mp3": 471466,
	"./Audio/stolphin.mp3": 520228,
	"./Audio/stolpin.mp3": 44578,
	"./Audio/stolrin.mp3": 595476,
	"./Audio/stomach.mp3": 376860,
	"./Audio/stome.mp3": 419165,
	"./Audio/stomp.mp3": 844932,
	"./Audio/stone.mp3": 677072,
	"./Audio/stoo.mp3": 885462,
	"./Audio/stool.mp3": 527390,
	"./Audio/stop.mp3": 297429,
	"./Audio/stopped.mp3": 165560,
	"./Audio/storage.mp3": 25728,
	"./Audio/store.mp3": 755596,
	"./Audio/stored.mp3": 499376,
	"./Audio/stores.mp3": 132563,
	"./Audio/stories.mp3": 279148,
	"./Audio/storm.mp3": 22868,
	"./Audio/stove.mp3": 451528,
	"./Audio/stow.mp3": 206622,
	"./Audio/strai.mp3": 256144,
	"./Audio/straight.mp3": 259471,
	"./Audio/strait.mp3": 216484,
	"./Audio/strand.mp3": 537165,
	"./Audio/strange.mp3": 93023,
	"./Audio/strangely.mp3": 981446,
	"./Audio/straw.mp3": 136118,
	"./Audio/stray.mp3": 808192,
	"./Audio/streak.mp3": 880907,
	"./Audio/stream.mp3": 753789,
	"./Audio/stree.mp3": 266512,
	"./Audio/street.mp3": 882980,
	"./Audio/streke.mp3": 399579,
	"./Audio/strength.mp3": 205698,
	"./Audio/stretch.mp3": 797208,
	"./Audio/stretched.mp3": 374807,
	"./Audio/strike.mp3": 594943,
	"./Audio/stripes.mp3": 408653,
	"./Audio/strobe.mp3": 631922,
	"./Audio/stroe.mp3": 525474,
	"./Audio/stroke.mp3": 47661,
	"./Audio/strop.mp3": 216563,
	"./Audio/stroy.mp3": 155446,
	"./Audio/structures.mp3": 231999,
	"./Audio/struke.mp3": 559531,
	"./Audio/stuck.mp3": 67703,
	"./Audio/student.mp3": 700582,
	"./Audio/students'.mp3": 896988,
	"./Audio/studious.mp3": 982059,
	"./Audio/stuff.mp3": 299189,
	"./Audio/stume.mp3": 784779,
	"./Audio/stump.mp3": 427290,
	"./Audio/stun.mp3": 309961,
	"./Audio/stune.mp3": 358202,
	"./Audio/stung.mp3": 918120,
	"./Audio/stunk.mp3": 951356,
	"./Audio/stunt.mp3": 310831,
	"./Audio/sty.mp3": 709873,
	"./Audio/style.mp3": 494708,
	"./Audio/subconscious.mp3": 877909,
	"./Audio/subdivide.mp3": 912162,
	"./Audio/subdivided.mp3": 699474,
	"./Audio/subheading.mp3": 541349,
	"./Audio/submarine.mp3": 771687,
	"./Audio/submerge.mp3": 863523,
	"./Audio/subscribe.mp3": 685331,
	"./Audio/subscript.mp3": 361440,
	"./Audio/substance.mp3": 40549,
	"./Audio/substantial.mp3": 554675,
	"./Audio/substitute.mp3": 455093,
	"./Audio/subtitle.mp3": 599865,
	"./Audio/subtract.mp3": 681121,
	"./Audio/subtraction.mp3": 665085,
	"./Audio/subvert.mp3": 770708,
	"./Audio/subway.mp3": 93202,
	"./Audio/success.mp3": 154554,
	"./Audio/successful.mp3": 544863,
	"./Audio/sucessfully.mp3": 929437,
	"./Audio/suddenly.mp3": 38969,
	"./Audio/sufficient.mp3": 841197,
	"./Audio/sug.mp3": 307896,
	"./Audio/sugar.mp3": 833405,
	"./Audio/suggest.mp3": 316161,
	"./Audio/suggested.mp3": 174322,
	"./Audio/suggestible.mp3": 260861,
	"./Audio/suggestion.mp3": 249117,
	"./Audio/suggestive.mp3": 562765,
	"./Audio/suhe.mp3": 866600,
	"./Audio/suil.mp3": 200198,
	"./Audio/suind.mp3": 271496,
	"./Audio/sulk.mp3": 369066,
	"./Audio/sult.mp3": 62625,
	"./Audio/sum.mp3": 401442,
	"./Audio/sume.mp3": 883479,
	"./Audio/summair.mp3": 255829,
	"./Audio/summar.mp3": 328946,
	"./Audio/summare.mp3": 520583,
	"./Audio/summer.mp3": 537286,
	"./Audio/summerer.mp3": 976979,
	"./Audio/summor.mp3": 976736,
	"./Audio/sump.mp3": 775358,
	"./Audio/sun.mp3": 711221,
	"./Audio/sund.mp3": 323387,
	"./Audio/sunday.mp3": 817289,
	"./Audio/sunk.mp3": 267680,
	"./Audio/sunny.mp3": 620470,
	"./Audio/sunset.mp3": 363111,
	"./Audio/sup.mp3": 324443,
	"./Audio/supercilious.mp3": 978814,
	"./Audio/superficial.mp3": 474866,
	"./Audio/superhero.mp3": 941578,
	"./Audio/superhuman.mp3": 289817,
	"./Audio/superior.mp3": 975052,
	"./Audio/superman.mp3": 457134,
	"./Audio/supermarket.mp3": 375826,
	"./Audio/supernatural.mp3": 601301,
	"./Audio/superscript.mp3": 369451,
	"./Audio/supersonic.mp3": 683514,
	"./Audio/superstar.mp3": 52914,
	"./Audio/superstitious.mp3": 655500,
	"./Audio/supervise.mp3": 313305,
	"./Audio/suppair.mp3": 231055,
	"./Audio/suppar.mp3": 148224,
	"./Audio/suppare.mp3": 523625,
	"./Audio/supper.mp3": 324236,
	"./Audio/supperer.mp3": 793821,
	"./Audio/suppor.mp3": 170962,
	"./Audio/support.mp3": 705618,
	"./Audio/supporters.mp3": 170434,
	"./Audio/suppose.mp3": 605628,
	"./Audio/supposedly.mp3": 305721,
	"./Audio/supposing.mp3": 700057,
	"./Audio/sure.mp3": 346778,
	"./Audio/surf.mp3": 808301,
	"./Audio/surface.mp3": 655266,
	"./Audio/surprise.mp3": 145064,
	"./Audio/surprised.mp3": 133404,
	"./Audio/surprising.mp3": 513229,
	"./Audio/surrender.mp3": 319717,
	"./Audio/surround.mp3": 369131,
	"./Audio/survey.mp3": 134767,
	"./Audio/survive.mp3": 161585,
	"./Audio/suspicious.mp3": 37124,
	"./Audio/swade.mp3": 495113,
	"./Audio/swaird.mp3": 377583,
	"./Audio/swallow.mp3": 91822,
	"./Audio/swam.mp3": 145197,
	"./Audio/swan.mp3": 683674,
	"./Audio/swang.mp3": 310317,
	"./Audio/swap.mp3": 497452,
	"./Audio/swapt.mp3": 615104,
	"./Audio/sward.mp3": 914078,
	"./Audio/swarm.mp3": 91915,
	"./Audio/swast.mp3": 724285,
	"./Audio/swat.mp3": 189744,
	"./Audio/sway.mp3": 512665,
	"./Audio/swear.mp3": 650309,
	"./Audio/sweast.mp3": 427444,
	"./Audio/sweat.mp3": 800147,
	"./Audio/sweater.mp3": 704946,
	"./Audio/swed.mp3": 559588,
	"./Audio/swede.mp3": 578589,
	"./Audio/sweeo.mp3": 935424,
	"./Audio/sweep.mp3": 546539,
	"./Audio/swell.mp3": 44040,
	"./Audio/swept.mp3": 847900,
	"./Audio/swerve.mp3": 508065,
	"./Audio/swest.mp3": 776057,
	"./Audio/swide.mp3": 723473,
	"./Audio/swied.mp3": 289011,
	"./Audio/swift.mp3": 14234,
	"./Audio/swim.mp3": 851445,
	"./Audio/swimming.mp3": 573530,
	"./Audio/swing.mp3": 959909,
	"./Audio/swipe.mp3": 878845,
	"./Audio/swirly.mp3": 840543,
	"./Audio/swoad.mp3": 829173,
	"./Audio/swoast.mp3": 822814,
	"./Audio/swode.mp3": 707135,
	"./Audio/swong.mp3": 92667,
	"./Audio/sword.mp3": 187368,
	"./Audio/swung.mp3": 895441,
	"./Audio/symbol.mp3": 245365,
	"./Audio/symbolic.mp3": 695793,
	"./Audio/symmetric.mp3": 278370,
	"./Audio/symmetrical.mp3": 669365,
	"./Audio/symmetry.mp3": 540855,
	"./Audio/sympathetic.mp3": 338352,
	"./Audio/sympathy.mp3": 79344,
	"./Audio/system.mp3": 127550,
	"./Audio/systematic.mp3": 130125,
	"./Audio/systems.mp3": 72485,
	"./Audio/t -2.mp3": 908620,
	"./Audio/t -3.mp3": 966481,
	"./Audio/t.mp3": 859379,
	"./Audio/ta.mp3": 917908,
	"./Audio/table.mp3": 565155,
	"./Audio/tables.mp3": 722022,
	"./Audio/tacher.mp3": 763428,
	"./Audio/tack.mp3": 388742,
	"./Audio/tacket.mp3": 191493,
	"./Audio/tact.mp3": 283365,
	"./Audio/tactician.mp3": 625379,
	"./Audio/tad.mp3": 484360,
	"./Audio/tag.mp3": 377087,
	"./Audio/tai.mp3": 912929,
	"./Audio/taid.mp3": 103591,
	"./Audio/taik.mp3": 501524,
	"./Audio/tail.mp3": 925359,
	"./Audio/tailm.mp3": 729372,
	"./Audio/tain.mp3": 144477,
	"./Audio/taint.mp3": 267587,
	"./Audio/tair.mp3": 546305,
	"./Audio/tait.mp3": 717975,
	"./Audio/tak.mp3": 807379,
	"./Audio/take.mp3": 613400,
	"./Audio/taki.mp3": 886828,
	"./Audio/talented.mp3": 548276,
	"./Audio/talk.mp3": 703799,
	"./Audio/tall.mp3": 730140,
	"./Audio/tallest.mp3": 57452,
	"./Audio/tally.mp3": 930777,
	"./Audio/talm.mp3": 865441,
	"./Audio/talt.mp3": 489780,
	"./Audio/tam.mp3": 141189,
	"./Audio/tame.mp3": 945990,
	"./Audio/tamp.mp3": 389599,
	"./Audio/tan.mp3": 373618,
	"./Audio/tangible.mp3": 633649,
	"./Audio/tank.mp3": 191065,
	"./Audio/tant.mp3": 67570,
	"./Audio/tao.mp3": 751287,
	"./Audio/taon.mp3": 793339,
	"./Audio/tap.mp3": 537268,
	"./Audio/tar.mp3": 785638,
	"./Audio/tarel.mp3": 842781,
	"./Audio/tari.mp3": 229111,
	"./Audio/tarl.mp3": 143758,
	"./Audio/tarn.mp3": 281628,
	"./Audio/tas.mp3": 541963,
	"./Audio/tase.mp3": 510976,
	"./Audio/tasi.mp3": 584964,
	"./Audio/tass.mp3": 193278,
	"./Audio/tat.mp3": 208472,
	"./Audio/taught.mp3": 697064,
	"./Audio/taunt.mp3": 507631,
	"./Audio/taut.mp3": 648867,
	"./Audio/tax.mp3": 481900,
	"./Audio/taxi.mp3": 92345,
	"./Audio/tay.mp3": 844209,
	"./Audio/te.mp3": 948344,
	"./Audio/tea.mp3": 973109,
	"./Audio/teach.mp3": 714024,
	"./Audio/teacher's.mp3": 407071,
	"./Audio/teacher.mp3": 86273,
	"./Audio/teachers'.mp3": 572663,
	"./Audio/teachers.mp3": 850844,
	"./Audio/teal.mp3": 596883,
	"./Audio/team.mp3": 614990,
	"./Audio/tear.mp3": 873725,
	"./Audio/teb.mp3": 536482,
	"./Audio/tecc.mp3": 79874,
	"./Audio/techer.mp3": 142800,
	"./Audio/technical.mp3": 368706,
	"./Audio/technician.mp3": 728103,
	"./Audio/technique.mp3": 301413,
	"./Audio/technology.mp3": 162055,
	"./Audio/teck.mp3": 46314,
	"./Audio/teckon.mp3": 397409,
	"./Audio/ted.mp3": 788428,
	"./Audio/tee.mp3": 846289,
	"./Audio/teebe.mp3": 340386,
	"./Audio/teed.mp3": 194359,
	"./Audio/teek.mp3": 938596,
	"./Audio/teen.mp3": 56365,
	"./Audio/teene.mp3": 890142,
	"./Audio/teese.mp3": 185141,
	"./Audio/teet.mp3": 219079,
	"./Audio/teether.mp3": 873200,
	"./Audio/teg.mp3": 242243,
	"./Audio/tegg.mp3": 814778,
	"./Audio/teke.mp3": 919268,
	"./Audio/telegram.mp3": 479076,
	"./Audio/telephone.mp3": 249895,
	"./Audio/teleport.mp3": 190092,
	"./Audio/telescope.mp3": 904231,
	"./Audio/television.mp3": 661873,
	"./Audio/tell.mp3": 929504,
	"./Audio/telm.mp3": 58245,
	"./Audio/telt.mp3": 125528,
	"./Audio/tem.mp3": 111545,
	"./Audio/teme.mp3": 653898,
	"./Audio/temperament.mp3": 523379,
	"./Audio/temperate.mp3": 361734,
	"./Audio/temperature.mp3": 482081,
	"./Audio/tempered.mp3": 51545,
	"./Audio/tempering.mp3": 451422,
	"./Audio/tempermental.mp3": 878989,
	"./Audio/temporary.mp3": 135358,
	"./Audio/ten.mp3": 451654,
	"./Audio/tenacious.mp3": 104930,
	"./Audio/tend.mp3": 630390,
	"./Audio/tennis.mp3": 724276,
	"./Audio/tension.mp3": 279025,
	"./Audio/tent.mp3": 458118,
	"./Audio/tep.mp3": 991552,
	"./Audio/term.mp3": 312623,
	"./Audio/terminal.mp3": 861289,
	"./Audio/terminate.mp3": 647154,
	"./Audio/termination.mp3": 961869,
	"./Audio/terminology.mp3": 686414,
	"./Audio/terr.mp3": 495676,
	"./Audio/terraform.mp3": 595819,
	"./Audio/terrain.mp3": 390044,
	"./Audio/terrapin.mp3": 457034,
	"./Audio/terrible.mp3": 139644,
	"./Audio/terribly.mp3": 622072,
	"./Audio/territorial.mp3": 514034,
	"./Audio/territory.mp3": 774949,
	"./Audio/terrorise.mp3": 814100,
	"./Audio/test.mp3": 590289,
	"./Audio/tet.mp3": 603708,
	"./Audio/th -2.mp3": 448314,
	"./Audio/th -3.mp3": 61279,
	"./Audio/th -4.mp3": 562180,
	"./Audio/th .mp3": 332243,
	"./Audio/th-2.mp3": 244660,
	"./Audio/th.mp3": 224849,
	"./Audio/th2.mp3": 38449,
	"./Audio/thail.mp3": 511345,
	"./Audio/thair.mp3": 374847,
	"./Audio/thal.mp3": 21750,
	"./Audio/thall.mp3": 913662,
	"./Audio/thame.mp3": 309168,
	"./Audio/than.mp3": 437188,
	"./Audio/thank.mp3": 820963,
	"./Audio/thanks.mp3": 903846,
	"./Audio/thar.mp3": 658128,
	"./Audio/thard.mp3": 248116,
	"./Audio/tharst.mp3": 121001,
	"./Audio/tharteen.mp3": 784996,
	"./Audio/thase.mp3": 632022,
	"./Audio/thass.mp3": 340056,
	"./Audio/that's.mp3": 916012,
	"./Audio/that.mp3": 45502,
	"./Audio/thatch.mp3": 509943,
	"./Audio/thaw.mp3": 217937,
	"./Audio/thawl.mp3": 645887,
	"./Audio/thay.mp3": 818479,
	"./Audio/the.mp3": 383282,
	"./Audio/thead.mp3": 343661,
	"./Audio/thear.mp3": 755979,
	"./Audio/theard.mp3": 739237,
	"./Audio/theast.mp3": 245241,
	"./Audio/theateen.mp3": 156967,
	"./Audio/thed.mp3": 266242,
	"./Audio/theff.mp3": 207494,
	"./Audio/their.mp3": 504771,
	"./Audio/theirs.mp3": 462918,
	"./Audio/them.mp3": 890383,
	"./Audio/theme.mp3": 333828,
	"./Audio/then.mp3": 790488,
	"./Audio/there's.mp3": 72971,
	"./Audio/there.mp3": 788293,
	"./Audio/therefore.mp3": 942591,
	"./Audio/these.mp3": 182882,
	"./Audio/they're.mp3": 948245,
	"./Audio/they.mp3": 107643,
	"./Audio/thick.mp3": 333512,
	"./Audio/thid.mp3": 42790,
	"./Audio/thief.mp3": 162199,
	"./Audio/thime.mp3": 673096,
	"./Audio/thimnair.mp3": 121805,
	"./Audio/thimnar.mp3": 106282,
	"./Audio/thimnay.mp3": 884373,
	"./Audio/thimney.mp3": 225241,
	"./Audio/thimnoy.mp3": 139831,
	"./Audio/thin.mp3": 739052,
	"./Audio/thing.mp3": 9191,
	"./Audio/things.mp3": 701362,
	"./Audio/think.mp3": 801067,
	"./Audio/thip.mp3": 925274,
	"./Audio/third.mp3": 975356,
	"./Audio/thirst.mp3": 462497,
	"./Audio/thirsty.mp3": 420342,
	"./Audio/thirteen.mp3": 496716,
	"./Audio/this.mp3": 386797,
	"./Audio/thise.mp3": 419038,
	"./Audio/thist.mp3": 404819,
	"./Audio/thistle.mp3": 587126,
	"./Audio/thiteen.mp3": 317486,
	"./Audio/thoa.mp3": 692837,
	"./Audio/thoad.mp3": 154635,
	"./Audio/thoil.mp3": 374123,
	"./Audio/thome.mp3": 498458,
	"./Audio/thor.mp3": 340514,
	"./Audio/thord.mp3": 988114,
	"./Audio/thorn.mp3": 486504,
	"./Audio/thorough.mp3": 785003,
	"./Audio/thoroughly.mp3": 976218,
	"./Audio/thorst.mp3": 910727,
	"./Audio/thorteen.mp3": 429754,
	"./Audio/those.mp3": 113900,
	"./Audio/though.mp3": 248416,
	"./Audio/thought.mp3": 634676,
	"./Audio/thoughtful.mp3": 552737,
	"./Audio/thoughtfully.mp3": 274032,
	"./Audio/thoughts.mp3": 661547,
	"./Audio/thow.mp3": 588803,
	"./Audio/thowl.mp3": 489637,
	"./Audio/thraw.mp3": 481073,
	"./Audio/thread.mp3": 927309,
	"./Audio/three.mp3": 778279,
	"./Audio/threw.mp3": 678693,
	"./Audio/thrill.mp3": 446982,
	"./Audio/throo.mp3": 984379,
	"./Audio/through.mp3": 39040,
	"./Audio/throw.mp3": 755939,
	"./Audio/thud.mp3": 207346,
	"./Audio/thue.mp3": 585015,
	"./Audio/thug.mp3": 974917,
	"./Audio/thumb.mp3": 727983,
	"./Audio/thump.mp3": 508877,
	"./Audio/thunder.mp3": 607277,
	"./Audio/thundered.mp3": 617054,
	"./Audio/thunk.mp3": 718239,
	"./Audio/thursday.mp3": 94939,
	"./Audio/thuse.mp3": 448594,
	"./Audio/ti.mp3": 166988,
	"./Audio/tibe.mp3": 106467,
	"./Audio/tick.mp3": 149646,
	"./Audio/ticken.mp3": 860839,
	"./Audio/ticket.mp3": 463501,
	"./Audio/tict.mp3": 924733,
	"./Audio/tid.mp3": 636272,
	"./Audio/tidiness.mp3": 457580,
	"./Audio/tie.mp3": 917013,
	"./Audio/tient.mp3": 883703,
	"./Audio/tiet.mp3": 133035,
	"./Audio/tiff.mp3": 980512,
	"./Audio/tig.mp3": 754439,
	"./Audio/tight.mp3": 649667,
	"./Audio/tik.mp3": 4043,
	"./Audio/tike.mp3": 507200,
	"./Audio/til.mp3": 670552,
	"./Audio/till.mp3": 948084,
	"./Audio/tilm.mp3": 907929,
	"./Audio/tilt.mp3": 188444,
	"./Audio/tim.mp3": 876925,
	"./Audio/time.mp3": 267534,
	"./Audio/timid.mp3": 801626,
	"./Audio/timney.mp3": 62403,
	"./Audio/timorous.mp3": 683377,
	"./Audio/timp.mp3": 250759,
	"./Audio/tin.mp3": 138922,
	"./Audio/tine.mp3": 920879,
	"./Audio/tinsel.mp3": 668594,
	"./Audio/tint.mp3": 782522,
	"./Audio/tiny.mp3": 668915,
	"./Audio/tip.mp3": 239708,
	"./Audio/tipet.mp3": 450139,
	"./Audio/tiptoe.mp3": 157096,
	"./Audio/tir.mp3": 771214,
	"./Audio/tirl.mp3": 156086,
	"./Audio/tirp.mp3": 42466,
	"./Audio/tis.mp3": 269459,
	"./Audio/tit.mp3": 474528,
	"./Audio/titet.mp3": 960495,
	"./Audio/tix.mp3": 473956,
	"./Audio/to.mp3": 915042,
	"./Audio/toa.mp3": 725939,
	"./Audio/toacher.mp3": 932407,
	"./Audio/toad.mp3": 817245,
	"./Audio/toael.mp3": 123732,
	"./Audio/toak.mp3": 308798,
	"./Audio/toal.mp3": 608053,
	"./Audio/toam.mp3": 921424,
	"./Audio/toan.mp3": 776359,
	"./Audio/toast.mp3": 215158,
	"./Audio/tob.mp3": 160956,
	"./Audio/tobe.mp3": 523045,
	"./Audio/tock.mp3": 66676,
	"./Audio/tocket.mp3": 665523,
	"./Audio/tocknair.mp3": 571646,
	"./Audio/tocknar.mp3": 406187,
	"./Audio/tocknay.mp3": 134476,
	"./Audio/tockney.mp3": 792219,
	"./Audio/tocknoy.mp3": 515978,
	"./Audio/tod.mp3": 808530,
	"./Audio/today.mp3": 423372,
	"./Audio/toe.mp3": 313047,
	"./Audio/toel.mp3": 762985,
	"./Audio/toffee.mp3": 29088,
	"./Audio/toft.mp3": 721876,
	"./Audio/tog.mp3": 599077,
	"./Audio/together.mp3": 209495,
	"./Audio/toi.mp3": 686107,
	"./Audio/toil.mp3": 935293,
	"./Audio/toin.mp3": 371343,
	"./Audio/tok.mp3": 153129,
	"./Audio/toke.mp3": 124954,
	"./Audio/told.mp3": 956090,
	"./Audio/tolerable.mp3": 848287,
	"./Audio/tolerably.mp3": 711619,
	"./Audio/tolerance.mp3": 412798,
	"./Audio/tolerant.mp3": 631238,
	"./Audio/toleration.mp3": 792270,
	"./Audio/tolm.mp3": 243863,
	"./Audio/tom.mp3": 995039,
	"./Audio/tome.mp3": 47348,
	"./Audio/tomorrow.mp3": 988020,
	"./Audio/ton.mp3": 611368,
	"./Audio/tonait.mp3": 675234,
	"./Audio/tone.mp3": 980961,
	"./Audio/toneet.mp3": 874210,
	"./Audio/tonet.mp3": 795863,
	"./Audio/tongue.mp3": 51649,
	"./Audio/tonight.mp3": 657944,
	"./Audio/too.mp3": 784973,
	"./Audio/took.mp3": 26616,
	"./Audio/toon.mp3": 178873,
	"./Audio/toose.mp3": 334185,
	"./Audio/top.mp3": 231102,
	"./Audio/tor.mp3": 345676,
	"./Audio/torch.mp3": 893153,
	"./Audio/torel.mp3": 770803,
	"./Audio/torl.mp3": 315160,
	"./Audio/torn.mp3": 783530,
	"./Audio/tot.mp3": 93730,
	"./Audio/total.mp3": 137269,
	"./Audio/tou.mp3": 698663,
	"./Audio/touch.mp3": 619478,
	"./Audio/tough.mp3": 790122,
	"./Audio/tourist.mp3": 364449,
	"./Audio/toward.mp3": 617064,
	"./Audio/towards.mp3": 533895,
	"./Audio/towel.mp3": 282142,
	"./Audio/towl.mp3": 324435,
	"./Audio/town.mp3": 556833,
	"./Audio/toy.mp3": 617387,
	"./Audio/tra.mp3": 357740,
	"./Audio/trace.mp3": 19304,
	"./Audio/track.mp3": 123374,
	"./Audio/tradition.mp3": 341259,
	"./Audio/train.mp3": 381045,
	"./Audio/trair.mp3": 3817,
	"./Audio/trairs.mp3": 511092,
	"./Audio/trane.mp3": 474255,
	"./Audio/tranquil.mp3": 434211,
	"./Audio/transcendent.mp3": 803538,
	"./Audio/transcribe.mp3": 224236,
	"./Audio/transect.mp3": 155343,
	"./Audio/transfer.mp3": 16576,
	"./Audio/transference.mp3": 431185,
	"./Audio/transferred.mp3": 337129,
	"./Audio/transferring.mp3": 482126,
	"./Audio/transformed.mp3": 133612,
	"./Audio/translate.mp3": 713325,
	"./Audio/transmission.mp3": 783481,
	"./Audio/transmit.mp3": 774933,
	"./Audio/transparent.mp3": 410417,
	"./Audio/transplant.mp3": 553548,
	"./Audio/transport.mp3": 900856,
	"./Audio/transportation.mp3": 382123,
	"./Audio/transported.mp3": 465655,
	"./Audio/trap.mp3": 810044,
	"./Audio/trar.mp3": 668974,
	"./Audio/trars.mp3": 295957,
	"./Audio/trash.mp3": 533585,
	"./Audio/travel.mp3": 911193,
	"./Audio/tray.mp3": 802217,
	"./Audio/tread.mp3": 769011,
	"./Audio/trear.mp3": 573429,
	"./Audio/treasure.mp3": 406666,
	"./Audio/treat.mp3": 842563,
	"./Audio/tree.mp3": 323641,
	"./Audio/trees.mp3": 507076,
	"./Audio/tremendous.mp3": 237931,
	"./Audio/trend.mp3": 582526,
	"./Audio/trene.mp3": 846467,
	"./Audio/tres.mp3": 649887,
	"./Audio/trial.mp3": 102775,
	"./Audio/triangle.mp3": 498377,
	"./Audio/triathlon.mp3": 614936,
	"./Audio/trick.mp3": 57766,
	"./Audio/tricycle.mp3": 943582,
	"./Audio/trident.mp3": 685379,
	"./Audio/tried.mp3": 593731,
	"./Audio/trier.mp3": 876965,
	"./Audio/tries.mp3": 826688,
	"./Audio/trine.mp3": 986215,
	"./Audio/trist.mp3": 309397,
	"./Audio/troas.mp3": 821662,
	"./Audio/trock.mp3": 472588,
	"./Audio/troe.mp3": 607663,
	"./Audio/trolley.mp3": 762528,
	"./Audio/trone.mp3": 633689,
	"./Audio/trop.mp3": 810934,
	"./Audio/trouble.mp3": 94594,
	"./Audio/trough.mp3": 773106,
	"./Audio/trousers.mp3": 899482,
	"./Audio/trow.mp3": 388557,
	"./Audio/truck.mp3": 163682,
	"./Audio/trudged.mp3": 377080,
	"./Audio/true.mp3": 382345,
	"./Audio/truly.mp3": 432665,
	"./Audio/trunk.mp3": 421837,
	"./Audio/truth.mp3": 832956,
	"./Audio/try.mp3": 887716,
	"./Audio/trying.mp3": 657132,
	"./Audio/tube.mp3": 230535,
	"./Audio/tubeless.mp3": 864340,
	"./Audio/tuck.mp3": 858,
	"./Audio/tucket.mp3": 259945,
	"./Audio/tud.mp3": 201052,
	"./Audio/tuesday.mp3": 129978,
	"./Audio/tuft.mp3": 732286,
	"./Audio/tug.mp3": 230803,
	"./Audio/tuil.mp3": 774923,
	"./Audio/tuin.mp3": 730073,
	"./Audio/tuke.mp3": 547220,
	"./Audio/tull.mp3": 787664,
	"./Audio/tum.mp3": 170249,
	"./Audio/tun.mp3": 923862,
	"./Audio/tune.mp3": 485899,
	"./Audio/tunnel.mp3": 649171,
	"./Audio/tunt.mp3": 444374,
	"./Audio/tup.mp3": 597616,
	"./Audio/tur.mp3": 133826,
	"./Audio/turbulent.mp3": 665414,
	"./Audio/turkair.mp3": 845879,
	"./Audio/turkar.mp3": 832872,
	"./Audio/turkay.mp3": 534551,
	"./Audio/turkey.mp3": 553155,
	"./Audio/turkoy.mp3": 309109,
	"./Audio/turn.mp3": 4872,
	"./Audio/tus.mp3": 715783,
	"./Audio/tuss.mp3": 101714,
	"./Audio/tut.mp3": 905324,
	"./Audio/tuww.mp3": 739178,
	"./Audio/tuxx.mp3": 447624,
	"./Audio/tuyy.mp3": 187690,
	"./Audio/tuzz.mp3": 656380,
	"./Audio/twas.mp3": 568782,
	"./Audio/twelfth.mp3": 24953,
	"./Audio/twelve.mp3": 780886,
	"./Audio/twenty.mp3": 743082,
	"./Audio/twice.mp3": 133723,
	"./Audio/twill.mp3": 264659,
	"./Audio/twirl.mp3": 732541,
	"./Audio/twist.mp3": 46454,
	"./Audio/two.mp3": 859109,
	"./Audio/type.mp3": 482069,
	"./Audio/typical.mp3": 987383,
	"./Audio/u -2.mp3": 973999,
	"./Audio/u -3.mp3": 748362,
	"./Audio/u .mp3": 552178,
	"./Audio/u-2.mp3": 195955,
	"./Audio/u-3.mp3": 669102,
	"./Audio/u.mp3": 848878,
	"./Audio/u2.mp3": 352752,
	"./Audio/uil.mp3": 654417,
	"./Audio/uit.mp3": 99561,
	"./Audio/unbelievable.mp3": 715483,
	"./Audio/unbelieveable.mp3": 108360,
	"./Audio/uncertain.mp3": 296018,
	"./Audio/unclear.mp3": 126295,
	"./Audio/uncoiled.mp3": 886406,
	"./Audio/unconscious.mp3": 435698,
	"./Audio/unconsciously.mp3": 505907,
	"./Audio/under.mp3": 907889,
	"./Audio/underneath.mp3": 503211,
	"./Audio/understandable.mp3": 490159,
	"./Audio/undeveloped.mp3": 438740,
	"./Audio/undo.mp3": 664107,
	"./Audio/unfair.mp3": 915542,
	"./Audio/unfamiliar.mp3": 262793,
	"./Audio/unfavourable.mp3": 239603,
	"./Audio/unfavourably.mp3": 491567,
	"./Audio/unfortunately.mp3": 331419,
	"./Audio/unhappy.mp3": 417390,
	"./Audio/unhealthy.mp3": 637223,
	"./Audio/unicorn.mp3": 508771,
	"./Audio/unicycle.mp3": 236713,
	"./Audio/unidentifiable.mp3": 709576,
	"./Audio/unidentified.mp3": 655087,
	"./Audio/uniform.mp3": 934619,
	"./Audio/unimaginable.mp3": 793583,
	"./Audio/unimaginative.mp3": 692542,
	"./Audio/unimportant.mp3": 936126,
	"./Audio/union.mp3": 607222,
	"./Audio/unique.mp3": 959704,
	"./Audio/unison.mp3": 304979,
	"./Audio/unit.mp3": 59015,
	"./Audio/universe.mp3": 244492,
	"./Audio/unkind.mp3": 984698,
	"./Audio/unknowing.mp3": 900623,
	"./Audio/unknowingly.mp3": 302102,
	"./Audio/unknown.mp3": 228101,
	"./Audio/unload.mp3": 594232,
	"./Audio/unlock.mp3": 379605,
	"./Audio/unlucky.mp3": 307500,
	"./Audio/unmoving.mp3": 303446,
	"./Audio/unnatural.mp3": 942555,
	"./Audio/unnaturally.mp3": 249450,
	"./Audio/unnecessarily.mp3": 18476,
	"./Audio/unnecessary.mp3": 959541,
	"./Audio/unpopular.mp3": 926999,
	"./Audio/unpopularity.mp3": 553705,
	"./Audio/unprepared.mp3": 797327,
	"./Audio/unpretentious.mp3": 841288,
	"./Audio/unprofessional.mp3": 382365,
	"./Audio/unprofessionally.mp3": 368100,
	"./Audio/unsocial.mp3": 745945,
	"./Audio/until.mp3": 81035,
	"./Audio/untrar.mp3": 654523,
	"./Audio/untrear.mp3": 166890,
	"./Audio/untrow.mp3": 508060,
	"./Audio/untrue.mp3": 652684,
	"./Audio/unusual.mp3": 80750,
	"./Audio/unwell.mp3": 336444,
	"./Audio/unzip.mp3": 240205,
	"./Audio/up.mp3": 377986,
	"./Audio/upstairs.mp3": 934000,
	"./Audio/ur -2.mp3": 527209,
	"./Audio/ur -3.mp3": 360196,
	"./Audio/ur .mp3": 475128,
	"./Audio/ur.mp3": 325424,
	"./Audio/ure -2.mp3": 217506,
	"./Audio/ure -3.mp3": 822439,
	"./Audio/ure .mp3": 799083,
	"./Audio/ure.mp3": 658937,
	"./Audio/urn.mp3": 68222,
	"./Audio/urt.mp3": 2436,
	"./Audio/us.mp3": 122517,
	"./Audio/use.mp3": 261430,
	"./Audio/used.mp3": 506310,
	"./Audio/using.mp3": 243395,
	"./Audio/usual.mp3": 192113,
	"./Audio/usually.mp3": 74208,
	"./Audio/ut.mp3": 515358,
	"./Audio/uthor.mp3": 347389,
	"./Audio/v -2.mp3": 673770,
	"./Audio/v -3.mp3": 635919,
	"./Audio/v.mp3": 274817,
	"./Audio/va.mp3": 967774,
	"./Audio/vacate.mp3": 512783,
	"./Audio/vacation.mp3": 331096,
	"./Audio/vacuum.mp3": 308552,
	"./Audio/vad.mp3": 829598,
	"./Audio/vag.mp3": 979057,
	"./Audio/vague.mp3": 347031,
	"./Audio/vai.mp3": 985743,
	"./Audio/vaid.mp3": 750313,
	"./Audio/vail.mp3": 585537,
	"./Audio/vain.mp3": 839475,
	"./Audio/vair.mp3": 575087,
	"./Audio/vait.mp3": 723449,
	"./Audio/val.mp3": 920486,
	"./Audio/valar.mp3": 34975,
	"./Audio/valay.mp3": 919360,
	"./Audio/valear.mp3": 667598,
	"./Audio/vallair.mp3": 89666,
	"./Audio/vallar.mp3": 966887,
	"./Audio/vallay.mp3": 395256,
	"./Audio/valley.mp3": 423420,
	"./Audio/vallow.mp3": 476696,
	"./Audio/valloy.mp3": 962974,
	"./Audio/valow.mp3": 938688,
	"./Audio/valt.mp3": 392486,
	"./Audio/valuable.mp3": 411915,
	"./Audio/value.mp3": 495936,
	"./Audio/van.mp3": 672116,
	"./Audio/vandalise.mp3": 47528,
	"./Audio/vard.mp3": 67236,
	"./Audio/variable.mp3": 43689,
	"./Audio/variation.mp3": 499976,
	"./Audio/varied.mp3": 417974,
	"./Audio/varies.mp3": 950173,
	"./Audio/varieties.mp3": 578499,
	"./Audio/variety.mp3": 272871,
	"./Audio/various.mp3": 298024,
	"./Audio/varying.mp3": 399171,
	"./Audio/vast.mp3": 30491,
	"./Audio/vat.mp3": 443982,
	"./Audio/vaul.mp3": 479061,
	"./Audio/vault.mp3": 884331,
	"./Audio/vaw.mp3": 47777,
	"./Audio/vax.mp3": 802970,
	"./Audio/vay.mp3": 511935,
	"./Audio/ve.mp3": 830402,
	"./Audio/vea.mp3": 805011,
	"./Audio/vear.mp3": 223931,
	"./Audio/veb.mp3": 444636,
	"./Audio/veck.mp3": 768724,
	"./Audio/vee.mp3": 392119,
	"./Audio/veeb.mp3": 124727,
	"./Audio/veed.mp3": 286369,
	"./Audio/veel.mp3": 603913,
	"./Audio/veen.mp3": 441595,
	"./Audio/veese.mp3": 401847,
	"./Audio/veet.mp3": 217649,
	"./Audio/veff.mp3": 746326,
	"./Audio/veg.mp3": 112645,
	"./Audio/vegetable.mp3": 791234,
	"./Audio/vehicle.mp3": 889740,
	"./Audio/veil.mp3": 555741,
	"./Audio/vein.mp3": 336623,
	"./Audio/velt.mp3": 40618,
	"./Audio/velvet.mp3": 256999,
	"./Audio/vem.mp3": 374719,
	"./Audio/ven.mp3": 455816,
	"./Audio/vent.mp3": 709452,
	"./Audio/vep.mp3": 819230,
	"./Audio/veracity.mp3": 706224,
	"./Audio/verb.mp3": 633534,
	"./Audio/verbal.mp3": 387993,
	"./Audio/verbose.mp3": 382013,
	"./Audio/verdict.mp3": 207404,
	"./Audio/verify.mp3": 531082,
	"./Audio/version.mp3": 792371,
	"./Audio/very.mp3": 39209,
	"./Audio/vess.mp3": 295692,
	"./Audio/vestle.mp3": 518186,
	"./Audio/vet.mp3": 681858,
	"./Audio/vexatious.mp3": 273385,
	"./Audio/vib.mp3": 157128,
	"./Audio/vibrant.mp3": 158049,
	"./Audio/vibration.mp3": 853505,
	"./Audio/vic.mp3": 802413,
	"./Audio/vich.mp3": 641807,
	"./Audio/vicious.mp3": 823677,
	"./Audio/vicked.mp3": 809239,
	"./Audio/victorious.mp3": 159764,
	"./Audio/vid.mp3": 173206,
	"./Audio/video.mp3": 584506,
	"./Audio/viel.mp3": 530461,
	"./Audio/viff.mp3": 796682,
	"./Audio/vig.mp3": 419593,
	"./Audio/vight.mp3": 815565,
	"./Audio/vigorous.mp3": 95069,
	"./Audio/vill.mp3": 782838,
	"./Audio/village.mp3": 111243,
	"./Audio/vim.mp3": 480147,
	"./Audio/vin.mp3": 450396,
	"./Audio/violinist.mp3": 735274,
	"./Audio/vip.mp3": 349610,
	"./Audio/viscount.mp3": 763318,
	"./Audio/vise.mp3": 894286,
	"./Audio/visible.mp3": 703321,
	"./Audio/visibly.mp3": 347397,
	"./Audio/vision.mp3": 770705,
	"./Audio/visit.mp3": 764586,
	"./Audio/visitors.mp3": 51760,
	"./Audio/viskers.mp3": 284604,
	"./Audio/vismer.mp3": 374595,
	"./Audio/visper.mp3": 804942,
	"./Audio/visualise.mp3": 249401,
	"./Audio/vit.mp3": 458406,
	"./Audio/voa.mp3": 869141,
	"./Audio/voad.mp3": 228827,
	"./Audio/voan.mp3": 742977,
	"./Audio/vob.mp3": 124610,
	"./Audio/voi.mp3": 524605,
	"./Audio/voice.mp3": 896009,
	"./Audio/volt.mp3": 339832,
	"./Audio/volume.mp3": 361707,
	"./Audio/voluntary.mp3": 347723,
	"./Audio/von.mp3": 895398,
	"./Audio/vood.mp3": 100901,
	"./Audio/voon.mp3": 872268,
	"./Audio/vor.mp3": 787826,
	"./Audio/vord.mp3": 808706,
	"./Audio/vose.mp3": 423516,
	"./Audio/voss.mp3": 356290,
	"./Audio/vow.mp3": 247763,
	"./Audio/vul.mp3": 235114,
	"./Audio/vun.mp3": 766744,
	"./Audio/vuse.mp3": 150178,
	"./Audio/vuss.mp3": 217404,
	"./Audio/w -2.mp3": 961445,
	"./Audio/w -3.mp3": 911168,
	"./Audio/w.mp3": 294396,
	"./Audio/wa.mp3": 351489,
	"./Audio/wack.mp3": 167787,
	"./Audio/wag.mp3": 280560,
	"./Audio/wai.mp3": 892006,
	"./Audio/waid.mp3": 588758,
	"./Audio/waik.mp3": 686981,
	"./Audio/wail.mp3": 397454,
	"./Audio/waip.mp3": 918186,
	"./Audio/wair.mp3": 296792,
	"./Audio/wait.mp3": 543334,
	"./Audio/wak.mp3": 643636,
	"./Audio/walk.mp3": 344658,
	"./Audio/walking.mp3": 75270,
	"./Audio/wall.mp3": 220033,
	"./Audio/wallet.mp3": 676226,
	"./Audio/walrus.mp3": 660075,
	"./Audio/wamp.mp3": 865270,
	"./Audio/wand.mp3": 506899,
	"./Audio/wander.mp3": 264498,
	"./Audio/want.mp3": 386211,
	"./Audio/wanted.mp3": 833148,
	"./Audio/wap.mp3": 913747,
	"./Audio/war.mp3": 19297,
	"./Audio/ward.mp3": 840935,
	"./Audio/warder.mp3": 259630,
	"./Audio/wardrobe.mp3": 116529,
	"./Audio/ware.mp3": 236002,
	"./Audio/warfare.mp3": 433293,
	"./Audio/warm.mp3": 437066,
	"./Audio/warplane.mp3": 465782,
	"./Audio/warship.mp3": 154115,
	"./Audio/wary.mp3": 865974,
	"./Audio/was.mp3": 883996,
	"./Audio/wash.mp3": 212324,
	"./Audio/washing.mp3": 719212,
	"./Audio/wasn't.mp3": 375187,
	"./Audio/wasn’t.mp3": 980189,
	"./Audio/wasp.mp3": 470444,
	"./Audio/wat.mp3": 374007,
	"./Audio/watch.mp3": 226598,
	"./Audio/water.mp3": 176606,
	"./Audio/wave.mp3": 683334,
	"./Audio/wax.mp3": 174523,
	"./Audio/way.mp3": 606806,
	"./Audio/we're.mp3": 236123,
	"./Audio/we.mp3": 266661,
	"./Audio/weak.mp3": 421137,
	"./Audio/wealth.mp3": 997686,
	"./Audio/wear.mp3": 640388,
	"./Audio/wearily.mp3": 69427,
	"./Audio/weary.mp3": 427361,
	"./Audio/weather.mp3": 444795,
	"./Audio/web.mp3": 53373,
	"./Audio/webra.mp3": 559098,
	"./Audio/weck.mp3": 650831,
	"./Audio/wedge.mp3": 434663,
	"./Audio/wednesday.mp3": 969235,
	"./Audio/wee.mp3": 424166,
	"./Audio/weeb.mp3": 59208,
	"./Audio/weed.mp3": 75286,
	"./Audio/week.mp3": 716037,
	"./Audio/weekend.mp3": 784832,
	"./Audio/weel.mp3": 883982,
	"./Audio/ween.mp3": 352476,
	"./Audio/weep.mp3": 251690,
	"./Audio/weff.mp3": 442109,
	"./Audio/weg.mp3": 633268,
	"./Audio/weigh.mp3": 171367,
	"./Audio/weight.mp3": 705889,
	"./Audio/weightless.mp3": 555150,
	"./Audio/weird.mp3": 345424,
	"./Audio/wek.mp3": 117168,
	"./Audio/weke.mp3": 695353,
	"./Audio/well.mp3": 725701,
	"./Audio/welt.mp3": 999357,
	"./Audio/wem.mp3": 307102,
	"./Audio/wen.mp3": 482737,
	"./Audio/went.mp3": 283175,
	"./Audio/wep.mp3": 862591,
	"./Audio/were.mp3": 145438,
	"./Audio/wes.mp3": 427336,
	"./Audio/wess.mp3": 696935,
	"./Audio/westle.mp3": 20273,
	"./Audio/wet.mp3": 11131,
	"./Audio/wh -2.mp3": 866669,
	"./Audio/wh -3.mp3": 221384,
	"./Audio/wh .mp3": 276020,
	"./Audio/wh.mp3": 832900,
	"./Audio/whack.mp3": 573107,
	"./Audio/whaft.mp3": 459555,
	"./Audio/whale.mp3": 645260,
	"./Audio/what.mp3": 55935,
	"./Audio/whate.mp3": 656212,
	"./Audio/whaw.mp3": 620680,
	"./Audio/wheat.mp3": 81010,
	"./Audio/wheb.mp3": 495173,
	"./Audio/wheck.mp3": 233591,
	"./Audio/wheeb.mp3": 514752,
	"./Audio/wheel.mp3": 689654,
	"./Audio/wheelchair.mp3": 555477,
	"./Audio/whelp.mp3": 381633,
	"./Audio/whem.mp3": 854422,
	"./Audio/when.mp3": 584457,
	"./Audio/where.mp3": 256566,
	"./Audio/whestle.mp3": 280505,
	"./Audio/whete.mp3": 315912,
	"./Audio/whether.mp3": 589132,
	"./Audio/whew.mp3": 835884,
	"./Audio/whey.mp3": 514474,
	"./Audio/which.mp3": 313028,
	"./Audio/whiff.mp3": 960025,
	"./Audio/while.mp3": 144244,
	"./Audio/whip.mp3": 704963,
	"./Audio/whirl.mp3": 959103,
	"./Audio/whisk.mp3": 33867,
	"./Audio/whiskers.mp3": 613513,
	"./Audio/whismer.mp3": 607888,
	"./Audio/whisper.mp3": 328269,
	"./Audio/whistle.mp3": 53829,
	"./Audio/white.mp3": 964140,
	"./Audio/whizz.mp3": 841281,
	"./Audio/who's.mp3": 93157,
	"./Audio/who.mp3": 389063,
	"./Audio/whole.mp3": 750794,
	"./Audio/wholly.mp3": 640520,
	"./Audio/whom.mp3": 749268,
	"./Audio/whoo.mp3": 840774,
	"./Audio/whose.mp3": 587751,
	"./Audio/whote.mp3": 125506,
	"./Audio/whow.mp3": 851758,
	"./Audio/why.mp3": 9633,
	"./Audio/wib.mp3": 391113,
	"./Audio/wich.mp3": 998412,
	"./Audio/wick.mp3": 452227,
	"./Audio/wicked.mp3": 100764,
	"./Audio/wid.mp3": 21375,
	"./Audio/wide.mp3": 739668,
	"./Audio/widening.mp3": 865446,
	"./Audio/width.mp3": 427283,
	"./Audio/wield.mp3": 458370,
	"./Audio/wife.mp3": 789534,
	"./Audio/wiff.mp3": 965169,
	"./Audio/wig.mp3": 128648,
	"./Audio/wiggle.mp3": 375318,
	"./Audio/wike.mp3": 133509,
	"./Audio/wild.mp3": 564961,
	"./Audio/will.mp3": 425033,
	"./Audio/willingness.mp3": 33666,
	"./Audio/wilt.mp3": 522417,
	"./Audio/wim.mp3": 17906,
	"./Audio/wimp.mp3": 286734,
	"./Audio/win.mp3": 785477,
	"./Audio/wind.mp3": 142571,
	"./Audio/windmill.mp3": 888621,
	"./Audio/window.mp3": 856829,
	"./Audio/wing.mp3": 595604,
	"./Audio/winter.mp3": 730746,
	"./Audio/wip.mp3": 186251,
	"./Audio/wipe.mp3": 252096,
	"./Audio/wire.mp3": 374378,
	"./Audio/wish.mp3": 406076,
	"./Audio/wishes.mp3": 679816,
	"./Audio/wiskers.mp3": 659649,
	"./Audio/wismer.mp3": 781720,
	"./Audio/wisper.mp3": 696069,
	"./Audio/wiss.mp3": 709483,
	"./Audio/wit.mp3": 495183,
	"./Audio/witch's.mp3": 578108,
	"./Audio/witch.mp3": 263534,
	"./Audio/with.mp3": 138981,
	"./Audio/wix.mp3": 330979,
	"./Audio/wiz.mp3": 488497,
	"./Audio/woad.mp3": 426412,
	"./Audio/woal.mp3": 481780,
	"./Audio/woan.mp3": 730150,
	"./Audio/woap.mp3": 440608,
	"./Audio/wob.mp3": 937935,
	"./Audio/wocket.mp3": 953970,
	"./Audio/wod.mp3": 584153,
	"./Audio/woe.mp3": 624308,
	"./Audio/woke.mp3": 253047,
	"./Audio/wol.mp3": 931249,
	"./Audio/wolt.mp3": 199719,
	"./Audio/woman's.mp3": 7731,
	"./Audio/woman.mp3": 540781,
	"./Audio/women's.mp3": 813247,
	"./Audio/women.mp3": 356001,
	"./Audio/women_s.mp3": 873511,
	"./Audio/won't.mp3": 450538,
	"./Audio/won.mp3": 773731,
	"./Audio/wonder.mp3": 476704,
	"./Audio/wonderful.mp3": 418461,
	"./Audio/wood.mp3": 648222,
	"./Audio/wool.mp3": 281638,
	"./Audio/woon.mp3": 490740,
	"./Audio/wop.mp3": 216685,
	"./Audio/word.mp3": 67961,
	"./Audio/wordy.mp3": 779118,
	"./Audio/wore.mp3": 12116,
	"./Audio/work.mp3": 492898,
	"./Audio/worker.mp3": 86887,
	"./Audio/workmanship.mp3": 899720,
	"./Audio/works.mp3": 694545,
	"./Audio/world.mp3": 51959,
	"./Audio/worm.mp3": 261196,
	"./Audio/worn.mp3": 715011,
	"./Audio/worries.mp3": 684292,
	"./Audio/worry.mp3": 168928,
	"./Audio/worse.mp3": 699103,
	"./Audio/worship.mp3": 769549,
	"./Audio/worst.mp3": 998858,
	"./Audio/worth.mp3": 394259,
	"./Audio/worthwhile.mp3": 202386,
	"./Audio/worthy.mp3": 257564,
	"./Audio/woss.mp3": 742553,
	"./Audio/wot.mp3": 833865,
	"./Audio/would.mp3": 141876,
	"./Audio/wound.mp3": 445074,
	"./Audio/woy.mp3": 99488,
	"./Audio/wrap.mp3": 81349,
	"./Audio/wreath.mp3": 441192,
	"./Audio/wreck.mp3": 46261,
	"./Audio/wren.mp3": 673239,
	"./Audio/wrench.mp3": 322886,
	"./Audio/wrestle.mp3": 236115,
	"./Audio/wrestling.mp3": 332858,
	"./Audio/wriggle.mp3": 597260,
	"./Audio/wrinkle.mp3": 644923,
	"./Audio/wrist.mp3": 319866,
	"./Audio/write.mp3": 166826,
	"./Audio/writer.mp3": 492932,
	"./Audio/written.mp3": 887602,
	"./Audio/wrong.mp3": 545252,
	"./Audio/wrote.mp3": 936820,
	"./Audio/wry.mp3": 668319,
	"./Audio/wub.mp3": 350509,
	"./Audio/wuck.mp3": 572383,
	"./Audio/wuke.mp3": 891785,
	"./Audio/wum.mp3": 529998,
	"./Audio/wump.mp3": 238690,
	"./Audio/wunt.mp3": 910423,
	"./Audio/x.mp3": 128479,
	"./Audio/xak.mp3": 541327,
	"./Audio/xap.mp3": 855904,
	"./Audio/xeb.mp3": 672694,
	"./Audio/xeck.mp3": 64934,
	"./Audio/xeff.mp3": 970408,
	"./Audio/xeg.mp3": 944031,
	"./Audio/xell.mp3": 545084,
	"./Audio/xem.mp3": 548069,
	"./Audio/xes.mp3": 566379,
	"./Audio/xet.mp3": 76024,
	"./Audio/xick.mp3": 411634,
	"./Audio/xiff.mp3": 888132,
	"./Audio/xim.mp3": 651217,
	"./Audio/xip.mp3": 554600,
	"./Audio/xub.mp3": 375558,
	"./Audio/xuck.mp3": 250518,
	"./Audio/xum.mp3": 743989,
	"./Audio/y -2.mp3": 476715,
	"./Audio/y -3.mp3": 21254,
	"./Audio/y.mp3": 184890,
	"./Audio/yacht.mp3": 1082,
	"./Audio/yad.mp3": 116885,
	"./Audio/yaid.mp3": 594536,
	"./Audio/yait.mp3": 110200,
	"./Audio/yak.mp3": 659494,
	"./Audio/yap.mp3": 727905,
	"./Audio/yar.mp3": 11859,
	"./Audio/yard.mp3": 825341,
	"./Audio/yart.mp3": 997613,
	"./Audio/yat.mp3": 803141,
	"./Audio/yawn.mp3": 77144,
	"./Audio/ye.mp3": 796319,
	"./Audio/year.mp3": 454002,
	"./Audio/yearly.mp3": 910451,
	"./Audio/yeb.mp3": 214159,
	"./Audio/yebra.mp3": 878024,
	"./Audio/yeck.mp3": 320529,
	"./Audio/yeeb.mp3": 350966,
	"./Audio/yeel.mp3": 506688,
	"./Audio/yeff.mp3": 941015,
	"./Audio/yeg.mp3": 148902,
	"./Audio/yell.mp3": 631967,
	"./Audio/yellow.mp3": 365409,
	"./Audio/yelp.mp3": 495299,
	"./Audio/yem.mp3": 845164,
	"./Audio/yen.mp3": 49955,
	"./Audio/yep.mp3": 492909,
	"./Audio/yes.mp3": 547738,
	"./Audio/yesterday.mp3": 893623,
	"./Audio/yestle.mp3": 140183,
	"./Audio/yet.mp3": 110089,
	"./Audio/yich.mp3": 192018,
	"./Audio/yick.mp3": 982565,
	"./Audio/yield.mp3": 403848,
	"./Audio/yiff.mp3": 740667,
	"./Audio/yim.mp3": 215952,
	"./Audio/yip.mp3": 67881,
	"./Audio/yiskers.mp3": 145639,
	"./Audio/yismer.mp3": 910357,
	"./Audio/yisper.mp3": 317759,
	"./Audio/yo.mp3": 247333,
	"./Audio/yoa.mp3": 591594,
	"./Audio/yoad.mp3": 448266,
	"./Audio/yoat.mp3": 204922,
	"./Audio/yoch.mp3": 686808,
	"./Audio/yog.mp3": 909492,
	"./Audio/yoga.mp3": 863849,
	"./Audio/yolp.mp3": 217497,
	"./Audio/yom.mp3": 583326,
	"./Audio/yon.mp3": 758961,
	"./Audio/yong.mp3": 269184,
	"./Audio/yor.mp3": 501869,
	"./Audio/you'll.mp3": 680377,
	"./Audio/you're.mp3": 363962,
	"./Audio/you've.mp3": 129758,
	"./Audio/you.mp3": 262166,
	"./Audio/young.mp3": 278375,
	"./Audio/youngster.mp3": 843415,
	"./Audio/your.mp3": 917192,
	"./Audio/youre.mp3": 198785,
	"./Audio/yourself.mp3": 945086,
	"./Audio/youth.mp3": 550146,
	"./Audio/youthful.mp3": 767303,
	"./Audio/yow.mp3": 926628,
	"./Audio/yub.mp3": 696063,
	"./Audio/yuck.mp3": 774625,
	"./Audio/yum.mp3": 765980,
	"./Audio/z -2.mp3": 807174,
	"./Audio/z .mp3": 310311,
	"./Audio/z.mp3": 918413,
	"./Audio/za.mp3": 347426,
	"./Audio/zach.mp3": 809099,
	"./Audio/zad-2.mp3": 668687,
	"./Audio/zad.mp3": 728978,
	"./Audio/zaddair.mp3": 340430,
	"./Audio/zaddar.mp3": 487323,
	"./Audio/zadder.mp3": 489511,
	"./Audio/zaddor.mp3": 679653,
	"./Audio/zag.mp3": 519525,
	"./Audio/zai.mp3": 606555,
	"./Audio/zaich.mp3": 159402,
	"./Audio/zaid.mp3": 1429,
	"./Audio/zaik.mp3": 27686,
	"./Audio/zail.mp3": 656893,
	"./Audio/zair.mp3": 380051,
	"./Audio/zait.mp3": 687685,
	"./Audio/zak.mp3": 769129,
	"./Audio/zake.mp3": 473178,
	"./Audio/zall.mp3": 603922,
	"./Audio/zane.mp3": 160033,
	"./Audio/zanoa.mp3": 107660,
	"./Audio/zanor.mp3": 4275,
	"./Audio/zanow.mp3": 570514,
	"./Audio/zanuhe.mp3": 71920,
	"./Audio/zanure.mp3": 405170,
	"./Audio/zar.mp3": 808652,
	"./Audio/zard.mp3": 790576,
	"./Audio/zark.mp3": 158347,
	"./Audio/zass.mp3": 645868,
	"./Audio/zat.mp3": 167202,
	"./Audio/zaw.mp3": 993333,
	"./Audio/ze.mp3": 331774,
	"./Audio/zear.mp3": 226359,
	"./Audio/zebra.mp3": 414203,
	"./Audio/zech.mp3": 773239,
	"./Audio/zee.mp3": 399683,
	"./Audio/zeech.mp3": 429922,
	"./Audio/zeed.mp3": 806925,
	"./Audio/zeel.mp3": 951653,
	"./Audio/zeen.mp3": 208151,
	"./Audio/zeet.mp3": 92125,
	"./Audio/zeff.mp3": 195138,
	"./Audio/zeg.mp3": 3729,
	"./Audio/zeke.mp3": 728430,
	"./Audio/zem.mp3": 701227,
	"./Audio/zen.mp3": 696788,
	"./Audio/zene.mp3": 635949,
	"./Audio/zero.mp3": 729267,
	"./Audio/zet.mp3": 799278,
	"./Audio/zick.mp3": 905964,
	"./Audio/zid.mp3": 735594,
	"./Audio/zie.mp3": 214095,
	"./Audio/zight.mp3": 380713,
	"./Audio/zike.mp3": 273490,
	"./Audio/zin.mp3": 537392,
	"./Audio/zine.mp3": 92153,
	"./Audio/zink.mp3": 122023,
	"./Audio/zip.mp3": 406166,
	"./Audio/zis.mp3": 805577,
	"./Audio/zit.mp3": 573850,
	"./Audio/zo.mp3": 197268,
	"./Audio/zoa.mp3": 362825,
	"./Audio/zoad.mp3": 116959,
	"./Audio/zoak.mp3": 309052,
	"./Audio/zoal.mp3": 308119,
	"./Audio/zoan.mp3": 51621,
	"./Audio/zoat.mp3": 642351,
	"./Audio/zoi.mp3": 986401,
	"./Audio/zoil.mp3": 104431,
	"./Audio/zoke.mp3": 665624,
	"./Audio/zol.mp3": 85920,
	"./Audio/zone.mp3": 877063,
	"./Audio/zoo.mp3": 341111,
	"./Audio/zood.mp3": 528865,
	"./Audio/zool.mp3": 362761,
	"./Audio/zoon.mp3": 200443,
	"./Audio/zoot.mp3": 460145,
	"./Audio/zor.mp3": 401638,
	"./Audio/zord.mp3": 199638,
	"./Audio/zorn.mp3": 476828,
	"./Audio/zort.mp3": 484838,
	"./Audio/zot.mp3": 155096,
	"./Audio/zow.mp3": 771343,
	"./Audio/zowl.mp3": 830913,
	"./Audio/zrill.mp3": 46450,
	"./Audio/zud.mp3": 889998,
	"./Audio/zug.mp3": 977441,
	"./Audio/zuil.mp3": 443409,
	"./Audio/zuke.mp3": 186334,
	"./Audio/zum.mp3": 132667,
	"./Audio/zump.mp3": 506113,
	"./Audio/zz.mp3": 555021,
	"./Duels/DuelAccept.png": 190208,
	"./Duels/DuelIgnore.png": 228578,
	"./Duels/Duelendscreen.png": 470161,
	"./Fractions/Animation/combo0.gif": 39910,
	"./Fractions/Animation/combo1.gif": 647807,
	"./Fractions/Animation/combo2.gif": 984696,
	"./Fractions/Animation/combo3.gif": 882609,
	"./Fractions/Animation/combo4.gif": 374634,
	"./Fractions/ExtraQuestions/fractions_extraquestions - BACKUP.csv": 613592,
	"./Fractions/ExtraQuestions/fractions_extraquestions.csv": 990407,
	"./Fractions/FractionsLevel.png": 875651,
	"./Fractions/FractionsMenu.png": 552276,
	"./Fractions/FractionsRating.png": 931594,
	"./Fractions/Images/numberlineblank.png": 367448,
	"./Fractions/fractions.gif": 746954,
	"./Fractions/menu_fractions.gif": 315756,
	"./Geometry/Animation/combo0.gif": 717527,
	"./Geometry/Animation/combo1.gif": 54366,
	"./Geometry/Animation/combo2.gif": 753449,
	"./Geometry/Animation/combo3.gif": 350160,
	"./Geometry/Animation/combo4.gif": 965803,
	"./Geometry/ExtraQuestions/geometry_extraquestions.csv": 857307,
	"./Geometry/GeometryLevel.png": 46449,
	"./Geometry/GeometryMenu.png": 384350,
	"./Geometry/GeometryRating.png": 797132,
	"./Geometry/Shapes/10quad105a110.png": 207343,
	"./Geometry/Shapes/10quad105a130.png": 446041,
	"./Geometry/Shapes/10quad105a145.png": 181397,
	"./Geometry/Shapes/10quad105a150.png": 822035,
	"./Geometry/Shapes/10quad105a65.png": 732038,
	"./Geometry/Shapes/10quad110a75.png": 159175,
	"./Geometry/Shapes/10quad115a115.png": 64225,
	"./Geometry/Shapes/10quad135a30.png": 380699,
	"./Geometry/Shapes/10quad150a140.png": 419430,
	"./Geometry/Shapes/10quad150a140_1.png": 526610,
	"./Geometry/Shapes/10quad150a25.png": 56752,
	"./Geometry/Shapes/10quad150a50.png": 532244,
	"./Geometry/Shapes/10quad35a150.png": 825525,
	"./Geometry/Shapes/10quad40a55.png": 736681,
	"./Geometry/Shapes/10quad50a20.png": 723120,
	"./Geometry/Shapes/10quad50a75.png": 126794,
	"./Geometry/Shapes/10quad60a70.png": 204464,
	"./Geometry/Shapes/10quad60a75.png": 133181,
	"./Geometry/Shapes/10quad65a45.png": 415519,
	"./Geometry/Shapes/10quad65a90.png": 526529,
	"./Geometry/Shapes/10quad65a95.png": 203612,
	"./Geometry/Shapes/10quad90a125.png": 27878,
	"./Geometry/Shapes/10quad90a140.png": 865169,
	"./Geometry/Shapes/10quad90a90.png": 367129,
	"./Geometry/Shapes/10quad90a90_1.png": 454585,
	"./Geometry/Shapes/15quad105a115.png": 568473,
	"./Geometry/Shapes/15quad105a45.png": 143189,
	"./Geometry/Shapes/15quad115a135.png": 462380,
	"./Geometry/Shapes/15quad115a135_1.png": 339228,
	"./Geometry/Shapes/15quad115a20.png": 824047,
	"./Geometry/Shapes/15quad115a50.png": 368674,
	"./Geometry/Shapes/15quad125a125.png": 419634,
	"./Geometry/Shapes/15quad125a150.png": 409970,
	"./Geometry/Shapes/15quad130a70.png": 626173,
	"./Geometry/Shapes/15quad140a40.png": 616615,
	"./Geometry/Shapes/15quad145a140.png": 151991,
	"./Geometry/Shapes/15quad145a15.png": 615534,
	"./Geometry/Shapes/15quad145a55.png": 928098,
	"./Geometry/Shapes/15quad15a95.png": 446992,
	"./Geometry/Shapes/15quad20a130.png": 803224,
	"./Geometry/Shapes/15quad30a25.png": 233932,
	"./Geometry/Shapes/15quad35a125.png": 545804,
	"./Geometry/Shapes/15quad35a40.png": 570848,
	"./Geometry/Shapes/15quad50a55.png": 409223,
	"./Geometry/Shapes/15quad50a70.png": 341280,
	"./Geometry/Shapes/15quad60a110.png": 895014,
	"./Geometry/Shapes/15quad75a60.png": 300054,
	"./Geometry/Shapes/15quad80a50.png": 713443,
	"./Geometry/Shapes/15quad85a125.png": 51769,
	"./Geometry/Shapes/15quad95a135.png": 713337,
	"./Geometry/Shapes/20quad105a65.png": 130079,
	"./Geometry/Shapes/20quad110a45.png": 693159,
	"./Geometry/Shapes/20quad115a20.png": 278303,
	"./Geometry/Shapes/20quad120a15.png": 55183,
	"./Geometry/Shapes/20quad125a70.png": 153583,
	"./Geometry/Shapes/20quad145a120.png": 861765,
	"./Geometry/Shapes/20quad15a130.png": 151308,
	"./Geometry/Shapes/20quad25a115.png": 139698,
	"./Geometry/Shapes/20quad25a50.png": 485674,
	"./Geometry/Shapes/20quad35a25.png": 851787,
	"./Geometry/Shapes/20quad35a70.png": 33045,
	"./Geometry/Shapes/20quad45a100.png": 456626,
	"./Geometry/Shapes/20quad50a145.png": 357861,
	"./Geometry/Shapes/20quad70a40.png": 555023,
	"./Geometry/Shapes/20quad75a10.png": 957723,
	"./Geometry/Shapes/20quad80a40.png": 89448,
	"./Geometry/Shapes/20quad85a125.png": 941673,
	"./Geometry/Shapes/20quad90a70.png": 966884,
	"./Geometry/Shapes/20quad95a90.png": 742437,
	"./Geometry/Shapes/25quad105a35.png": 415793,
	"./Geometry/Shapes/25quad110a60.png": 448469,
	"./Geometry/Shapes/25quad115a95.png": 958002,
	"./Geometry/Shapes/25quad130a100.png": 728544,
	"./Geometry/Shapes/25quad135a35.png": 56742,
	"./Geometry/Shapes/25quad145a110.png": 179227,
	"./Geometry/Shapes/25quad145a90.png": 90898,
	"./Geometry/Shapes/25quad15a115.png": 435970,
	"./Geometry/Shapes/25quad35a105.png": 407259,
	"./Geometry/Shapes/25quad35a55.png": 823005,
	"./Geometry/Shapes/25quad35a80.png": 29343,
	"./Geometry/Shapes/25quad40a75.png": 849811,
	"./Geometry/Shapes/25quad50a45.png": 24859,
	"./Geometry/Shapes/25quad60a20.png": 943495,
	"./Geometry/Shapes/25quad75a125.png": 126773,
	"./Geometry/Shapes/25quad75a125_1.png": 458925,
	"./Geometry/Shapes/270deg.png": 897191,
	"./Geometry/Shapes/3QuartTurn.png": 44075,
	"./Geometry/Shapes/3QuartTurnAC.png": 554523,
	"./Geometry/Shapes/AboveSquare.png": 710394,
	"./Geometry/Shapes/Acute-01.png": 310538,
	"./Geometry/Shapes/Acute-010.png": 116880,
	"./Geometry/Shapes/Acute-02.png": 467969,
	"./Geometry/Shapes/Acute-03.png": 730488,
	"./Geometry/Shapes/Acute-04.png": 852631,
	"./Geometry/Shapes/Acute-05.png": 153134,
	"./Geometry/Shapes/Acute-06.png": 380965,
	"./Geometry/Shapes/Acute-07.png": 145052,
	"./Geometry/Shapes/Acute-08.png": 850091,
	"./Geometry/Shapes/Acute-09.png": 475938,
	"./Geometry/Shapes/Acute-10.png": 161256,
	"./Geometry/Shapes/Acute-11.png": 59121,
	"./Geometry/Shapes/Acute-12.png": 128954,
	"./Geometry/Shapes/Acute-13.png": 446531,
	"./Geometry/Shapes/Acute-14.png": 516364,
	"./Geometry/Shapes/Acute-15.png": 885461,
	"./Geometry/Shapes/Acute-16.png": 718110,
	"./Geometry/Shapes/Acute-17.png": 436423,
	"./Geometry/Shapes/Acute-18.png": 992192,
	"./Geometry/Shapes/Acute-19.png": 447017,
	"./Geometry/Shapes/Acute-20.png": 183149,
	"./Geometry/Shapes/Acute.png": 359948,
	"./Geometry/Shapes/Acute1.png": 68031,
	"./Geometry/Shapes/Arrow.png": 806167,
	"./Geometry/Shapes/Arrowsaboveeachother.png": 467562,
	"./Geometry/Shapes/Arrowspointingaway.png": 192888,
	"./Geometry/Shapes/Arrowspointingtowards.png": 541828,
	"./Geometry/Shapes/Asset 210.png": 114733,
	"./Geometry/Shapes/BehindSquare.png": 885063,
	"./Geometry/Shapes/BelowSquare.png": 31370,
	"./Geometry/Shapes/Circdia10.png": 462942,
	"./Geometry/Shapes/Circdia20.png": 775055,
	"./Geometry/Shapes/Circdia50.png": 371266,
	"./Geometry/Shapes/Circle.png": 463790,
	"./Geometry/Shapes/Circlecirc.png": 757455,
	"./Geometry/Shapes/Circledia.png": 475002,
	"./Geometry/Shapes/Circlerad.png": 345797,
	"./Geometry/Shapes/Circlerad15.png": 133847,
	"./Geometry/Shapes/Circrad10.png": 445409,
	"./Geometry/Shapes/Circrad15.png": 647228,
	"./Geometry/Shapes/Circrad30.png": 363223,
	"./Geometry/Shapes/Cube.png": 756397,
	"./Geometry/Shapes/Cubeplan.png": 927800,
	"./Geometry/Shapes/Cubesquareface.png": 464155,
	"./Geometry/Shapes/Cuboid.png": 446880,
	"./Geometry/Shapes/Cuboidplan.png": 262601,
	"./Geometry/Shapes/Cylinder.png": 418468,
	"./Geometry/Shapes/Cylindercircleface.png": 494451,
	"./Geometry/Shapes/Cylinderplan.png": 987085,
	"./Geometry/Shapes/Grid-1,-1.png": 735740,
	"./Geometry/Shapes/Grid-1,-2.png": 536375,
	"./Geometry/Shapes/Grid-1,-3.png": 393358,
	"./Geometry/Shapes/Grid-1,-4.png": 229473,
	"./Geometry/Shapes/Grid-1,-5.png": 744856,
	"./Geometry/Shapes/Grid-1,1.png": 384317,
	"./Geometry/Shapes/Grid-1,2.png": 343078,
	"./Geometry/Shapes/Grid-1,3.png": 382095,
	"./Geometry/Shapes/Grid-1,4.png": 939248,
	"./Geometry/Shapes/Grid-1,5.png": 536153,
	"./Geometry/Shapes/Grid-2,-1.png": 798081,
	"./Geometry/Shapes/Grid-2,-2.png": 283850,
	"./Geometry/Shapes/Grid-2,-3.png": 922707,
	"./Geometry/Shapes/Grid-2,-4.png": 567836,
	"./Geometry/Shapes/Grid-2,-5.png": 650725,
	"./Geometry/Shapes/Grid-2,1.png": 192606,
	"./Geometry/Shapes/Grid-2,2.png": 359957,
	"./Geometry/Shapes/Grid-2,3.png": 990860,
	"./Geometry/Shapes/Grid-2,4.png": 921027,
	"./Geometry/Shapes/Grid-2,5.png": 603450,
	"./Geometry/Shapes/Grid-3,-1.png": 607170,
	"./Geometry/Shapes/Grid-3,-2.png": 155353,
	"./Geometry/Shapes/Grid-3,-3.png": 558448,
	"./Geometry/Shapes/Grid-3,-4.png": 1295,
	"./Geometry/Shapes/Grid-3,-5.png": 962278,
	"./Geometry/Shapes/Grid-3,1.png": 404719,
	"./Geometry/Shapes/Grid-3,2.png": 230228,
	"./Geometry/Shapes/Grid-3,3.png": 663261,
	"./Geometry/Shapes/Grid-3,4.png": 959010,
	"./Geometry/Shapes/Grid-3,5.png": 180139,
	"./Geometry/Shapes/Grid-4,-1.png": 729839,
	"./Geometry/Shapes/Grid-4,-2.png": 708372,
	"./Geometry/Shapes/Grid-4,-3.png": 929501,
	"./Geometry/Shapes/Grid-4,-4.png": 767778,
	"./Geometry/Shapes/Grid-4,-5.png": 658283,
	"./Geometry/Shapes/Grid-4,1.png": 474304,
	"./Geometry/Shapes/Grid-4,2.png": 855515,
	"./Geometry/Shapes/Grid-4,3.png": 533970,
	"./Geometry/Shapes/Grid-4,4.png": 863949,
	"./Geometry/Shapes/Grid-4,5.png": 200708,
	"./Geometry/Shapes/Grid-5,-1.png": 428680,
	"./Geometry/Shapes/Grid-5,-2.png": 765539,
	"./Geometry/Shapes/Grid-5,-3.png": 1434,
	"./Geometry/Shapes/Grid-5,-4.png": 341557,
	"./Geometry/Shapes/Grid-5,-5.png": 589292,
	"./Geometry/Shapes/Grid-5,1.png": 487865,
	"./Geometry/Shapes/Grid-5,2.png": 631778,
	"./Geometry/Shapes/Grid-5,3.png": 852907,
	"./Geometry/Shapes/Grid-5,4.png": 902996,
	"./Geometry/Shapes/Grid-5,5.png": 336029,
	"./Geometry/Shapes/Grid1,-1.png": 473291,
	"./Geometry/Shapes/Grid1,-2.png": 719792,
	"./Geometry/Shapes/Grid1,-3.png": 800345,
	"./Geometry/Shapes/Grid1,-4.png": 123622,
	"./Geometry/Shapes/Grid1,-5.png": 646287,
	"./Geometry/Shapes/Grid1,1.png": 148412,
	"./Geometry/Shapes/Grid1,2.png": 949047,
	"./Geometry/Shapes/Grid1,3.png": 806030,
	"./Geometry/Shapes/Grid1,4.png": 642145,
	"./Geometry/Shapes/Grid1,5.png": 673880,
	"./Geometry/Shapes/Grid1,6.png": 848371,
	"./Geometry/Shapes/Grid1,7.png": 693162,
	"./Geometry/Shapes/Grid1,8.png": 927229,
	"./Geometry/Shapes/Grid1,9.png": 706100,
	"./Geometry/Shapes/Grid2,-1.png": 266810,
	"./Geometry/Shapes/Grid2,-2.png": 443057,
	"./Geometry/Shapes/Grid2,-3.png": 994664,
	"./Geometry/Shapes/Grid2,-4.png": 574279,
	"./Geometry/Shapes/Grid2,-5.png": 398494,
	"./Geometry/Shapes/Grid2,1.png": 422119,
	"./Geometry/Shapes/Grid2,2.png": 37292,
	"./Geometry/Shapes/Grid2,3.png": 120181,
	"./Geometry/Shapes/Grid2,4.png": 262234,
	"./Geometry/Shapes/Grid2,5.png": 967459,
	"./Geometry/Shapes/Grid2,6.png": 630600,
	"./Geometry/Shapes/Grid2,7.png": 870545,
	"./Geometry/Shapes/Grid2,8.png": 359062,
	"./Geometry/Shapes/Grid2,9.png": 137151,
	"./Geometry/Shapes/Grid3,-1.png": 157273,
	"./Geometry/Shapes/Grid3,-2.png": 92738,
	"./Geometry/Shapes/Grid3,-3.png": 830219,
	"./Geometry/Shapes/Grid3,-4.png": 267956,
	"./Geometry/Shapes/Grid3,-5.png": 5437,
	"./Geometry/Shapes/Grid3,1.png": 539766,
	"./Geometry/Shapes/Grid3,2.png": 971533,
	"./Geometry/Shapes/Grid3,3.png": 791940,
	"./Geometry/Shapes/Grid3,4.png": 446747,
	"./Geometry/Shapes/Grid3,5.png": 641554,
	"./Geometry/Shapes/Grid3,6.png": 189737,
	"./Geometry/Shapes/Grid3,7.png": 65536,
	"./Geometry/Shapes/Grid3,8.png": 509767,
	"./Geometry/Shapes/Grid3,9.png": 333982,
	"./Geometry/Shapes/Grid4,-1.png": 800800,
	"./Geometry/Shapes/Grid4,-2.png": 155835,
	"./Geometry/Shapes/Grid4,-3.png": 890482,
	"./Geometry/Shapes/Grid4,-4.png": 272045,
	"./Geometry/Shapes/Grid4,-5.png": 745892,
	"./Geometry/Shapes/Grid4,1.png": 464849,
	"./Geometry/Shapes/Grid4,2.png": 856538,
	"./Geometry/Shapes/Grid4,3.png": 561763,
	"./Geometry/Shapes/Grid4,4.png": 631596,
	"./Geometry/Shapes/Grid4,5.png": 714485,
	"./Geometry/Shapes/Grid4,6.png": 628734,
	"./Geometry/Shapes/Grid4,7.png": 500071,
	"./Geometry/Shapes/Grid4,8.png": 872800,
	"./Geometry/Shapes/Grid4,9.png": 327625,
	"./Geometry/Shapes/Grid5,-1.png": 264455,
	"./Geometry/Shapes/Grid5,-2.png": 344396,
	"./Geometry/Shapes/Grid5,-3.png": 713493,
	"./Geometry/Shapes/Grid5,-4.png": 956986,
	"./Geometry/Shapes/Grid5,-5.png": 274563,
	"./Geometry/Shapes/Grid5,1.png": 49816,
	"./Geometry/Shapes/Grid5,2.png": 224307,
	"./Geometry/Shapes/Grid5,3.png": 373546,
	"./Geometry/Shapes/Grid5,4.png": 358213,
	"./Geometry/Shapes/Grid5,5.png": 40700,
	"./Geometry/Shapes/Grid5,6.png": 629431,
	"./Geometry/Shapes/Grid5,7.png": 155790,
	"./Geometry/Shapes/Grid5,8.png": 971353,
	"./Geometry/Shapes/Grid5,9.png": 255600,
	"./Geometry/Shapes/Grid6,1.png": 338627,
	"./Geometry/Shapes/Grid6,2.png": 476648,
	"./Geometry/Shapes/Grid6,3.png": 925041,
	"./Geometry/Shapes/Grid6,4.png": 880478,
	"./Geometry/Shapes/Grid6,5.png": 56263,
	"./Geometry/Shapes/Grid6,6.png": 805580,
	"./Geometry/Shapes/Grid6,7.png": 717205,
	"./Geometry/Shapes/Grid6,8.png": 188050,
	"./Geometry/Shapes/Grid6,9.png": 993243,
	"./Geometry/Shapes/Grid7,1.png": 709042,
	"./Geometry/Shapes/Grid7,2.png": 523657,
	"./Geometry/Shapes/Grid7,3.png": 645536,
	"./Geometry/Shapes/Grid7,4.png": 596863,
	"./Geometry/Shapes/Grid7,5.png": 699926,
	"./Geometry/Shapes/Grid7,6.png": 513901,
	"./Geometry/Shapes/Grid7,7.png": 260004,
	"./Geometry/Shapes/Grid7,8.png": 3875,
	"./Geometry/Shapes/Grid7,9.png": 756122,
	"./Geometry/Shapes/Grid8,1.png": 813581,
	"./Geometry/Shapes/Grid8,2.png": 381814,
	"./Geometry/Shapes/Grid8,3.png": 435615,
	"./Geometry/Shapes/Grid8,4.png": 907584,
	"./Geometry/Shapes/Grid8,5.png": 31785,
	"./Geometry/Shapes/Grid8,6.png": 483602,
	"./Geometry/Shapes/Grid8,7.png": 805147,
	"./Geometry/Shapes/Grid8,8.png": 101132,
	"./Geometry/Shapes/Grid8,9.png": 12757,
	"./Geometry/Shapes/Grid9,1.png": 132500,
	"./Geometry/Shapes/Grid9,2.png": 153967,
	"./Geometry/Shapes/Grid9,3.png": 572422,
	"./Geometry/Shapes/Grid9,4.png": 174841,
	"./Geometry/Shapes/Grid9,5.png": 168592,
	"./Geometry/Shapes/Grid9,6.png": 82411,
	"./Geometry/Shapes/Grid9,7.png": 191906,
	"./Geometry/Shapes/Grid9,8.png": 613285,
	"./Geometry/Shapes/Grid9,9.png": 861020,
	"./Geometry/Shapes/Gridsquare.png": 519535,
	"./Geometry/Shapes/Gridsquare22.png": 577259,
	"./Geometry/Shapes/Gridsquare42.png": 391713,
	"./Geometry/Shapes/Gridsquare50.png": 822408,
	"./Geometry/Shapes/Gridsquaremirror.png": 837072,
	"./Geometry/Shapes/Gridsquaremirror11.png": 639536,
	"./Geometry/Shapes/Gridsquaremirror20.png": 760516,
	"./Geometry/Shapes/Gridsquaremirror22.png": 991990,
	"./Geometry/Shapes/Gridsquaremirror23.png": 45791,
	"./Geometry/Shapes/Horizontalline.png": 402572,
	"./Geometry/Shapes/InfrontSquare.png": 658063,
	"./Geometry/Shapes/LeftSquare.png": 195588,
	"./Geometry/Shapes/NETCone.png": 349288,
	"./Geometry/Shapes/NETCyl.png": 226289,
	"./Geometry/Shapes/NETSqupyr.png": 744391,
	"./Geometry/Shapes/NETcube.png": 401590,
	"./Geometry/Shapes/NETcuboid.png": 781635,
	"./Geometry/Shapes/NEThexprism.png": 125791,
	"./Geometry/Shapes/NETtrianprism.png": 724156,
	"./Geometry/Shapes/NETtripyr.png": 87825,
	"./Geometry/Shapes/NSymCircle.png": 703029,
	"./Geometry/Shapes/NSymSquare.png": 347072,
	"./Geometry/Shapes/NSymrect.png": 550083,
	"./Geometry/Shapes/NSymtriangle.png": 335181,
	"./Geometry/Shapes/Obtuse-01.png": 222446,
	"./Geometry/Shapes/Obtuse-02.png": 450277,
	"./Geometry/Shapes/Obtuse-03.png": 698012,
	"./Geometry/Shapes/Obtuse-04.png": 595411,
	"./Geometry/Shapes/Obtuse-05.png": 379850,
	"./Geometry/Shapes/Obtuse-06.png": 20929,
	"./Geometry/Shapes/Obtuse-07.png": 799800,
	"./Geometry/Shapes/Obtuse-08.png": 474607,
	"./Geometry/Shapes/Obtuse-09.png": 409414,
	"./Geometry/Shapes/Obtuse-10.png": 585676,
	"./Geometry/Shapes/Obtuse-11.png": 954773,
	"./Geometry/Shapes/Obtuse-12.png": 787422,
	"./Geometry/Shapes/Obtuse-13.png": 505735,
	"./Geometry/Shapes/Obtuse-14.png": 714216,
	"./Geometry/Shapes/Obtuse-15.png": 128433,
	"./Geometry/Shapes/Obtuse-16.png": 198266,
	"./Geometry/Shapes/Obtuse-17.png": 999491,
	"./Geometry/Shapes/Obtuse-18.png": 319447,
	"./Geometry/Shapes/Obtuse-19.png": 298125,
	"./Geometry/Shapes/Obtuse.png": 128816,
	"./Geometry/Shapes/Obtuse1.png": 727675,
	"./Geometry/Shapes/Parallellines.png": 674154,
	"./Geometry/Shapes/Perplines.png": 52184,
	"./Geometry/Shapes/Pyramid.png": 756464,
	"./Geometry/Shapes/Pyramid2.png": 464224,
	"./Geometry/Shapes/Pyramidplan.png": 521209,
	"./Geometry/Shapes/Pyramidsquareface.png": 361138,
	"./Geometry/Shapes/Pyramidtriangleface.png": 387195,
	"./Geometry/Shapes/Quarterturn.png": 409997,
	"./Geometry/Shapes/QuarterturnAC.png": 338761,
	"./Geometry/Shapes/Rectangle.png": 622727,
	"./Geometry/Shapes/Rectangle2.png": 755701,
	"./Geometry/Shapes/Rectangle3.png": 519788,
	"./Geometry/Shapes/Reflex-01.png": 790718,
	"./Geometry/Shapes/Reflex-02.png": 876469,
	"./Geometry/Shapes/Reflex-03.png": 124204,
	"./Geometry/Shapes/Reflex-04.png": 300451,
	"./Geometry/Shapes/Reflex-05.png": 536346,
	"./Geometry/Shapes/Reflex-06.png": 957457,
	"./Geometry/Shapes/Reflex-07.png": 963592,
	"./Geometry/Shapes/Reflex-08.png": 893439,
	"./Geometry/Shapes/Reflex-09.png": 480150,
	"./Geometry/Shapes/Reflex-10.png": 871708,
	"./Geometry/Shapes/Reflex-11.png": 623973,
	"./Geometry/Shapes/Reflex-12.png": 396142,
	"./Geometry/Shapes/Reflex-13.png": 95639,
	"./Geometry/Shapes/Reflex-14.png": 973496,
	"./Geometry/Shapes/Reflex-15.png": 194625,
	"./Geometry/Shapes/Reflex-16.png": 37194,
	"./Geometry/Shapes/Reflex-17.png": 769107,
	"./Geometry/Shapes/Reflex-18.png": 143188,
	"./Geometry/Shapes/Reflex-19.png": 364317,
	"./Geometry/Shapes/Reflex1.png": 975403,
	"./Geometry/Shapes/Right-01.png": 486092,
	"./Geometry/Shapes/Right-010.png": 340822,
	"./Geometry/Shapes/Right-02.png": 736775,
	"./Geometry/Shapes/Right-03.png": 560990,
	"./Geometry/Shapes/Right-04.png": 605553,
	"./Geometry/Shapes/Right-05.png": 157160,
	"./Geometry/Shapes/Right-06.png": 535491,
	"./Geometry/Shapes/Right-07.png": 429306,
	"./Geometry/Shapes/Right-08.png": 198541,
	"./Geometry/Shapes/Right-09.png": 535300,
	"./Geometry/Shapes/Right-10.png": 532266,
	"./Geometry/Shapes/Right-11.png": 383027,
	"./Geometry/Shapes/Right-12.png": 208536,
	"./Geometry/Shapes/Right-13.png": 481249,
	"./Geometry/Shapes/Right-14.png": 798158,
	"./Geometry/Shapes/Right-15.png": 788151,
	"./Geometry/Shapes/Right-16.png": 683068,
	"./Geometry/Shapes/Right-17.png": 516933,
	"./Geometry/Shapes/Right-18.png": 616066,
	"./Geometry/Shapes/Right-19.png": 379723,
	"./Geometry/Shapes/Right-20.png": 23867,
	"./Geometry/Shapes/RightAngle1.png": 366952,
	"./Geometry/Shapes/RightSquare.png": 498559,
	"./Geometry/Shapes/Sphere.png": 186565,
	"./Geometry/Shapes/Square.png": 952555,
	"./Geometry/Shapes/SquareOutCircle.png": 483299,
	"./Geometry/Shapes/SquareTri.png": 607984,
	"./Geometry/Shapes/SquareTriCir.png": 22948,
	"./Geometry/Shapes/SquareinCircle.png": 691054,
	"./Geometry/Shapes/SymCircle.png": 533985,
	"./Geometry/Shapes/SymSquare.png": 170892,
	"./Geometry/Shapes/Symtriangle.png": 434193,
	"./Geometry/Shapes/Triangle.png": 885698,
	"./Geometry/Shapes/TriangleA.png": 829233,
	"./Geometry/Shapes/TriangleB.png": 415418,
	"./Geometry/Shapes/TriangleRA.png": 511817,
	"./Geometry/Shapes/TriangleRA2.png": 868863,
	"./Geometry/Shapes/Triangleangles.png": 783906,
	"./Geometry/Shapes/Triangleangles2.png": 712490,
	"./Geometry/Shapes/Triangprismplan.png": 496789,
	"./Geometry/Shapes/TriangularPrismPlan.png": 126811,
	"./Geometry/Shapes/Verticalline.png": 465978,
	"./Geometry/Shapes/WholeTurn.png": 855792,
	"./Geometry/Shapes/WholeTurnAC.png": 529176,
	"./Geometry/Shapes/blade.png": 311906,
	"./Geometry/Shapes/circlecentre.png": 360279,
	"./Geometry/Shapes/circlecircum.png": 627997,
	"./Geometry/Shapes/circlediameter.png": 757779,
	"./Geometry/Shapes/circleradius.png": 170948,
	"./Geometry/Shapes/circletrianglerectangle.png": 478563,
	"./Geometry/Shapes/circletrianglesquare.png": 711087,
	"./Geometry/Shapes/clockhand12.png": 445720,
	"./Geometry/Shapes/compass.png": 563684,
	"./Geometry/Shapes/compassE.png": 836211,
	"./Geometry/Shapes/compassN.png": 986352,
	"./Geometry/Shapes/compassS.png": 398485,
	"./Geometry/Shapes/compassW.png": 572145,
	"./Geometry/Shapes/dial.png": 591127,
	"./Geometry/Shapes/firstquadgrid.png": 270231,
	"./Geometry/Shapes/firstquadgrid13.png": 646983,
	"./Geometry/Shapes/firstquadgrid15.png": 999409,
	"./Geometry/Shapes/firstquadgrid23.png": 926122,
	"./Geometry/Shapes/firstquadgrid25.png": 593276,
	"./Geometry/Shapes/firstquadgrid32.png": 726420,
	"./Geometry/Shapes/firstquadgrid35.png": 676331,
	"./Geometry/Shapes/firstquadgrid42.png": 273257,
	"./Geometry/Shapes/firstquadgrid43.png": 302080,
	"./Geometry/Shapes/firstquadgrid51.png": 927705,
	"./Geometry/Shapes/firstquadgrid52.png": 379522,
	"./Geometry/Shapes/firstquadgrid55.png": 998250,
	"./Geometry/Shapes/fullquadgrid-1-1.png": 190952,
	"./Geometry/Shapes/fullquadgrid-11.png": 805401,
	"./Geometry/Shapes/fullquadgrid-2-2.png": 58624,
	"./Geometry/Shapes/fullquadgrid-2-4.png": 413622,
	"./Geometry/Shapes/fullquadgrid-3-3.png": 649684,
	"./Geometry/Shapes/fullquadgrid-34.png": 231726,
	"./Geometry/Shapes/fullquadgrid-4-1.png": 833777,
	"./Geometry/Shapes/fullquadgrid-4-2.png": 903610,
	"./Geometry/Shapes/fullquadgrid-4-4.png": 291020,
	"./Geometry/Shapes/fullquadgrid-42.png": 495397,
	"./Geometry/Shapes/fullquadgrid-44.png": 283731,
	"./Geometry/Shapes/fullquadgrid11.png": 79150,
	"./Geometry/Shapes/fullquadgrid2-2.png": 773145,
	"./Geometry/Shapes/fullquadgrid24.png": 898402,
	"./Geometry/Shapes/fullquadgrid3-2.png": 195020,
	"./Geometry/Shapes/fullquadgrid31.png": 622296,
	"./Geometry/Shapes/fullquadgrid33.png": 641578,
	"./Geometry/Shapes/fullquadgrid4-1.png": 191400,
	"./Geometry/Shapes/fullquadgrid4-4.png": 915605,
	"./Geometry/Shapes/fullquadgrid43.png": 832459,
	"./Geometry/Shapes/fullquadgrid44.png": 540468,
	"./Geometry/Shapes/grid.png": 543370,
	"./Geometry/Shapes/grid2squares.png": 113228,
	"./Geometry/Shapes/grid2squares15.png": 9378,
	"./Geometry/Shapes/grid2squares25.png": 481891,
	"./Geometry/Shapes/grid2squares43.png": 143235,
	"./Geometry/Shapes/grid2squares52.png": 495297,
	"./Geometry/Shapes/grid2squares54.png": 523159,
	"./Geometry/Shapes/grid2squares55.png": 577582,
	"./Geometry/Shapes/halfturn.png": 274712,
	"./Geometry/Shapes/halfturnAC.png": 572608,
	"./Geometry/Shapes/irregpoly1.png": 927678,
	"./Geometry/Shapes/irregpoly2.png": 529781,
	"./Geometry/Shapes/irregpoly3.png": 777516,
	"./Geometry/Shapes/isosTriangle.png": 204868,
	"./Geometry/Shapes/isossidetriangle10c.png": 807207,
	"./Geometry/Shapes/isossidetriangle14a.png": 590681,
	"./Geometry/Shapes/isossidetriangle14a_1.png": 455737,
	"./Geometry/Shapes/isossidetriangle14b.png": 42498,
	"./Geometry/Shapes/isossidetriangle14b_1.png": 637014,
	"./Geometry/Shapes/isossidetriangle16b.png": 556344,
	"./Geometry/Shapes/isossidetriangle18b.png": 761606,
	"./Geometry/Shapes/isossidetriangle20a.png": 923334,
	"./Geometry/Shapes/isossidetriangle24a.png": 2378,
	"./Geometry/Shapes/isossidetriangle28b.png": 183349,
	"./Geometry/Shapes/isossidetriangle30b.png": 239324,
	"./Geometry/Shapes/isossidetriangle34c.png": 844041,
	"./Geometry/Shapes/isossidetriangle34c_1.png": 893993,
	"./Geometry/Shapes/isossidetriangle38b.png": 112500,
	"./Geometry/Shapes/isossidetriangle42b.png": 70221,
	"./Geometry/Shapes/isossidetriangle44b.png": 777039,
	"./Geometry/Shapes/isossidetriangle44c.png": 491942,
	"./Geometry/Shapes/isossidetriangle58a.png": 331241,
	"./Geometry/Shapes/isossidetriangle60b.png": 914649,
	"./Geometry/Shapes/isossidetriangle62a.png": 550492,
	"./Geometry/Shapes/isossidetriangle62c.png": 74926,
	"./Geometry/Shapes/isossidetriangle64a.png": 57982,
	"./Geometry/Shapes/isossidetriangle64b.png": 660085,
	"./Geometry/Shapes/isossidetriangle64b_1.png": 170989,
	"./Geometry/Shapes/isossidetriangle64b_2.png": 780310,
	"./Geometry/Shapes/isossidetriangle66b.png": 956803,
	"./Geometry/Shapes/isossidetriangle66c.png": 155578,
	"./Geometry/Shapes/isossidetriangle68a.png": 198794,
	"./Geometry/Shapes/isossidetriangle68b.png": 229377,
	"./Geometry/Shapes/isossidetriangle6b.png": 159537,
	"./Geometry/Shapes/isossidetriangle70b.png": 504152,
	"./Geometry/Shapes/isossidetriangle70c.png": 776865,
	"./Geometry/Shapes/isossidetriangle72c.png": 962411,
	"./Geometry/Shapes/isossidetriangle74a.png": 358671,
	"./Geometry/Shapes/isossidetriangle74a_1.png": 380387,
	"./Geometry/Shapes/isossidetriangle74b.png": 623412,
	"./Geometry/Shapes/isossidetriangle78b.png": 585632,
	"./Geometry/Shapes/isossidetriangle80a.png": 722508,
	"./Geometry/Shapes/isossidetriangle80c.png": 440606,
	"./Geometry/Shapes/isossidetriangle80c_1.png": 782874,
	"./Geometry/Shapes/isossidetriangle8c.png": 711146,
	"./Geometry/Shapes/isostoptriangle10b.png": 689144,
	"./Geometry/Shapes/isostoptriangle14b.png": 522196,
	"./Geometry/Shapes/isostoptriangle16b.png": 552318,
	"./Geometry/Shapes/isostoptriangle18b.png": 202688,
	"./Geometry/Shapes/isostoptriangle20a.png": 969792,
	"./Geometry/Shapes/isostoptriangle22a.png": 942998,
	"./Geometry/Shapes/isostoptriangle22c.png": 291172,
	"./Geometry/Shapes/isostoptriangle28a.png": 440120,
	"./Geometry/Shapes/isostoptriangle28b.png": 235731,
	"./Geometry/Shapes/isostoptriangle28c.png": 20170,
	"./Geometry/Shapes/isostoptriangle36c.png": 136693,
	"./Geometry/Shapes/isostoptriangle38a.png": 267017,
	"./Geometry/Shapes/isostoptriangle38b.png": 936050,
	"./Geometry/Shapes/isostoptriangle38b_1.png": 190662,
	"./Geometry/Shapes/isostoptriangle42a.png": 655696,
	"./Geometry/Shapes/isostoptriangle42a_1.png": 988360,
	"./Geometry/Shapes/isostoptriangle42c.png": 322210,
	"./Geometry/Shapes/isostoptriangle44b.png": 357793,
	"./Geometry/Shapes/isostoptriangle44c.png": 85080,
	"./Geometry/Shapes/isostoptriangle46a.png": 358564,
	"./Geometry/Shapes/isostoptriangle48b.png": 930453,
	"./Geometry/Shapes/isostoptriangle50a.png": 879863,
	"./Geometry/Shapes/isostoptriangle50c.png": 608645,
	"./Geometry/Shapes/isostoptriangle54b.png": 149248,
	"./Geometry/Shapes/isostoptriangle56a.png": 196673,
	"./Geometry/Shapes/isostoptriangle62b.png": 292609,
	"./Geometry/Shapes/isostoptriangle62c.png": 71480,
	"./Geometry/Shapes/isostoptriangle66a.png": 56134,
	"./Geometry/Shapes/isostoptriangle66a_1.png": 144946,
	"./Geometry/Shapes/isostoptriangle66c.png": 404308,
	"./Geometry/Shapes/isostoptriangle66c_1.png": 230004,
	"./Geometry/Shapes/isostoptriangle6a.png": 56704,
	"./Geometry/Shapes/isostoptriangle6a_1.png": 413816,
	"./Geometry/Shapes/isostoptriangle72b.png": 245300,
	"./Geometry/Shapes/isostoptriangle74b.png": 254370,
	"./Geometry/Shapes/isostoptriangle74c.png": 144875,
	"./Geometry/Shapes/isostoptriangle78c.png": 261519,
	"./Geometry/Shapes/isostoptriangle80b.png": 634625,
	"./Geometry/Shapes/isostoptriangle8b.png": 274793,
	"./Geometry/Shapes/isostoptriangle8b_1.png": 955209,
	"./Geometry/Shapes/line104a.png": 452978,
	"./Geometry/Shapes/line11c.png": 20807,
	"./Geometry/Shapes/line124a.png": 702648,
	"./Geometry/Shapes/line139a.png": 467630,
	"./Geometry/Shapes/line13b.png": 506996,
	"./Geometry/Shapes/line148b.png": 512857,
	"./Geometry/Shapes/line152b.png": 765930,
	"./Geometry/Shapes/line15b.png": 108514,
	"./Geometry/Shapes/line166b.png": 868217,
	"./Geometry/Shapes/line173a.png": 802316,
	"./Geometry/Shapes/line29a.png": 505422,
	"./Geometry/Shapes/line33b.png": 606146,
	"./Geometry/Shapes/line35c.png": 139997,
	"./Geometry/Shapes/line36b.png": 517925,
	"./Geometry/Shapes/line42b.png": 862346,
	"./Geometry/Shapes/line55a.png": 792077,
	"./Geometry/Shapes/line55b.png": 360310,
	"./Geometry/Shapes/line56b.png": 485675,
	"./Geometry/Shapes/line57a.png": 514599,
	"./Geometry/Shapes/line61c.png": 487616,
	"./Geometry/Shapes/line63c.png": 837246,
	"./Geometry/Shapes/line68c.png": 828275,
	"./Geometry/Shapes/line73c.png": 408247,
	"./Geometry/Shapes/line78b.png": 737227,
	"./Geometry/Shapes/line94b.png": 458497,
	"./Geometry/Shapes/line99b.png": 989006,
	"./Geometry/Shapes/misstriangle15a.png": 729007,
	"./Geometry/Shapes/misstriangle15a50.png": 511624,
	"./Geometry/Shapes/misstriangle15a65.png": 235648,
	"./Geometry/Shapes/misstriangle15a85.png": 700058,
	"./Geometry/Shapes/misstriangle20a.png": 413471,
	"./Geometry/Shapes/misstriangle20a50.png": 926520,
	"./Geometry/Shapes/misstriangle25a.png": 491260,
	"./Geometry/Shapes/misstriangle25a75.png": 215888,
	"./Geometry/Shapes/misstriangle30a.png": 834574,
	"./Geometry/Shapes/misstriangle30a15.png": 763212,
	"./Geometry/Shapes/misstriangle30a20.png": 418076,
	"./Geometry/Shapes/misstriangle30a40.png": 920026,
	"./Geometry/Shapes/misstriangle30a45.png": 79911,
	"./Geometry/Shapes/misstriangle30a55.png": 889432,
	"./Geometry/Shapes/misstriangle30a60.png": 185344,
	"./Geometry/Shapes/misstriangle35a.png": 939001,
	"./Geometry/Shapes/misstriangle35a65.png": 873182,
	"./Geometry/Shapes/misstriangle35a70.png": 4376,
	"./Geometry/Shapes/misstriangle40a.png": 77113,
	"./Geometry/Shapes/misstriangle45a.png": 972686,
	"./Geometry/Shapes/misstriangle45a30.png": 596071,
	"./Geometry/Shapes/misstriangle50a.png": 286248,
	"./Geometry/Shapes/misstriangle50a35.png": 956088,
	"./Geometry/Shapes/misstriangle50a80.png": 476392,
	"./Geometry/Shapes/misstriangle55a.png": 993571,
	"./Geometry/Shapes/misstriangle55a85.png": 959350,
	"./Geometry/Shapes/misstriangle60a.png": 886619,
	"./Geometry/Shapes/misstriangle60a15.png": 769789,
	"./Geometry/Shapes/misstriangle60a45.png": 244746,
	"./Geometry/Shapes/misstriangle60a65.png": 621372,
	"./Geometry/Shapes/misstriangle65a.png": 542496,
	"./Geometry/Shapes/misstriangle65a85.png": 855133,
	"./Geometry/Shapes/misstriangle70a.png": 248618,
	"./Geometry/Shapes/misstriangle70a80.png": 312330,
	"./Geometry/Shapes/misstriangle75a.png": 123277,
	"./Geometry/Shapes/misstriangle80a.png": 201653,
	"./Geometry/Shapes/misstriangle80a55.png": 362267,
	"./Geometry/Shapes/misstriangle80a75.png": 826337,
	"./Geometry/Shapes/misstriangle85a.png": 527026,
	"./Geometry/Shapes/misstriangle85a15.png": 134424,
	"./Geometry/Shapes/misstriangle85a20.png": 734784,
	"./Geometry/Shapes/misstriangle85a40.png": 191638,
	"./Geometry/Shapes/misstriangle85a45.png": 466107,
	"./Geometry/Shapes/misstriangle85a50.png": 974641,
	"./Geometry/Shapes/misstriangle85a85.png": 945743,
	"./Geometry/Shapes/oppangle100b.png": 440903,
	"./Geometry/Shapes/oppangle101a.png": 755923,
	"./Geometry/Shapes/oppangle103b.png": 708674,
	"./Geometry/Shapes/oppangle104b.png": 110259,
	"./Geometry/Shapes/oppangle104b_1.png": 453599,
	"./Geometry/Shapes/oppangle105b.png": 809492,
	"./Geometry/Shapes/oppangle107b.png": 882366,
	"./Geometry/Shapes/oppangle108a.png": 190004,
	"./Geometry/Shapes/oppangle108c.png": 343718,
	"./Geometry/Shapes/oppangle10a.png": 455320,
	"./Geometry/Shapes/oppangle10b.png": 629811,
	"./Geometry/Shapes/oppangle115a.png": 453978,
	"./Geometry/Shapes/oppangle115a_1.png": 677502,
	"./Geometry/Shapes/oppangle115a_2.png": 279605,
	"./Geometry/Shapes/oppangle116a.png": 352123,
	"./Geometry/Shapes/oppangle116b.png": 573792,
	"./Geometry/Shapes/oppangle118b.png": 592798,
	"./Geometry/Shapes/oppangle11c.png": 957725,
	"./Geometry/Shapes/oppangle124a.png": 816146,
	"./Geometry/Shapes/oppangle126b.png": 672999,
	"./Geometry/Shapes/oppangle127b.png": 973912,
	"./Geometry/Shapes/oppangle129a.png": 93565,
	"./Geometry/Shapes/oppangle129b.png": 26150,
	"./Geometry/Shapes/oppangle130c.png": 953741,
	"./Geometry/Shapes/oppangle130c_1.png": 637461,
	"./Geometry/Shapes/oppangle137a.png": 756834,
	"./Geometry/Shapes/oppangle139b.png": 884075,
	"./Geometry/Shapes/oppangle13a.png": 368821,
	"./Geometry/Shapes/oppangle140a.png": 279400,
	"./Geometry/Shapes/oppangle140a_1.png": 901136,
	"./Geometry/Shapes/oppangle140b.png": 81027,
	"./Geometry/Shapes/oppangle146b.png": 522521,
	"./Geometry/Shapes/oppangle14c.png": 649694,
	"./Geometry/Shapes/oppangle150b.png": 349154,
	"./Geometry/Shapes/oppangle152b.png": 112024,
	"./Geometry/Shapes/oppangle155a.png": 227662,
	"./Geometry/Shapes/oppangle157c.png": 360906,
	"./Geometry/Shapes/oppangle15b.png": 903544,
	"./Geometry/Shapes/oppangle160a.png": 937322,
	"./Geometry/Shapes/oppangle160a_1.png": 956942,
	"./Geometry/Shapes/oppangle163c.png": 204953,
	"./Geometry/Shapes/oppangle164b.png": 393405,
	"./Geometry/Shapes/oppangle164c.png": 172276,
	"./Geometry/Shapes/oppangle164c_1.png": 188372,
	"./Geometry/Shapes/oppangle166c.png": 697698,
	"./Geometry/Shapes/oppangle168a.png": 510882,
	"./Geometry/Shapes/oppangle169b.png": 435250,
	"./Geometry/Shapes/oppangle169c.png": 700603,
	"./Geometry/Shapes/oppangle20b.png": 228528,
	"./Geometry/Shapes/oppangle20b_1.png": 719400,
	"./Geometry/Shapes/oppangle24c.png": 689717,
	"./Geometry/Shapes/oppangle26a.png": 117581,
	"./Geometry/Shapes/oppangle26b.png": 685814,
	"./Geometry/Shapes/oppangle27a.png": 548966,
	"./Geometry/Shapes/oppangle33a.png": 91451,
	"./Geometry/Shapes/oppangle40c.png": 40831,
	"./Geometry/Shapes/oppangle43b.png": 797899,
	"./Geometry/Shapes/oppangle49c.png": 447660,
	"./Geometry/Shapes/oppangle50c.png": 365006,
	"./Geometry/Shapes/oppangle60a.png": 51407,
	"./Geometry/Shapes/oppangle60b.png": 832500,
	"./Geometry/Shapes/oppangle67c.png": 675008,
	"./Geometry/Shapes/oppangle70b.png": 869173,
	"./Geometry/Shapes/oppangle72a.png": 880616,
	"./Geometry/Shapes/oppangle76a.png": 759580,
	"./Geometry/Shapes/oppangle78c.png": 50388,
	"./Geometry/Shapes/oppangle79c.png": 379455,
	"./Geometry/Shapes/oppangle80a.png": 207169,
	"./Geometry/Shapes/oppangle83a.png": 436468,
	"./Geometry/Shapes/oppangle85b.png": 525261,
	"./Geometry/Shapes/oppangle86a.png": 906487,
	"./Geometry/Shapes/oppangle87b.png": 237371,
	"./Geometry/Shapes/oppangle87b_1.png": 620983,
	"./Geometry/Shapes/oppangle87b_2.png": 32252,
	"./Geometry/Shapes/oppangle88a.png": 799769,
	"./Geometry/Shapes/oppangle95a.png": 55819,
	"./Geometry/Shapes/oppangle97c.png": 848323,
	"./Geometry/Shapes/oppangle99b.png": 833412,
	"./Geometry/Shapes/point100a157.png": 330923,
	"./Geometry/Shapes/point102b145.png": 928321,
	"./Geometry/Shapes/point104a127.png": 469862,
	"./Geometry/Shapes/point107c112.png": 997583,
	"./Geometry/Shapes/point108b107.png": 232029,
	"./Geometry/Shapes/point115c57.png": 331148,
	"./Geometry/Shapes/point117b73.png": 87221,
	"./Geometry/Shapes/point117c170.png": 330328,
	"./Geometry/Shapes/point126b167.png": 76027,
	"./Geometry/Shapes/point132b28.png": 685232,
	"./Geometry/Shapes/point132c60.png": 849561,
	"./Geometry/Shapes/point138b131.png": 945611,
	"./Geometry/Shapes/point143c157.png": 778854,
	"./Geometry/Shapes/point144a12.png": 980361,
	"./Geometry/Shapes/point147c129.png": 501914,
	"./Geometry/Shapes/point147c18.png": 725588,
	"./Geometry/Shapes/point14b90.png": 327296,
	"./Geometry/Shapes/point150a134.png": 429209,
	"./Geometry/Shapes/point159a136.png": 61622,
	"./Geometry/Shapes/point160c93.png": 425404,
	"./Geometry/Shapes/point164c151.png": 586309,
	"./Geometry/Shapes/point168c98.png": 582807,
	"./Geometry/Shapes/point19a29.png": 818020,
	"./Geometry/Shapes/point30c144.png": 693623,
	"./Geometry/Shapes/point33b165.png": 868712,
	"./Geometry/Shapes/point33b165_1.png": 279248,
	"./Geometry/Shapes/point41c109.png": 157994,
	"./Geometry/Shapes/point48a122.png": 42124,
	"./Geometry/Shapes/point57a150.png": 910827,
	"./Geometry/Shapes/point57c84.png": 513959,
	"./Geometry/Shapes/point58c165.png": 592902,
	"./Geometry/Shapes/point59a35.png": 248475,
	"./Geometry/Shapes/point61c45.png": 177887,
	"./Geometry/Shapes/point69b166.png": 531814,
	"./Geometry/Shapes/point73b108.png": 795747,
	"./Geometry/Shapes/point73b130.png": 453866,
	"./Geometry/Shapes/point87c104.png": 626993,
	"./Geometry/Shapes/point92b19.png": 484743,
	"./Geometry/Shapes/point97b107.png": 719554,
	"./Geometry/Shapes/point97c38.png": 984166,
	"./Geometry/Shapes/quad1.png": 271378,
	"./Geometry/Shapes/raTriangle.png": 285581,
	"./Geometry/Shapes/rect12x20.png": 203859,
	"./Geometry/Shapes/rect15x50.png": 943579,
	"./Geometry/Shapes/rect20x40.png": 799444,
	"./Geometry/Shapes/rect25x50.png": 549040,
	"./Geometry/Shapes/rect5x10.png": 70748,
	"./Geometry/Shapes/rectlongside.png": 435735,
	"./Geometry/Shapes/rectlongside150.png": 225029,
	"./Geometry/Shapes/rectlongside20.png": 303713,
	"./Geometry/Shapes/rectlongside270.png": 967052,
	"./Geometry/Shapes/rectlongside45.png": 416310,
	"./Geometry/Shapes/rectlongside8.png": 377231,
	"./Geometry/Shapes/rectshortside.png": 803749,
	"./Geometry/Shapes/rectshortside15.png": 184951,
	"./Geometry/Shapes/rectshortside2.png": 459539,
	"./Geometry/Shapes/rectshortside5.png": 104668,
	"./Geometry/Shapes/rectshortside7.png": 933550,
	"./Geometry/Shapes/rectshortside75.png": 74705,
	"./Geometry/Shapes/right11a.png": 762551,
	"./Geometry/Shapes/right20a.png": 72371,
	"./Geometry/Shapes/right21b.png": 596967,
	"./Geometry/Shapes/right23a.png": 223762,
	"./Geometry/Shapes/right24c.png": 238269,
	"./Geometry/Shapes/right27c.png": 382076,
	"./Geometry/Shapes/right32a.png": 427868,
	"./Geometry/Shapes/right33a.png": 951779,
	"./Geometry/Shapes/right35a.png": 509061,
	"./Geometry/Shapes/right41a.png": 746798,
	"./Geometry/Shapes/right49a.png": 828278,
	"./Geometry/Shapes/right51a.png": 724107,
	"./Geometry/Shapes/right51b.png": 758704,
	"./Geometry/Shapes/right5c.png": 153138,
	"./Geometry/Shapes/right60b.png": 116700,
	"./Geometry/Shapes/right64a.png": 621627,
	"./Geometry/Shapes/right66a.png": 940641,
	"./Geometry/Shapes/right69b.png": 461907,
	"./Geometry/Shapes/right70a.png": 800710,
	"./Geometry/Shapes/right77a.png": 605483,
	"./Geometry/Shapes/right7a.png": 20086,
	"./Geometry/Shapes/right85a.png": 153678,
	"./Geometry/Shapes/right8a.png": 802131,
	"./Geometry/Shapes/symrect.png": 510319,
	"./Geometry/Shapes/triangle15a44.png": 488971,
	"./Geometry/Shapes/triangle16a68.png": 704436,
	"./Geometry/Shapes/triangle22a70.png": 804240,
	"./Geometry/Shapes/triangle22a73.png": 691883,
	"./Geometry/Shapes/triangle23b39.png": 769885,
	"./Geometry/Shapes/triangle23c20.png": 948490,
	"./Geometry/Shapes/triangle28c75.png": 580317,
	"./Geometry/Shapes/triangle30b70.png": 359024,
	"./Geometry/Shapes/triangle31b82.png": 191512,
	"./Geometry/Shapes/triangle35b68.png": 449872,
	"./Geometry/Shapes/triangle36b81.png": 683706,
	"./Geometry/Shapes/triangle37b65.png": 974284,
	"./Geometry/Shapes/triangle38a45.png": 41083,
	"./Geometry/Shapes/triangle40a18.png": 408122,
	"./Geometry/Shapes/triangle41a8.png": 419484,
	"./Geometry/Shapes/triangle49c80.png": 644988,
	"./Geometry/Shapes/triangle52c27.png": 18909,
	"./Geometry/Shapes/triangle52c65.png": 432419,
	"./Geometry/Shapes/triangle53b38.png": 565683,
	"./Geometry/Shapes/triangle54a21.png": 907715,
	"./Geometry/Shapes/triangle54a21_1.png": 583151,
	"./Geometry/Shapes/triangle54c13.png": 249078,
	"./Geometry/Shapes/triangle55a14.png": 270576,
	"./Geometry/Shapes/triangle59a48.png": 838911,
	"./Geometry/Shapes/triangle59b26.png": 750068,
	"./Geometry/Shapes/triangle59b46.png": 898226,
	"./Geometry/Shapes/triangle59b70.png": 78137,
	"./Geometry/Shapes/triangle59c67.png": 263436,
	"./Geometry/Shapes/triangle5b85.png": 319254,
	"./Geometry/Shapes/triangle61b69.png": 610168,
	"./Geometry/Shapes/triangle63b21.png": 935858,
	"./Geometry/Shapes/triangle63b32.png": 649186,
	"./Geometry/Shapes/triangle63b49.png": 552720,
	"./Geometry/Shapes/triangle65b65.png": 683832,
	"./Geometry/Shapes/triangle66c54.png": 85976,
	"./Geometry/Shapes/triangle67a37.png": 546388,
	"./Geometry/Shapes/triangle68a15.png": 843537,
	"./Geometry/Shapes/triangle68c72.png": 470878,
	"./Geometry/Shapes/triangle70a51.png": 586828,
	"./Geometry/Shapes/triangle71b20.png": 334780,
	"./Geometry/Shapes/triangle71c39.png": 979543,
	"./Geometry/Shapes/triangle72b83.png": 785088,
	"./Geometry/Shapes/triangle74a19.png": 350244,
	"./Geometry/Shapes/triangle75c45.png": 695466,
	"./Geometry/Shapes/triangle76c45.png": 582695,
	"./Geometry/Shapes/triangle77a66.png": 137023,
	"./Geometry/Shapes/triangle79b46.png": 851924,
	"./Geometry/Shapes/triangle81c37.png": 372138,
	"./Geometry/Shapes/triangle81c82.png": 566042,
	"./Geometry/Shapes/triangle83a61.png": 67187,
	"./Geometry/Shapes/triangle85a41.png": 302795,
	"./Geometry/Shapes/triangle8b56.png": 321625,
	"./Geometry/Shapes/triangle90a18.png": 502443,
	"./Geometry/Shapes/triangle90a33.png": 928470,
	"./Geometry/Shapes/triangle90a53.png": 389268,
	"./Geometry/Shapes/triangle90a55.png": 118050,
	"./Geometry/Shapes/triangle90a57.png": 967888,
	"./Geometry/Shapes/triangle90a72.png": 52107,
	"./Geometry/Shapes/triangle90a73.png": 288450,
	"./Geometry/Shapes/triangle90a84.png": 783332,
	"./Geometry/Shapes/triangle90b10.png": 926944,
	"./Geometry/Shapes/triangle90b16.png": 464982,
	"./Geometry/Shapes/triangle90b16_1.png": 869826,
	"./Geometry/Shapes/triangle90b25.png": 958328,
	"./Geometry/Shapes/triangle90b29.png": 128020,
	"./Geometry/Shapes/triangle90b31.png": 158019,
	"./Geometry/Shapes/triangle90b54.png": 417432,
	"./Geometry/Shapes/triangle90b84.png": 720535,
	"./Geometry/Shapes/triangle90c11.png": 166540,
	"./Geometry/Shapes/triangle90c11_1.png": 52796,
	"./Geometry/Shapes/triangle90c41.png": 69903,
	"./Geometry/Shapes/triangle90c48.png": 950926,
	"./Geometry/Shapes/triangle90c52.png": 196179,
	"./Geometry/Shapes/triangle90c78.png": 700303,
	"./Geometry/Shapes/triangle90c84.png": 973238,
	"./Geometry/Shapes/trianglea0.png": 361861,
	"./Geometry/Shapes/trianglea1.png": 832444,
	"./Geometry/Shapes/trianglea3.png": 490062,
	"./Geometry/Shapes/trianglea4.png": 326177,
	"./Geometry/Shapes/trianglea5.png": 841560,
	"./Geometry/Shapes/trianglea8.png": 611261,
	"./Geometry/Shapes/windmill.png": 551750,
	"./Geometry/Shapes/windmillblueattop.png": 873312,
	"./Geometry/geometry.gif": 557184,
	"./Geometry/menu_geometry.gif": 380872,
	"./Grammar/Animation/combo0.gif": 717448,
	"./Grammar/Animation/combo1.gif": 134529,
	"./Grammar/Animation/combo2.gif": 386870,
	"./Grammar/Animation/combo3.gif": 623247,
	"./Grammar/Animation/combo4.gif": 46652,
	"./Grammar/GrammarLevel.png": 989311,
	"./Grammar/GrammarMenu.png": 320944,
	"./Grammar/GrammarRating.png": 141134,
	"./Grammar/grammar.gif": 627030,
	"./Grammar/menu_grammar.gif": 571408,
	"./Greyed_out_diamond.png": 779360,
	"./KS1/KS1Fixed.csv": 415859,
	"./KS1/KS1Questions": 579971,
	"./KS1/KS1Questions.json": 579971,
	"./KS1/ROUND1BG.gif": 628291,
	"./KS1/ROUND2BG.gif": 955456,
	"./KS1/ROUND2BG.png": 196275,
	"./KS1/ROUND3BG.gif": 408493,
	"./KS1/ROUND3BG.png": 457262,
	"./KS1/ROUND4BG.gif": 710130,
	"./KS1/menu_ks1.gif": 165120,
	"./MathsVocab/Animation/combo0.png": 665906,
	"./MathsVocab/Animation/combo1.png": 380731,
	"./MathsVocab/Animation/combo2.png": 118752,
	"./MathsVocab/Animation/combo3.png": 996873,
	"./MathsVocab/Animation/combo4.png": 656790,
	"./Measurements/Animation/combo0.gif": 742266,
	"./Measurements/Animation/combo1.gif": 542339,
	"./Measurements/Animation/combo2.gif": 807100,
	"./Measurements/Animation/combo3.gif": 21717,
	"./Measurements/Animation/combo4.gif": 935414,
	"./Measurements/ExtraQuestions/measurement_extraquestions.csv": 907062,
	"./Measurements/Images/10pcoin.png": 212511,
	"./Measurements/Images/1pcoin.png": 699373,
	"./Measurements/Images/20pcoin.png": 168272,
	"./Measurements/Images/2pcoin.png": 965360,
	"./Measurements/Images/50pcoin.png": 280219,
	"./Measurements/Images/5pcoin.png": 822417,
	"./Measurements/Images/AimeeonScale.png": 142125,
	"./Measurements/Images/BottleMeasure1.png": 371584,
	"./Measurements/Images/BottleMeasure2.png": 149915,
	"./Measurements/Images/BottleMeasure3.png": 513317,
	"./Measurements/Images/BottleMeasure4.png": 608205,
	"./Measurements/Images/BottleMeasure5.png": 368260,
	"./Measurements/Images/BottleMeasure6.png": 322911,
	"./Measurements/Images/BottleMeasure7.png": 726582,
	"./Measurements/Images/BottleMeasure8.png": 438513,
	"./Measurements/Images/BottleMeasure9.png": 540648,
	"./Measurements/Images/CCubes-1.png": 767240,
	"./Measurements/Images/CCubes-10.png": 996986,
	"./Measurements/Images/CCubes-11.png": 314563,
	"./Measurements/Images/CCubes-12.png": 29288,
	"./Measurements/Images/CCubes-13.png": 927153,
	"./Measurements/Images/CCubes-14.png": 586142,
	"./Measurements/Images/CCubes-15.png": 304455,
	"./Measurements/Images/CCubes-16.png": 384396,
	"./Measurements/Images/CCubes-17.png": 753493,
	"./Measurements/Images/CCubes-18.png": 224338,
	"./Measurements/Images/CCubes-19.png": 638555,
	"./Measurements/Images/CCubes-2.png": 104099,
	"./Measurements/Images/CCubes-20.png": 784139,
	"./Measurements/Images/CCubes-3.png": 339994,
	"./Measurements/Images/CCubes-4.png": 680117,
	"./Measurements/Images/CCubes-5.png": 927852,
	"./Measurements/Images/CCubes-6.png": 346855,
	"./Measurements/Images/CCubes-7.png": 594366,
	"./Measurements/Images/CCubes-8.png": 623881,
	"./Measurements/Images/CCubes-9.png": 745760,
	"./Measurements/Images/Clock1.png": 852914,
	"./Measurements/Images/Clock10.png": 225320,
	"./Measurements/Images/Clock11.png": 673713,
	"./Measurements/Images/Clock12.png": 497466,
	"./Measurements/Images/Clock2.png": 667529,
	"./Measurements/Images/Clock3.png": 789408,
	"./Measurements/Images/Clock4.png": 740735,
	"./Measurements/Images/Clock5.png": 327446,
	"./Measurements/Images/Clock6.png": 657773,
	"./Measurements/Images/Clock7.png": 403876,
	"./Measurements/Images/Clock8.png": 147747,
	"./Measurements/Images/Clock9.png": 383642,
	"./Measurements/Images/Cuboid.png": 666063,
	"./Measurements/Images/Cuboids-1.png": 350138,
	"./Measurements/Images/Cuboids-10.png": 185600,
	"./Measurements/Images/Cuboids-11.png": 309801,
	"./Measurements/Images/Cuboids-12.png": 761618,
	"./Measurements/Images/Cuboids-13.png": 83163,
	"./Measurements/Images/Cuboids-14.png": 428356,
	"./Measurements/Images/Cuboids-15.png": 91597,
	"./Measurements/Images/Cuboids-16.png": 659830,
	"./Measurements/Images/Cuboids-17.png": 713631,
	"./Measurements/Images/Cuboids-18.png": 50216,
	"./Measurements/Images/Cuboids-19.png": 498609,
	"./Measurements/Images/Cuboids-2.png": 526385,
	"./Measurements/Images/Cuboids-20.png": 409989,
	"./Measurements/Images/Cuboids-3.png": 77992,
	"./Measurements/Images/Cuboids-4.png": 657607,
	"./Measurements/Images/Cuboids-5.png": 481822,
	"./Measurements/Images/Cuboids-6.png": 802197,
	"./Measurements/Images/Cuboids-7.png": 890572,
	"./Measurements/Images/Cuboids-8.png": 594587,
	"./Measurements/Images/Cuboids-9.png": 273042,
	"./Measurements/Images/DigClock.png": 802403,
	"./Measurements/Images/EmileHeight1.png": 985397,
	"./Measurements/Images/EmileHeight10.png": 97937,
	"./Measurements/Images/EmileHeight2.png": 899646,
	"./Measurements/Images/EmileHeight3.png": 652135,
	"./Measurements/Images/EmileHeight4.png": 72520,
	"./Measurements/Images/EmileHeight5.png": 66385,
	"./Measurements/Images/EmileHeight6.png": 161626,
	"./Measurements/Images/EmileHeight7.png": 409379,
	"./Measurements/Images/EmileHeight8.png": 665508,
	"./Measurements/Images/EmileHeight9.png": 919405,
	"./Measurements/Images/EmileonScale.png": 129064,
	"./Measurements/Images/GemonScale.png": 939645,
	"./Measurements/Images/LShape-1.png": 674144,
	"./Measurements/Images/LShape-10.png": 125090,
	"./Measurements/Images/LShape-11.png": 346219,
	"./Measurements/Images/LShape-12.png": 458576,
	"./Measurements/Images/LShape-13.png": 464825,
	"./Measurements/Images/LShape-14.png": 531782,
	"./Measurements/Images/LShape-15.png": 570799,
	"./Measurements/Images/LShape-16.png": 396308,
	"./Measurements/Images/LShape-17.png": 312989,
	"./Measurements/Images/LShape-18.png": 536394,
	"./Measurements/Images/LShape-19.png": 691603,
	"./Measurements/Images/LShape-2.png": 512827,
	"./Measurements/Images/LShape-20.png": 195155,
	"./Measurements/Images/LShape-3.png": 763826,
	"./Measurements/Images/LShape-4.png": 145389,
	"./Measurements/Images/LShape-5.png": 619236,
	"./Measurements/Images/LShape-6.png": 532799,
	"./Measurements/Images/LShape-7.png": 754710,
	"./Measurements/Images/LShape-8.png": 266193,
	"./Measurements/Images/LShape-9.png": 26248,
	"./Measurements/Images/LadderMeasure1.png": 53048,
	"./Measurements/Images/LadderMeasure10.png": 451690,
	"./Measurements/Images/LadderMeasure2.png": 848659,
	"./Measurements/Images/LadderMeasure3.png": 116746,
	"./Measurements/Images/LadderMeasure4.png": 187173,
	"./Measurements/Images/LadderMeasure5.png": 951260,
	"./Measurements/Images/LadderMeasure6.png": 658839,
	"./Measurements/Images/LadderMeasure7.png": 959342,
	"./Measurements/Images/LadderMeasure8.png": 748729,
	"./Measurements/Images/LadderMeasure9.png": 520099,
	"./Measurements/Images/LiftSign.png": 109141,
	"./Measurements/Images/LineMeasure1.png": 455566,
	"./Measurements/Images/LineMeasure10.png": 474060,
	"./Measurements/Images/LineMeasure2.png": 657989,
	"./Measurements/Images/LineMeasure3.png": 340476,
	"./Measurements/Images/LineMeasure4.png": 40435,
	"./Measurements/Images/LineMeasure5.png": 189674,
	"./Measurements/Images/LineMeasure6.png": 138657,
	"./Measurements/Images/LineMeasure7.png": 865944,
	"./Measurements/Images/LineMeasure8.png": 667599,
	"./Measurements/Images/LineMeasure9.png": 382502,
	"./Measurements/Images/NewRuler20.png": 318257,
	"./Measurements/Images/NewRuler30.png": 382230,
	"./Measurements/Images/NewRulerRope.png": 131395,
	"./Measurements/Images/NewScale.png": 470197,
	"./Measurements/Images/NewScaleDial.png": 551967,
	"./Measurements/Images/NewScaleDialSmall.png": 991482,
	"./Measurements/Images/Para-1.png": 841285,
	"./Measurements/Images/Para-10.png": 548385,
	"./Measurements/Images/Para-11.png": 63768,
	"./Measurements/Images/Para-12.png": 238259,
	"./Measurements/Images/Para-13.png": 599402,
	"./Measurements/Images/Para-14.png": 67717,
	"./Measurements/Images/Para-15.png": 54652,
	"./Measurements/Images/Para-16.png": 338935,
	"./Measurements/Images/Para-17.png": 195918,
	"./Measurements/Images/Para-18.png": 985305,
	"./Measurements/Images/Para-19.png": 388400,
	"./Measurements/Images/Para-2.png": 969486,
	"./Measurements/Images/Para-20.png": 883852,
	"./Measurements/Images/Para-3.png": 112503,
	"./Measurements/Images/Para-4.png": 837336,
	"./Measurements/Images/Para-5.png": 805601,
	"./Measurements/Images/Para-6.png": 856618,
	"./Measurements/Images/Para-7.png": 11827,
	"./Measurements/Images/Para-8.png": 869556,
	"./Measurements/Images/Para-9.png": 90685,
	"./Measurements/Images/RATri-1.png": 135453,
	"./Measurements/Images/RATri-10.png": 883657,
	"./Measurements/Images/RATri-11.png": 428832,
	"./Measurements/Images/RATri-12.png": 783867,
	"./Measurements/Images/RATri-13.png": 518514,
	"./Measurements/Images/RATri-14.png": 900077,
	"./Measurements/Images/RATri-15.png": 373924,
	"./Measurements/Images/RATri-16.png": 287487,
	"./Measurements/Images/RATri-17.png": 509398,
	"./Measurements/Images/RATri-18.png": 20881,
	"./Measurements/Images/RATri-19.png": 780936,
	"./Measurements/Images/RATri-2.png": 354246,
	"./Measurements/Images/RATri-20.png": 414196,
	"./Measurements/Images/RATri-3.png": 876911,
	"./Measurements/Images/RATri-4.png": 281040,
	"./Measurements/Images/RATri-5.png": 287289,
	"./Measurements/Images/RATri-6.png": 431202,
	"./Measurements/Images/RATri-7.png": 652331,
	"./Measurements/Images/RATri-8.png": 642844,
	"./Measurements/Images/RATri-9.png": 725733,
	"./Measurements/Images/Rectangle.png": 91966,
	"./Measurements/Images/Rectangles-1.png": 869681,
	"./Measurements/Images/Rectangles-10.png": 287749,
	"./Measurements/Images/Rectangles-11.png": 758332,
	"./Measurements/Images/Rectangles-12.png": 558967,
	"./Measurements/Images/Rectangles-13.png": 415950,
	"./Measurements/Images/Rectangles-14.png": 252065,
	"./Measurements/Images/Rectangles-15.png": 767448,
	"./Measurements/Images/Rectangles-16.png": 941939,
	"./Measurements/Images/Rectangles-17.png": 303082,
	"./Measurements/Images/Rectangles-18.png": 537149,
	"./Measurements/Images/Rectangles-19.png": 316020,
	"./Measurements/Images/Rectangles-2.png": 939514,
	"./Measurements/Images/Rectangles-20.png": 63360,
	"./Measurements/Images/Rectangles-3.png": 257091,
	"./Measurements/Images/Rectangles-4.png": 326924,
	"./Measurements/Images/Rectangles-5.png": 696021,
	"./Measurements/Images/Rectangles-6.png": 528670,
	"./Measurements/Images/Rectangles-7.png": 246983,
	"./Measurements/Images/Rectangles-8.png": 802752,
	"./Measurements/Images/Rectangles-9.png": 257577,
	"./Measurements/Images/RomClock1.png": 822280,
	"./Measurements/Images/RomClock10.png": 30778,
	"./Measurements/Images/RomClock11.png": 620611,
	"./Measurements/Images/RomClock12.png": 242280,
	"./Measurements/Images/RomClock2.png": 159139,
	"./Measurements/Images/RomClock3.png": 937562,
	"./Measurements/Images/RomClock4.png": 311861,
	"./Measurements/Images/RomClock5.png": 228972,
	"./Measurements/Images/RomClock6.png": 97447,
	"./Measurements/Images/RomClock7.png": 226110,
	"./Measurements/Images/RomClock8.png": 925001,
	"./Measurements/Images/RomClock9.png": 470176,
	"./Measurements/Images/RopeMeasure1.png": 419860,
	"./Measurements/Images/RopeMeasure10.png": 437697,
	"./Measurements/Images/RopeMeasure2.png": 594351,
	"./Measurements/Images/RopeMeasure3.png": 555334,
	"./Measurements/Images/RopeMeasure4.png": 4729,
	"./Measurements/Images/RopeMeasure5.png": 998480,
	"./Measurements/Images/RopeMeasure6.png": 369771,
	"./Measurements/Images/RopeMeasure7.png": 148642,
	"./Measurements/Images/RopeMeasure8.png": 443173,
	"./Measurements/Images/RopeMeasure9.png": 360284,
	"./Measurements/Images/ScramblerHeight1.png": 812264,
	"./Measurements/Images/ScramblerHeight10.png": 171034,
	"./Measurements/Images/ScramblerHeight2.png": 674243,
	"./Measurements/Images/ScramblerHeight3.png": 84410,
	"./Measurements/Images/ScramblerHeight4.png": 52821,
	"./Measurements/Images/ScramblerHeight5.png": 141196,
	"./Measurements/Images/ScramblerHeight6.png": 391879,
	"./Measurements/Images/ScramblerHeight7.png": 216094,
	"./Measurements/Images/ScramblerHeight8.png": 71849,
	"./Measurements/Images/ScramblerHeight9.png": 947648,
	"./Measurements/Images/ScrambleronScale.png": 395301,
	"./Measurements/Images/Tri-1.png": 719276,
	"./Measurements/Images/Tri-10.png": 945462,
	"./Measurements/Images/Tri-11.png": 541791,
	"./Measurements/Images/Tri-12.png": 587140,
	"./Measurements/Images/Tri-13.png": 827085,
	"./Measurements/Images/Tri-14.png": 954578,
	"./Measurements/Images/Tri-15.png": 368795,
	"./Measurements/Images/Tri-16.png": 590464,
	"./Measurements/Images/Tri-17.png": 45289,
	"./Measurements/Images/Tri-18.png": 316382,
	"./Measurements/Images/Tri-19.png": 34695,
	"./Measurements/Images/Tri-2.png": 104103,
	"./Measurements/Images/Tri-20.png": 419015,
	"./Measurements/Images/Tri-3.png": 716414,
	"./Measurements/Images/Tri-4.png": 552529,
	"./Measurements/Images/Tri-5.png": 312584,
	"./Measurements/Images/Tri-6.png": 649443,
	"./Measurements/Images/Tri-7.png": 944218,
	"./Measurements/Images/Tri-8.png": 431725,
	"./Measurements/Images/Tri-9.png": 905572,
	"./Measurements/Images/WeightonScale.png": 850134,
	"./Measurements/Images/£10note.png": 557085,
	"./Measurements/Images/£1coin.png": 563674,
	"./Measurements/Images/£20note.png": 262564,
	"./Measurements/Images/£2coin.png": 559557,
	"./Measurements/Images/£50note.png": 375313,
	"./Measurements/Images/£5note.png": 855069,
	"./Measurements/MeasurementLevel.png": 169908,
	"./Measurements/MeasurementMenu.png": 415517,
	"./Measurements/MeasurementRating.png": 293523,
	"./Measurements/measurements.gif": 454858,
	"./Measurements/menu_measurements.gif": 850968,
	"./Multiplication/Animation/Learn/Round1Idle.gif": 387481,
	"./Multiplication/Animation/Learn/Round1Transition.gif": 349178,
	"./Multiplication/Animation/Learn/Round2Idle.gif": 309406,
	"./Multiplication/Animation/Learn/Round2Transition.gif": 225629,
	"./Multiplication/Animation/Learn/Round3Loop.gif": 961203,
	"./Multiplication/Animation/Learn/Round3Transition.gif": 80,
	"./Multiplication/Animation/Learn/Round4/Step10CorrectStart.gif": 993318,
	"./Multiplication/Animation/Learn/Round4/Step10DestroyedStart.gif": 99919,
	"./Multiplication/Animation/Learn/Round4/Step10Loop.gif": 540086,
	"./Multiplication/Animation/Learn/Round4/Step11CorrectStart.gif": 495923,
	"./Multiplication/Animation/Learn/Round4/Step11DestroyedStart.gif": 983106,
	"./Multiplication/Animation/Learn/Round4/Step11Loop.gif": 533727,
	"./Multiplication/Animation/Learn/Round4/Step12CorrectStart.gif": 576488,
	"./Multiplication/Animation/Learn/Round4/Step12DestroyedStart.gif": 179241,
	"./Multiplication/Animation/Learn/Round4/Step12Loop.gif": 529772,
	"./Multiplication/Animation/Learn/Round4/Step13CorrectStart.gif": 832869,
	"./Multiplication/Animation/Learn/Round4/Step13DestroyedStart.gif": 839484,
	"./Multiplication/Animation/Learn/Round4/Step13Loop.gif": 566685,
	"./Multiplication/Animation/Learn/Round4/Step14CorrectStart.gif": 307554,
	"./Multiplication/Animation/Learn/Round4/Step14DestroyedStart.gif": 789363,
	"./Multiplication/Animation/Learn/Round4/Step14Loop.gif": 874370,
	"./Multiplication/Animation/Learn/Round4/Step15CorrectStart.gif": 94799,
	"./Multiplication/Animation/Learn/Round4/Step15DestroyedStart.gif": 650070,
	"./Multiplication/Animation/Learn/Round4/Step15Loop.gif": 821659,
	"./Multiplication/Animation/Learn/Round4/Step16CorrectStart.gif": 839588,
	"./Multiplication/Animation/Learn/Round4/Step16DestroyedStart.gif": 591437,
	"./Multiplication/Animation/Learn/Round4/Step16Loop.gif": 983512,
	"./Multiplication/Animation/Learn/Round4/Step17CorrectStart.gif": 315809,
	"./Multiplication/Animation/Learn/Round4/Step17DestroyedStart.gif": 964480,
	"./Multiplication/Animation/Learn/Round4/Step17Loop.gif": 674377,
	"./Multiplication/Animation/Learn/Round4/Step18CorrectStart.gif": 956894,
	"./Multiplication/Animation/Learn/Round4/Step18Loop.gif": 206062,
	"./Multiplication/Animation/Learn/Round4/Step1CorrectStart.gif": 391950,
	"./Multiplication/Animation/Learn/Round4/Step1DestroyedStart.gif": 912423,
	"./Multiplication/Animation/Learn/Round4/Step1Loop.gif": 472030,
	"./Multiplication/Animation/Learn/Round4/Step1Start.gif": 609002,
	"./Multiplication/Animation/Learn/Round4/Step2CorrectStart.gif": 106893,
	"./Multiplication/Animation/Learn/Round4/Step2DestroyedStart.gif": 472116,
	"./Multiplication/Animation/Learn/Round4/Step2Loop.gif": 773797,
	"./Multiplication/Animation/Learn/Round4/Step3CorrectStart.gif": 430000,
	"./Multiplication/Animation/Learn/Round4/Step3DestroyedStart.gif": 960353,
	"./Multiplication/Animation/Learn/Round4/Step3Loop.gif": 972596,
	"./Multiplication/Animation/Learn/Round4/Step4CorrectStart.gif": 392599,
	"./Multiplication/Animation/Learn/Round4/Step4DestroyedStart.gif": 823950,
	"./Multiplication/Animation/Learn/Round4/Step4Loop.gif": 872995,
	"./Multiplication/Animation/Learn/Round4/Step5CorrectStart.gif": 407690,
	"./Multiplication/Animation/Learn/Round4/Step5DestroyedStart.gif": 99851,
	"./Multiplication/Animation/Learn/Round4/Step5Loop.gif": 344906,
	"./Multiplication/Animation/Learn/Round4/Step6CorrectStart.gif": 158249,
	"./Multiplication/Animation/Learn/Round4/Step6DestroyedStart.gif": 616728,
	"./Multiplication/Animation/Learn/Round4/Step6Loop.gif": 54577,
	"./Multiplication/Animation/Learn/Round4/Step7CorrectStart.gif": 909260,
	"./Multiplication/Animation/Learn/Round4/Step7DestroyedStart.gif": 858981,
	"./Multiplication/Animation/Learn/Round4/Step7Loop.gif": 397312,
	"./Multiplication/Animation/Learn/Round4/Step8CorrectStart.gif": 957283,
	"./Multiplication/Animation/Learn/Round4/Step8DestroyedStart.gif": 245906,
	"./Multiplication/Animation/Learn/Round4/Step8Loop.gif": 185551,
	"./Multiplication/Animation/Learn/Round4/Step9CorrectStart.gif": 84694,
	"./Multiplication/Animation/Learn/Round4/Step9DestroyedStart.gif": 50079,
	"./Multiplication/Animation/Learn/Round4/Step9Loop.gif": 244390,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step10Correct.gif": 807867,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step10Destroyed.gif": 559480,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step10Start.gif": 959601,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step11Correct.gif": 660188,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step11Destroyed.gif": 159191,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step11Start.gif": 731822,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step12Correct.gif": 259085,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step12Destroyed.gif": 865346,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step12Start.gif": 405007,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step13Correct.gif": 410430,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step13Destroyed.gif": 473985,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step13Start.gif": 339756,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step14Correct.gif": 235775,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step14Destroyed.gif": 938500,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step14Start.gif": 507581,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step15Correct.gif": 714640,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step15Destroyed.gif": 744243,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step15Start.gif": 533482,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step16Correct.gif": 969185,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step16Destroyed.gif": 195694,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step16Start.gif": 65643,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step17Correct.gif": 690562,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step17Destroyed.gif": 107693,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step17Start.gif": 679720,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step18Correct.gif": 695811,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step18Start.gif": 985769,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step1Correct.gif": 90805,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step1Destroyed.gif": 661978,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step2Correct.gif": 754404,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step2Destroyed.gif": 930223,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step2Start.gif": 950886,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step3Correct.gif": 66691,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step3Destroyed.gif": 88112,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step3Start.gif": 883497,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step4Correct.gif": 636522,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step4Destroyed.gif": 503237,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step4Start.gif": 888704,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step5Correct.gif": 502793,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step5Destroyed.gif": 820262,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step5Start.gif": 142979,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step6Correct.gif": 534136,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step6Destroyed.gif": 36523,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step6Start.gif": 494146,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step7Correct.gif": 128807,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step7Destroyed.gif": 702876,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step7Start.gif": 802709,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step8Correct.gif": 921854,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step8Destroyed.gif": 374081,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step8Start.gif": 667436,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step9Correct.gif": 926541,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step9Destroyed.gif": 547458,
	"./Multiplication/Animation/Learn/Round4/Unneeded/Step9Start.gif": 137935,
	"./Multiplication/Animation/Learn/round1.gif": 669067,
	"./Multiplication/Animation/Learn/round2.png": 908679,
	"./Multiplication/Animation/Learn/round3.gif": 608829,
	"./Multiplication/Animation/Learn/round4.png": 531377,
	"./Multiplication/Animation/Learn/transition1.png": 674807,
	"./Multiplication/Animation/Learn/transition2.gif": 784027,
	"./Multiplication/Animation/Learn/transition3.png": 403589,
	"./Multiplication/Animation/combo0.gif": 737065,
	"./Multiplication/Animation/combo1.gif": 333776,
	"./Multiplication/Animation/combo2.gif": 701143,
	"./Multiplication/Animation/combo3.gif": 554334,
	"./Multiplication/Animation/combo4.gif": 346653,
	"./Multiplication/ExtraQuestions/mult_extraquestions.csv": 646155,
	"./Multiplication/MultiplicationLevel.png": 325721,
	"./Multiplication/MultiplicationLevel.png.old": 995225,
	"./Multiplication/MultiplicationMenu.png": 59766,
	"./Multiplication/MultiplicationRating.png": 434756,
	"./Multiplication/menu_multiplication.gif": 830660,
	"./Multiplication/multiplication_rating.gif": 969064,
	"./NumberAndPlace/Animation/combo0.gif": 113414,
	"./NumberAndPlace/Animation/combo1.gif": 751327,
	"./NumberAndPlace/Animation/combo2.gif": 757592,
	"./NumberAndPlace/Animation/combo3.gif": 232209,
	"./NumberAndPlace/Animation/combo4.gif": 396554,
	"./NumberAndPlace/ExtraQuestions/numplace_extraquestions.csv": 606149,
	"./NumberAndPlace/Images/1000cube1.png": 320140,
	"./NumberAndPlace/Images/1000cube2.png": 240199,
	"./NumberAndPlace/Images/1000cube3.png": 521886,
	"./NumberAndPlace/Images/1000cube4.png": 862897,
	"./NumberAndPlace/Images/1000cube5.png": 965032,
	"./NumberAndPlace/Images/1000cube6.png": 250307,
	"./NumberAndPlace/Images/1000token.png": 848139,
	"./NumberAndPlace/Images/100cube1.png": 789966,
	"./NumberAndPlace/Images/100cube2.png": 178117,
	"./NumberAndPlace/Images/100cube3.png": 648700,
	"./NumberAndPlace/Images/100cube4.png": 832307,
	"./NumberAndPlace/Images/100cube5.png": 193450,
	"./NumberAndPlace/Images/100cube6.png": 142433,
	"./NumberAndPlace/Images/100cube7.png": 657816,
	"./NumberAndPlace/Images/100cube8.png": 425295,
	"./NumberAndPlace/Images/100cube9.png": 386278,
	"./NumberAndPlace/Images/100token.png": 688609,
	"./NumberAndPlace/Images/10cube1.png": 567764,
	"./NumberAndPlace/Images/10cube2.png": 589231,
	"./NumberAndPlace/Images/10cube3.png": 7686,
	"./NumberAndPlace/Images/10cube4.png": 610105,
	"./NumberAndPlace/Images/10cube5.png": 603856,
	"./NumberAndPlace/Images/10cube6.png": 34027,
	"./NumberAndPlace/Images/10cube7.png": 143522,
	"./NumberAndPlace/Images/10cube8.png": 48549,
	"./NumberAndPlace/Images/10cube9.png": 812636,
	"./NumberAndPlace/Images/10token.png": 460035,
	"./NumberAndPlace/Images/1cube1.png": 279686,
	"./NumberAndPlace/Images/1cube2.png": 577245,
	"./NumberAndPlace/Images/1cube3.png": 144212,
	"./NumberAndPlace/Images/1cube4.png": 94123,
	"./NumberAndPlace/Images/1cube5.png": 872994,
	"./NumberAndPlace/Images/1cube6.png": 729081,
	"./NumberAndPlace/Images/1cube7.png": 722832,
	"./NumberAndPlace/Images/1cube8.png": 342743,
	"./NumberAndPlace/Images/1cube9.png": 397166,
	"./NumberAndPlace/Images/1token.png": 645897,
	"./NumberAndPlace/Images/Barmodel1.png": 477162,
	"./NumberAndPlace/Images/Barmodel2.png": 426145,
	"./NumberAndPlace/Images/Barmodel3.png": 153432,
	"./NumberAndPlace/Images/Barmodel4.png": 733047,
	"./NumberAndPlace/Images/Barmodel5.png": 743054,
	"./NumberAndPlace/Images/Barmodel6.png": 461829,
	"./NumberAndPlace/Images/Barmodel7.png": 144316,
	"./NumberAndPlace/Images/Barmodel8.png": 547000,
	"./NumberAndPlace/Images/blank.png": 712563,
	"./NumberAndPlace/Images/bluegem.png": 459296,
	"./NumberAndPlace/Images/greencounter.png": 88194,
	"./NumberAndPlace/Images/numberline1.png": 370615,
	"./NumberAndPlace/Images/numberline10.png": 506583,
	"./NumberAndPlace/Images/numberline11.png": 561006,
	"./NumberAndPlace/Images/numberline12.png": 331365,
	"./NumberAndPlace/Images/numberline13.png": 248476,
	"./NumberAndPlace/Images/numberline14.png": 603347,
	"./NumberAndPlace/Images/numberline15.png": 448138,
	"./NumberAndPlace/Images/numberline16.png": 478721,
	"./NumberAndPlace/Images/numberline17.png": 257592,
	"./NumberAndPlace/Images/numberline18.png": 482543,
	"./NumberAndPlace/Images/numberline19.png": 443526,
	"./NumberAndPlace/Images/numberline2.png": 559503,
	"./NumberAndPlace/Images/numberline20.png": 363654,
	"./NumberAndPlace/Images/numberline3.png": 99397,
	"./NumberAndPlace/Images/numberline4.png": 114730,
	"./NumberAndPlace/Images/numberline5.png": 965491,
	"./NumberAndPlace/Images/numberline6.png": 791000,
	"./NumberAndPlace/Images/numberline7.png": 63713,
	"./NumberAndPlace/Images/numberline8.png": 307558,
	"./NumberAndPlace/Images/numberline9.png": 592655,
	"./NumberAndPlace/Images/numberlineblank.png": 850424,
	"./NumberAndPlace/Images/numberlinecount.png": 400591,
	"./NumberAndPlace/Images/placetablehundredstensones.png": 942898,
	"./NumberAndPlace/Images/placetabletensones.png": 69029,
	"./NumberAndPlace/Images/placetablethousandshundredsones.png": 194861,
	"./NumberAndPlace/Images/purplecounter.png": 978023,
	"./NumberAndPlace/Images/redgem.png": 250419,
	"./NumberAndPlace/Images/rocket.png": 291205,
	"./NumberAndPlace/Images/tenframecounter.png": 42973,
	"./NumberAndPlace/Images/tenframetable.png": 396849,
	"./NumberAndPlace/Images/tenframetable_full.png": 990385,
	"./NumberAndPlace/Images/tenframetablequestion.png": 80521,
	"./NumberAndPlace/Images/wholemodel.png": 295281,
	"./NumberAndPlace/Images/yellowgem.png": 567888,
	"./NumberAndPlace/NumberAndPlaceLevel.png": 826891,
	"./NumberAndPlace/NumberAndPlaceMenu.png": 781676,
	"./NumberAndPlace/NumberAndPlaceRating.png": 592130,
	"./NumberAndPlace/PartWholeImages/PART WHOLE MODEL 1.png": 452439,
	"./NumberAndPlace/PartWholeImages/PART WHOLE MODEL 2.png": 194332,
	"./NumberAndPlace/PartWholeImages/WholeMissing/question1.png": 401292,
	"./NumberAndPlace/PartWholeImages/WholeMissing/question2.png": 168327,
	"./NumberAndPlace/PartWholeImages/WholeMissing/question3.png": 992542,
	"./NumberAndPlace/PartWholeImages/WholeMissing/question4.png": 520753,
	"./NumberAndPlace/PartWholeImages/WholeMissing/question5.png": 588712,
	"./NumberAndPlace/PartWholeImages/part whole model 1,000-30.png": 503015,
	"./NumberAndPlace/PartWholeImages/part whole model 10 and 7.png": 424107,
	"./NumberAndPlace/PartWholeImages/part whole model 100-30.png": 467659,
	"./NumberAndPlace/PartWholeImages/part whole model 16-29.png": 456435,
	"./NumberAndPlace/PartWholeImages/part whole model 17 -10.png": 386666,
	"./NumberAndPlace/PartWholeImages/part whole model 2,145.png": 558336,
	"./NumberAndPlace/PartWholeImages/part whole model 20 and 5.png": 968724,
	"./NumberAndPlace/PartWholeImages/part whole model 4,897.png": 517206,
	"./NumberAndPlace/PartWholeImages/part whole model total 24 2.png": 294722,
	"./NumberAndPlace/PartWholeImages/part whole model total 24.png": 721160,
	"./NumberAndPlace/PartWholeImages/part whole model £12-£2.png": 379068,
	"./NumberAndPlace/PartWholeImages/part whole model £36-£30.png": 472519,
	"./NumberAndPlace/PartWholeImages/upside down part whole mode 33-3.png": 524326,
	"./NumberAndPlace/PartWholeTemplate.png": 864042,
	"./NumberAndPlace/menu_numplace.gif": 249374,
	"./NumberAndPlace/numplace.gif": 268680,
	"./NumberSense/Images/Empty.png": 219640,
	"./NumberSense/Images/aimee1.png": 67249,
	"./NumberSense/Images/aimee10.png": 15877,
	"./NumberSense/Images/aimee2.png": 137082,
	"./NumberSense/Images/aimee3.png": 938307,
	"./NumberSense/Images/aimee4.png": 8140,
	"./NumberSense/Images/aimee5.png": 893589,
	"./NumberSense/Images/aimee6.png": 726238,
	"./NumberSense/Images/aimee7.png": 444551,
	"./NumberSense/Images/aimee8.png": 483968,
	"./NumberSense/Images/aimee9.png": 455145,
	"./NumberSense/Images/emile1.png": 543632,
	"./NumberSense/Images/emile10.png": 426066,
	"./NumberSense/Images/emile2.png": 457451,
	"./NumberSense/Images/emile3.png": 83298,
	"./NumberSense/Images/emile4.png": 728669,
	"./NumberSense/Images/emile5.png": 507540,
	"./NumberSense/Images/emile6.png": 529007,
	"./NumberSense/Images/emile7.png": 947462,
	"./NumberSense/Images/emile8.png": 75329,
	"./NumberSense/Images/emile9.png": 337848,
	"./NumberSense/Images/planet1.png": 262888,
	"./NumberSense/Images/planet10.png": 510874,
	"./NumberSense/Images/planet2.png": 124867,
	"./NumberSense/Images/planet3.png": 535034,
	"./NumberSense/Images/planet4.png": 503445,
	"./NumberSense/Images/planet5.png": 591820,
	"./NumberSense/Images/planet6.png": 842503,
	"./NumberSense/Images/planet7.png": 666718,
	"./NumberSense/Images/planet8.png": 522473,
	"./NumberSense/Images/planet9.png": 398272,
	"./NumberSense/Images/rectangle1.png": 90583,
	"./NumberSense/Images/rectangle2.png": 383004,
	"./NumberSense/Images/rectangle3.png": 618917,
	"./NumberSense/Images/rectangle4.png": 548490,
	"./NumberSense/Images/rectangle5.png": 280403,
	"./NumberSense/Images/rocket1.png": 210722,
	"./NumberSense/Images/rocket10.png": 996248,
	"./NumberSense/Images/rocket2.png": 66809,
	"./NumberSense/Images/rocket3.png": 60560,
	"./NumberSense/Images/rocket4.png": 656431,
	"./NumberSense/Images/rocket5.png": 617414,
	"./NumberSense/Images/rocket6.png": 914973,
	"./NumberSense/Images/rocket7.png": 481940,
	"./NumberSense/Images/rocket8.png": 777235,
	"./NumberSense/Images/rocket9.png": 622026,
	"./NumberSense/Images/scrambler1.png": 664474,
	"./NumberSense/Images/scrambler10.png": 23385,
	"./NumberSense/Images/scrambler2.png": 628118,
	"./NumberSense/Images/scrambler3.png": 41407,
	"./NumberSense/Images/scrambler4.png": 90080,
	"./NumberSense/Images/scrambler5.png": 968201,
	"./NumberSense/Images/scrambler6.png": 637234,
	"./NumberSense/Images/scrambler7.png": 352059,
	"./NumberSense/Images/scrambler8.png": 272172,
	"./NumberSense/Images/scrambler9.png": 24437,
	"./NumberSense/Images/tableratios.png": 576431,
	"./NumberSense/Images/triangle1.png": 380782,
	"./NumberSense/Images/triangle2.png": 608613,
	"./NumberSense/Images/triangle3.png": 856348,
	"./NumberSense/Images/triangle4.png": 753747,
	"./NumberSense/Images/triangle5.png": 538186,
	"./Phonics/Animation/Learn/round1.gif": 731993,
	"./Phonics/Animation/Learn/round2.gif": 425806,
	"./Phonics/Animation/Learn/round3.gif": 357895,
	"./Phonics/Animation/Learn/round4.gif": 753716,
	"./Phonics/Animation/Learn/round5.gif": 338765,
	"./Phonics/Animation/Learn/transition1.gif": 153942,
	"./Phonics/Animation/Learn/transition2.gif": 295265,
	"./Phonics/Animation/Learn/transition3.gif": 383080,
	"./Phonics/Animation/Learn/transition4.gif": 719779,
	"./Phonics/Animation/combo0.png": 316192,
	"./Phonics/Animation/combo1.png": 287369,
	"./Phonics/Animation/combo2.png": 922226,
	"./Phonics/Animation/combo3.png": 671227,
	"./Phonics/Animation/combo4.png": 261284,
	"./Phonics/Images/aim.png": 50927,
	"./Phonics/Images/aimx.png": 640135,
	"./Phonics/Images/bad.png": 537853,
	"./Phonics/Images/badx.png": 458225,
	"./Phonics/Images/bag.png": 470438,
	"./Phonics/Images/bagx.png": 544156,
	"./Phonics/Images/bath.png": 74065,
	"./Phonics/Images/bathx.png": 366365,
	"./Phonics/Images/beard.png": 227874,
	"./Phonics/Images/bell.png": 505641,
	"./Phonics/Images/bellx.png": 638357,
	"./Phonics/Images/big.png": 875486,
	"./Phonics/Images/bigx.png": 943892,
	"./Phonics/Images/bit.png": 283845,
	"./Phonics/Images/bitx.png": 11033,
	"./Phonics/Images/blew.png": 798440,
	"./Phonics/Images/blewx.png": 312690,
	"./Phonics/Images/born.png": 658867,
	"./Phonics/Images/bornx.png": 671619,
	"./Phonics/Images/bow.png": 829060,
	"./Phonics/Images/bowx.png": 317494,
	"./Phonics/Images/boy.png": 485498,
	"./Phonics/Images/boyx.png": 487272,
	"./Phonics/Images/bug.png": 268482,
	"./Phonics/Images/bugx.png": 643984,
	"./Phonics/Images/burn.png": 503921,
	"./Phonics/Images/burnx.png": 192317,
	"./Phonics/Images/but.png": 616745,
	"./Phonics/Images/butx.png": 773013,
	"./Phonics/Images/came.png": 713528,
	"./Phonics/Images/camex.png": 143298,
	"./Phonics/Images/card.png": 615312,
	"./Phonics/Images/cardx.png": 218490,
	"./Phonics/Images/chew.png": 541711,
	"./Phonics/Images/chewx.png": 342631,
	"./Phonics/Images/claw.png": 683623,
	"./Phonics/Images/clawx.png": 769439,
	"./Phonics/Images/coin.png": 312861,
	"./Phonics/Images/coinx.png": 375825,
	"./Phonics/Images/cord.png": 62894,
	"./Phonics/Images/cordx.png": 652068,
	"./Phonics/Images/cot.png": 806110,
	"./Phonics/Images/cotx.png": 367188,
	"./Phonics/Images/crab.png": 15664,
	"./Phonics/Images/crabx.png": 842458,
	"./Phonics/Images/crew.png": 763777,
	"./Phonics/Images/crewx.png": 979981,
	"./Phonics/Images/crow.png": 859939,
	"./Phonics/Images/crowx.png": 327475,
	"./Phonics/Images/cry.png": 852296,
	"./Phonics/Images/cryx.png": 65874,
	"./Phonics/Images/dad.png": 871207,
	"./Phonics/Images/dadx.png": 628767,
	"./Phonics/Images/day.png": 983010,
	"./Phonics/Images/dayx.png": 282736,
	"./Phonics/Images/dear.png": 436598,
	"./Phonics/Images/dearx.png": 169900,
	"./Phonics/Images/deep.png": 163624,
	"./Phonics/Images/deepx.png": 83058,
	"./Phonics/Images/did.png": 440927,
	"./Phonics/Images/didx.png": 689335,
	"./Phonics/Images/die.png": 360950,
	"./Phonics/Images/diex.png": 435948,
	"./Phonics/Images/dish.png": 284170,
	"./Phonics/Images/dishx.png": 659000,
	"./Phonics/Images/dog.png": 619310,
	"./Phonics/Images/dogx.png": 261476,
	"./Phonics/Images/doll.png": 333477,
	"./Phonics/Images/dollx.png": 50489,
	"./Phonics/Images/dray.png": 953586,
	"./Phonics/Images/drayx.png": 565440,
	"./Phonics/Images/each.png": 706745,
	"./Phonics/Images/eachx.png": 543461,
	"./Phonics/Images/ear.png": 244764,
	"./Phonics/Images/end.png": 541487,
	"./Phonics/Images/endx.png": 299399,
	"./Phonics/Images/exit.png": 476726,
	"./Phonics/Images/exitx.png": 439596,
	"./Phonics/Images/fact.png": 874568,
	"./Phonics/Images/factx.png": 884882,
	"./Phonics/Images/fan.png": 851435,
	"./Phonics/Images/fanx.png": 537051,
	"./Phonics/Images/fast.png": 978904,
	"./Phonics/Images/fastx.png": 174882,
	"./Phonics/Images/fat.png": 263377,
	"./Phonics/Images/fatx.png": 910621,
	"./Phonics/Images/fear.png": 673288,
	"./Phonics/Images/fearx.png": 600658,
	"./Phonics/Images/feel.png": 124874,
	"./Phonics/Images/feelx.png": 99768,
	"./Phonics/Images/fin.png": 504451,
	"./Phonics/Images/finx.png": 129491,
	"./Phonics/Images/flea.png": 499826,
	"./Phonics/Images/fleax.png": 13952,
	"./Phonics/Images/flew.png": 394260,
	"./Phonics/Images/flewx.png": 227718,
	"./Phonics/Images/for.png": 619373,
	"./Phonics/Images/forx.png": 985057,
	"./Phonics/Images/frog.png": 159944,
	"./Phonics/Images/frogx.png": 662482,
	"./Phonics/Images/fun.png": 854991,
	"./Phonics/Images/funx.png": 38503,
	"./Phonics/Images/gag.png": 378159,
	"./Phonics/Images/gagx.png": 17159,
	"./Phonics/Images/game.png": 463340,
	"./Phonics/Images/gamex.png": 304798,
	"./Phonics/Images/gear.png": 43395,
	"./Phonics/Images/gearx.png": 387475,
	"./Phonics/Images/get.png": 710040,
	"./Phonics/Images/getx.png": 462562,
	"./Phonics/Images/gig.png": 181047,
	"./Phonics/Images/gigx.png": 219759,
	"./Phonics/Images/glee.png": 293829,
	"./Phonics/Images/gleex.png": 482521,
	"./Phonics/Images/got.png": 593050,
	"./Phonics/Images/gotx.png": 631240,
	"./Phonics/Images/grew.png": 531301,
	"./Phonics/Images/grewx.png": 536825,
	"./Phonics/Images/grey.png": 516779,
	"./Phonics/Images/greyx.png": 434843,
	"./Phonics/Images/grow.png": 485783,
	"./Phonics/Images/growx.png": 623503,
	"./Phonics/Images/hair.png": 452798,
	"./Phonics/Images/hairx.png": 834164,
	"./Phonics/Images/hand.png": 734625,
	"./Phonics/Images/handx.png": 993005,
	"./Phonics/Images/hat.png": 318139,
	"./Phonics/Images/hatx.png": 458091,
	"./Phonics/Images/hear.png": 602146,
	"./Phonics/Images/hit.png": 357139,
	"./Phonics/Images/hitx.png": 678883,
	"./Phonics/Images/hoe.png": 4280,
	"./Phonics/Images/hoex.png": 447170,
	"./Phonics/Images/home.png": 303375,
	"./Phonics/Images/homex.png": 166119,
	"./Phonics/Images/huff.png": 981175,
	"./Phonics/Images/huffx.png": 119087,
	"./Phonics/Images/hunt.png": 900189,
	"./Phonics/Images/huntx.png": 838225,
	"./Phonics/Images/hurt.png": 127953,
	"./Phonics/Images/hurtx.png": 379421,
	"./Phonics/Images/jeep.png": 620186,
	"./Phonics/Images/jeepx.png": 990344,
	"./Phonics/Images/joy.png": 903938,
	"./Phonics/Images/joyx.png": 646160,
	"./Phonics/Images/kick.png": 883692,
	"./Phonics/Images/kickx.png": 501214,
	"./Phonics/Images/king.png": 293295,
	"./Phonics/Images/kingx.png": 216327,
	"./Phonics/Images/kit.png": 210192,
	"./Phonics/Images/kitx.png": 820602,
	"./Phonics/Images/knew.png": 427773,
	"./Phonics/Images/knewx.png": 273329,
	"./Phonics/Images/lap.png": 886939,
	"./Phonics/Images/lapx.png": 396939,
	"./Phonics/Images/late.png": 901458,
	"./Phonics/Images/latex.png": 219680,
	"./Phonics/Images/lie.png": 795566,
	"./Phonics/Images/liex.png": 56804,
	"./Phonics/Images/lit.png": 490215,
	"./Phonics/Images/litx.png": 696543,
	"./Phonics/Images/loaf.png": 171879,
	"./Phonics/Images/loafx.png": 283206,
	"./Phonics/Images/look.png": 441487,
	"./Phonics/Images/lookx.png": 570535,
	"./Phonics/Images/lung.png": 384690,
	"./Phonics/Images/lungx.png": 479552,
	"./Phonics/Images/made.png": 488629,
	"./Phonics/Images/madex.png": 132169,
	"./Phonics/Images/make.png": 710732,
	"./Phonics/Images/makex.png": 692670,
	"./Phonics/Images/map.png": 951478,
	"./Phonics/Images/mapx.png": 138220,
	"./Phonics/Images/mat.png": 960594,
	"./Phonics/Images/matx.png": 326560,
	"./Phonics/Images/may.png": 40711,
	"./Phonics/Images/mayx.png": 381439,
	"./Phonics/Images/moth.png": 733934,
	"./Phonics/Images/mothx.png": 940260,
	"./Phonics/Images/mud.png": 436894,
	"./Phonics/Images/mudx.png": 86292,
	"./Phonics/Images/nag.png": 625394,
	"./Phonics/Images/nagx.png": 605312,
	"./Phonics/Images/name.png": 213495,
	"./Phonics/Images/namex.png": 127727,
	"./Phonics/Images/nap.png": 436509,
	"./Phonics/Images/napx.png": 336401,
	"./Phonics/Images/near.png": 492736,
	"./Phonics/Images/nearx.png": 907562,
	"./Phonics/Images/nest.png": 666956,
	"./Phonics/Images/nestx.png": 6270,
	"./Phonics/Images/net.png": 381997,
	"./Phonics/Images/netx.png": 444705,
	"./Phonics/Images/nip.png": 190997,
	"./Phonics/Images/nipx.png": 166505,
	"./Phonics/Images/not.png": 185971,
	"./Phonics/Images/notx.png": 396547,
	"./Phonics/Images/oil.png": 743356,
	"./Phonics/Images/oilx.png": 385774,
	"./Phonics/Images/out.png": 642640,
	"./Phonics/Images/outx.png": 222906,
	"./Phonics/Images/pan.png": 910361,
	"./Phonics/Images/panx.png": 523205,
	"./Phonics/Images/park.png": 45762,
	"./Phonics/Images/parkx.png": 939408,
	"./Phonics/Images/path.png": 171939,
	"./Phonics/Images/pathx.png": 528243,
	"./Phonics/Images/peg.png": 937604,
	"./Phonics/Images/pegx.png": 282742,
	"./Phonics/Images/pie.png": 159986,
	"./Phonics/Images/piex.png": 679808,
	"./Phonics/Images/pig.png": 553952,
	"./Phonics/Images/pigx.png": 287434,
	"./Phonics/Images/pink.png": 751958,
	"./Phonics/Images/pinkx.png": 219596,
	"./Phonics/Images/pit.png": 4331,
	"./Phonics/Images/pitx.png": 807643,
	"./Phonics/Images/play.png": 338084,
	"./Phonics/Images/playx.png": 586198,
	"./Phonics/Images/pop.png": 984301,
	"./Phonics/Images/popx.png": 923553,
	"./Phonics/Images/prey.png": 192450,
	"./Phonics/Images/preyx.png": 132048,
	"./Phonics/Images/puff.png": 105583,
	"./Phonics/Images/puffx.png": 865031,
	"./Phonics/Images/quit.png": 152411,
	"./Phonics/Images/quitx.png": 394123,
	"./Phonics/Images/quiz.png": 783701,
	"./Phonics/Images/quizx.png": 540713,
	"./Phonics/Images/ram.png": 828588,
	"./Phonics/Images/ramx.png": 873310,
	"./Phonics/Images/rat.png": 486941,
	"./Phonics/Images/ratx.png": 750225,
	"./Phonics/Images/rear.png": 43196,
	"./Phonics/Images/rearx.png": 94254,
	"./Phonics/Images/rot.png": 838639,
	"./Phonics/Images/rotx.png": 556039,
	"./Phonics/Images/row.png": 817172,
	"./Phonics/Images/rowx.png": 372678,
	"./Phonics/Images/rude.png": 467184,
	"./Phonics/Images/rudex.png": 502874,
	"./Phonics/Images/run.png": 439427,
	"./Phonics/Images/runx.png": 26643,
	"./Phonics/Images/sack.png": 640876,
	"./Phonics/Images/sackx.png": 519710,
	"./Phonics/Images/sad.png": 884256,
	"./Phonics/Images/sadx.png": 512970,
	"./Phonics/Images/same.png": 214856,
	"./Phonics/Images/samex.png": 728466,
	"./Phonics/Images/sand.png": 299284,
	"./Phonics/Images/sandx.png": 432838,
	"./Phonics/Images/sang.png": 990127,
	"./Phonics/Images/sangx.png": 208647,
	"./Phonics/Images/sat.png": 573840,
	"./Phonics/Images/satx.png": 434810,
	"./Phonics/Images/say.png": 18533,
	"./Phonics/Images/sayx.png": 8313,
	"./Phonics/Images/seat.png": 873281,
	"./Phonics/Images/seatx.png": 249677,
	"./Phonics/Images/seem.png": 501332,
	"./Phonics/Images/seemx.png": 568902,
	"./Phonics/Images/sell.png": 239778,
	"./Phonics/Images/sellx.png": 111600,
	"./Phonics/Images/shed.png": 437396,
	"./Phonics/Images/shedx.png": 774,
	"./Phonics/Images/sigh.png": 219059,
	"./Phonics/Images/sighx.png": 588227,
	"./Phonics/Images/slow.png": 387129,
	"./Phonics/Images/slowx.png": 638245,
	"./Phonics/Images/song.png": 483137,
	"./Phonics/Images/songx.png": 973261,
	"./Phonics/Images/stun.png": 758082,
	"./Phonics/Images/stunx.png": 339216,
	"./Phonics/Images/sun.png": 401094,
	"./Phonics/Images/sunx.png": 551356,
	"./Phonics/Images/sure.png": 280989,
	"./Phonics/Images/surex.png": 910033,
	"./Phonics/Images/tan.png": 778717,
	"./Phonics/Images/tanx.png": 440977,
	"./Phonics/Images/tap.png": 50531,
	"./Phonics/Images/tapx.png": 386099,
	"./Phonics/Images/tear.png": 442534,
	"./Phonics/Images/ten.png": 696065,
	"./Phonics/Images/tenx.png": 227277,
	"./Phonics/Images/thear.png": 166544,
	"./Phonics/Images/theard.png": 442086,
	"./Phonics/Images/them.png": 876,
	"./Phonics/Images/themx.png": 160734,
	"./Phonics/Images/thin.png": 891035,
	"./Phonics/Images/thinx.png": 479691,
	"./Phonics/Images/thud.png": 593917,
	"./Phonics/Images/thudx.png": 188081,
	"./Phonics/Images/tie.png": 312998,
	"./Phonics/Images/tiex.png": 954908,
	"./Phonics/Images/toad.png": 422382,
	"./Phonics/Images/toadx.png": 393252,
	"./Phonics/Images/toe.png": 829964,
	"./Phonics/Images/toex.png": 104382,
	"./Phonics/Images/toil.png": 797854,
	"./Phonics/Images/toilx.png": 656340,
	"./Phonics/Images/toy.png": 786928,
	"./Phonics/Images/toyx.png": 908762,
	"./Phonics/Images/tray.png": 800002,
	"./Phonics/Images/trayx.png": 797712,
	"./Phonics/Images/turn.png": 778871,
	"./Phonics/Images/turnx.png": 63599,
	"./Phonics/Images/urn.png": 626913,
	"./Phonics/Images/urnx.png": 305709,
	"./Phonics/Images/vat.png": 126689,
	"./Phonics/Images/vatx.png": 82093,
	"./Phonics/Images/way.png": 610529,
	"./Phonics/Images/wayx.png": 367853,
	"./Phonics/Images/when.png": 153826,
	"./Phonics/Images/whenx.png": 505648,
	"./Phonics/Images/with.png": 198750,
	"./Phonics/Images/withx.png": 470292,
	"./Phonics/Images/woke.png": 241508,
	"./Phonics/Images/wokex.png": 322006,
	"./Phonics/Images/worn.png": 658184,
	"./Phonics/Images/wornx.png": 854418,
	"./Phonics/Images/year.png": 723949,
	"./Phonics/Images/yell.png": 711436,
	"./Phonics/Images/yellx.png": 716222,
	"./Phonics/Images/yes.png": 284429,
	"./Phonics/Images/yesx.png": 105793,
	"./Phonics/Images/yet.png": 411922,
	"./Phonics/Images/yetx.png": 223712,
	"./Phonics/Images/yuck.png": 344474,
	"./Phonics/Images/yuckx.png": 265800,
	"./Phonics/Images/zear.png": 536148,
	"./Phonics/Images/zip.png": 816905,
	"./Phonics/Images/zipx.png": 301109,
	"./Phonics/crosshair.png": 238911,
	"./Phonics/ghost.png": 449454,
	"./Phonics/ghost_blue.png": 821535,
	"./Phonics/ghost_green.png": 137530,
	"./Phonics/ghost_red.png": 772382,
	"./Phonics/ghost_yellow.png": 470427,
	"./Phonics/phonicsmenu.gif": 567527,
	"./Ratios/Animation/combo0.gif": 621091,
	"./Ratios/Animation/combo1.gif": 255770,
	"./Ratios/Animation/combo2.gif": 509813,
	"./Ratios/Animation/combo3.gif": 71580,
	"./Ratios/Animation/combo4.gif": 885743,
	"./Ratios/RatiosLevel.png": 632773,
	"./Ratios/RatiosMenu.png": 872626,
	"./Shiny_Diamond.png": 85088,
	"./Spelling/Animation/Learn/round1.gif": 687103,
	"./Spelling/Animation/Learn/round2.png": 767627,
	"./Spelling/Animation/Learn/round3.gif": 921905,
	"./Spelling/Animation/Learn/round4.png": 942845,
	"./Spelling/Animation/Learn/transition1.png": 517451,
	"./Spelling/Animation/Learn/transition2.gif": 920575,
	"./Spelling/Animation/Learn/transition3.png": 844505,
	"./Spelling/Animation/combo0.gif": 488341,
	"./Spelling/Animation/combo1.gif": 1468,
	"./Spelling/Animation/combo2.gif": 313411,
	"./Spelling/Animation/combo3.gif": 383629,
	"./Spelling/Animation/combo4.gif": 89345,
	"./Spelling/SpellingLevel.png": 664625,
	"./Spelling/SpellingMenu.png": 694174,
	"./Spelling/SpellingRating.png": 133964,
	"./Spelling/menu_spelling.gif": 464644,
	"./Spelling/spatswords.csv": 688967,
	"./Spelling/spelling_rating.gif": 879664,
	"./Statistics/Animation/combo0.gif": 704932,
	"./Statistics/Animation/combo1.gif": 544189,
	"./Statistics/Animation/combo2.gif": 849378,
	"./Statistics/Animation/combo3.gif": 757451,
	"./Statistics/Animation/combo4.gif": 479728,
	"./Statistics/Images/Bar.png": 908012,
	"./Statistics/Images/BarBar.png": 787285,
	"./Statistics/Images/Elephant.png": 956596,
	"./Statistics/Images/ElephantHalf.png": 341319,
	"./Statistics/Images/Giraffe.png": 185687,
	"./Statistics/Images/GiraffeHalf.png": 35884,
	"./Statistics/Images/Line.png": 104685,
	"./Statistics/Images/LineGraph.png": 543653,
	"./Statistics/Images/LineGraph1.png": 876856,
	"./Statistics/Images/LineGraph2.png": 222611,
	"./Statistics/Images/LineGraph3.png": 67402,
	"./Statistics/Images/LineGraph4.png": 434277,
	"./Statistics/Images/Lion.png": 576933,
	"./Statistics/Images/LionHalf.png": 963310,
	"./Statistics/Images/Pictograph.png": 456690,
	"./Statistics/Images/Pie1.png": 552536,
	"./Statistics/Images/Pie2.png": 727027,
	"./Statistics/Images/Pie3.png": 876266,
	"./Statistics/Images/Pie4.png": 860933,
	"./Statistics/Images/Pie5.png": 543420,
	"./Statistics/Images/Sequence.png": 975508,
	"./Statistics/Images/Tally.png": 527445,
	"./Statistics/Images/Tally1.png": 50344,
	"./Statistics/Images/Tally2.png": 335619,
	"./Statistics/Images/Tally3.png": 18042,
	"./Statistics/Images/Tally4.png": 774549,
	"./Statistics/Images/Tally5.png": 405452,
	"./Statistics/Images/TallyLine.png": 675827,
	"./Statistics/Images/TallyStrike.png": 50643,
	"./Statistics/Images/TimeTable.png": 195938,
	"./Statistics/Images/Zebra.png": 935939,
	"./Statistics/Images/ZebraHalf.png": 648104,
	"./Statistics/StatisticsLevel.png": 210239,
	"./Statistics/StatisticsMenu.png": 442288,
	"./Statistics/StatisticsRating.png.png": 933857,
	"./Statistics/menu_statistics.gif": 272208,
	"./Statistics/statistics.gif": 148566,
	"./abydos-bg2.png": 870840,
	"./abydos-game-bg.png": 502943,
	"./abydos.png": 481702,
	"./algebra.png": 337360,
	"./audio-icon.png": 952574,
	"./background.png": 919754,
	"./battle_screen.png": 266885,
	"./commetior-bg.png": 672979,
	"./commetior-bg2.png": 528265,
	"./commetior-game-bg2.png": 207202,
	"./commetior.png": 514643,
	"./cup_bg.png": 442676,
	"./emile_left.png": 469204,
	"./equitas-bg.png": 642730,
	"./equitas.png": 136836,
	"./expert.png": 361590,
	"./fracture-bg.png": 419666,
	"./fracture.png": 773932,
	"./global-rank.png": 628624,
	"./heim-bg.png": 287689,
	"./heim.png": 673477,
	"./intervention.png": 430689,
	"./ks1_bg.png": 423949,
	"./ks1cupbg.png": 325122,
	"./ks1fixed.png": 819193,
	"./ks1icon.png": 657236,
	"./logo.png": 260283,
	"./master.png": 756788,
	"./maths_assessments/arithmetic.csv": 644494,
	"./maths_assessments/assets/Back.png": 388067,
	"./maths_assessments/assets/Back_old.png": 364121,
	"./maths_assessments/assets/Blank.png": 112250,
	"./maths_assessments/assets/Block/2length&height1.png": 294868,
	"./maths_assessments/assets/Block/2length&height10.png": 458222,
	"./maths_assessments/assets/Block/2length&height2.png": 316335,
	"./maths_assessments/assets/Block/2length&height3.png": 734790,
	"./maths_assessments/assets/Block/2length&height4.png": 337209,
	"./maths_assessments/assets/Block/2length&height5.png": 330960,
	"./maths_assessments/assets/Block/2length&height6.png": 244779,
	"./maths_assessments/assets/Block/2length&height7.png": 870626,
	"./maths_assessments/assets/Block/2length&height8.png": 775653,
	"./maths_assessments/assets/Block/2length&height9.png": 539740,
	"./maths_assessments/assets/Block/2measurement1.png": 682017,
	"./maths_assessments/assets/Block/2measurement10.png": 128437,
	"./maths_assessments/assets/Block/2measurement11.png": 892524,
	"./maths_assessments/assets/Block/2measurement12.png": 795175,
	"./maths_assessments/assets/Block/2measurement2.png": 733034,
	"./maths_assessments/assets/Block/2measurement3.png": 888243,
	"./maths_assessments/assets/Block/2measurement4.png": 188284,
	"./maths_assessments/assets/Block/2measurement5.png": 717701,
	"./maths_assessments/assets/Block/2measurement6.png": 845902,
	"./maths_assessments/assets/Block/2measurement7.png": 988919,
	"./maths_assessments/assets/Block/2measurement8.png": 38384,
	"./maths_assessments/assets/Block/2measurement9.png": 635289,
	"./maths_assessments/assets/Block/2measurements1.png": 43090,
	"./maths_assessments/assets/Block/2measurements10.png": 177992,
	"./maths_assessments/assets/Block/2measurements11.png": 688209,
	"./maths_assessments/assets/Block/2measurements12.png": 267098,
	"./maths_assessments/assets/Block/2measurements2.png": 133801,
	"./maths_assessments/assets/Block/2measurements3.png": 678976,
	"./maths_assessments/assets/Block/2measurements4.png": 113951,
	"./maths_assessments/assets/Block/2measurements5.png": 33974,
	"./maths_assessments/assets/Block/2measurements6.png": 915597,
	"./maths_assessments/assets/Block/2measurements7.png": 675652,
	"./maths_assessments/assets/Block/2measurements8.png": 133315,
	"./maths_assessments/assets/Block/2measurements9.png": 815738,
	"./maths_assessments/assets/Block/2position1.png": 170808,
	"./maths_assessments/assets/Block/2position2.png": 516563,
	"./maths_assessments/assets/Block/2position3.png": 361354,
	"./maths_assessments/assets/Block/2position4.png": 728229,
	"./maths_assessments/assets/Block/2position5.png": 161692,
	"./maths_assessments/assets/Block/2position6.png": 903447,
	"./maths_assessments/assets/Block/2position7.png": 474222,
	"./maths_assessments/assets/Block/2time1.png": 881590,
	"./maths_assessments/assets/Block/2time10.png": 642852,
	"./maths_assessments/assets/Block/2time11.png": 169005,
	"./maths_assessments/assets/Block/2time2.png": 763213,
	"./maths_assessments/assets/Block/2time3.png": 523268,
	"./maths_assessments/assets/Block/2time4.png": 304923,
	"./maths_assessments/assets/Block/2time5.png": 890706,
	"./maths_assessments/assets/Block/2time6.png": 981417,
	"./maths_assessments/assets/Block/2time7.png": 526592,
	"./maths_assessments/assets/Block/2time8.png": 970823,
	"./maths_assessments/assets/Block/2time9.png": 252510,
	"./maths_assessments/assets/Block/3fractions1.png": 680547,
	"./maths_assessments/assets/Block/3fractions10.png": 504011,
	"./maths_assessments/assets/Block/3fractions11.png": 740354,
	"./maths_assessments/assets/Block/3fractions2.png": 343688,
	"./maths_assessments/assets/Block/3fractions3.png": 337553,
	"./maths_assessments/assets/Block/3fractions4.png": 654462,
	"./maths_assessments/assets/Block/3fractions5.png": 923303,
	"./maths_assessments/assets/Block/3fractions6.png": 504300,
	"./maths_assessments/assets/Block/3fractions7.png": 256565,
	"./maths_assessments/assets/Block/3fractions8.png": 869362,
	"./maths_assessments/assets/Block/3fractions9.png": 100539,
	"./maths_assessments/assets/Block/3measurements1.png": 815317,
	"./maths_assessments/assets/Block/3measurements10.png": 428593,
	"./maths_assessments/assets/Block/3measurements11.png": 14376,
	"./maths_assessments/assets/Block/3measurements12.png": 299651,
	"./maths_assessments/assets/Block/3measurements2.png": 978590,
	"./maths_assessments/assets/Block/3measurements3.png": 154375,
	"./maths_assessments/assets/Block/3measurements4.png": 574760,
	"./maths_assessments/assets/Block/3measurements5.png": 23153,
	"./maths_assessments/assets/Block/3measurements6.png": 846906,
	"./maths_assessments/assets/Block/3measurements7.png": 436739,
	"./maths_assessments/assets/Block/3measurements8.png": 436548,
	"./maths_assessments/assets/Block/3measurements9.png": 616141,
	"./maths_assessments/assets/Block/3shapes1.png": 71638,
	"./maths_assessments/assets/Block/3shapes10.png": 500484,
	"./maths_assessments/assets/Block/3shapes2.png": 462317,
	"./maths_assessments/assets/Block/3shapes3.png": 419812,
	"./maths_assessments/assets/Block/3shapes4.png": 829755,
	"./maths_assessments/assets/Block/3shapes5.png": 80754,
	"./maths_assessments/assets/Block/3shapes6.png": 445897,
	"./maths_assessments/assets/Block/3shapes7.png": 474720,
	"./maths_assessments/assets/Block/3shapes8.png": 618343,
	"./maths_assessments/assets/Block/3shapes9.png": 230654,
	"./maths_assessments/assets/Block/3time1.png": 316465,
	"./maths_assessments/assets/Block/3time10.png": 887045,
	"./maths_assessments/assets/Block/3time11.png": 873980,
	"./maths_assessments/assets/Block/3time2.png": 386298,
	"./maths_assessments/assets/Block/3time3.png": 187523,
	"./maths_assessments/assets/Block/3time4.png": 257356,
	"./maths_assessments/assets/Block/3time5.png": 142805,
	"./maths_assessments/assets/Block/3time6.png": 975454,
	"./maths_assessments/assets/Block/3time7.png": 177415,
	"./maths_assessments/assets/Block/3time8.png": 733184,
	"./maths_assessments/assets/Block/3time9.png": 704361,
	"./maths_assessments/assets/Block/4decimals1.png": 700937,
	"./maths_assessments/assets/Block/4decimals10.png": 933997,
	"./maths_assessments/assets/Block/4decimals2.png": 369970,
	"./maths_assessments/assets/Block/4decimals3.png": 84795,
	"./maths_assessments/assets/Block/4decimals4.png": 920932,
	"./maths_assessments/assets/Block/4decimals5.png": 174829,
	"./maths_assessments/assets/Block/4decimals6.png": 360854,
	"./maths_assessments/assets/Block/4decimals7.png": 257791,
	"./maths_assessments/assets/Block/4decimals8.png": 327944,
	"./maths_assessments/assets/Block/4decimals9.png": 838161,
	"./maths_assessments/assets/Block/4position1.png": 263066,
	"./maths_assessments/assets/Block/4position2.png": 684177,
	"./maths_assessments/assets/Block/4position3.png": 173960,
	"./maths_assessments/assets/Block/4position4.png": 753575,
	"./maths_assessments/assets/Block/4position5.png": 1086,
	"./maths_assessments/assets/Block/4position6.png": 86837,
	"./maths_assessments/assets/Block/4position7.png": 850924,
	"./maths_assessments/assets/Block/4position8.png": 930811,
	"./maths_assessments/assets/Block/4shapes1.png": 910927,
	"./maths_assessments/assets/Block/4shapes2.png": 988468,
	"./maths_assessments/assets/Block/4shapes3.png": 209597,
	"./maths_assessments/assets/Block/4shapes4.png": 516802,
	"./maths_assessments/assets/Block/4shapes5.png": 280459,
	"./maths_assessments/assets/Block/4shapes6.png": 315056,
	"./maths_assessments/assets/Block/4shapes7.png": 30809,
	"./maths_assessments/assets/Block/4shapes8.png": 215246,
	"./maths_assessments/assets/Block/4statistics1.png": 852026,
	"./maths_assessments/assets/Block/4statistics2.png": 28273,
	"./maths_assessments/assets/Block/4statistics3.png": 579880,
	"./maths_assessments/assets/Block/4statistics4.png": 159495,
	"./maths_assessments/assets/Block/4statistics5.png": 983710,
	"./maths_assessments/assets/Block/4statistics6.png": 304085,
	"./maths_assessments/assets/Block/4statistics7.png": 908812,
	"./maths_assessments/assets/Block/4statistics8.png": 96475,
	"./maths_assessments/assets/Block/4time1.png": 584888,
	"./maths_assessments/assets/Block/4time2.png": 930643,
	"./maths_assessments/assets/Block/4time3.png": 291786,
	"./maths_assessments/assets/Block/4time4.png": 658661,
	"./maths_assessments/assets/Block/4time5.png": 575772,
	"./maths_assessments/assets/Block/4time6.png": 833879,
	"./maths_assessments/assets/Block/4time7.png": 888302,
	"./maths_assessments/assets/Block/4time8.png": 220217,
	"./maths_assessments/assets/Block/4time9.png": 213968,
	"./maths_assessments/assets/Block/5decimals1.png": 630782,
	"./maths_assessments/assets/Block/5decimals10.png": 156220,
	"./maths_assessments/assets/Block/5decimals11.png": 685637,
	"./maths_assessments/assets/Block/5decimals12.png": 813838,
	"./maths_assessments/assets/Block/5decimals2.png": 716533,
	"./maths_assessments/assets/Block/5decimals3.png": 964268,
	"./maths_assessments/assets/Block/5decimals4.png": 140515,
	"./maths_assessments/assets/Block/5decimals5.png": 892762,
	"./maths_assessments/assets/Block/5decimals6.png": 797521,
	"./maths_assessments/assets/Block/5decimals7.png": 803656,
	"./maths_assessments/assets/Block/5decimals8.png": 733503,
	"./maths_assessments/assets/Block/5decimals9.png": 320214,
	"./maths_assessments/assets/Block/5shapes1.png": 804960,
	"./maths_assessments/assets/Block/5shapes2.png": 66939,
	"./maths_assessments/assets/Block/5shapes3.png": 352114,
	"./maths_assessments/assets/Block/5shapes4.png": 156973,
	"./maths_assessments/assets/Block/5shapes5.png": 903076,
	"./maths_assessments/assets/Block/5shapes6.png": 239935,
	"./maths_assessments/assets/Block/5shapes7.png": 342998,
	"./maths_assessments/assets/Block/5shapes8.png": 820305,
	"./maths_assessments/assets/Block/5shapes9.png": 310088,
	"./maths_assessments/assets/Block/5units1.png": 660525,
	"./maths_assessments/assets/Block/5units10.png": 259673,
	"./maths_assessments/assets/Block/5units11.png": 662768,
	"./maths_assessments/assets/Block/5units12.png": 932619,
	"./maths_assessments/assets/Block/5units13.png": 711490,
	"./maths_assessments/assets/Block/5units14.png": 107837,
	"./maths_assessments/assets/Block/5units2.png": 846550,
	"./maths_assessments/assets/Block/5units3.png": 743487,
	"./maths_assessments/assets/Block/5units4.png": 308512,
	"./maths_assessments/assets/Block/5units5.png": 186633,
	"./maths_assessments/assets/Block/5units6.png": 855666,
	"./maths_assessments/assets/Block/5units7.png": 570491,
	"./maths_assessments/assets/Block/5units8.png": 490604,
	"./maths_assessments/assets/Block/5units9.png": 726517,
	"./maths_assessments/assets/Block/5volume1.png": 647544,
	"./maths_assessments/assets/Block/5volume2.png": 993299,
	"./maths_assessments/assets/Block/5volume3.png": 354442,
	"./maths_assessments/assets/Block/5volume4.png": 721317,
	"./maths_assessments/assets/Block/6shapes1.png": 105825,
	"./maths_assessments/assets/Block/6shapes2.png": 156842,
	"./maths_assessments/assets/Block/6shapes3.png": 795699,
	"./maths_assessments/assets/Block/6shapes4.png": 612092,
	"./maths_assessments/assets/Block/6shapes5.png": 141509,
	"./maths_assessments/assets/Block/6shapes6.png": 753358,
	"./maths_assessments/assets/Block/6shapes7.png": 412727,
	"./maths_assessments/assets/Block/6shapes8.png": 945840,
	"./maths_assessments/assets/Block/6shapes9.png": 542745,
	"./maths_assessments/assets/Block/6statistics1.png": 259868,
	"./maths_assessments/assets/Block/6statistics2.png": 1623,
	"./maths_assessments/assets/Block/6statistics3.png": 572398,
	"./maths_assessments/assets/Block/6statistics4.png": 490113,
	"./maths_assessments/assets/Block/6statistics5.png": 268984,
	"./maths_assessments/assets/Block/6statistics6.png": 614739,
	"./maths_assessments/assets/Block/6statistics7.png": 459530,
	"./maths_assessments/assets/Block/6statistics8.png": 236125,
	"./maths_assessments/assets/BlockAutumn/2autumnaddition&subtraction1.png": 352447,
	"./maths_assessments/assets/BlockAutumn/2autumnaddition&subtraction2.png": 438884,
	"./maths_assessments/assets/BlockAutumn/2autumnaddition&subtraction3.png": 965037,
	"./maths_assessments/assets/BlockAutumn/2autumnaddition&subtraction4.png": 583474,
	"./maths_assessments/assets/BlockAutumn/2autumnaddition&subtraction5.png": 848827,
	"./maths_assessments/assets/BlockAutumn/2autumnaddition&subtraction6.png": 493792,
	"./maths_assessments/assets/BlockAutumn/2autumnaddition&subtraction7.png": 948617,
	"./maths_assessments/assets/BlockAutumn/2autumnaddition&subtraction8.png": 249726,
	"./maths_assessments/assets/BlockAutumn/2autumnaddition&subtraction9.png": 121063,
	"./maths_assessments/assets/BlockAutumn/2autumnmoney1.png": 991769,
	"./maths_assessments/assets/BlockAutumn/2autumnmoney10.png": 870397,
	"./maths_assessments/assets/BlockAutumn/2autumnmoney2.png": 443586,
	"./maths_assessments/assets/BlockAutumn/2autumnmoney3.png": 664715,
	"./maths_assessments/assets/BlockAutumn/2autumnmoney4.png": 618804,
	"./maths_assessments/assets/BlockAutumn/2autumnmoney5.png": 839933,
	"./maths_assessments/assets/BlockAutumn/2autumnmoney6.png": 798694,
	"./maths_assessments/assets/BlockAutumn/2autumnmoney7.png": 837711,
	"./maths_assessments/assets/BlockAutumn/2autumnmoney8.png": 70232,
	"./maths_assessments/assets/BlockAutumn/2autumnmoney9.png": 554849,
	"./maths_assessments/assets/BlockAutumn/2autumnmultiplication1.png": 82933,
	"./maths_assessments/assets/BlockAutumn/2autumnmultiplication2.png": 480830,
	"./maths_assessments/assets/BlockAutumn/2autumnmultiplication3.png": 749671,
	"./maths_assessments/assets/BlockAutumn/2autumnmultiplication4.png": 170056,
	"./maths_assessments/assets/BlockAutumn/2autumnmultiplication5.png": 163921,
	"./maths_assessments/assets/BlockAutumn/2autumnmultiplication6.png": 742810,
	"./maths_assessments/assets/BlockAutumn/2autumnmultiplication7.png": 506915,
	"./maths_assessments/assets/BlockAutumn/2autumnplacevalue1.png": 786531,
	"./maths_assessments/assets/BlockAutumn/2autumnplacevalue10.png": 795467,
	"./maths_assessments/assets/BlockAutumn/2autumnplacevalue11.png": 31810,
	"./maths_assessments/assets/BlockAutumn/2autumnplacevalue2.png": 933320,
	"./maths_assessments/assets/BlockAutumn/2autumnplacevalue3.png": 443537,
	"./maths_assessments/assets/BlockAutumn/2autumnplacevalue4.png": 760446,
	"./maths_assessments/assets/BlockAutumn/2autumnplacevalue5.png": 512935,
	"./maths_assessments/assets/BlockAutumn/2autumnplacevalue6.png": 610284,
	"./maths_assessments/assets/BlockAutumn/2autumnplacevalue7.png": 846197,
	"./maths_assessments/assets/BlockAutumn/2autumnplacevalue8.png": 975346,
	"./maths_assessments/assets/BlockAutumn/2autumnplacevalue9.png": 690171,
	"./maths_assessments/assets/BlockAutumn/3autumnaddition&subtraction1.png": 210680,
	"./maths_assessments/assets/BlockAutumn/3autumnaddition&subtraction10.png": 781930,
	"./maths_assessments/assets/BlockAutumn/3autumnaddition&subtraction2.png": 556435,
	"./maths_assessments/assets/BlockAutumn/3autumnaddition&subtraction3.png": 917578,
	"./maths_assessments/assets/BlockAutumn/3autumnaddition&subtraction4.png": 284453,
	"./maths_assessments/assets/BlockAutumn/3autumnaddition&subtraction5.png": 201564,
	"./maths_assessments/assets/BlockAutumn/3autumnaddition&subtraction6.png": 459671,
	"./maths_assessments/assets/BlockAutumn/3autumnaddition&subtraction7.png": 514094,
	"./maths_assessments/assets/BlockAutumn/3autumnaddition&subtraction8.png": 846009,
	"./maths_assessments/assets/BlockAutumn/3autumnaddition&subtraction9.png": 839760,
	"./maths_assessments/assets/BlockAutumn/3autumnmultiplication&division1.png": 241547,
	"./maths_assessments/assets/BlockAutumn/3autumnmultiplication&division2.png": 276144,
	"./maths_assessments/assets/BlockAutumn/3autumnmultiplication&division3.png": 991897,
	"./maths_assessments/assets/BlockAutumn/3autumnmultiplication&division4.png": 103270,
	"./maths_assessments/assets/BlockAutumn/3autumnmultiplication&division5.png": 872015,
	"./maths_assessments/assets/BlockAutumn/3autumnmultiplication&division6.png": 949556,
	"./maths_assessments/assets/BlockAutumn/3autumnmultiplication&division7.png": 170685,
	"./maths_assessments/assets/BlockAutumn/3autumnmultiplication&division8.png": 394090,
	"./maths_assessments/assets/BlockAutumn/3autumnmultiplication&division9.png": 244851,
	"./maths_assessments/assets/BlockAutumn/3autumnplacevalue1.png": 343684,
	"./maths_assessments/assets/BlockAutumn/3autumnplacevalue2.png": 298335,
	"./maths_assessments/assets/BlockAutumn/3autumnplacevalue3.png": 702006,
	"./maths_assessments/assets/BlockAutumn/3autumnplacevalue4.png": 318185,
	"./maths_assessments/assets/BlockAutumn/3autumnplacevalue5.png": 347008,
	"./maths_assessments/assets/BlockAutumn/3autumnplacevalue6.png": 125339,
	"./maths_assessments/assets/BlockAutumn/3autumnplacevalue7.png": 711122,
	"./maths_assessments/assets/BlockAutumn/3autumnplacevalue8.png": 240277,
	"./maths_assessments/assets/BlockAutumn/3autumnplacevalue9.png": 871180,
	"./maths_assessments/assets/BlockAutumn/4autumnaddition&subtraction1.png": 945589,
	"./maths_assessments/assets/BlockAutumn/4autumnaddition&subtraction10.png": 323857,
	"./maths_assessments/assets/BlockAutumn/4autumnaddition&subtraction2.png": 859838,
	"./maths_assessments/assets/BlockAutumn/4autumnaddition&subtraction3.png": 612327,
	"./maths_assessments/assets/BlockAutumn/4autumnaddition&subtraction4.png": 32712,
	"./maths_assessments/assets/BlockAutumn/4autumnaddition&subtraction5.png": 542929,
	"./maths_assessments/assets/BlockAutumn/4autumnaddition&subtraction6.png": 121818,
	"./maths_assessments/assets/BlockAutumn/4autumnaddition&subtraction7.png": 369571,
	"./maths_assessments/assets/BlockAutumn/4autumnaddition&subtraction8.png": 625700,
	"./maths_assessments/assets/BlockAutumn/4autumnaddition&subtraction9.png": 879597,
	"./maths_assessments/assets/BlockAutumn/4autumnlength&perimeter1.png": 317196,
	"./maths_assessments/assets/BlockAutumn/4autumnlength&perimeter2.png": 84231,
	"./maths_assessments/assets/BlockAutumn/4autumnlength&perimeter3.png": 908446,
	"./maths_assessments/assets/BlockAutumn/4autumnlength&perimeter4.png": 953009,
	"./maths_assessments/assets/BlockAutumn/4autumnlength&perimeter5.png": 504616,
	"./maths_assessments/assets/BlockAutumn/4autumnlength&perimeter6.png": 366595,
	"./maths_assessments/assets/BlockAutumn/4autumnlength&perimeter7.png": 776762,
	"./maths_assessments/assets/BlockAutumn/4autumnlength&perimeter8.png": 29645,
	"./maths_assessments/assets/BlockAutumn/4autumnmultiplication&division1.png": 958396,
	"./maths_assessments/assets/BlockAutumn/4autumnmultiplication&division10.png": 879110,
	"./maths_assessments/assets/BlockAutumn/4autumnmultiplication&division2.png": 759031,
	"./maths_assessments/assets/BlockAutumn/4autumnmultiplication&division3.png": 616014,
	"./maths_assessments/assets/BlockAutumn/4autumnmultiplication&division4.png": 452129,
	"./maths_assessments/assets/BlockAutumn/4autumnmultiplication&division5.png": 483864,
	"./maths_assessments/assets/BlockAutumn/4autumnmultiplication&division6.png": 658355,
	"./maths_assessments/assets/BlockAutumn/4autumnmultiplication&division7.png": 503146,
	"./maths_assessments/assets/BlockAutumn/4autumnmultiplication&division8.png": 737213,
	"./maths_assessments/assets/BlockAutumn/4autumnmultiplication&division9.png": 516084,
	"./maths_assessments/assets/BlockAutumn/4autumnplacevalue1.png": 430957,
	"./maths_assessments/assets/BlockAutumn/4autumnplacevalue2.png": 40278,
	"./maths_assessments/assets/BlockAutumn/4autumnplacevalue3.png": 302015,
	"./maths_assessments/assets/BlockAutumn/4autumnplacevalue4.png": 443360,
	"./maths_assessments/assets/BlockAutumn/4autumnplacevalue5.png": 414537,
	"./maths_assessments/assets/BlockAutumn/4autumnplacevalue6.png": 49394,
	"./maths_assessments/assets/BlockAutumn/4autumnplacevalue7.png": 798395,
	"./maths_assessments/assets/BlockAutumn/4autumnplacevalue8.png": 718508,
	"./maths_assessments/assets/BlockAutumn/4autumnplacevalue9.png": 801397,
	"./maths_assessments/assets/BlockAutumn/5autumnaddition&subtraction1.png": 705126,
	"./maths_assessments/assets/BlockAutumn/5autumnaddition&subtraction10.png": 771604,
	"./maths_assessments/assets/BlockAutumn/5autumnaddition&subtraction2.png": 288893,
	"./maths_assessments/assets/BlockAutumn/5autumnaddition&subtraction3.png": 67764,
	"./maths_assessments/assets/BlockAutumn/5autumnaddition&subtraction4.png": 359755,
	"./maths_assessments/assets/BlockAutumn/5autumnaddition&subtraction5.png": 596098,
	"./maths_assessments/assets/BlockAutumn/5autumnaddition&subtraction6.png": 110105,
	"./maths_assessments/assets/BlockAutumn/5autumnaddition&subtraction7.png": 878000,
	"./maths_assessments/assets/BlockAutumn/5autumnaddition&subtraction8.png": 768183,
	"./maths_assessments/assets/BlockAutumn/5autumnaddition&subtraction9.png": 778190,
	"./maths_assessments/assets/BlockAutumn/5autumnarea&perimeter1.png": 212802,
	"./maths_assessments/assets/BlockAutumn/5autumnarea&perimeter10.png": 841912,
	"./maths_assessments/assets/BlockAutumn/5autumnarea&perimeter11.png": 63041,
	"./maths_assessments/assets/BlockAutumn/5autumnarea&perimeter2.png": 760985,
	"./maths_assessments/assets/BlockAutumn/5autumnarea&perimeter3.png": 680432,
	"./maths_assessments/assets/BlockAutumn/5autumnarea&perimeter4.png": 606927,
	"./maths_assessments/assets/BlockAutumn/5autumnarea&perimeter5.png": 567910,
	"./maths_assessments/assets/BlockAutumn/5autumnarea&perimeter6.png": 609149,
	"./maths_assessments/assets/BlockAutumn/5autumnarea&perimeter7.png": 388020,
	"./maths_assessments/assets/BlockAutumn/5autumnarea&perimeter8.png": 13939,
	"./maths_assessments/assets/BlockAutumn/5autumnarea&perimeter9.png": 375082,
	"./maths_assessments/assets/BlockAutumn/5autumnmultiplication&division1.png": 532625,
	"./maths_assessments/assets/BlockAutumn/5autumnmultiplication&division10.png": 786021,
	"./maths_assessments/assets/BlockAutumn/5autumnmultiplication&division11.png": 550108,
	"./maths_assessments/assets/BlockAutumn/5autumnmultiplication&division2.png": 627866,
	"./maths_assessments/assets/BlockAutumn/5autumnmultiplication&division3.png": 875619,
	"./maths_assessments/assets/BlockAutumn/5autumnmultiplication&division4.png": 699372,
	"./maths_assessments/assets/BlockAutumn/5autumnmultiplication&division5.png": 451637,
	"./maths_assessments/assets/BlockAutumn/5autumnmultiplication&division6.png": 143505,
	"./maths_assessments/assets/BlockAutumn/5autumnmultiplication&division7.png": 118375,
	"./maths_assessments/assets/BlockAutumn/5autumnmultiplication&division8.png": 517280,
	"./maths_assessments/assets/BlockAutumn/5autumnmultiplication&division9.png": 395401,
	"./maths_assessments/assets/BlockAutumn/5autumnplacevalue1.png": 653038,
	"./maths_assessments/assets/BlockAutumn/5autumnplacevalue10.png": 81196,
	"./maths_assessments/assets/BlockAutumn/5autumnplacevalue11.png": 833461,
	"./maths_assessments/assets/BlockAutumn/5autumnplacevalue2.png": 880869,
	"./maths_assessments/assets/BlockAutumn/5autumnplacevalue3.png": 644956,
	"./maths_assessments/assets/BlockAutumn/5autumnplacevalue4.png": 542355,
	"./maths_assessments/assets/BlockAutumn/5autumnplacevalue5.png": 810442,
	"./maths_assessments/assets/BlockAutumn/5autumnplacevalue6.png": 967873,
	"./maths_assessments/assets/BlockAutumn/5autumnplacevalue7.png": 230392,
	"./maths_assessments/assets/BlockAutumn/5autumnplacevalue8.png": 421551,
	"./maths_assessments/assets/BlockAutumn/5autumnplacevalue9.png": 840006,
	"./maths_assessments/assets/BlockAutumn/5autumnstatistics1.png": 821757,
	"./maths_assessments/assets/BlockAutumn/5autumnstatistics2.png": 754342,
	"./maths_assessments/assets/BlockAutumn/5autumnstatistics3.png": 523087,
	"./maths_assessments/assets/BlockAutumn/5autumnstatistics4.png": 927216,
	"./maths_assessments/assets/BlockAutumn/5autumnstatistics5.png": 642969,
	"./maths_assessments/assets/BlockAutumn/5autumnstatistics6.png": 128962,
	"./maths_assessments/assets/BlockAutumn/5autumnstatistics7.png": 892619,
	"./maths_assessments/assets/BlockAutumn/5autumnstatistics8.png": 712316,
	"./maths_assessments/assets/BlockAutumn/5autumnstatistics9.png": 29829,
	"./maths_assessments/assets/BlockAutumn/6autumnadding&subtractingfractions1.png": 816935,
	"./maths_assessments/assets/BlockAutumn/6autumnadding&subtractingfractions10.png": 70791,
	"./maths_assessments/assets/BlockAutumn/6autumnadding&subtractingfractions2.png": 948460,
	"./maths_assessments/assets/BlockAutumn/6autumnadding&subtractingfractions3.png": 31349,
	"./maths_assessments/assets/BlockAutumn/6autumnadding&subtractingfractions4.png": 657050,
	"./maths_assessments/assets/BlockAutumn/6autumnadding&subtractingfractions5.png": 878627,
	"./maths_assessments/assets/BlockAutumn/6autumnadding&subtractingfractions6.png": 25416,
	"./maths_assessments/assets/BlockAutumn/6autumnadding&subtractingfractions7.png": 781713,
	"./maths_assessments/assets/BlockAutumn/6autumnadding&subtractingfractions8.png": 270230,
	"./maths_assessments/assets/BlockAutumn/6autumnadding&subtractingfractions9.png": 531967,
	"./maths_assessments/assets/BlockAutumn/6autumnmultiplying&dividingfractions1.png": 780574,
	"./maths_assessments/assets/BlockAutumn/6autumnmultiplying&dividingfractions10.png": 970012,
	"./maths_assessments/assets/BlockAutumn/6autumnmultiplying&dividingfractions11.png": 536549,
	"./maths_assessments/assets/BlockAutumn/6autumnmultiplying&dividingfractions12.png": 282542,
	"./maths_assessments/assets/BlockAutumn/6autumnmultiplying&dividingfractions13.png": 711767,
	"./maths_assessments/assets/BlockAutumn/6autumnmultiplying&dividingfractions2.png": 947925,
	"./maths_assessments/assets/BlockAutumn/6autumnmultiplying&dividingfractions3.png": 578828,
	"./maths_assessments/assets/BlockAutumn/6autumnmultiplying&dividingfractions4.png": 508995,
	"./maths_assessments/assets/BlockAutumn/6autumnmultiplying&dividingfractions5.png": 191418,
	"./maths_assessments/assets/BlockAutumn/6autumnmultiplying&dividingfractions6.png": 121585,
	"./maths_assessments/assets/BlockAutumn/6autumnmultiplying&dividingfractions7.png": 223720,
	"./maths_assessments/assets/BlockAutumn/6autumnmultiplying&dividingfractions8.png": 5983,
	"./maths_assessments/assets/BlockAutumn/6autumnmultiplying&dividingfractions9.png": 409654,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations1.png": 323037,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations10.png": 182985,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations11.png": 304864,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations12.png": 566843,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations2.png": 541830,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations21.png": 934653,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations210.png": 230953,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations22.png": 867238,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations23.png": 635983,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations24.png": 40112,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations25.png": 755865,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations26.png": 241858,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations27.png": 5515,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations28.png": 825212,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations29.png": 142725,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations3.png": 607023,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations4.png": 138000,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations5.png": 144249,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations6.png": 161314,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations7.png": 51819,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations8.png": 830428,
	"./maths_assessments/assets/BlockAutumn/6autumnoperations9.png": 582693,
	"./maths_assessments/assets/BlockAutumn/6autumnplacevalue1.png": 814383,
	"./maths_assessments/assets/BlockAutumn/6autumnplacevalue2.png": 309268,
	"./maths_assessments/assets/BlockAutumn/6autumnplacevalue3.png": 530397,
	"./maths_assessments/assets/BlockAutumn/6autumnplacevalue4.png": 146293,
	"./maths_assessments/assets/BlockAutumn/6autumnplacevalue5.png": 259179,
	"./maths_assessments/assets/BlockAutumn/6autumnplacevalue6.png": 345360,
	"./maths_assessments/assets/BlockAutumn/6autumnplacevalue7.png": 351609,
	"./maths_assessments/assets/BlockAutumn/6autumnpositions&directions1.png": 485403,
	"./maths_assessments/assets/BlockAutumn/6autumnpositions&directions2.png": 707072,
	"./maths_assessments/assets/BlockAutumn/6autumnpositions&directions3.png": 678249,
	"./maths_assessments/assets/BlockAutumn/6autumnpositions&directions4.png": 62070,
	"./maths_assessments/assets/BlockAutumn/6autumnpositions&directions5.png": 658399,
	"./maths_assessments/assets/BlockAutumn/6autumnpositions&directions6.png": 703748,
	"./maths_assessments/assets/BlockSpring/2springdivision1.png": 5408,
	"./maths_assessments/assets/BlockSpring/2springdivision10.png": 891810,
	"./maths_assessments/assets/BlockSpring/2springdivision11.png": 782315,
	"./maths_assessments/assets/BlockSpring/2springdivision12.png": 868496,
	"./maths_assessments/assets/BlockSpring/2springdivision13.png": 874745,
	"./maths_assessments/assets/BlockSpring/2springdivision14.png": 272326,
	"./maths_assessments/assets/BlockSpring/2springdivision2.png": 267387,
	"./maths_assessments/assets/BlockSpring/2springdivision3.png": 552562,
	"./maths_assessments/assets/BlockSpring/2springdivision4.png": 357421,
	"./maths_assessments/assets/BlockSpring/2springdivision5.png": 103524,
	"./maths_assessments/assets/BlockSpring/2springdivision6.png": 440383,
	"./maths_assessments/assets/BlockSpring/2springdivision7.png": 543446,
	"./maths_assessments/assets/BlockSpring/2springdivision8.png": 20753,
	"./maths_assessments/assets/BlockSpring/2springdivision9.png": 510536,
	"./maths_assessments/assets/BlockSpring/2springfractions1.png": 627622,
	"./maths_assessments/assets/BlockSpring/2springfractions2.png": 668861,
	"./maths_assessments/assets/BlockSpring/2springfractions3.png": 447732,
	"./maths_assessments/assets/BlockSpring/2springfractions4.png": 493643,
	"./maths_assessments/assets/BlockSpring/2springfractions5.png": 272514,
	"./maths_assessments/assets/BlockSpring/2springfractions6.png": 820697,
	"./maths_assessments/assets/BlockSpring/2springfractions7.png": 223792,
	"./maths_assessments/assets/BlockSpring/2springshapes1.png": 856497,
	"./maths_assessments/assets/BlockSpring/2springshapes10.png": 617413,
	"./maths_assessments/assets/BlockSpring/2springshapes11.png": 299900,
	"./maths_assessments/assets/BlockSpring/2springshapes2.png": 680250,
	"./maths_assessments/assets/BlockSpring/2springshapes3.png": 786435,
	"./maths_assessments/assets/BlockSpring/2springshapes4.png": 737036,
	"./maths_assessments/assets/BlockSpring/2springshapes5.png": 648661,
	"./maths_assessments/assets/BlockSpring/2springshapes6.png": 811934,
	"./maths_assessments/assets/BlockSpring/2springshapes7.png": 987719,
	"./maths_assessments/assets/BlockSpring/2springshapes8.png": 543488,
	"./maths_assessments/assets/BlockSpring/2springshapes9.png": 667689,
	"./maths_assessments/assets/BlockSpring/2springstatistics1.png": 94988,
	"./maths_assessments/assets/BlockSpring/2springstatistics2.png": 15047,
	"./maths_assessments/assets/BlockSpring/2springstatistics3.png": 296734,
	"./maths_assessments/assets/BlockSpring/2springstatistics4.png": 637745,
	"./maths_assessments/assets/BlockSpring/2springstatistics5.png": 739880,
	"./maths_assessments/assets/BlockSpring/2springstatistics6.png": 25155,
	"./maths_assessments/assets/BlockSpring/2springstatistics7.png": 223930,
	"./maths_assessments/assets/BlockSpring/2springstatistics8.png": 807437,
	"./maths_assessments/assets/BlockSpring/2springstatistics9.png": 567492,
	"./maths_assessments/assets/BlockSpring/3springfractions1.png": 506063,
	"./maths_assessments/assets/BlockSpring/3springfractions2.png": 287156,
	"./maths_assessments/assets/BlockSpring/3springfractions3.png": 508285,
	"./maths_assessments/assets/BlockSpring/3springfractions4.png": 111938,
	"./maths_assessments/assets/BlockSpring/3springfractions5.png": 333067,
	"./maths_assessments/assets/BlockSpring/3springfractions6.png": 63216,
	"./maths_assessments/assets/BlockSpring/3springfractions7.png": 660121,
	"./maths_assessments/assets/BlockSpring/3springfractions8.png": 870734,
	"./maths_assessments/assets/BlockSpring/3springfractions9.png": 13751,
	"./maths_assessments/assets/BlockSpring/3springlength&perimeter1.png": 783173,
	"./maths_assessments/assets/BlockSpring/3springlength&perimeter2.png": 64398,
	"./maths_assessments/assets/BlockSpring/3springlength&perimeter3.png": 54391,
	"./maths_assessments/assets/BlockSpring/3springlength&perimeter4.png": 474776,
	"./maths_assessments/assets/BlockSpring/3springlength&perimeter5.png": 747489,
	"./maths_assessments/assets/BlockSpring/3springlength&perimeter6.png": 798506,
	"./maths_assessments/assets/BlockSpring/3springlength&perimeter7.png": 649267,
	"./maths_assessments/assets/BlockSpring/3springlength&perimeter8.png": 353972,
	"./maths_assessments/assets/BlockSpring/3springlength&perimeter9.png": 575101,
	"./maths_assessments/assets/BlockSpring/3springmoney1.png": 496844,
	"./maths_assessments/assets/BlockSpring/3springmoney10.png": 333270,
	"./maths_assessments/assets/BlockSpring/3springmoney2.png": 416903,
	"./maths_assessments/assets/BlockSpring/3springmoney3.png": 698590,
	"./maths_assessments/assets/BlockSpring/3springmoney4.png": 39601,
	"./maths_assessments/assets/BlockSpring/3springmoney5.png": 625384,
	"./maths_assessments/assets/BlockSpring/3springmoney6.png": 427011,
	"./maths_assessments/assets/BlockSpring/3springmoney7.png": 109434,
	"./maths_assessments/assets/BlockSpring/3springmoney8.png": 209293,
	"./maths_assessments/assets/BlockSpring/3springmoney9.png": 969348,
	"./maths_assessments/assets/BlockSpring/3springmultiplication&division1.png": 177083,
	"./maths_assessments/assets/BlockSpring/3springmultiplication&division2.png": 822048,
	"./maths_assessments/assets/BlockSpring/3springmultiplication&division3.png": 276873,
	"./maths_assessments/assets/BlockSpring/3springmultiplication&division4.png": 902614,
	"./maths_assessments/assets/BlockSpring/3springmultiplication&division5.png": 680703,
	"./maths_assessments/assets/BlockSpring/3springmultiplication&division6.png": 767140,
	"./maths_assessments/assets/BlockSpring/3springmultiplication&division7.png": 809645,
	"./maths_assessments/assets/BlockSpring/3springmultiplication&division8.png": 805786,
	"./maths_assessments/assets/BlockSpring/3springmultiplication&division9.png": 511011,
	"./maths_assessments/assets/BlockSpring/3springstatistics1.png": 468923,
	"./maths_assessments/assets/BlockSpring/3springstatistics10.png": 374483,
	"./maths_assessments/assets/BlockSpring/3springstatistics11.png": 735626,
	"./maths_assessments/assets/BlockSpring/3springstatistics2.png": 690592,
	"./maths_assessments/assets/BlockSpring/3springstatistics3.png": 568713,
	"./maths_assessments/assets/BlockSpring/3springstatistics4.png": 228630,
	"./maths_assessments/assets/BlockSpring/3springstatistics5.png": 641919,
	"./maths_assessments/assets/BlockSpring/3springstatistics6.png": 788708,
	"./maths_assessments/assets/BlockSpring/3springstatistics7.png": 42605,
	"./maths_assessments/assets/BlockSpring/3springstatistics8.png": 284826,
	"./maths_assessments/assets/BlockSpring/3springstatistics9.png": 48931,
	"./maths_assessments/assets/BlockSpring/4springdecimals1.png": 230481,
	"./maths_assessments/assets/BlockSpring/4springdecimals10.png": 813029,
	"./maths_assessments/assets/BlockSpring/4springdecimals2.png": 105818,
	"./maths_assessments/assets/BlockSpring/4springdecimals3.png": 327395,
	"./maths_assessments/assets/BlockSpring/4springdecimals4.png": 397228,
	"./maths_assessments/assets/BlockSpring/4springdecimals5.png": 963765,
	"./maths_assessments/assets/BlockSpring/4springdecimals6.png": 878014,
	"./maths_assessments/assets/BlockSpring/4springdecimals7.png": 265703,
	"./maths_assessments/assets/BlockSpring/4springdecimals8.png": 122080,
	"./maths_assessments/assets/BlockSpring/4springdecimals9.png": 93257,
	"./maths_assessments/assets/BlockSpring/4springdivision1.png": 508974,
	"./maths_assessments/assets/BlockSpring/4springdivision10.png": 350444,
	"./maths_assessments/assets/BlockSpring/4springdivision2.png": 736805,
	"./maths_assessments/assets/BlockSpring/4springdivision3.png": 500892,
	"./maths_assessments/assets/BlockSpring/4springdivision4.png": 398291,
	"./maths_assessments/assets/BlockSpring/4springdivision5.png": 666378,
	"./maths_assessments/assets/BlockSpring/4springdivision6.png": 823809,
	"./maths_assessments/assets/BlockSpring/4springdivision7.png": 86328,
	"./maths_assessments/assets/BlockSpring/4springdivision8.png": 277487,
	"./maths_assessments/assets/BlockSpring/4springdivision9.png": 695942,
	"./maths_assessments/assets/BlockSpring/4springfractions1.png": 583760,
	"./maths_assessments/assets/BlockSpring/4springfractions10.png": 883218,
	"./maths_assessments/assets/BlockSpring/4springfractions11.png": 204763,
	"./maths_assessments/assets/BlockSpring/4springfractions2.png": 497579,
	"./maths_assessments/assets/BlockSpring/4springfractions3.png": 607074,
	"./maths_assessments/assets/BlockSpring/4springfractions4.png": 768797,
	"./maths_assessments/assets/BlockSpring/4springfractions5.png": 547668,
	"./maths_assessments/assets/BlockSpring/4springfractions6.png": 52783,
	"./maths_assessments/assets/BlockSpring/4springfractions7.png": 987590,
	"./maths_assessments/assets/BlockSpring/4springfractions8.png": 599105,
	"./maths_assessments/assets/BlockSpring/4springfractions9.png": 377976,
	"./maths_assessments/assets/BlockSpring/4springmultiplication1.png": 316663,
	"./maths_assessments/assets/BlockSpring/4springmultiplication2.png": 727932,
	"./maths_assessments/assets/BlockSpring/4springmultiplication3.png": 45445,
	"./maths_assessments/assets/BlockSpring/4springmultiplication4.png": 60778,
	"./maths_assessments/assets/BlockSpring/4springmultiplication5.png": 911539,
	"./maths_assessments/assets/BlockSpring/4springmultiplication6.png": 737048,
	"./maths_assessments/assets/BlockSpring/4springmultiplication7.png": 9761,
	"./maths_assessments/assets/BlockSpring/4springmultiplication8.png": 769958,
	"./maths_assessments/assets/BlockSpring/4springmultiplication9.png": 538703,
	"./maths_assessments/assets/BlockSpring/5springdecimals&percentages1.png": 677613,
	"./maths_assessments/assets/BlockSpring/5springdecimals&percentages10.png": 263129,
	"./maths_assessments/assets/BlockSpring/5springdecimals&percentages11.png": 666224,
	"./maths_assessments/assets/BlockSpring/5springdecimals&percentages12.png": 936075,
	"./maths_assessments/assets/BlockSpring/5springdecimals&percentages2.png": 863638,
	"./maths_assessments/assets/BlockSpring/5springdecimals&percentages3.png": 760575,
	"./maths_assessments/assets/BlockSpring/5springdecimals&percentages4.png": 809248,
	"./maths_assessments/assets/BlockSpring/5springdecimals&percentages5.png": 203721,
	"./maths_assessments/assets/BlockSpring/5springdecimals&percentages6.png": 872754,
	"./maths_assessments/assets/BlockSpring/5springdecimals&percentages7.png": 587579,
	"./maths_assessments/assets/BlockSpring/5springdecimals&percentages8.png": 507692,
	"./maths_assessments/assets/BlockSpring/5springdecimals&percentages9.png": 743605,
	"./maths_assessments/assets/BlockSpring/5springfractionsa1.png": 507924,
	"./maths_assessments/assets/BlockSpring/5springfractionsa10.png": 42478,
	"./maths_assessments/assets/BlockSpring/5springfractionsa11.png": 741975,
	"./maths_assessments/assets/BlockSpring/5springfractionsa12.png": 518044,
	"./maths_assessments/assets/BlockSpring/5springfractionsa2.png": 13039,
	"./maths_assessments/assets/BlockSpring/5springfractionsa3.png": 947846,
	"./maths_assessments/assets/BlockSpring/5springfractionsa4.png": 550265,
	"./maths_assessments/assets/BlockSpring/5springfractionsa5.png": 544016,
	"./maths_assessments/assets/BlockSpring/5springfractionsa6.png": 457835,
	"./maths_assessments/assets/BlockSpring/5springfractionsa7.png": 567330,
	"./maths_assessments/assets/BlockSpring/5springfractionsa8.png": 988709,
	"./maths_assessments/assets/BlockSpring/5springfractionsa9.png": 236444,
	"./maths_assessments/assets/BlockSpring/5springfractionsb1.png": 656609,
	"./maths_assessments/assets/BlockSpring/5springfractionsb10.png": 376885,
	"./maths_assessments/assets/BlockSpring/5springfractionsb11.png": 293996,
	"./maths_assessments/assets/BlockSpring/5springfractionsb2.png": 707626,
	"./maths_assessments/assets/BlockSpring/5springfractionsb3.png": 558387,
	"./maths_assessments/assets/BlockSpring/5springfractionsb4.png": 374780,
	"./maths_assessments/assets/BlockSpring/5springfractionsb5.png": 692293,
	"./maths_assessments/assets/BlockSpring/5springfractionsb6.png": 489870,
	"./maths_assessments/assets/BlockSpring/5springfractionsb7.png": 963511,
	"./maths_assessments/assets/BlockSpring/5springfractionsb8.png": 589680,
	"./maths_assessments/assets/BlockSpring/5springfractionsb9.png": 305433,
	"./maths_assessments/assets/BlockSpring/5springmultiplication1.png": 147104,
	"./maths_assessments/assets/BlockSpring/5springmultiplication10.png": 463138,
	"./maths_assessments/assets/BlockSpring/5springmultiplication11.png": 684267,
	"./maths_assessments/assets/BlockSpring/5springmultiplication2.png": 502139,
	"./maths_assessments/assets/BlockSpring/5springmultiplication3.png": 753138,
	"./maths_assessments/assets/BlockSpring/5springmultiplication4.png": 134701,
	"./maths_assessments/assets/BlockSpring/5springmultiplication5.png": 92196,
	"./maths_assessments/assets/BlockSpring/5springmultiplication6.png": 522111,
	"./maths_assessments/assets/BlockSpring/5springmultiplication7.png": 744022,
	"./maths_assessments/assets/BlockSpring/5springmultiplication8.png": 255505,
	"./maths_assessments/assets/BlockSpring/5springmultiplication9.png": 499208,
	"./maths_assessments/assets/BlockSpring/6springalgebra1.png": 35245,
	"./maths_assessments/assets/BlockSpring/6springalgebra10.png": 758534,
	"./maths_assessments/assets/BlockSpring/6springalgebra11.png": 820400,
	"./maths_assessments/assets/BlockSpring/6springalgebra12.png": 785803,
	"./maths_assessments/assets/BlockSpring/6springalgebra13.png": 22146,
	"./maths_assessments/assets/BlockSpring/6springalgebra2.png": 644566,
	"./maths_assessments/assets/BlockSpring/6springalgebra3.png": 422655,
	"./maths_assessments/assets/BlockSpring/6springalgebra4.png": 564000,
	"./maths_assessments/assets/BlockSpring/6springalgebra5.png": 18825,
	"./maths_assessments/assets/BlockSpring/6springalgebra6.png": 653682,
	"./maths_assessments/assets/BlockSpring/6springalgebra7.png": 919035,
	"./maths_assessments/assets/BlockSpring/6springalgebra8.png": 322796,
	"./maths_assessments/assets/BlockSpring/6springalgebra9.png": 405685,
	"./maths_assessments/assets/BlockSpring/6springconvertingunits1.png": 114469,
	"./maths_assessments/assets/BlockSpring/6springconvertingunits10.png": 188417,
	"./maths_assessments/assets/BlockSpring/6springconvertingunits11.png": 967288,
	"./maths_assessments/assets/BlockSpring/6springconvertingunits2.png": 860462,
	"./maths_assessments/assets/BlockSpring/6springconvertingunits3.png": 289687,
	"./maths_assessments/assets/BlockSpring/6springconvertingunits4.png": 40696,
	"./maths_assessments/assets/BlockSpring/6springconvertingunits5.png": 778177,
	"./maths_assessments/assets/BlockSpring/6springconvertingunits6.png": 747594,
	"./maths_assessments/assets/BlockSpring/6springconvertingunits7.png": 902803,
	"./maths_assessments/assets/BlockSpring/6springconvertingunits8.png": 91156,
	"./maths_assessments/assets/BlockSpring/6springconvertingunits9.png": 524189,
	"./maths_assessments/assets/BlockSpring/6springdecimals1.png": 169623,
	"./maths_assessments/assets/BlockSpring/6springdecimals10.png": 83959,
	"./maths_assessments/assets/BlockSpring/6springdecimals11.png": 940942,
	"./maths_assessments/assets/BlockSpring/6springdecimals12.png": 812741,
	"./maths_assessments/assets/BlockSpring/6springdecimals13.png": 283324,
	"./maths_assessments/assets/BlockSpring/6springdecimals2.png": 911516,
	"./maths_assessments/assets/BlockSpring/6springdecimals3.png": 994405,
	"./maths_assessments/assets/BlockSpring/6springdecimals4.png": 111178,
	"./maths_assessments/assets/BlockSpring/6springdecimals5.png": 266387,
	"./maths_assessments/assets/BlockSpring/6springdecimals6.png": 920632,
	"./maths_assessments/assets/BlockSpring/6springdecimals7.png": 141761,
	"./maths_assessments/assets/BlockSpring/6springdecimals8.png": 106566,
	"./maths_assessments/assets/BlockSpring/6springdecimals9.png": 145583,
	"./maths_assessments/assets/BlockSpring/6springpercentages1.png": 128480,
	"./maths_assessments/assets/BlockSpring/6springpercentages10.png": 360866,
	"./maths_assessments/assets/BlockSpring/6springpercentages11.png": 735019,
	"./maths_assessments/assets/BlockSpring/6springpercentages12.png": 821200,
	"./maths_assessments/assets/BlockSpring/6springpercentages13.png": 49830,
	"./maths_assessments/assets/BlockSpring/6springpercentages14.png": 225030,
	"./maths_assessments/assets/BlockSpring/6springpercentages15.png": 806575,
	"./maths_assessments/assets/BlockSpring/6springpercentages16.png": 785108,
	"./maths_assessments/assets/BlockSpring/6springpercentages17.png": 6237,
	"./maths_assessments/assets/BlockSpring/6springpercentages18.png": 195466,
	"./maths_assessments/assets/BlockSpring/6springpercentages19.png": 927379,
	"./maths_assessments/assets/BlockSpring/6springpercentages2.png": 906811,
	"./maths_assessments/assets/BlockSpring/6springpercentages3.png": 675634,
	"./maths_assessments/assets/BlockSpring/6springpercentages4.png": 996845,
	"./maths_assessments/assets/BlockSpring/6springpercentages5.png": 226596,
	"./maths_assessments/assets/BlockSpring/6springpercentages6.png": 79807,
	"./maths_assessments/assets/BlockSpring/6springpercentages7.png": 666518,
	"./maths_assessments/assets/BlockSpring/6springpercentages8.png": 143825,
	"./maths_assessments/assets/BlockSpring/6springpercentages9.png": 149960,
	"./maths_assessments/assets/BlockSpring/6springperimetersareas&volumes1.png": 664490,
	"./maths_assessments/assets/BlockSpring/6springperimetersareas&volumes2.png": 613473,
	"./maths_assessments/assets/BlockSpring/6springperimetersareas&volumes3.png": 340760,
	"./maths_assessments/assets/BlockSpring/6springperimetersareas&volumes4.png": 920375,
	"./maths_assessments/assets/BlockSpring/6springperimetersareas&volumes5.png": 446734,
	"./maths_assessments/assets/BlockSpring/6springperimetersareas&volumes6.png": 649157,
	"./maths_assessments/assets/BlockSpring/6springperimetersareas&volumes7.png": 331644,
	"./maths_assessments/assets/BlockSpring/6springperimetersareas&volumes8.png": 511947,
	"./maths_assessments/assets/BlockSpring/6springperimetersareas&volumes9.png": 748290,
	"./maths_assessments/assets/BlockSpring/6springratios1.png": 244031,
	"./maths_assessments/assets/BlockSpring/6springratios10.png": 974575,
	"./maths_assessments/assets/BlockSpring/6springratios11.png": 393030,
	"./maths_assessments/assets/BlockSpring/6springratios12.png": 174237,
	"./maths_assessments/assets/BlockSpring/6springratios2.png": 907172,
	"./maths_assessments/assets/BlockSpring/6springratios3.png": 161069,
	"./maths_assessments/assets/BlockSpring/6springratios4.png": 356210,
	"./maths_assessments/assets/BlockSpring/6springratios5.png": 71035,
	"./maths_assessments/assets/BlockSpring/6springratios6.png": 292704,
	"./maths_assessments/assets/BlockSpring/6springratios7.png": 687177,
	"./maths_assessments/assets/BlockSpring/6springratios8.png": 141310,
	"./maths_assessments/assets/BlockSpring/6springratios9.png": 893799,
	"./maths_assessments/assets/Next.png": 942329,
	"./maths_assessments/assets/Next_old.png": 66359,
	"./maths_assessments/assets/Spag.png": 470115,
	"./maths_assessments/assets/Year1/ARAutumnEnd/year1question1.png": 173445,
	"./maths_assessments/assets/Year1/ARAutumnEnd/year1question10.png": 513889,
	"./maths_assessments/assets/Year1/ARAutumnEnd/year1question2.png": 301646,
	"./maths_assessments/assets/Year1/ARAutumnEnd/year1question3.png": 444663,
	"./maths_assessments/assets/Year1/ARAutumnEnd/year1question4.png": 169496,
	"./maths_assessments/assets/Year1/ARAutumnEnd/year1question5.png": 137761,
	"./maths_assessments/assets/Year1/ARAutumnEnd/year1question6.png": 188778,
	"./maths_assessments/assets/Year1/ARAutumnEnd/year1question7.png": 343987,
	"./maths_assessments/assets/Year1/ARAutumnEnd/year1question8.png": 201716,
	"./maths_assessments/assets/Year1/ARAutumnEnd/year1question9.png": 939197,
	"./maths_assessments/assets/Year1/ARSpringEnd/year1question1.png": 916028,
	"./maths_assessments/assets/Year1/ARSpringEnd/year1question10.png": 845638,
	"./maths_assessments/assets/Year1/ARSpringEnd/year1question2.png": 21111,
	"./maths_assessments/assets/Year1/ARSpringEnd/year1question3.png": 31118,
	"./maths_assessments/assets/Year1/ARSpringEnd/year1question4.png": 714209,
	"./maths_assessments/assets/Year1/ARSpringEnd/year1question5.png": 441496,
	"./maths_assessments/assets/Year1/ARSpringEnd/year1question6.png": 615987,
	"./maths_assessments/assets/Year1/ARSpringEnd/year1question7.png": 765226,
	"./maths_assessments/assets/Year1/ARSpringEnd/year1question8.png": 541821,
	"./maths_assessments/assets/Year1/ARSpringEnd/year1question9.png": 320692,
	"./maths_assessments/assets/Year1/ARSummerEnd/year1question1.png": 409492,
	"./maths_assessments/assets/Year1/ARSummerEnd/year1question10.png": 462382,
	"./maths_assessments/assets/Year1/ARSummerEnd/year1question2.png": 430959,
	"./maths_assessments/assets/Year1/ARSummerEnd/year1question3.png": 849414,
	"./maths_assessments/assets/Year1/ARSummerEnd/year1question4.png": 451833,
	"./maths_assessments/assets/Year1/ARSummerEnd/year1question5.png": 445584,
	"./maths_assessments/assets/Year1/ARSummerEnd/year1question6.png": 875755,
	"./maths_assessments/assets/Year1/ARSummerEnd/year1question7.png": 985250,
	"./maths_assessments/assets/Year1/ARSummerEnd/year1question8.png": 890277,
	"./maths_assessments/assets/Year1/ARSummerEnd/year1question9.png": 654364,
	"./maths_assessments/assets/Year1/REAutumnEnd/year1question1.png": 130551,
	"./maths_assessments/assets/Year1/REAutumnEnd/year1question10.png": 33751,
	"./maths_assessments/assets/Year1/REAutumnEnd/year1question11.png": 334254,
	"./maths_assessments/assets/Year1/REAutumnEnd/year1question12.png": 562085,
	"./maths_assessments/assets/Year1/REAutumnEnd/year1question13.png": 809820,
	"./maths_assessments/assets/Year1/REAutumnEnd/year1question2.png": 329916,
	"./maths_assessments/assets/Year1/REAutumnEnd/year1question3.png": 859333,
	"./maths_assessments/assets/Year1/REAutumnEnd/year1question4.png": 874666,
	"./maths_assessments/assets/Year1/REAutumnEnd/year1question5.png": 513523,
	"./maths_assessments/assets/Year1/REAutumnEnd/year1question6.png": 339032,
	"./maths_assessments/assets/Year1/REAutumnEnd/year1question7.png": 823649,
	"./maths_assessments/assets/Year1/REAutumnEnd/year1question8.png": 67494,
	"./maths_assessments/assets/Year1/REAutumnEnd/year1question9.png": 106511,
	"./maths_assessments/assets/Year1/RESpringEnd/year1question1.png": 580658,
	"./maths_assessments/assets/Year1/RESpringEnd/year1question2.png": 395273,
	"./maths_assessments/assets/Year1/RESpringEnd/year1question3.png": 517152,
	"./maths_assessments/assets/Year1/RESpringEnd/year1question4.png": 468479,
	"./maths_assessments/assets/Year1/RESpringEnd/year1question5.png": 571542,
	"./maths_assessments/assets/Year1/RESpringEnd/year1question6.png": 385517,
	"./maths_assessments/assets/Year1/RESpringEnd/year1question7.png": 131620,
	"./maths_assessments/assets/Year1/RESpringEnd/year1question8.png": 875491,
	"./maths_assessments/assets/Year1/RESpringEnd/year1question9.png": 627738,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question1.png": 924626,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question10.png": 765256,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question11.png": 5201,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question12.png": 396890,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question13.png": 102115,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question14.png": 171948,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question15.png": 254837,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question16.png": 169086,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question17.png": 40423,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question18.png": 413152,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question19.png": 867977,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question2.png": 472809,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question20.png": 878925,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question21.png": 215684,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question22.png": 500959,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question23.png": 963510,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question24.png": 613481,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question3.png": 348608,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question4.png": 876639,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question5.png": 822838,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question6.png": 254605,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question7.png": 591364,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question8.png": 591555,
	"./maths_assessments/assets/Year1/RESummerEnd/year1question9.png": 1722,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question1.png": 601222,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question10.png": 271732,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question11.png": 492861,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question12.png": 909094,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question13.png": 194191,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question14.png": 81968,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question15.png": 314073,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question16.png": 800066,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question17.png": 563723,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question18.png": 867068,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question19.png": 700933,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question2.png": 898781,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question20.png": 741193,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question21.png": 346720,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question22.png": 125051,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question23.png": 410226,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question24.png": 215085,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question25.png": 961188,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question3.png": 161300,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question4.png": 627563,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question5.png": 737058,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question6.png": 203641,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question7.png": 197392,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question8.png": 113751,
	"./maths_assessments/assets/Year1/ReadyToProgress/1/year1question9.png": 930606,
	"./maths_assessments/assets/Year1/ReadyToProgress/2/year1question1.png": 903475,
	"./maths_assessments/assets/Year1/ReadyToProgress/2/year1question10.png": 131035,
	"./maths_assessments/assets/Year1/ReadyToProgress/2/year1question11.png": 809490,
	"./maths_assessments/assets/Year1/ReadyToProgress/2/year1question12.png": 357673,
	"./maths_assessments/assets/Year1/ReadyToProgress/2/year1question2.png": 728984,
	"./maths_assessments/assets/Year1/ReadyToProgress/2/year1question3.png": 697249,
	"./maths_assessments/assets/Year1/ReadyToProgress/2/year1question4.png": 861134,
	"./maths_assessments/assets/Year1/ReadyToProgress/2/year1question5.png": 4151,
	"./maths_assessments/assets/Year1/ReadyToProgress/2/year1question6.png": 203516,
	"./maths_assessments/assets/Year1/ReadyToProgress/2/year1question7.png": 732933,
	"./maths_assessments/assets/Year1/ReadyToProgress/2/year1question8.png": 585986,
	"./maths_assessments/assets/Year1/ReadyToProgress/2/year1question9.png": 807115,
	"./maths_assessments/assets/Year1/ReadyToProgress/3/year1question1.png": 446948,
	"./maths_assessments/assets/Year1/ReadyToProgress/3/year1question2.png": 360511,
	"./maths_assessments/assets/Year1/ReadyToProgress/3/year1question3.png": 582422,
	"./maths_assessments/assets/Year1/ReadyToProgress/4/year1question1.png": 51969,
	"./maths_assessments/assets/Year1/ReadyToProgress/4/year1question2.png": 537738,
	"./maths_assessments/assets/Year1/ReadyToProgress/4/year1question3.png": 176595,
	"./maths_assessments/assets/Year1/ReadyToProgress/4/year1question4.png": 821724,
	"./maths_assessments/assets/Year1/ReadyToProgress/4/year1question5.png": 904613,
	"./maths_assessments/assets/Year1/ReadyToProgress/5/year1question1.png": 377154,
	"./maths_assessments/assets/Year1/ReadyToProgress/5/year1question2.png": 925337,
	"./maths_assessments/assets/Year1/ReadyToProgress/5/year1question3.png": 328432,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question1.png": 595983,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question10.png": 881471,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question11.png": 468182,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question12.png": 282157,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question13.png": 28260,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question14.png": 708475,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question15.png": 477298,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question16.png": 808265,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question2.png": 377076,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question3.png": 598205,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question4.png": 201858,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question5.png": 422987,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question6.png": 153136,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question7.png": 750041,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question8.png": 960654,
	"./maths_assessments/assets/Year1/ReadyToProgress/6/year1question9.png": 103671,
	"./maths_assessments/assets/Year2/ARAutumnEnd/year2question1.png": 984125,
	"./maths_assessments/assets/Year2/ARAutumnEnd/year2question10.png": 560361,
	"./maths_assessments/assets/Year2/ARAutumnEnd/year2question11.png": 589184,
	"./maths_assessments/assets/Year2/ARAutumnEnd/year2question12.png": 367515,
	"./maths_assessments/assets/Year2/ARAutumnEnd/year2question13.png": 469650,
	"./maths_assessments/assets/Year2/ARAutumnEnd/year2question14.png": 825805,
	"./maths_assessments/assets/Year2/ARAutumnEnd/year2question15.png": 585860,
	"./maths_assessments/assets/Year2/ARAutumnEnd/year2question2.png": 459238,
	"./maths_assessments/assets/Year2/ARAutumnEnd/year2question3.png": 498255,
	"./maths_assessments/assets/Year2/ARAutumnEnd/year2question4.png": 55408,
	"./maths_assessments/assets/Year2/ARAutumnEnd/year2question5.png": 652313,
	"./maths_assessments/assets/Year2/ARAutumnEnd/year2question6.png": 587778,
	"./maths_assessments/assets/Year2/ARAutumnEnd/year2question7.png": 808907,
	"./maths_assessments/assets/Year2/ARAutumnEnd/year2question8.png": 205308,
	"./maths_assessments/assets/Year2/ARAutumnEnd/year2question9.png": 734725,
	"./maths_assessments/assets/Year2/ARSpringEnd/year2question1.png": 524716,
	"./maths_assessments/assets/Year2/ARSpringEnd/year2question10.png": 84982,
	"./maths_assessments/assets/Year2/ARSpringEnd/year2question11.png": 681311,
	"./maths_assessments/assets/Year2/ARSpringEnd/year2question12.png": 726660,
	"./maths_assessments/assets/Year2/ARSpringEnd/year2question13.png": 966605,
	"./maths_assessments/assets/Year2/ARSpringEnd/year2question14.png": 610450,
	"./maths_assessments/assets/Year2/ARSpringEnd/year2question15.png": 508315,
	"./maths_assessments/assets/Year2/ARSpringEnd/year2question2.png": 393191,
	"./maths_assessments/assets/Year2/ARSpringEnd/year2question3.png": 521854,
	"./maths_assessments/assets/Year2/ARSpringEnd/year2question4.png": 357969,
	"./maths_assessments/assets/Year2/ARSpringEnd/year2question5.png": 118024,
	"./maths_assessments/assets/Year2/ARSpringEnd/year2question6.png": 454883,
	"./maths_assessments/assets/Year2/ARSpringEnd/year2question7.png": 233306,
	"./maths_assessments/assets/Year2/ARSpringEnd/year2question8.png": 237165,
	"./maths_assessments/assets/Year2/ARSpringEnd/year2question9.png": 711012,
	"./maths_assessments/assets/Year2/ARSummerEnd/year2question1.png": 654868,
	"./maths_assessments/assets/Year2/ARSummerEnd/year2question10.png": 856494,
	"./maths_assessments/assets/Year2/ARSummerEnd/year2question11.png": 555991,
	"./maths_assessments/assets/Year2/ARSummerEnd/year2question12.png": 332060,
	"./maths_assessments/assets/Year2/ARSummerEnd/year2question13.png": 84325,
	"./maths_assessments/assets/Year2/ARSummerEnd/year2question14.png": 497546,
	"./maths_assessments/assets/Year2/ARSummerEnd/year2question15.png": 229459,
	"./maths_assessments/assets/Year2/ARSummerEnd/year2question2.png": 159983,
	"./maths_assessments/assets/Year2/ARSummerEnd/year2question3.png": 94790,
	"./maths_assessments/assets/Year2/ARSummerEnd/year2question4.png": 697209,
	"./maths_assessments/assets/Year2/ARSummerEnd/year2question5.png": 690960,
	"./maths_assessments/assets/Year2/ARSummerEnd/year2question6.png": 604779,
	"./maths_assessments/assets/Year2/ARSummerEnd/year2question7.png": 714274,
	"./maths_assessments/assets/Year2/ARSummerEnd/year2question8.png": 135653,
	"./maths_assessments/assets/Year2/ARSummerEnd/year2question9.png": 383388,
	"./maths_assessments/assets/Year2/REAutumnEnd/year2question1.png": 301971,
	"./maths_assessments/assets/Year2/REAutumnEnd/year2question10.png": 376635,
	"./maths_assessments/assets/Year2/REAutumnEnd/year2question11.png": 661810,
	"./maths_assessments/assets/Year2/REAutumnEnd/year2question12.png": 476425,
	"./maths_assessments/assets/Year2/REAutumnEnd/year2question13.png": 598304,
	"./maths_assessments/assets/Year2/REAutumnEnd/year2question14.png": 549631,
	"./maths_assessments/assets/Year2/REAutumnEnd/year2question2.png": 956216,
	"./maths_assessments/assets/Year2/REAutumnEnd/year2question3.png": 177345,
	"./maths_assessments/assets/Year2/REAutumnEnd/year2question4.png": 37249,
	"./maths_assessments/assets/Year2/REAutumnEnd/year2question5.png": 688855,
	"./maths_assessments/assets/Year2/REAutumnEnd/year2question6.png": 430748,
	"./maths_assessments/assets/Year2/REAutumnEnd/year2question7.png": 513637,
	"./maths_assessments/assets/Year2/REAutumnEnd/year2question8.png": 735458,
	"./maths_assessments/assets/Year2/REAutumnEnd/year2question9.png": 956587,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question1.png": 926510,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question10.png": 699884,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question11.png": 452149,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question12.png": 366398,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question13.png": 118887,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question14.png": 539272,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question15.png": 533137,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question16.png": 112026,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question17.png": 876131,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question18.png": 615908,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question19.png": 869805,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question2.png": 154341,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question3.png": 402076,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question4.png": 299475,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question5.png": 567562,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question6.png": 724993,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question7.png": 503864,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question8.png": 178671,
	"./maths_assessments/assets/Year2/RESpringEnd/year2question9.png": 113478,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question1.png": 65174,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question10.png": 997316,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question11.png": 660557,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question12.png": 228790,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question13.png": 282591,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question14.png": 754560,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question15.png": 878761,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question16.png": 330578,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question17.png": 652123,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question18.png": 948108,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question19.png": 859733,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question2.png": 972205,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question20.png": 592089,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question21.png": 876336,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question22.png": 841739,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question23.png": 78082,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question24.png": 770877,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question25.png": 549748,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question26.png": 472207,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question3.png": 929700,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question4.png": 339643,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question5.png": 590642,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question6.png": 439433,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question7.png": 984608,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question8.png": 128231,
	"./maths_assessments/assets/Year2/RESummerEnd/year2question9.png": 740542,
	"./maths_assessments/assets/Year2/ReadyToProgress/1/year2question1.png": 63234,
	"./maths_assessments/assets/Year2/ReadyToProgress/1/year2question10.png": 165624,
	"./maths_assessments/assets/Year2/ReadyToProgress/1/year2question11.png": 386753,
	"./maths_assessments/assets/Year2/ReadyToProgress/1/year2question12.png": 229322,
	"./maths_assessments/assets/Year2/ReadyToProgress/1/year2question2.png": 577241,
	"./maths_assessments/assets/Year2/ReadyToProgress/1/year2question3.png": 861488,
	"./maths_assessments/assets/Year2/ReadyToProgress/1/year2question4.png": 457359,
	"./maths_assessments/assets/Year2/ReadyToProgress/1/year2question5.png": 172262,
	"./maths_assessments/assets/Year2/ReadyToProgress/1/year2question6.png": 756029,
	"./maths_assessments/assets/Year2/ReadyToProgress/1/year2question7.png": 534900,
	"./maths_assessments/assets/Year2/ReadyToProgress/1/year2question8.png": 830195,
	"./maths_assessments/assets/Year2/ReadyToProgress/1/year2question9.png": 979434,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question1.png": 104703,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question10.png": 704687,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question11.png": 123142,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question12.png": 904349,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question13.png": 683220,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question14.png": 633131,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question15.png": 258978,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question16.png": 725561,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question2.png": 251492,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question3.png": 505389,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question4.png": 700530,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question5.png": 415355,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question6.png": 153376,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question7.png": 31497,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question8.png": 485630,
	"./maths_assessments/assets/Year2/ReadyToProgress/2/year2question9.png": 754471,
	"./maths_assessments/assets/Year2/ReadyToProgress/3/year2question1.png": 267136,
	"./maths_assessments/assets/Year2/ReadyToProgress/3/year2question2.png": 164699,
	"./maths_assessments/assets/Year2/ReadyToProgress/3/year2question3.png": 843154,
	"./maths_assessments/assets/Year2/ReadyToProgress/3/year2question4.png": 173133,
	"./maths_assessments/assets/Year2/ReadyToProgress/4/year2question1.png": 94133,
	"./maths_assessments/assets/Year2/ReadyToProgress/4/year2question2.png": 8382,
	"./maths_assessments/assets/Year2/ReadyToProgress/4/year2question3.png": 760871,
	"./maths_assessments/assets/Year2/ReadyToProgress/4/year2question4.png": 181256,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question1.png": 978113,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question10.png": 196629,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question11.png": 311180,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question12.png": 747591,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question13.png": 29278,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question14.png": 370289,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question15.png": 956072,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question16.png": 241347,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question17.png": 440122,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question18.png": 23629,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question19.png": 783684,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question2.png": 463882,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question3.png": 102739,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question4.png": 747868,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question5.png": 830757,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question6.png": 60398,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question7.png": 5975,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question8.png": 386064,
	"./maths_assessments/assets/Year3/ARAutumnEnd/year3question9.png": 392313,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question1.png": 71304,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question10.png": 658682,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question11.png": 976259,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question12.png": 690984,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question13.png": 588849,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question14.png": 247838,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question15.png": 966151,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question16.png": 46092,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question17.png": 415189,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question18.png": 886034,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question19.png": 300251,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question2.png": 408163,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question3.png": 644058,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question4.png": 984181,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question5.png": 231916,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question6.png": 650919,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question7.png": 898430,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question8.png": 927945,
	"./maths_assessments/assets/Year3/ARSpringEnd/year3question9.png": 49824,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question1.png": 84392,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question10.png": 29786,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question11.png": 793891,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question12.png": 457032,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question13.png": 450897,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question14.png": 767806,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question15.png": 36647,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question16.png": 617644,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question17.png": 369909,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question18.png": 982706,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question19.png": 697531,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question2.png": 462723,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question20.png": 423275,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question3.png": 872890,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question4.png": 324949,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question5.png": 413324,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question6.png": 664007,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question7.png": 488222,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question8.png": 343977,
	"./maths_assessments/assets/Year3/ARSummerEnd/year3question9.png": 219776,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question1.png": 846719,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question10.png": 909679,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question11.png": 870662,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question12.png": 651869,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question13.png": 735188,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question14.png": 685099,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question15.png": 463970,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question16.png": 803705,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question17.png": 797456,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question18.png": 417367,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question19.png": 988142,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question2.png": 933156,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question3.png": 975661,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question4.png": 594098,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question5.png": 343099,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question6.png": 988064,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question7.png": 959241,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question8.png": 743998,
	"./maths_assessments/assets/Year3/REAutumnEnd/year3question9.png": 131687,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question1.png": 143810,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question10.png": 376120,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question11.png": 597249,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question12.png": 439818,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question13.png": 171731,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question14.png": 274332,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question15.png": 510245,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question16.png": 798766,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question2.png": 657817,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question3.png": 425712,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question4.png": 537935,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question5.png": 252838,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question6.png": 836605,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question7.png": 615476,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question8.png": 910771,
	"./maths_assessments/assets/Year3/RESpringEnd/year3question9.png": 60010,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question1.png": 575050,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question10.png": 178960,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question11.png": 185209,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question12.png": 202274,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question13.png": 92779,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question14.png": 142868,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question15.png": 363997,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question16.png": 582790,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question17.png": 164335,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question18.png": 973176,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question19.png": 194305,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question2.png": 89281,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question20.png": 128149,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question21.png": 759052,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question22.png": 679111,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question23.png": 960798,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question24.png": 301809,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question25.png": 403944,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question26.png": 689219,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question27.png": 371642,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question28.png": 471501,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question29.png": 231556,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question3.png": 868152,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question30.png": 958250,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question31.png": 113459,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question32.png": 938968,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question33.png": 907233,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question34.png": 71118,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question4.png": 117143,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question5.png": 171566,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question6.png": 941925,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question7.png": 859036,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question8.png": 868523,
	"./maths_assessments/assets/Year3/RESummerEnd/year3question9.png": 647394,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question1.png": 754338,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question10.png": 40792,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question11.png": 313505,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question12.png": 364522,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question13.png": 215283,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question14.png": 31676,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question15.png": 349189,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question16.png": 630414,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question17.png": 620407,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question18.png": 246576,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question19.png": 962329,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question2.png": 610425,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question20.png": 869597,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question21.png": 648468,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question22.png": 669935,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question23.png": 88390,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question3.png": 604176,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question4.png": 200047,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question5.png": 161030,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question6.png": 458589,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question7.png": 25556,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question8.png": 320851,
	"./maths_assessments/assets/Year3/ReadyToProgress/1/year3question9.png": 165642,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question1.png": 142703,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question10.png": 538655,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question11.png": 484854,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question12.png": 916621,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question13.png": 253380,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question14.png": 908187,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question15.png": 586642,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question16.png": 134825,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question2.png": 121236,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question3.png": 858717,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question4.png": 696994,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question5.png": 587499,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question6.png": 157328,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question7.png": 163577,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question8.png": 890542,
	"./maths_assessments/assets/Year3/ReadyToProgress/2/year3question9.png": 73687,
	"./maths_assessments/assets/Year3/ReadyToProgress/3/year3question1.png": 534640,
	"./maths_assessments/assets/Year3/ReadyToProgress/3/year3question2.png": 16395,
	"./maths_assessments/assets/Year3/ReadyToProgress/3/year3question3.png": 252738,
	"./maths_assessments/assets/Year3/ReadyToProgress/3/year3question4.png": 945533,
	"./maths_assessments/assets/Year3/ReadyToProgress/3/year3question5.png": 724404,
	"./maths_assessments/assets/Year3/ReadyToProgress/3/year3question6.png": 646863,
	"./maths_assessments/assets/Year3/ReadyToProgress/3/year3question7.png": 361766,
	"./maths_assessments/assets/Year3/ReadyToProgress/4/year3question1.png": 87237,
	"./maths_assessments/assets/Year3/ReadyToProgress/4/year3question10.png": 989537,
	"./maths_assessments/assets/Year3/ReadyToProgress/4/year3question11.png": 716824,
	"./maths_assessments/assets/Year3/ReadyToProgress/4/year3question2.png": 368462,
	"./maths_assessments/assets/Year3/ReadyToProgress/4/year3question3.png": 358455,
	"./maths_assessments/assets/Year3/ReadyToProgress/4/year3question4.png": 778840,
	"./maths_assessments/assets/Year3/ReadyToProgress/4/year3question5.png": 51553,
	"./maths_assessments/assets/Year3/ReadyToProgress/4/year3question6.png": 102570,
	"./maths_assessments/assets/Year3/ReadyToProgress/4/year3question7.png": 953331,
	"./maths_assessments/assets/Year3/ReadyToProgress/4/year3question8.png": 658036,
	"./maths_assessments/assets/Year3/ReadyToProgress/4/year3question9.png": 879165,
	"./maths_assessments/assets/Year3/ReadyToProgress/5/year3question1.png": 302150,
	"./maths_assessments/assets/Year3/ReadyToProgress/5/year3question2.png": 83357,
	"./maths_assessments/assets/Year3/ReadyToProgress/5/year3question3.png": 650324,
	"./maths_assessments/assets/Year3/ReadyToProgress/5/year3question4.png": 600235,
	"./maths_assessments/assets/Year3/ReadyToProgress/5/year3question5.png": 379106,
	"./maths_assessments/assets/Year3/ReadyToProgress/5/year3question6.png": 235193,
	"./maths_assessments/assets/Year3/ReadyToProgress/6/year3question1.png": 329507,
	"./maths_assessments/assets/Year3/ReadyToProgress/6/year3question2.png": 992648,
	"./maths_assessments/assets/Year3/ReadyToProgress/6/year3question3.png": 232593,
	"./maths_assessments/assets/Year3/ReadyToProgress/6/year3question4.png": 396478,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question1.png": 518265,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question10.png": 705181,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question11.png": 484052,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question12.png": 505519,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question13.png": 923974,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question14.png": 526393,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question15.png": 520144,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question16.png": 433963,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question17.png": 543458,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question18.png": 964837,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question19.png": 212572,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question2.png": 662178,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question20.png": 360024,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question3.png": 399659,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question4.png": 933396,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question5.png": 366429,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question6.png": 585222,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question7.png": 624239,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question8.png": 882936,
	"./maths_assessments/assets/Year4/ARAutumnEnd/year4question9.png": 620417,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question1.png": 348688,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question10.png": 782546,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question11.png": 104091,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question12.png": 206528,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question13.png": 330729,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question14.png": 680758,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question15.png": 734559,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question16.png": 449284,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question17.png": 112525,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question18.png": 343290,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question19.png": 449475,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question2.png": 262507,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question3.png": 372002,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question4.png": 533725,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question5.png": 312596,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question6.png": 817711,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question7.png": 236166,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question8.png": 364033,
	"./maths_assessments/assets/Year4/ARSpringEnd/year4question9.png": 142904,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question1.png": 251864,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question10.png": 201226,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question11.png": 356435,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question12.png": 494328,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question13.png": 231809,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question14.png": 314094,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question15.png": 743319,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question16.png": 485212,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question17.png": 568101,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question18.png": 273570,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question19.png": 11051,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question2.png": 426355,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question20.png": 40475,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question3.png": 575594,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question4.png": 560261,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question5.png": 242748,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question6.png": 831479,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question7.png": 357838,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question8.png": 173401,
	"./maths_assessments/assets/Year4/ARSummerEnd/year4question9.png": 457648,
	"./maths_assessments/assets/Year4/REAutumnEnd/year4question1.png": 801907,
	"./maths_assessments/assets/Year4/REAutumnEnd/year4question10.png": 178395,
	"./maths_assessments/assets/Year4/REAutumnEnd/year4question11.png": 856850,
	"./maths_assessments/assets/Year4/REAutumnEnd/year4question12.png": 405033,
	"./maths_assessments/assets/Year4/REAutumnEnd/year4question13.png": 280832,
	"./maths_assessments/assets/Year4/REAutumnEnd/year4question14.png": 808863,
	"./maths_assessments/assets/Year4/REAutumnEnd/year4question15.png": 755062,
	"./maths_assessments/assets/Year4/REAutumnEnd/year4question2.png": 111064,
	"./maths_assessments/assets/Year4/REAutumnEnd/year4question3.png": 595681,
	"./maths_assessments/assets/Year4/REAutumnEnd/year4question4.png": 759566,
	"./maths_assessments/assets/Year4/REAutumnEnd/year4question5.png": 902583,
	"./maths_assessments/assets/Year4/REAutumnEnd/year4question6.png": 101948,
	"./maths_assessments/assets/Year4/REAutumnEnd/year4question7.png": 631365,
	"./maths_assessments/assets/Year4/REAutumnEnd/year4question8.png": 484418,
	"./maths_assessments/assets/Year4/REAutumnEnd/year4question9.png": 705547,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question1.png": 487982,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question10.png": 746028,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question11.png": 498293,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question12.png": 412542,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question13.png": 165031,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question14.png": 585416,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question15.png": 579281,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question16.png": 674522,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question17.png": 922275,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question18.png": 178404,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question19.png": 432301,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question2.png": 715813,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question20.png": 816449,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question21.png": 595320,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question3.png": 963548,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question4.png": 860947,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question5.png": 645386,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question6.png": 286465,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question7.png": 65336,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question8.png": 256495,
	"./maths_assessments/assets/Year4/RESpringEnd/year4question9.png": 674950,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question1.png": 552134,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question10.png": 518260,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question11.png": 739389,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question12.png": 155622,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question13.png": 440719,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question14.png": 844848,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question15.png": 560601,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question16.png": 46594,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question17.png": 810251,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question18.png": 629948,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question19.png": 947461,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question2.png": 333341,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question20.png": 987721,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question21.png": 109600,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question22.png": 371579,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question23.png": 656754,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question24.png": 461613,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question25.png": 207716,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question26.png": 544575,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question27.png": 647638,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question28.png": 124945,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question29.png": 614728,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question3.png": 112212,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question30.png": 563630,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question31.png": 746775,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question32.png": 39196,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question33.png": 275109,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question34.png": 204682,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question35.png": 936595,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question36.png": 140984,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question37.png": 362113,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question4.png": 62123,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question5.png": 171618,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question6.png": 376934,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question7.png": 148304,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question8.png": 64663,
	"./maths_assessments/assets/Year4/RESummerEnd/year4question9.png": 365166,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question1.png": 178934,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question10.png": 605156,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question11.png": 647661,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question12.png": 256982,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question13.png": 35071,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question14.png": 660064,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question15.png": 631241,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question16.png": 266098,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question17.png": 15099,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question18.png": 935212,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question19.png": 18101,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question2.png": 60557,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question20.png": 776633,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question21.png": 770384,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question22.png": 658027,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question23.png": 436898,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question24.png": 624797,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question25.png": 708116,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question26.png": 882607,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question27.png": 843590,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question28.png": 878785,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question29.png": 435275,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question3.png": 820612,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question4.png": 602267,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question5.png": 704402,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question6.png": 795113,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question7.png": 823936,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question8.png": 784519,
	"./maths_assessments/assets/Year4/ReadyToProgress/1/year4question9.png": 66206,
	"./maths_assessments/assets/Year4/ReadyToProgress/2/year4question1.png": 763683,
	"./maths_assessments/assets/Year4/ReadyToProgress/2/year4question2.png": 426824,
	"./maths_assessments/assets/Year4/ReadyToProgress/2/year4question3.png": 420689,
	"./maths_assessments/assets/Year4/ReadyToProgress/2/year4question4.png": 253950,
	"./maths_assessments/assets/Year4/ReadyToProgress/2/year4question5.png": 6439,
	"./maths_assessments/assets/Year4/ReadyToProgress/2/year4question6.png": 587436,
	"./maths_assessments/assets/Year4/ReadyToProgress/2/year4question7.png": 339701,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question1.png": 610564,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question10.png": 6046,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question11.png": 181831,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question12.png": 931148,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question13.png": 842773,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question14.png": 874362,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question15.png": 464195,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question16.png": 602216,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question2.png": 565215,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question3.png": 968886,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question4.png": 68713,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question5.png": 613888,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question6.png": 392219,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question7.png": 978002,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question8.png": 507157,
	"./maths_assessments/assets/Year4/ReadyToProgress/3/year4question9.png": 138060,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question1.png": 341281,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question10.png": 58805,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question11.png": 492268,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question12.png": 360743,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question13.png": 973054,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question14.png": 809169,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question15.png": 569224,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question16.png": 422435,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question17.png": 200858,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question2.png": 392298,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question3.png": 759411,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question4.png": 59452,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question5.png": 376965,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question6.png": 174542,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question7.png": 648183,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question8.png": 274352,
	"./maths_assessments/assets/Year4/ReadyToProgress/4/year4question9.png": 990105,
	"./maths_assessments/assets/Year4/ReadyToProgress/5/year4question1.png": 336898,
	"./maths_assessments/assets/Year4/ReadyToProgress/5/year4question2.png": 885081,
	"./maths_assessments/assets/Year4/ReadyToProgress/5/year4question3.png": 288176,
	"./maths_assessments/assets/Year4/ReadyToProgress/5/year4question4.png": 731023,
	"./maths_assessments/assets/Year4/ReadyToProgress/5/year4question5.png": 692006,
	"./maths_assessments/assets/Year4/ReadyToProgress/5/year4question6.png": 733245,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question1.png": 314717,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question10.png": 208649,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question11.png": 330528,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question12.png": 108859,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question13.png": 394034,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question14.png": 198893,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question15.png": 944996,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question16.png": 281855,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question17.png": 384918,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question18.png": 345873,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question19.png": 352008,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question2.png": 533510,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question20.png": 255540,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question3.png": 598703,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question4.png": 129680,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question5.png": 135929,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question6.png": 152994,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question7.png": 43499,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question8.png": 822108,
	"./maths_assessments/assets/Year5/ARAutumnEnd/year5question9.png": 574373,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question1.png": 597964,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question10.png": 695638,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question11.png": 473727,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question12.png": 43812,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question13.png": 86317,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question14.png": 704754,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question15.png": 453755,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question16.png": 98720,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question17.png": 69897,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question2.png": 364999,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question3.png": 189214,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question4.png": 233777,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question5.png": 785384,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question6.png": 647363,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question7.png": 57530,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question8.png": 310413,
	"./maths_assessments/assets/Year5/ARSpringEnd/year5question9.png": 647172,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question1.png": 307508,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question10.png": 564622,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question11.png": 554615,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question12.png": 965884,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question13.png": 283397,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question14.png": 298730,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question15.png": 149491,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question16.png": 975000,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question17.png": 247713,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question18.png": 491558,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question19.png": 776655,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question2.png": 229967,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question20.png": 810303,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question3.png": 461222,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question4.png": 349849,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question5.png": 634096,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question6.png": 599499,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question7.png": 835842,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question8.png": 736709,
	"./maths_assessments/assets/Year5/ARSummerEnd/year5question9.png": 419196,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question1.png": 901215,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question10.png": 843407,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question11.png": 558310,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question12.png": 142077,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question13.png": 404596,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question14.png": 696587,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question15.png": 932930,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question16.png": 446937,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question17.png": 731184,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question18.png": 105015,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question19.png": 631374,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question2.png": 615940,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question20.png": 14942,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question21.png": 733255,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question3.png": 279181,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question4.png": 949202,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question5.png": 270747,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question6.png": 373184,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question7.png": 497385,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question8.png": 641630,
	"./maths_assessments/assets/Year5/REAutumnEnd/year5question9.png": 817415,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question1.png": 914626,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question10.png": 957496,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question11.png": 178625,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question12.png": 148042,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question13.png": 303251,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question14.png": 432028,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question15.png": 514917,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question16.png": 260910,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question17.png": 690135,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question18.png": 70224,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question19.png": 76473,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question2.png": 462809,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question20.png": 52349,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question21.png": 831220,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question22.png": 753679,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question23.png": 468582,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question3.png": 865904,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question4.png": 308751,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question5.png": 269734,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question6.png": 310973,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question7.png": 89844,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question8.png": 715763,
	"./maths_assessments/assets/Year5/RESpringEnd/year5question9.png": 76906,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question1.png": 808130,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question10.png": 566904,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question11.png": 788033,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question12.png": 146954,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question13.png": 362515,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question14.png": 465116,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question15.png": 217381,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question16.png": 767169,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question17.png": 689047,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question18.png": 772688,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question19.png": 778937,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question2.png": 322137,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question20.png": 238461,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question21.png": 17332,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question22.png": 752591,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question23.png": 713574,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question24.png": 906649,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question25.png": 309744,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question26.png": 63243,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question27.png": 842114,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question28.png": 989061,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question29.png": 459644,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question3.png": 90032,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question30.png": 121650,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question31.png": 387003,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question4.png": 202255,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question5.png": 917158,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question6.png": 500925,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question7.png": 279796,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question8.png": 575091,
	"./maths_assessments/assets/Year5/RESummerEnd/year5question9.png": 724330,
	"./maths_assessments/assets/Year5/ReadyToProgress/1/year5question1.png": 719342,
	"./maths_assessments/assets/Year5/ReadyToProgress/1/year5question10.png": 774700,
	"./maths_assessments/assets/Year5/ReadyToProgress/1/year5question11.png": 857589,
	"./maths_assessments/assets/Year5/ReadyToProgress/1/year5question12.png": 771838,
	"./maths_assessments/assets/Year5/ReadyToProgress/1/year5question13.png": 643175,
	"./maths_assessments/assets/Year5/ReadyToProgress/1/year5question14.png": 368008,
	"./maths_assessments/assets/Year5/ReadyToProgress/1/year5question15.png": 607953,
	"./maths_assessments/assets/Year5/ReadyToProgress/1/year5question2.png": 489701,
	"./maths_assessments/assets/Year5/ReadyToProgress/1/year5question3.png": 406812,
	"./maths_assessments/assets/Year5/ReadyToProgress/1/year5question4.png": 761683,
	"./maths_assessments/assets/Year5/ReadyToProgress/1/year5question5.png": 606474,
	"./maths_assessments/assets/Year5/ReadyToProgress/1/year5question6.png": 637057,
	"./maths_assessments/assets/Year5/ReadyToProgress/1/year5question7.png": 415928,
	"./maths_assessments/assets/Year5/ReadyToProgress/1/year5question8.png": 640879,
	"./maths_assessments/assets/Year5/ReadyToProgress/1/year5question9.png": 601862,
	"./maths_assessments/assets/Year5/ReadyToProgress/2/year5question1.png": 546187,
	"./maths_assessments/assets/Year5/ReadyToProgress/2/year5question10.png": 913379,
	"./maths_assessments/assets/Year5/ReadyToProgress/2/year5question11.png": 691802,
	"./maths_assessments/assets/Year5/ReadyToProgress/2/year5question2.png": 276336,
	"./maths_assessments/assets/Year5/ReadyToProgress/2/year5question3.png": 873241,
	"./maths_assessments/assets/Year5/ReadyToProgress/2/year5question4.png": 680166,
	"./maths_assessments/assets/Year5/ReadyToProgress/2/year5question5.png": 719183,
	"./maths_assessments/assets/Year5/ReadyToProgress/2/year5question6.png": 983924,
	"./maths_assessments/assets/Year5/ReadyToProgress/2/year5question7.png": 721405,
	"./maths_assessments/assets/Year5/ReadyToProgress/2/year5question8.png": 970986,
	"./maths_assessments/assets/Year5/ReadyToProgress/2/year5question9.png": 126195,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question1.png": 407660,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question10.png": 537014,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question11.png": 590815,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question12.png": 305540,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question13.png": 968781,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question14.png": 638802,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question15.png": 960347,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question16.png": 62784,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question17.png": 186985,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question18.png": 847582,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question19.png": 23367,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question2.png": 532692,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question20.png": 679943,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question21.png": 961630,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question22.png": 128981,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question23.png": 759884,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question24.png": 690051,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question25.png": 888826,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question26.png": 302641,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question27.png": 404776,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question28.png": 187039,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question29.png": 590710,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question3.png": 557822,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question30.png": 930684,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question31.png": 460101,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question32.png": 71950,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question33.png": 731319,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question4.png": 240913,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question5.png": 730696,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question6.png": 67555,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question7.png": 819802,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question8.png": 577581,
	"./maths_assessments/assets/Year5/ReadyToProgress/3/year5question9.png": 323684,
	"./maths_assessments/assets/Year5/ReadyToProgress/4/year5question1.png": 184153,
	"./maths_assessments/assets/Year5/ReadyToProgress/4/year5question2.png": 635970,
	"./maths_assessments/assets/Year5/ReadyToProgress/4/year5question3.png": 857099,
	"./maths_assessments/assets/Year5/ReadyToProgress/4/year5question4.png": 811188,
	"./maths_assessments/assets/Year5/ReadyToProgress/4/year5question5.png": 32317,
	"./maths_assessments/assets/Year5/ReadyToProgress/4/year5question6.png": 991078,
	"./maths_assessments/assets/Year5/ReadyToProgress/4/year5question7.png": 30095,
	"./maths_assessments/assets/Year5/ReadyToProgress/5/year5question1.png": 357594,
	"./maths_assessments/assets/Year5/ReadyToProgress/5/year5question10.png": 630432,
	"./maths_assessments/assets/Year5/ReadyToProgress/5/year5question2.png": 778705,
	"./maths_assessments/assets/Year5/ReadyToProgress/5/year5question3.png": 268488,
	"./maths_assessments/assets/Year5/ReadyToProgress/5/year5question4.png": 848103,
	"./maths_assessments/assets/Year5/ReadyToProgress/5/year5question5.png": 95614,
	"./maths_assessments/assets/Year5/ReadyToProgress/5/year5question6.png": 181365,
	"./maths_assessments/assets/Year5/ReadyToProgress/5/year5question7.png": 945452,
	"./maths_assessments/assets/Year5/ReadyToProgress/5/year5question8.png": 25339,
	"./maths_assessments/assets/Year5/ReadyToProgress/5/year5question9.png": 310514,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question1.png": 332581,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question10.png": 322369,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question11.png": 362507,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question12.png": 896851,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question13.png": 164938,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question14.png": 235365,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question15.png": 999452,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question16.png": 707031,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question17.png": 7534,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question18.png": 796921,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question2.png": 104750,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question3.png": 804247,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question4.png": 682104,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question5.png": 419585,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question6.png": 262154,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question7.png": 994067,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question8.png": 851796,
	"./maths_assessments/assets/Year6/ARAutumnEnd/year6question9.png": 72925,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question1.png": 26236,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question10.png": 712390,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question11.png": 751407,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question12.png": 576916,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question13.png": 493597,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question14.png": 305698,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question15.png": 526827,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question16.png": 639184,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question17.png": 645433,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question18.png": 829870,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question19.png": 259095,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question2.png": 310519,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question20.png": 185943,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question21.png": 486446,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question22.png": 714277,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question23.png": 478364,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question3.png": 167502,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question4.png": 519969,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question5.png": 35352,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question6.png": 209843,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question7.png": 570986,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question8.png": 805053,
	"./maths_assessments/assets/Year6/ARSpringEnd/year6question9.png": 583924,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question1.png": 372852,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question10.png": 135182,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question11.png": 278199,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question12.png": 993916,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question13.png": 6981,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question14.png": 538666,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question15.png": 177523,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question16.png": 3032,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question17.png": 487649,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question18.png": 731494,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question19.png": 770511,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question2.png": 591759,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question3.png": 552742,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question4.png": 745817,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question5.png": 148912,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question6.png": 418763,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question7.png": 197634,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question8.png": 828229,
	"./maths_assessments/assets/Year6/ARSummerEnd/year6question9.png": 815164,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question1.png": 679971,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question10.png": 225355,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question11.png": 461698,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question12.png": 975705,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question13.png": 743600,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question14.png": 855823,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question15.png": 570726,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question16.png": 154493,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question17.png": 933364,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question18.png": 228659,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question19.png": 377898,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question2.png": 826760,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question20.png": 438202,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question21.png": 755779,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question22.png": 470504,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question23.png": 368369,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question3.png": 336977,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question4.png": 653886,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question5.png": 406375,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question6.png": 503724,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question7.png": 255989,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question8.png": 868786,
	"./maths_assessments/assets/Year6/REAutumnEnd/year6question9.png": 583611,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question1.png": 524646,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question10.png": 952020,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question11.png": 385053,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question12.png": 603846,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question13.png": 642863,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question14.png": 530640,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question15.png": 536889,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question16.png": 680802,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question17.png": 418283,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question18.png": 892444,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question19.png": 975333,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question2.png": 108413,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question20.png": 168233,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question21.png": 44032,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question22.png": 941595,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question3.png": 370932,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question4.png": 662923,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question5.png": 899266,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question6.png": 413273,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question7.png": 697520,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question8.png": 71351,
	"./maths_assessments/assets/Year6/RESpringEnd/year6question9.png": 597710,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question1.png": 684958,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question10.png": 290268,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question11.png": 373157,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question12.png": 602798,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question13.png": 548375,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question14.png": 299384,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question15.png": 520513,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question16.png": 6282,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question17.png": 645139,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question18.png": 349844,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question19.png": 782877,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question2.png": 852309,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question20.png": 754865,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question21.png": 306472,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question22.png": 168451,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question23.png": 578618,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question24.png": 30677,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question25.png": 119052,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question26.png": 886087,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question27.png": 710302,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question28.png": 566057,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question29.png": 441856,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question3.png": 966860,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question30.png": 302486,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question31.png": 715775,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question32.png": 378916,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question4.png": 897027,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question5.png": 95802,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question6.png": 25969,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question7.png": 611752,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question8.png": 394015,
	"./maths_assessments/assets/Year6/RESummerEnd/year6question9.png": 797686,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question1.png": 64786,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question10.png": 779912,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question11.png": 19857,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question12.png": 411546,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question13.png": 116771,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question14.png": 186604,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question15.png": 269493,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question16.png": 183742,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question17.png": 55079,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question18.png": 427808,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question19.png": 882633,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question2.png": 129321,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question20.png": 893581,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question21.png": 230340,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question22.png": 31967,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question23.png": 978166,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question24.png": 628137,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question25.png": 503936,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question26.png": 885147,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question27.png": 563602,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question28.png": 92757,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question29.png": 181132,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question3.png": 5120,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question30.png": 311106,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question31.png": 74763,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question32.png": 109360,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question33.png": 825113,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question34.png": 936486,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question35.png": 705231,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question36.png": 782772,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question37.png": 3901,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question38.png": 227306,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question39.png": 78067,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question4.png": 16799,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question40.png": 714895,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question41.png": 946150,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question5.png": 479350,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question6.png": 394765,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question7.png": 731524,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question8.png": 731715,
	"./maths_assessments/assets/Year6/ReadyToProgress/1/year6question9.png": 141882,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question1.png": 815455,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question10.png": 765775,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question11.png": 997030,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question12.png": 64445,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question13.png": 843316,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question14.png": 135307,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question15.png": 371650,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question16.png": 885657,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question17.png": 169904,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question18.png": 543735,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question2.png": 530180,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question3.png": 193421,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question4.png": 863442,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question5.png": 184987,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question6.png": 287424,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question7.png": 411625,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question8.png": 555870,
	"./maths_assessments/assets/Year6/ReadyToProgress/2/year6question9.png": 731655,
	"./maths_assessments/assets/endgame.png": 724945,
	"./maths_assessments/assets/marks1.png": 398633,
	"./mathsvocabpreview.jpg": 551278,
	"./meso-bg.png": 587524,
	"./meso-game-bg.png": 969059,
	"./meso.png": 928794,
	"./minima.png": 666685,
	"./mtc-bg.png": 466280,
	"./mtc.png": 365910,
	"./mult.png": 456040,
	"./myradin-bg.png": 178896,
	"./myradin.png": 58046,
	"./novice.png": 370708,
	"./numint.png": 468977,
	"./phobiaplaneticon.png": 122426,
	"./phobiapreview.jpg": 682467,
	"./placeholder_screen.png": 366012,
	"./polygonia-bg.png": 520446,
	"./polygonia.png": 273664,
	"./primer print.ttf": 57164,
	"./primus-bg.png": 129692,
	"./primus.png": 454834,
	"./rating.png": 375337,
	"./reorderNumpad.png": 486542,
	"./school-rank.png": 422111,
	"./scrambler_right.png": 717694,
	"./spatsbg.png": 492984,
	"./sweetplaneticon.png": 776317,
	"./tortuga-bg.png": 334120,
	"./tortuga.png": 565014,
	"./trophies.png": 337492,
	"./trophy.png": 628944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23140;